(function() {


(function() {
  this.KotiveWebappConfigs = (function() {
    var charDecodings, charEncodings;
    charEncodings = {
      '[': '&sqrleft;',
      ']': '&sqrright;',
      '{': '&curlleft;',
      '}': '&curlright;',
      ':': '&colon;',
      '^': '&kappie;'
    };
    charDecodings = Object.keys(charEncodings).reduce(function(obj, key) {
      obj[charEncodings[key]] = key;
      return obj;
    }, {});
    return {
      syncableStores: ['groups', 'template-activities', 'template-fields', 'conditions', 'roles'],
      storesToClear: ['template-activities', 'template-fields', 'groups', 'engine-sync', 'filters', 'conditions', 'groups', 'template-fields', 'roles', 'group-roles-links', 'template-activity-auths'],
      apiSyncInterval: 4000,
      disabledKotiveServices: ['amplitude', 'asana', 'aweber', 'basecamp', 'basecamp2', 'constantcontact', 'desk', 'freshbooks', 'github', 'hackernews', 'hellosign', 'hipchat', 'ibmwatson', 'intercom', 'kissmetrics', 'mixpanel', 'pdf', 'salesforce', 'sendgrid', 'sms', 'stripe', 'trello', 'verticalresponse'],
      checkForUpdates: 45,
      intercomAppId: 'oclei6zk',
      amplitudeAppKey: 'f9b576000c9779641fe889589d061069',
      charEncodings: charEncodings,
      charDecodings: charDecodings,
      formData: {
        name: 'form',
        label: 'Form',
        description: 'Default form for capturing information from a user',
        hashSum: '2',
        order: 0
      },
      subTaskflowData: {
        name: 'subtree',
        label: 'Sub taskflow',
        description: 'A taskflow included as a task in the main taskflow.',
        hashSum: '1',
        order: 1
      },
      webappOnline: null,
      onlineCheckInterval: 30,
      offlineCheckInterval: 120,
      onlineConnectTimeout: 15,
      webappUpdatesCheckInterval: 420
    };
  })();

}).call(this);

//# sourceMappingURL=app_configs.js.map


(function() {
  var isSafariBrowser;

  isSafariBrowser = function() {
    var userAgent;
    userAgent = navigator.userAgent;
    return /safari/i.test(userAgent) && !/chrome/i.test(userAgent);
  };

  this.KotiveDB = (function() {
    var createTransaction, db, dbAvailableRequests, dbConnectorInited, dbTransactionRequests, ensureObjectStoreCreated, ensureObjectStoreIndex, indexedDB, initiateDbConnector, requestTransaction, setupComplete, version;
    version = 11;
    if (isSafariBrowser()) {
      window.shimIndexedDB.__useShim();
    }
    indexedDB = isSafariBrowser() ? window.shimIndexedDB : window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
    if (indexedDB.__debug != null) {
      indexedDB.__debug(false);
    }
    db = null;
    dbConnectorInited = false;
    dbTransactionRequests = [];
    dbAvailableRequests = [];
    setupComplete = false;
    initiateDbConnector = function(callback) {
      var dbName, request;
      dbName = (typeof KotiveENV !== "undefined" && KotiveENV !== null) && KotiveENV === 'test' ? 'KotiveDB-test' : 'KotiveDB';
      request = indexedDB.open(dbName, version);
      request.onerror = function(event) {
        console.error("IndexedDB exited with error code " + request.errorCode);
        throw event.error;
      };
      request.onupgradeneeded = function(event) {
        var objectstore, tmpdb, transaction;
        tmpdb = event.target.result;
        transaction = event.target.transaction;
        window.tmpdb = tmpdb;
        ensureObjectStoreCreated(tmpdb, transaction, 'groups');
        objectstore = ensureObjectStoreCreated(tmpdb, transaction, 'template-activities');
        ensureObjectStoreIndex(objectstore, 'template-activities', 'id_parent');
        ensureObjectStoreIndex(objectstore, 'template-activities', 'id_root');
        ensureObjectStoreCreated(tmpdb, transaction, 'template-fields');
        objectstore = ensureObjectStoreCreated(tmpdb, transaction, 'template-activity-types');
        ensureObjectStoreIndex(objectstore, 'template-activity-types', 'name', true);
        objectstore = ensureObjectStoreCreated(tmpdb, transaction, 'template-activity-sub-types');
        ensureObjectStoreIndex(objectstore, 'template-activity-sub-types', 'name', true);
        ensureObjectStoreCreated(tmpdb, transaction, 'engine-sync');
        ensureObjectStoreCreated(tmpdb, transaction, 'conditions');
        ensureObjectStoreCreated(tmpdb, transaction, 'filters');
        ensureObjectStoreCreated(tmpdb, transaction, 'roles');
        ensureObjectStoreCreated(tmpdb, transaction, 'group-roles-links');
        return ensureObjectStoreCreated(tmpdb, transaction, 'template-activity-auths');
      };
      return request.onsuccess = function(event) {
        db = request.result;
        KotiveServices.update();
        dbConnectorInited = true;
        Ember.run(function() {
          return callback();
        });
        return _.each(dbTransactionRequests, function(data) {
          var stores, transType;
          stores = data[0], transType = data[1], callback = data[2];
          return Ember.run(function() {
            return callback(null, createTransaction(stores, transType));
          });
        });
      };
    };
    ensureObjectStoreCreated = function(db, transaction, name, id) {
      if (id == null) {
        id = 'id';
      }
      if (db.objectStoreNames.contains(name)) {
        return transaction.objectStore(name);
      } else {
        return db.createObjectStore(name, {
          keyPath: id
        });
      }
    };
    ensureObjectStoreIndex = function(objectstore, storeName, column, unique) {
      var indexName;
      if (unique == null) {
        unique = false;
      }
      indexName = storeName + "-" + column;
      if (!objectstore.indexNames.contains(indexName)) {
        return objectstore.createIndex(indexName, column, {
          unique: unique
        });
      }
    };
    createTransaction = function(stores, transType) {
      if (transType == null) {
        transType = 'readonly';
      }
      if (typeof stores === 'string') {
        stores = [stores];
      }
      return db.transaction(stores, transType);
    };
    requestTransaction = function(stores, transType, callback) {
      return this.available(function(available) {
        var err;
        if (available) {
          if (dbConnectorInited) {
            return Ember.run(function() {
              return callback(null, createTransaction(stores, transType));
            });
          } else {
            return dbTransactionRequests.push([stores, transType, callback]);
          }
        } else {
          err = new Error('IndexedDB is not available - cannot process request');
          return callback(err);
        }
      });
    };
    initiateDbConnector(function() {
      setupComplete = true;
      return dbAvailableRequests.forEach(function(cb) {
        return cb(true);
      });
    }, function(err) {
      console.log(err);
      setupComplete = true;
      return dbAvailableRequests.forEach(function(cb) {
        return cb(false);
      });
    });
    return {
      available: function(callback) {
        if (setupComplete) {
          return callback(indexedDB != null);
        } else {
          return dbAvailableRequests.push(callback);
        }
      },
      requestTransaction: requestTransaction,
      generateId: function() {
        return uuid.v4().replace(/\-/g, '');
      }
    };
  })();

}).call(this);

//# sourceMappingURL=connector.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  this.KotiveBatchRecordsSync = (function() {
    var alreadySynced, appStore, basicAuthToken, createActivities, createAuthRecords, createConditions, createFields, createGroupRolesLinks, createNewRoles, fetchBatchRecords, linkGroupToWorkflows, syncCallbacks, synchronizeGroup, userEmail, verifyAppGroup;
    basicAuthToken = null;
    userEmail = null;
    alreadySynced = $.localStorage.get('syncedGroups') || [];
    syncCallbacks = {};
    appStore = function() {
      return KotiveWebapp.__container__.lookup('store:main');
    };
    synchronizeGroup = function(groupId) {
      var composed;
      composed = async.compose(linkGroupToWorkflows, createGroupRolesLinks, createFields, createConditions, createActivities, createNewRoles, createAuthRecords, fetchBatchRecords, verifyAppGroup);
      return composed(groupId, function(err) {
        if (err != null) {
          console.log(err);
        }
        alreadySynced.pushObject(groupId);
        $.localStorage.set('syncedGroups', alreadySynced);
        if (syncCallbacks[groupId] != null) {
          return syncCallbacks[groupId].forEach(function(cb) {
            return cb();
          });
        }
      });
    };
    verifyAppGroup = function(groupId, callback) {
      return KotiveDB.requestTransaction('groups', 'readonly', function(error, transaction) {
        var objectstore, request;
        if (error != null) {
          return callback(error);
        }
        objectstore = transaction.objectStore('groups');
        request = objectstore.get(groupId);
        request.onerror = function(event) {
          return callback(event.error);
        };
        return request.onsuccess = function(event) {
          var composed, group, pollyfillFn;
          group = request.result;
          if (group.level === 'application') {
            return callback(null, groupId);
          } else {
            pollyfillFn = function(data, callback) {
              var batchRecords;
              groupId = data[0], batchRecords = data[1];
              return callback(null, [groupId, null, batchRecords]);
            };
            composed = async.compose(createGroupRolesLinks, pollyfillFn, createNewRoles, fetchBatchRecords);
            return composed(groupId, function(err) {
              if (err != null) {
                console.log(err);
              }
              return callback("Skipping sync process for group '" + groupId + "' type " + group.level + " - only role information will be synced");
            });
          }
        };
      });
    };
    fetchBatchRecords = function(groupId, callback) {
      return Ember.$.ajax({
        url: "/api/batch/group/" + groupId,
        type: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: basicAuthToken
        },
        success: function(data, textStatus, jqXHR) {
          return callback(null, [groupId, data]);
        },
        error: function(jqXHR, textStatus, errorThrown) {
          var error;
          error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
          return callback(error);
        }
      });
    };
    createAuthRecords = function(data, callback) {
      var auths, batchRecords, groupid;
      groupid = data[0], batchRecords = data[1];
      auths = batchRecords.templateActivityAuths.map(function(taa) {
        return {
          id: taa.id.toString(),
          label: taa.label,
          service: taa.service,
          groupId: taa.groupId.toString()
        };
      });
      return async.each(auths, function(auth, next) {
        return KotiveDB.requestTransaction('template-activity-auths', 'readwrite', function(error, transaction) {
          var objectstore, request;
          if (error != null) {
            next(error);
          }
          objectstore = transaction.objectStore('template-activity-auths');
          request = objectstore.put(auth);
          request.onerror = function(event) {
            return next(event.error);
          };
          return request.onsuccess = function(event) {
            return next(null);
          };
        });
      }, function(err) {
        if (err != null) {
          return callback(err);
        } else {
          return callback(null, data);
        }
      });
    };
    createNewRoles = function(data, callback) {
      var batchRecords, groupId, roles;
      groupId = data[0], batchRecords = data[1];
      roles = batchRecords.roles.map(function(r) {
        return {
          id: r.roleId.toString(),
          label: r.label,
          primaryGroupId: r.groupId.toString(),
          createdBy: userEmail
        };
      });
      return async.each(roles, function(role, next) {
        return KotiveDB.requestTransaction('roles', 'readwrite', function(error, transaction) {
          var objectstore, request;
          if (error != null) {
            next(error);
          }
          objectstore = transaction.objectStore('roles');
          request = objectstore.put(role);
          request.onerror = function(event) {
            return next(event.error);
          };
          return request.onsuccess = function(event) {
            return next(null);
          };
        });
      }, function(err) {
        if (err != null) {
          return callback(err);
        } else {
          return callback(null, [groupId, batchRecords]);
        }
      });
    };
    createActivities = function(data, callback) {
      var batchRecords, groupId, workflowIds;
      groupId = data[0], batchRecords = data[1];
      workflowIds = [];
      batchRecords.templateActivities = batchRecords.templateActivities || [];
      return async.each(batchRecords.templateActivities, function(activityData, next) {
        var templateConditions, templateFields;
        ['id', 'id_parent', 'id_root', 'templateActivityAuthId'].forEach(function(element) {
          return activityData[element] = activityData[element] != null ? activityData[element].toString() : null;
        });
        activityData.createdBy = userEmail;
        if (activityData.id_parent === "0") {
          activityData.groups = [groupId];
          activityData.templateActivities = [];
          workflowIds.push(activityData.id);
          batchRecords.templateActivities.forEach(function(element, index, array) {
            if (element.id_root.toString() === activityData.id) {
              return activityData.templateActivities.push(element.id.toString());
            }
          });
        }
        if (batchRecords.templateFields != null) {
          templateFields = [];
          batchRecords.templateFields.forEach(function(element, index, array) {
            if (element.id_tActivity.toString() === activityData.id) {
              return templateFields.push(element.id.toString());
            }
          });
          if (templateFields.length > 0) {
            activityData.templateFields = templateFields;
          }
        }
        if (batchRecords.guards != null) {
          templateConditions = [];
          batchRecords.guards.forEach(function(element, index, array) {
            if (element.tActivityId.toString() === activityData.id) {
              return templateConditions.push(element.id.toString());
            }
          });
          if (templateConditions.length > 0) {
            activityData.templateConditions = templateConditions;
          }
        }
        return KotiveDB.requestTransaction('template-activities', 'readwrite', function(error, transaction) {
          var objectstore, request;
          if (error != null) {
            return next(error);
          }
          objectstore = transaction.objectStore('template-activities');
          request = objectstore.put(activityData);
          request.onerror = function(event) {
            return next(event.error);
          };
          return request.onsuccess = function(event) {
            return next(null);
          };
        });
      }, function(err) {
        return callback(err, [groupId, batchRecords, workflowIds]);
      });
    };
    createConditions = function(data, callback) {
      var batchRecords, groupId, guards, positions, processFilters, workflowIds;
      groupId = data[0], batchRecords = data[1], workflowIds = data[2];
      processFilters = function(guardData, callback) {
        var order;
        if (guardData.spec !== '') {
          order = 0;
          return async.mapSeries(guardData.spec.split('~~'), function(filterString, next) {
            var comparatorIdentifier, comparatorStr, comparison, property, ref, ref1, value;
            ref = filterString.split('=>'), comparatorStr = ref[0], comparatorIdentifier = ref[1];
            value = comparatorStr.substring(4);
            ref1 = (function() {
              switch (filterString.substring(3, 4)) {
                case '=':
                  return ['is', value];
                case '>':
                  return ['greater than', value];
                case '>':
                  return ['less than', value];
                case '%':
                  return ['contains', value];
                case '!':
                  if (filterString.substring(4, 5) === '=') {
                    return ['is not', comparatorStr.substring(5)];
                  } else {
                    return ['is', value];
                  }
                default:
                  return ['is', value];
              }
            })(), comparison = ref1[0], value = ref1[1];
            comparatorIdentifier = comparatorIdentifier.substring(1, comparatorIdentifier.length - 1);
            property = (function() {
              switch (comparatorIdentifier) {
                case 'user.email:{currentuser.id}':
                  return 'current-user_email';
                case 'currentuser.rids':
                  return 'current-user_role';
                default:
                  if (/^activity\.id/.test(comparatorIdentifier)) {
                    return "templateActivity-" + (comparatorIdentifier.split(':')[1]);
                  } else {
                    return comparatorIdentifier.split(':')[1];
                  }
              }
            })();
            return KotiveDB.requestTransaction('filters', 'readwrite', function(error, transaction) {
              var filter, objectstore, request;
              if (error != null) {
                return next(error);
              }
              objectstore = transaction.objectStore('filters');
              filter = {
                id: KotiveDB.generateId(),
                property: property,
                comparison: comparison,
                value: value,
                order: order,
                conditions: [guardData.id.toString()]
              };
              order += 1;
              request = objectstore.put(filter);
              request.onerror = function(event) {
                return next(event.error);
              };
              return request.onsuccess = function(event) {
                return next(null, filter);
              };
            });
          }, function(err, filters) {
            return callback(err, filters);
          });
        } else {
          return callback(null, []);
        }
      };
      guards = batchRecords.guards || [];
      positions = {};
      return async.eachSeries(guards, function(guardData, next) {
        return processFilters(guardData, function(err, filters) {
          var guard, templateActivityId, type;
          if (err != null) {
            return next(err);
          } else {
            templateActivityId = guardData.tActivityId.toString();
            type = guardData.state === 'active' ? 'activation' : 'completion';
            if (positions[templateActivityId] != null) {
              if (positions[templateActivityId][type] != null) {
                positions[templateActivityId][type] += 1;
              } else {
                positions[templateActivityId][type] = 0;
              }
            } else {
              positions[templateActivityId] = {};
              positions[templateActivityId][type] = 0;
            }
            guard = {
              id: guardData.id.toString(),
              name: guardData.label,
              type: type,
              order: positions[templateActivityId][type],
              status: guardData.active ? 'active' : 'disabled',
              templateActivities: [templateActivityId],
              filters: filters.map(function(filter) {
                return filter.id;
              }),
              createdBy: userEmail
            };
            return KotiveDB.requestTransaction('conditions', 'readwrite', function(error, transaction) {
              var objectstore, request;
              if (error != null) {
                return next(error);
              }
              objectstore = transaction.objectStore('conditions');
              request = objectstore.put(guard);
              request.onerror = function(event) {
                return next(event.error);
              };
              return request.onsuccess = function(event) {
                return next(null);
              };
            });
          }
        });
      }, function(err) {
        return callback(err, data);
      });
    };
    createFields = function(data, callback) {
      var batchRecords, groupId, templateFields, workflowIds;
      groupId = data[0], batchRecords = data[1], workflowIds = data[2];
      templateFields = batchRecords.templateFields || [];
      return async.each(templateFields, function(fieldData, next) {
        fieldData.id = fieldData.id.toString();
        fieldData.templateActivities = [fieldData.id_tActivity.toString()];
        fieldData.createdBy = userEmail;
        delete fieldData.id_tActivity;
        return KotiveDB.requestTransaction('template-fields', 'readwrite', function(error, transaction) {
          var objectstore, request;
          if (error != null) {
            return next(error);
          }
          objectstore = transaction.objectStore('template-fields');
          request = objectstore.put(fieldData);
          request.onerror = function(event) {
            return next(event.error);
          };
          return request.onsuccess = function(event) {
            return next(null);
          };
        });
      }, function(err) {
        return callback(err, [groupId, workflowIds, batchRecords]);
      });
    };
    createGroupRolesLinks = function(data, callback) {
      var batchRecords, groupId, groupRolesLink, workflowIds;
      groupId = data[0], workflowIds = data[1], batchRecords = data[2];
      groupRolesLink = {
        id: groupId,
        roles: batchRecords.roles.map(function(r) {
          return r.roleId.toString();
        }),
        createdBy: userEmail
      };
      return KotiveDB.requestTransaction('group-roles-links', 'readwrite', function(error, transaction) {
        var objectstore, request;
        if (error != null) {
          return callback(error);
        }
        objectstore = transaction.objectStore('group-roles-links');
        request = objectstore.put(groupRolesLink);
        request.onerror = function(event) {
          return callback(event.error);
        };
        return request.onsuccess = function(event) {
          return callback(null, [groupId, workflowIds]);
        };
      });
    };
    linkGroupToWorkflows = function(data, callback) {
      var composedRun, fetchGroupData, groupId, link, workflowIds;
      groupId = data[0], workflowIds = data[1];
      fetchGroupData = function(callback) {
        return KotiveDB.requestTransaction('groups', 'readonly', function(error, transaction) {
          var objectstore, request;
          if (error != null) {
            return callback(error);
          }
          objectstore = transaction.objectStore('groups');
          request = objectstore.get(groupId);
          request.onerror = function(event) {
            return callback(event.error);
          };
          return request.onsuccess = function(event) {
            return callback(null, request.result);
          };
        });
      };
      link = function(groupData, callback) {
        groupData.workflows = workflowIds;
        return KotiveDB.requestTransaction('groups', 'readwrite', function(error, transaction) {
          var objectstore, request;
          if (error != null) {
            return callback(error);
          }
          objectstore = transaction.objectStore('groups');
          request = objectstore.put(groupData);
          request.onerror = function(event) {
            return callback(event.error);
          };
          return request.onsuccess = function(event) {
            return callback();
          };
        });
      };
      composedRun = async.compose(link, fetchGroupData);
      return composedRun(function(err) {
        return callback(err);
      });
    };
    return {
      batchSyncGroups: function(groupIds) {
        if (!(groupIds instanceof Array)) {
          groupIds = [groupIds];
        }
        return groupIds.forEach(function(groupId) {
          if (indexOf.call(alreadySynced, groupId) < 0) {
            return synchronizeGroup(groupId);
          }
        });
      },
      onSyncComplete: function(groupId, callback) {
        if (indexOf.call(alreadySynced, groupId) >= 0) {
          return callback();
        } else {
          syncCallbacks[groupId] = syncCallbacks[groupId] || [];
          return syncCallbacks[groupId].pushObject(callback);
        }
      },
      setBasicAuthToken: function(token) {
        return basicAuthToken = token;
      },
      setUserEmail: function(email) {
        return userEmail = email;
      },
      fetchBatchRecords: fetchBatchRecords
    };
  })();

}).call(this);

//# sourceMappingURL=kotive_batch_records_sync.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  this.KotiveBatchUpdater = (function() {
    var KotiveDB, addBatchRecordForNoClient, addBatchRecordsFromEvents, addReferenceRecord, apiNameFor, cachedGroupsForActivity, collateUpdateEvents, createBatchGroupRecord, createBatchGuardRecord, createBatchObject, createBatchRecord, createBatchRoleRecord, createBatchTemplateActivityRecord, createBatchTemplateFieldRecord, createdRecordsCounter, encodeFilter, firstTimeSyncedRecords, getAuthToken, getParentGroupForActivity, getSingularNameFor, processResults, pushBatchObject, removeEventData, storeNameFor, syncStoreName, syncableStores, trackCreatedEvents, updateCreatedByReference;
    KotiveDB = null;
    apiNameFor = {
      'groups': 'groups',
      'template-activities': 'templateActivities',
      'template-fields': 'templateFields',
      'conditions': 'guards',
      'roles': 'roles'
    };
    storeNameFor = {};
    createdRecordsCounter = {};
    Object.keys(apiNameFor).forEach(function(key, index, array) {
      storeNameFor[apiNameFor[key]] = key;
      return createdRecordsCounter[apiNameFor[key]] = 0;
    });
    syncableStores = Object.keys(apiNameFor);
    syncStoreName = null;
    firstTimeSyncedRecords = {};
    cachedGroupsForActivity = {};
    collateUpdateEvents = function(callback) {
      var events, removeEventIds;
      events = {};
      removeEventIds = [];
      return KotiveDB.requestTransaction(syncStoreName, 'readonly', function(err, transaction) {
        var cursorRequest, objectstore;
        if (err != null) {
          return callback(err);
        }
        objectstore = transaction.objectStore(syncStoreName);
        transaction.oncomplete = function(event) {
          var transformedEvents;
          transformedEvents = {};
          return async.each(Object.keys(events), function(storeName, cb) {
            var eventGroup;
            eventGroup = events[storeName];
            return async.map(Object.keys(eventGroup), function(id, next) {
              return next(null, eventGroup[id]);
            }, function(err, results) {
              transformedEvents[storeName] = results;
              return cb(err);
            });
          }, function(err, results) {
            if (err != null) {
              return callback(err);
            } else {
              return callback(null, [removeEventIds, transformedEvents]);
            }
          });
        };
        cursorRequest = objectstore.openCursor();
        cursorRequest.onerror = function(error) {
          return callback(error);
        };
        return cursorRequest.onsuccess = function(event) {
          var cursor, eventData, eventGroup, id, record, recordId, storeName, type;
          cursor = event.target.result;
          if (cursor != null) {
            eventData = cursor.value;
            id = eventData.id, recordId = eventData.recordId, type = eventData.type, storeName = eventData.storeName, record = eventData.record;
            events[storeName] = events[storeName] || {};
            eventGroup = events[storeName];
            if (eventGroup[recordId] != null) {
              if (type === 'delete') {
                if (eventGroup[recordId].type === 'create') {
                  eventGroup[recordId].eventIds.forEach(function(eventId) {
                    return removeEventIds.push(eventId);
                  });
                  removeEventIds.push(id);
                  delete eventGroup[recordId];
                } else {
                  eventGroup[recordId].type = type;
                  eventGroup[recordId].record = record;
                  eventGroup[recordId].eventIds.push(id);
                }
              } else if (type === 'update') {
                if (eventGroup[recordId].type === 'update') {
                  eventGroup[recordId].record = record;
                }
                eventGroup[recordId].eventIds.push(id);
              } else {
                if (eventGroup[recordId].type !== 'delete') {
                  eventGroup[recordId].type = type;
                }
                eventGroup[recordId].eventIds.push(id);
              }
            } else {
              eventGroup[recordId] = {
                id: recordId,
                type: type,
                record: record,
                eventIds: [id]
              };
            }
            return cursor["continue"]();
          }
        };
      });
    };
    createBatchObject = function(data, callback) {
      var composed, events, removeEventIds;
      removeEventIds = data[0], events = data[1];
      composed = async.compose(addBatchRecordForNoClient, addBatchRecordsFromEvents);
      return composed(events, function(err, batchRecords) {
        return callback(err, [removeEventIds, batchRecords]);
      });
    };
    addBatchRecordsFromEvents = function(events, callback) {
      var batchRecords, ids;
      batchRecords = {};
      ids = [];
      return async.each(Object.keys(events), function(storeName, cb) {
        return async.map(events[storeName], function(eventData, next) {
          if (eventData.id != null) {
            if (eventData.type === 'delete') {
              return createBatchRecord(eventData.record, eventData, storeName, function(record) {
                return next(null, record);
              });
            } else {
              return KotiveDB.requestTransaction(storeName, 'readonly', function(error, transaction) {
                var objectstore, request;
                if (error != null) {
                  return next(error);
                }
                objectstore = transaction.objectStore(storeName);
                request = objectstore.get(eventData.id);
                request.onerror = function(event) {
                  return next(event.error);
                };
                return request.onsuccess = function(event) {
                  ids.push(eventData.id);
                  if (request.result != null) {
                    return createBatchRecord(request.result, eventData, storeName, function(record) {
                      return next(null, record);
                    });
                  } else {
                    return next(null, null);
                  }
                };
              });
            }
          } else {
            return next(null, null);
          }
        }, function(err, results) {
          batchRecords[apiNameFor[storeName]] = results.filter(function(record) {
            return record != null;
          });
          return cb(err);
        });
      }, function(err) {
        return callback(err, [batchRecords, ids]);
      });
    };
    addBatchRecordForNoClient = function(data, callback) {
      var batchRecords, ids;
      batchRecords = data[0], ids = data[1];
      return async.each(syncableStores, function(storeName, cb) {
        var apiStoreName;
        apiStoreName = apiNameFor[storeName];
        return KotiveDB.requestTransaction(storeName, 'readonly', function(err, transaction) {
          var cursorRequest, objectstore, recordsToBatch;
          if (err != null) {
            return callback(err);
          }
          recordsToBatch = [];
          objectstore = transaction.objectStore(storeName);
          transaction.oncomplete = function(event) {
            return async.each(recordsToBatch, function(data, next) {
              var eventData, record;
              record = data[0], storeName = data[1];
              eventData = {
                type: 'create',
                eventIds: []
              };
              batchRecords[apiStoreName] = batchRecords[apiStoreName] || [];
              return createBatchRecord(record, eventData, storeName, function(batchRecord) {
                batchRecords[apiStoreName].push(batchRecord);
                firstTimeSyncedRecords[record.id] = record;
                return next();
              });
            }, function(err) {
              return cb(err);
            });
          };
          cursorRequest = objectstore.openCursor();
          cursorRequest.onerror = function(error) {
            return callback(error);
          };
          return cursorRequest.onsuccess = function(event) {
            var cursor, record, ref;
            cursor = event.target.result;
            if (cursor != null) {
              record = cursor.value;
              if (!((ref = record.id, indexOf.call(ids, ref) >= 0) || (Object.keys(record).length === 2 && (record.references != null)) || (record.createdBy != null))) {
                recordsToBatch.push([record, storeName]);
                return cursor["continue"]();
              } else {
                return cursor["continue"]();
              }
            }
          };
        });
      }, function(err) {
        return callback(null, batchRecords);
      });
    };
    createBatchRecord = function(record, eventData, storeName, callback) {
      if (eventData.type === 'delete') {
        record = eventData.record;
      }
      switch (storeName) {
        case 'groups':
          return createBatchGroupRecord(record, eventData, callback);
        case 'template-activities':
          return createBatchTemplateActivityRecord(record, eventData, callback);
        case 'template-fields':
          return createBatchTemplateFieldRecord(record, eventData, callback);
        case 'conditions':
          return createBatchGuardRecord(record, eventData, callback);
        case 'roles':
          return createBatchRoleRecord(record, eventData, callback);
        default:
          throw new Error("Unknown store name received for processing - " + storeName);
      }
    };
    createBatchGroupRecord = function(record, eventData, callback) {
      return callback({
        meta: {
          type: eventData.type,
          clientId: record.id,
          parentId: record.id_parent || "1",
          eventIds: eventData.eventIds
        },
        group: {
          label: record.label,
          extend_id: -1,
          status: record.status,
          level: record.level
        }
      });
    };
    createBatchTemplateActivityRecord = function(record, eventData, callback) {
      return getParentGroupForActivity(record, function(groupId) {
        return callback({
          meta: {
            type: eventData.type,
            clientId: record.id,
            parentId: groupId,
            parentActivityId: record.id_parent,
            eventIds: eventData.eventIds
          },
          templateActivity: {
            id_parent: -1,
            id_root: -1,
            order: record.order || 0,
            label: record.label,
            kind: record.kind,
            publish: record.publish,
            templateActivityAuthId: record.templateActivityAuthId != null ? parseInt(record.templateActivityAuthId) : null
          }
        });
      });
    };
    createBatchTemplateFieldRecord = function(record, eventData, callback) {
      return callback({
        meta: {
          type: eventData.type,
          clientId: record.id,
          parentId: record.templateActivities[0],
          eventIds: eventData.eventIds
        },
        templateField: {
          id_tActivity: -1,
          label: record.label,
          pattern: record.pattern,
          style: record.style,
          order: record.order,
          required: record.required,
          visible: record.visible,
          readonly: record.readonly
        }
      });
    };
    createBatchGuardRecord = function(record, eventData, callback) {
      var fetchFilter, fetchTemplateField, isTemplateFieldFilter;
      isTemplateFieldFilter = function(property) {
        return /^\d+$/.test(property) || /^[0-9a-f]+$/.test(property);
      };
      fetchTemplateField = function(id) {
        return new Ember.RSVP.Promise(function(resolve, reject) {
          return KotiveDB.requestTransaction('template-fields', 'readonly', function(error, transaction) {
            var objectstore, request;
            if (error != null) {
              return reject(error);
            } else {
              objectstore = transaction.objectStore('template-fields');
              request = objectstore.get(id);
              request.onerror = function(event) {
                return reject(event.error);
              };
              return request.onsuccess = function(event) {
                return resolve(request.result);
              };
            }
          });
        });
      };
      fetchFilter = function(id, callback) {
        return KotiveDB.requestTransaction('filters', 'readonly', function(error, transaction) {
          var objectstore, request;
          if (error != null) {
            return callback(error);
          }
          objectstore = transaction.objectStore('filters');
          request = objectstore.get(id);
          request.onerror = function(event) {
            return callback(event.error);
          };
          return request.onsuccess = function(event) {
            var filter;
            filter = request.result;
            if (isTemplateFieldFilter(filter.property)) {
              return fetchTemplateField(filter.property).then(function(templateField) {
                return callback(null, encodeFilter(filter, templateField));
              }, callback);
            } else {
              return callback(null, encodeFilter(filter));
            }
          };
        });
      };
      record.filters = record.filters || [];
      return async.map(record.filters, fetchFilter, function(err, filters) {
        return callback({
          meta: {
            type: eventData.type,
            clientId: record.id,
            parentId: record.templateActivities[0],
            eventIds: eventData.eventIds
          },
          guard: {
            active: true,
            label: record.name || '',
            spec: filters.join('~~'),
            state: record.type === 'activation' ? 'active' : 'complete',
            inverted: false
          }
        });
      });
    };
    createBatchRoleRecord = function(role, eventData, callback) {
      return callback({
        meta: {
          type: eventData.type,
          clientId: role.id,
          parentId: role.primaryGroupId,
          eventIds: eventData.eventIds
        },
        role: {
          id: -1,
          label: role.label
        }
      });
    };
    encodeFilter = function(filter, templateField) {
      var comparator, property, ref, style, type, value;
      comparator = (function() {
        switch (filter.comparison) {
          case 'is':
            return '=';
          case 'is not':
            return '!=';
          case 'greater than':
            return '>';
          case 'less than':
            return '<';
          case 'contains':
            return '%';
        }
      })();
      type = 'str';
      value = filter.value || '';
      if (templateField != null) {
        style = JSON.parse(templateField.style);
        if (style.kind === 'number') {
          type = 'num';
        }
        if (style.kind === 'email') {
          type = 'ema';
        }
      }
      if (/^templateActivity\-/.test(filter.property)) {
        type = 'dat';
      }
      ref = (function() {
        switch (filter.property) {
          case 'current-user_role':
            return ['currentuser.rids', 'rid'];
          case 'current-user_email':
            return ['user.email:{currentuser.id}', 'ema'];
          default:
            if (/^templateActivity\-/.test(filter.property)) {
              return ["activity.id:" + (filter.property.split('-')[1]), type];
            } else {
              return ["field.value:" + filter.property, type];
            }
        }
      })(), property = ref[0], type = ref[1];
      return "" + type + comparator + (value.trim()) + "=>{" + property + "}";
    };
    getParentGroupForActivity = function(activity, callback) {
      if (activity.groups != null) {
        if (!cachedGroupsForActivity[activity.id]) {
          cachedGroupsForActivity[activity.id] = activity.groups[0];
        }
        return callback(cachedGroupsForActivity[activity.id]);
      } else {
        if (cachedGroupsForActivity[activity.id_parent]) {
          return callback(cachedGroupsForActivity[activity.id_parent]);
        } else {
          return KotiveDB.requestTransaction('template-activities', 'readonly', function(err, transaction) {
            var objectstore, request;
            if (err != null) {
              throw new Error(err);
            }
            objectstore = transaction.objectStore('template-activities');
            request = objectstore.get(activity.id_parent);
            request.onerror = function(event) {
              throw new Error(event.error);
            };
            return request.onsuccess = function(event) {
              return getParentGroupForActivity(request.result, callback);
            };
          });
        }
      }
    };
    pushBatchObject = function(data, callback) {
      var batchRecords, removeEventIds;
      removeEventIds = data[0], batchRecords = data[1];
      return async.reduce(Object.keys(batchRecords), 0, function(sum, apiStoreName, next) {
        return next(null, sum + batchRecords[apiStoreName].length);
      }, function(err, result) {
        var basicToken;
        if (err != null) {
          return callback(err);
        }
        if (result === 0) {
          return callback(null, [removeEventIds, {}]);
        } else {
          basicToken = getAuthToken();
          return $.ajax({
            url: '/api/batch/process',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json;charset=UTF-8',
            data: JSON.stringify(batchRecords),
            headers: {
              Authorization: basicToken
            },
            success: function(data, textStatus, jqXHR) {
              return callback(null, [removeEventIds, data]);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              return callback("Failed to upload batch records to API: " + errorThrown);
            }
          });
        }
      });
    };
    getAuthToken = function() {
      var email, hash, token;
      email = $.localStorage.get('user-email');
      token = $.localStorage.get('auth-token');
      hash = btoa(email + ":" + token);
      return "Basic " + hash;
    };
    processResults = function(data, callback) {
      var batchRecords, removeEventIds;
      removeEventIds = data[0], batchRecords = data[1];
      return async.each(Object.keys(batchRecords), function(collectionName, cb) {
        var batchGroups;
        batchGroups = batchRecords[collectionName];
        return async.each(batchGroups, function(record, done) {
          var recordData, ref;
          if (((ref = record.meta.statusCode) === 200 || ref === 201) || (record.meta.statusCode === 400 && record.meta.type === 'delete')) {
            record.meta.eventIds.forEach(function(id) {
              return removeEventIds.push(id);
            });
          }
          if (record.meta.statusCode === 201) {
            recordData = record[getSingularNameFor(collectionName)];
            return addReferenceRecord(record.meta.clientId, recordData.id.toString(), collectionName, function(err) {
              if (err != null) {
                return done(err);
              }
              createdRecordsCounter[collectionName]++;
              return updateCreatedByReference(record.meta.clientId, collectionName, done);
            });
          } else {
            return done();
          }
        }, function(err) {
          return cb(err);
        });
      }, function(err) {
        return callback(null, removeEventIds);
      });
    };
    addReferenceRecord = function(clientId, serverId, collectionName, callback) {
      var storeName;
      storeName = storeNameFor[collectionName];
      return KotiveDB.requestTransaction(storeName, 'readwrite', function(err, transaction) {
        var objectstore, referenceRecord;
        if (err != null) {
          return callback(err);
        }
        objectstore = transaction.objectStore(storeName);
        referenceRecord = {
          id: serverId,
          references: clientId
        };
        transaction.oncomplete = function(event) {
          return callback();
        };
        transaction.onerror = function(event) {
          return callback(event.error);
        };
        return objectstore.add(referenceRecord);
      });
    };
    updateCreatedByReference = function(id, collectionName, callback) {
      var data, storeName, userEmail;
      storeName = storeNameFor[collectionName];
      if (firstTimeSyncedRecords[id] != null) {
        userEmail = $.localStorage.get('user-email');
        data = firstTimeSyncedRecords[id];
        data.createdBy = userEmail;
        return KotiveDB.requestTransaction(storeName, 'readwrite', function(err, transaction) {
          var objectstore, request;
          if (err != null) {
            return callback(err);
          }
          objectstore = transaction.objectStore(storeName);
          request = objectstore.put(data);
          request.onerror = function(event) {
            return callback(event.error);
          };
          return request.onsuccess = function(event) {
            return callback();
          };
        });
      } else {
        return callback();
      }
    };
    getSingularNameFor = function(storeName) {
      switch (storeName) {
        case 'groups':
          return 'group';
        case 'templateActivities':
          return 'templateActivity';
        case 'templateFields':
          return 'templateField';
        case 'guards':
          return 'guard';
        case 'roles':
          return 'role';
        default:
          throw new Error("Invalid store name received for singular lookup - " + storeName);
      }
    };
    removeEventData = function(ids, callback) {
      return KotiveDB.requestTransaction(syncStoreName, 'readwrite', function(err, transaction) {
        if (err != null) {
          return callback(err);
        }
        return async.each(ids, function(id, cb) {
          var request;
          request = transaction.objectStore(syncStoreName)["delete"](id);
          return request.onsuccess = function(event) {
            return cb();
          };
        }, function(err) {
          return callback(err);
        });
      });
    };
    trackCreatedEvents = function(callback) {
      if (($.localStorage.get('user-email') != null) && ($.localStorage.get('auth-token') != null)) {
        Object.keys(createdRecordsCounter).forEach(function(key, value, array) {
          if (createdRecordsCounter[key] > 0) {
            if (window.location.hostname !== '127.0.0.1' && window.location.hostname !== 'localhost') {
              if ((KotiveWebappConfigs.amplitudeAppKey != null) && KotiveWebappConfigs.amplitudeAppKey !== '') {
                amplitude.logEvent("Added a new " + getSingularNameFor(key), {
                  count: createdRecordsCounter[key]
                });
              }
              if ((KotiveWebappConfigs.intercomAppId != null) && KotiveWebappConfigs.intercomAppId !== '') {
                window.Intercom('trackEvent', "Added a new " + getSingularNameFor(key), {
                  count: createdRecordsCounter[key]
                });
              }
            }
            return createdRecordsCounter[key] = 0;
          }
        });
      }
      return callback();
    };
    return {
      setStoreName: function(name) {
        return syncStoreName = name;
      },
      setKotiveDB: function(dbObject) {
        return KotiveDB = dbObject;
      },
      run: function(callback) {
        var composedRun;
        firstTimeSyncedRecords = {};
        cachedGroupsForActivity = {};
        composedRun = async.compose(trackCreatedEvents, removeEventData, processResults, pushBatchObject, createBatchObject, collateUpdateEvents);
        return composedRun(function(err) {
          return callback(err);
        });
      }
    };
  })();

}).call(this);

//# sourceMappingURL=kotive_batch_updater.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  this.KotiveServices = this.KotiveServices || {};

  this.KotiveServices.update = function() {
    var collateChildIds, ensureActivityUpToDate, ensureChildActivityUpToDate, ensureFormActivityUpToDate, ensureParentActivityUpToDate, ensureSubTaskflowActivityUpToDate, fetchActivityDbRecord, fetchChildActivityDbRecord, fetchJsonForActivity, fetchParentActivityDbRecord, generateId, getChildDbObjects, getDbObjects, getParentDbObjects, promises, storeChildName, storeParentName, waitForHashSums, waitForServiceRequests;
    storeParentName = 'template-activity-types';
    storeChildName = 'template-activity-sub-types';
    generateId = KotiveDB.generateId;
    waitForHashSums = (function(_this) {
      return function(callback) {
        if (_this.hashSums != null) {
          return callback();
        } else {
          return Ember.run.later(function() {
            return waitForHashSums(callback);
          }, 300);
        }
      };
    })(this);
    ensureFormActivityUpToDate = function() {
      return ensureActivityUpToDate(KotiveWebappConfigs.formData);
    };
    ensureSubTaskflowActivityUpToDate = function() {
      return ensureActivityUpToDate(KotiveWebappConfigs.subTaskflowData);
    };
    ensureActivityUpToDate = function(data) {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return fetchParentActivityDbRecord(data.name).then(function(dbData) {
          if (dbData != null) {
            if (dbData.hashSum !== data.hashSum) {
              data.id = dbData.id;
              return getParentDbObjects('readwrite', function(error, transaction, objectstore, nameIndex) {
                if (error != null) {
                  reject(error);
                }
                transaction.oncomplete = function(event) {
                  return resolve();
                };
                transaction.onerror = function(event) {
                  return reject(event.error);
                };
                return objectstore.put(data);
              });
            } else {
              return resolve();
            }
          } else {
            data.id = generateId();
            return getParentDbObjects('readwrite', function(error, transaction, objectstore, nameIndex) {
              if (error != null) {
                reject(error);
              }
              transaction.oncomplete = function(event) {
                return resolve();
              };
              transaction.onerror = function(event) {
                return reject(event.error);
              };
              return objectstore.add(data);
            });
          }
        }, reject);
      });
    };
    ensureChildActivityUpToDate = function(activityName, serviceName, serviceParent, hashSum) {
      var setupData;
      setupData = function(data) {
        data.label = data.name;
        data.name = activityName;
        data.serviceParent = serviceParent;
        return data.hashSum = hashSum;
      };
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return fetchChildActivityDbRecord(activityName).then(function(dbData) {
          if (dbData == null) {
            return fetchJsonForActivity(activityName).then(function(data) {
              data.id = generateId();
              setupData(data);
              return getChildDbObjects('readwrite', function(error, transaction, objectstore, nameIndex) {
                if (error != null) {
                  reject(error);
                }
                objectstore.add(data);
                return resolve(data.id);
              });
            }, function(err) {
              return reject(err);
            });
          } else if (dbData.hashSum !== hashSum) {
            return fetchJsonForActivity(activityName).then(function(data) {
              data.id = dbData.id;
              setupData(data);
              if (data.name === "form") {
                data.order = 0;
              } else if (data.name.indexOf("email") !== -1) {
                data.order = 1;
              } else if (data.name.indexOf("subtree") !== -1) {
                data.order = 2;
              } else if (data.name.indexOf("sms") !== -1) {
                data.order = 3;
              } else {
                data.order = 999;
              }
              return getChildDbObjects('readwrite', function(error, transaction, objectstore, nameIndex) {
                if (error != null) {
                  reject(error);
                }
                objectstore.put(data);
                return resolve(data.id);
              });
            }, function(err) {
              return reject(err);
            });
          } else {
            return resolve(dbData.id);
          }
        });
      });
    };
    ensureParentActivityUpToDate = function(serviceName, childPromises, hashSum) {
      var childIdsChanged, setupData;
      setupData = function(data, childIds) {
        data.label = data.name;
        data.name = serviceName;
        data.hashSum = hashSum;
        data.templateActivitySubTypes = childIds;
        if (data.name === "form") {
          data.order = 0;
        } else if (data.name.indexOf("email") !== -1) {
          data.order = 1;
        } else if (data.name.indexOf("subtree") !== -1) {
          data.order = 2;
        } else if (data.name.indexOf("sms") !== -1) {
          data.order = 3;
        } else {
          data.order = 99;
        }
        if (data['auth-method'] != null) {
          data.authMethod = data['auth-method'];
          return delete data['auth-method'];
        }
      };
      childIdsChanged = function(dbData, childIds) {
        var check1, check2;
        if (!dbData.templateActivitySubTypes) {
          return true;
        }
        check1 = _.all(dbData.templateActivitySubTypes, function(id) {
          return indexOf.call(childIds, id) >= 0;
        });
        check2 = _.all(childIds, function(id) {
          return indexOf.call(dbData.templateActivitySubTypes, id) >= 0;
        });
        return !(check1 && check2);
      };
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return collateChildIds(childPromises, [], function(childIds) {
          return fetchParentActivityDbRecord(serviceName).then(function(dbData) {
            if (dbData == null) {
              return fetchJsonForActivity(serviceName + "/config").then(function(data) {
                data.id = generateId();
                setupData(data, childIds);
                return getParentDbObjects('readwrite', function(error, transaction, objectstore, nameIndex) {
                  if (error != null) {
                    reject(error);
                  }
                  objectstore.add(data);
                  return resolve();
                });
              }, function(err) {
                return reject(err);
              });
            } else if (dbData.hashSum !== hashSum || childIdsChanged(dbData, childIds)) {
              return fetchJsonForActivity(serviceName + "/config").then(function(data) {
                data.id = dbData.id;
                setupData(data, childIds);
                return getParentDbObjects('readwrite', function(error, transaction, objectstore, nameIndex) {
                  if (error != null) {
                    reject(error);
                  }
                  objectstore.put(data);
                  return resolve();
                });
              }, function(err) {
                return reject(err);
              });
            } else {
              return resolve();
            }
          }, function(err) {
            return reject(err);
          });
        });
      });
    };
    collateChildIds = function(promises, childIds, callback) {
      var promise;
      if (promises.length === 0) {
        return callback(childIds);
      } else {
        promise = promises.pop();
        return promise.then(function(id) {
          childIds.push(id);
          return collateChildIds(promises, childIds, callback);
        });
      }
    };
    waitForServiceRequests = (function(_this) {
      return function(promises) {
        var promise;
        if (promises.length === 0) {
          _this.serviceUpdated = true;
          return _.each(_this.updatedPendingRequests, function(callback) {
            return callback();
          });
        } else {
          promise = promises.pop();
          return promise.then(function() {
            return waitForServiceRequests(promises);
          }, function(err) {
            throw new Error(err);
          });
        }
      };
    })(this);
    fetchParentActivityDbRecord = function(name) {
      return fetchActivityDbRecord(name, storeParentName);
    };
    fetchChildActivityDbRecord = function(name) {
      return fetchActivityDbRecord(name, storeChildName);
    };
    fetchActivityDbRecord = function(name, storeName) {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return getDbObjects('readonly', storeName, function(error, transaction, objectstore, nameIndex) {
          var request;
          if (error != null) {
            return reject(error);
          } else {
            request = nameIndex.get(name);
            request.onsuccess = function(event) {
              return resolve(event.target.result);
            };
            return request.onerror = function(event) {
              return reject(event.target.error);
            };
          }
        });
      });
    };
    getParentDbObjects = function(mode, callback) {
      return getDbObjects(mode, storeParentName, callback);
    };
    getChildDbObjects = function(mode, callback) {
      return getDbObjects(mode, storeChildName, callback);
    };
    getDbObjects = function(mode, storeName, callback) {
      return KotiveDB.requestTransaction(storeName, mode, function(error, transaction) {
        var nameIndex, objectstore;
        if (error != null) {
          return calback(error);
        } else {
          objectstore = transaction.objectStore(storeName);
          nameIndex = objectstore.index(storeName + "-name");
          nameIndex.get('name');
          return callback(null, transaction, objectstore, nameIndex);
        }
      });
    };
    fetchJsonForActivity = function(serviceName) {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return $.ajax({
          url: "/bower_components/kotive-services/" + serviceName + ".json",
          dataType: 'json',
          type: 'GET',
          success: function(data, textStatus, jqXHR) {
            return resolve(data);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            console.log("Cannot process request (" + textStatus + "): " + errorThrown);
            return reject("Cannot process request (" + textStatus + "): " + errorThrown);
          }
        });
      });
    };
    promises = [ensureFormActivityUpToDate(), ensureSubTaskflowActivityUpToDate()];
    return Ember.RSVP.all(promises).then((function(_this) {
      return function() {
        return waitForHashSums(function() {
          var servicePromises;
          servicePromises = [];
          _.each(_this.hashSums, function(services, serviceParent) {
            var childPromises, promise;
            childPromises = [];
            _.each(services.services, function(hash, serviceName) {
              var promise;
              promise = ensureChildActivityUpToDate(serviceParent + "/" + serviceName, serviceName, serviceParent, hash);
              return childPromises.push(promise);
            });
            promise = ensureParentActivityUpToDate(serviceParent, childPromises, services.hashSum);
            return servicePromises.push(promise);
          });
          return waitForServiceRequests(servicePromises);
        });
      };
    })(this))["catch"](function(err) {
      throw new Error(err);
    });
  };

  this.KotiveServices.updatedPendingRequests = [];

  this.KotiveServices.serviceUpdated = false;

  this.KotiveServices.updated = function(callback) {
    if (this.serviceUpdated) {
      return callback();
    } else {
      return this.updatedPendingRequests.push(callback);
    }
  };

}).call(this);

//# sourceMappingURL=kotive_services_processor.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  this.KotiveSyncEngine = (function() {
    var KotiveBatchUpdater, KotiveDB, clearDataStores, clearTimer, doForcedSyncRun, doScheduledSyncRun, doSyncRun, doingSync, engineStatus, init, processEvent, setKotiveDB, syncInterval, syncRequired, syncStoreName, timer, transformEvent, waitForKotiveSetup;
    syncStoreName = 'engine-sync';
    syncInterval = 4000;
    KotiveDB = null;
    KotiveBatchUpdater = null;
    engineStatus = 'unstarted';
    document.addEventListener('KotiveWebapp:online', function() {
      return syncRequired();
    });
    timer = null;
    doingSync = false;
    syncRequired = {
      required: false,
      callback: [],
      reset: function() {
        this.required = false;
        this.forced = null;
        return this.callbacks = [];
      }
    };
    waitForKotiveSetup = (function(_this) {
      return function(callback) {
        return async.doUntil(function(cb) {
          return async.nextTick(cb);
        }, function() {
          return (_this.KotiveDB != null) && _this.KotiveBatchUpdater;
        }, function() {
          _this.KotiveBatchUpdater.setStoreName(syncStoreName);
          KotiveBatchUpdater = _this.KotiveBatchUpdater;
          setKotiveDB(_this.KotiveDB);
          return callback();
        });
      };
    })(this);
    setKotiveDB = function(dbObject) {
      KotiveDB = dbObject;
      return KotiveBatchUpdater.setKotiveDB(dbObject);
    };
    init = function() {
      return engineStatus = 'running';
    };
    processEvent = function(type, storeName, id, record, callback) {
      var ref;
      ref = transformEvent(type, storeName, record, id), type = ref[0], storeName = ref[1], id = ref[2], record = ref[3];
      if (engineStatus !== 'disabled' && ($.localStorage.get('user-email') != null) && ($.localStorage.get('auth-token') != null) && indexOf.call(KotiveWebappConfigs.syncableStores, storeName) >= 0) {
        return KotiveDB.requestTransaction(syncStoreName, 'readwrite', function(err, transaction) {
          var objectstore, request;
          if (err != null) {
            return callback(err);
          }
          objectstore = transaction.objectStore(syncStoreName);
          transaction.oncomplete = function(event) {
            syncRequired();
            if (callback != null) {
              return callback();
            }
          };
          transaction.onerror = function(event) {
            if (callback != null) {
              return callback(event.error);
            } else {
              throw new Error(event.error);
            }
          };
          return request = objectstore.add({
            id: KotiveDB.generateId(),
            storeName: storeName,
            recordId: id,
            record: record,
            type: type
          });
        });
      } else {
        if (callback != null) {
          return callback();
        }
      }
    };
    transformEvent = function(type, storeName, record, id) {
      switch (storeName) {
        case 'filters':
          return ['update', 'conditions', record.conditions[0], null];
        default:
          return [type, storeName, id, type === 'delete' ? record : null];
      }
    };
    syncRequired = function(forceRun, callback) {
      if (forceRun == null) {
        forceRun = false;
      }
      if ((engineStatus === 'running' || forceRun) && KotiveWebappConfigs.webappOnline) {
        if (forceRun) {
          return doForcedSyncRun(callback);
        } else {
          return doScheduledSyncRun(callback);
        }
      } else {
        if (callback != null) {
          return callback('Engine sync run process is not currently running');
        }
      }
    };
    doForcedSyncRun = function(callback) {
      clearTimer();
      if (doingSync) {
        syncRequired.required = true;
        if (callback != null) {
          return syncRequired.callbacks.push(callback);
        }
      } else {
        return doSyncRun(callback);
      }
    };
    doScheduledSyncRun = function(callback) {
      clearTimer();
      if (doingSync) {
        syncRequired.required = true;
        if (callback != null) {
          return syncRequired.callbacks.push(callback);
        }
      } else {
        return timer = setTimeout(function() {
          return doSyncRun(callback);
        }, KotiveWebappConfigs.apiSyncInterval);
      }
    };
    clearTimer = function() {
      if (timer != null) {
        clearTimeout(timer);
        return timer = null;
      }
    };
    doSyncRun = function(callback) {
      if (($.localStorage.get('user-email') != null) && ($.localStorage.get('auth-token') != null)) {
        console.log('#> Doing sync run! <#');
        return KotiveBatchUpdater.run(function(err) {
          var callbacks;
          if (callback != null) {
            callback(err);
          }
          if (syncRequired.required) {
            callbacks = syncRequired.callbacks;
            syncRequired.reset();
            return doForcedSyncRun(function(err) {
              return async.each(callbacks, function(item, next) {
                item(err);
                return next();
              }, function() {
                return true;
              });
            });
          }
        });
      } else {
        if (callback != null) {
          return callback('No credentials available for doing sync process');
        }
      }
    };
    clearDataStores = function(callback) {
      return async.each(KotiveWebappConfigs.storesToClear, function(storeName, next) {
        return KotiveDB.requestTransaction(storeName, 'readwrite', function(err, transaction) {
          var objectstore, request;
          if (err != null) {
            throw new Error(err);
          }
          objectstore = transaction.objectStore(storeName);
          request = objectstore.clear();
          request.onsuccess = function(event) {
            return next();
          };
          return request.onerror = function(event) {
            return next(event.message);
          };
        });
      }, function(err) {
        if (callback != null) {
          return callback(err);
        }
      });
    };
    waitForKotiveSetup(function() {
      return KotiveDB.available(function(available) {
        if (available) {
          console.log('#> Starting up Kotive Sync Engine <#');
          return init();
        } else {
          if (KotiveENV === 'test') {
            console.log('#> Running Kotive sync engine in test mode <#');
            setKotiveDB(KotiveDBMock);
            engineStatus = 'testmode';
            return init();
          } else {
            console.log('#> No KotiveDB for sync engine - cannot run sync process! <#');
            return engineStatus = 'unavailable';
          }
        }
      });
    });
    return {
      updated: function(storeName, id, record, callback) {
        return processEvent('update', storeName, id, record, callback);
      },
      created: function(storeName, id, record, callback) {
        return processEvent('create', storeName, id, record, callback);
      },
      deleted: function(storeName, id, record, callback) {
        return processEvent('delete', storeName, id, record, callback);
      },
      forceSync: function(callback) {
        return syncRequired(true, callback);
      },
      sync: function(callback) {
        return syncRequired(false, callback);
      },
      userDidLogOut: function(callback) {
        return clearDataStores(callback);
      },
      disable: function() {
        if (engineStatus === 'running') {
          return engineStatus = 'disabled';
        }
      },
      enable: function() {
        if (engineStatus === 'disabled') {
          return engineStatus = 'running';
        }
      }
    };
  })();

}).call(this);

//# sourceMappingURL=kotive_sync_engine.js.map


  Ember.run((function(_this) {
    return function() {
      return KotiveDB.available(function() {
        _this.KotiveWebapp = Ember.Application.create({
          LOG_TRANSITIONS: true
        });
        window.matchMedia = window.matchMedia || function() {
          return {
            matches: false,
            addListener: function() {},
            removeListener: function() {}
          };
        };


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  this.GenerateKotiveDBAdapter = function() {
    var generateId, getStoreName;
    getStoreName = function(type) {
      switch (type) {
        case KotiveWebapp.Group:
          return 'groups';
        case KotiveWebapp.User:
          return 'users';
        case KotiveWebapp.TemplateActivity:
          return 'template-activities';
        case KotiveWebapp.Workflow:
          return 'template-activities';
        case KotiveWebapp.TemplateField:
          return 'template-fields';
        case KotiveWebapp.TemplateActivityType:
          return 'template-activity-types';
        case KotiveWebapp.TemplateActivitySubType:
          return 'template-activity-sub-types';
        case KotiveWebapp.Condition:
          return 'conditions';
        case KotiveWebapp.Filter:
          return 'filters';
        case KotiveWebapp.Role:
          return 'roles';
        case KotiveWebapp.GroupRolesLink:
          return 'group-roles-links';
        case KotiveWebapp.TemplateActivityAuth:
          return 'template-activity-auths';
        default:
          throw new Error("Unknown model type received: " + type);
      }
    };
    generateId = KotiveDB.generateId;
    return DS.Adapter.extend({
      find: function(store, type, id, model, requestedId) {
        if (id != null) {
          return new Ember.RSVP.Promise((function(_this) {
            return function(resolve, reject) {
              var storeName;
              storeName = getStoreName(type);
              return KotiveDB.requestTransaction(storeName, 'readonly', function(error, transaction) {
                var objectstore, request;
                if (error != null) {
                  return reject(error);
                } else {
                  objectstore = transaction.objectStore(storeName);
                  request = objectstore.get(id);
                  request.onerror = function(event) {
                    return reject(event.error);
                  };
                  return request.onsuccess = function(event) {
                    var result;
                    result = request.result;
                    if (result != null) {
                      if (Object.keys(result).length === 2 && (result.references != null)) {
                        return _this.find(store, type, result.references, model, id).then(resolve, reject);
                      } else {
                        if (requestedId != null) {
                          result.actualId = result.id;
                          result.id = requestedId;
                        }
                        return resolve(result);
                      }
                    } else {
                      return resolve(null);
                    }
                  };
                }
              });
            };
          })(this));
        } else {
          return this.findAll(store, type);
        }
      },
      findAll: function(store, type, sinceToken) {
        return new Ember.RSVP.Promise((function(_this) {
          return function(resolve, reject) {
            var storeName;
            storeName = getStoreName(type);
            return KotiveDB.requestTransaction(storeName, 'readonly', function(error, transaction) {
              var cursorRequest, items, objectstore;
              if (error != null) {
                return reject(error);
              } else {
                objectstore = transaction.objectStore(storeName);
                items = [];
                transaction.oncomplete = function(event) {
                  return resolve(items);
                };
                cursorRequest = objectstore.openCursor();
                cursorRequest.onerror = function(error) {
                  return reject(error);
                };
                return cursorRequest.onsuccess = function(event) {
                  var cursor;
                  cursor = event.target.result;
                  if (cursor != null) {
                    if (!_this.referenceRecordData(cursor.value)) {
                      items.push(cursor.value);
                    }
                    return cursor["continue"]();
                  }
                };
              }
            });
          };
        })(this));
      },
      findQuery: function() {
        console.log(arguments);
        throw new Error('FINDQUERY IMPLEMENT!');
      },
      findMany: function(store, type, ids, parentModel) {
        return new Ember.RSVP.Promise((function(_this) {
          return function(resolve, reject) {
            var storeName;
            storeName = getStoreName(type);
            return KotiveDB.requestTransaction(storeName, 'readonly', function(error, transaction) {
              var cursorRequest, items, objectstore;
              if (error != null) {
                return reject(error);
              } else {
                objectstore = transaction.objectStore(storeName);
                items = [];
                transaction.oncomplete = function(event) {
                  return resolve(items);
                };
                cursorRequest = objectstore.openCursor();
                cursorRequest.onerror = function(error) {
                  return resolve(items);
                };
                return cursorRequest.onsuccess = function(event) {
                  var cursor, ref;
                  cursor = event.target.result;
                  if (cursor != null) {
                    if ((ref = cursor.value.id, indexOf.call(ids, ref) >= 0) && !_this.referenceRecordData(cursor.value)) {
                      items.push(cursor.value);
                    }
                    return cursor["continue"]();
                  }
                };
              }
            });
          };
        })(this));
      },
      createRecord: function(store, type, record) {
        return new Ember.RSVP.Promise((function(_this) {
          return function(resolve, reject) {
            var createdBy, data, storeName;
            data = _this.serialize(record, {
              includeId: true
            });
            storeName = getStoreName(type);
            if (data.id == null) {
              data.id = generateId();
            }
            createdBy = $.localStorage.get('user-email');
            if (createdBy != null) {
              data.createdBy = createdBy;
            }
            return KotiveDB.requestTransaction(storeName, 'readwrite', function(error, transaction) {
              var objectstore;
              if (error != null) {
                return reject(error);
              } else {
                objectstore = transaction.objectStore(storeName);
                transaction.oncomplete = function(event) {
                  return KotiveSyncEngine.created(storeName, data.id, data, function(err) {
                    if (err != null) {
                      console.log(err);
                    }
                    return resolve(data);
                  });
                };
                transaction.onerror = function(event) {
                  return reject(event.error);
                };
                return objectstore.add(data);
              }
            });
          };
        })(this));
      },
      updateRecord: function(store, type, record) {
        return new Ember.RSVP.Promise((function(_this) {
          return function(resolve, reject) {
            var data, storeName;
            data = _this.serialize(record, {
              includeId: true
            });
            storeName = getStoreName(type);
            return KotiveDB.requestTransaction(storeName, 'readwrite', function(error, transaction) {
              var objectstore, request;
              if (error != null) {
                return reject(error);
              } else {
                objectstore = transaction.objectStore(storeName);
                request = objectstore.put(data);
                request.onerror = function(event) {
                  return reject(event.error);
                };
                return request.onsuccess = function(event) {
                  return KotiveSyncEngine.updated(storeName, data.id, data, function(err) {
                    if (err != null) {
                      console.log(err);
                    }
                    return resolve(data);
                  });
                };
              }
            });
          };
        })(this));
      },
      deleteRecord: function(store, type, record) {
        return new Ember.RSVP.Promise((function(_this) {
          return function(resolve, reject) {
            var id, storeName;
            storeName = getStoreName(type);
            id = record.get('id');
            return KotiveDB.requestTransaction(storeName, 'readwrite', function(error, transaction) {
              var request;
              if (error != null) {
                return reject(error);
              } else {
                request = transaction.objectStore(storeName)["delete"](id);
                return request.onsuccess = function(event) {
                  var data;
                  data = _this.serialize(record, {
                    includeId: true
                  });
                  return KotiveSyncEngine.deleted(storeName, id, data, function(err) {
                    if (err != null) {
                      console.log(err);
                    }
                    return resolve();
                  });
                };
              }
            });
          };
        })(this));
      },
      referenceRecordData: function(data) {
        return Object.keys(data).length === 2 && (data.references != null);
      }
    });
  };

}).call(this);

//# sourceMappingURL=adapter_generator.js.map


(function() {
  this.KotiveServices = this.KotiveServices || {};

  this.KotiveServices.hashSums = {
    "woodpecker": {
      "services": {
        "add_a_prospect_to_campaign": "59bcc1c90224006bce9a159c65a1159961deb252",
        "add_a_prospect_to_prospects_list": "c1e7971b27a875999d5b021349b4b79a3a4357ea",
        "change_prospect_status_to_blacklist": "fd206ddcf092a51cbbcd991c7426a2b45534cd22",
        "edit_a_prospect": "3a265005c8e748275296f95da2f7806b51a0429f"
      },
      "hashSum": "d5e6b071c3a3310a72d588099f662797b285a86d"
    },
    "webhook": {
      "services": {
        "json": "d3e52e15963dbc3b922cd36ff447306b30a10284"
      },
      "hashSum": "4569f52d1632a522d62a6c97f7bd658ba009d5e5"
    },
    "verticalresponse": {
      "services": {
        "add_contact_to_list": "bf5a10dde39c9710ba8be923b9eac15524b2a602",
        "create_list": "4238ee101b0d777fc985a05b0414fb0a8b960fb5",
        "delete_list": "2d44965a87740e78c278e1540ef72fa8bf0be295",
        "get_list": "dce094ff0aef8d3fda59866bc5dd207ff8fc4eab",
        "remove_contact_from_list": "3d34aa8d7857fb90ddb841a49694aa4765b44d9d",
        "update_list": "eebbe6ed9c638861977707cdf20ec1d50b933044"
      },
      "hashSum": "cd9f49ed31760513fdf22f6b2afb6c485d0fe783"
    },
    "twilio": {
      "services": {
        "send_sms": "f4b29c2b18e41b13adc43e9ec4007006ea67a402"
      },
      "hashSum": "ecdfd07924572d2982c41dee90d0412a142e8fd5"
    },
    "trello": {
      "services": {
        "add_members": "96a4ef7d77c677309d35047ec1d28a303379277a",
        "list_cards": "301bcdc1cf2cad948a1fd76dcc71f1135b9a709a",
        "new_card": "300ba547ea168daab0a2701e6d90d7e31e7ed789",
        "new_comment": "cc3abc88b04f168d903a64baffdb11dff3224b89",
        "update_card": "b1c231d20e9c1293a3bab88e2f0b716ea0be3512"
      },
      "hashSum": "6236e701d33a398192e78a88136662be3dd3e235"
    },
    "textutilities": {
      "services": {
        "find_and_replace": "4de18920160cc33e3d37debab892535f83f96470",
        "find_and_replace_map": "1433f28c5e6f6c0f763ca3aaf3e8449f584f0ed0",
        "replace_string_for_each_item_in_list": "252017121221596a2b5c2beac625f345afbdca71"
      },
      "hashSum": "0ad2a6642ffc645f29e8790af34e34fc0f3425b9"
    },
    "talentlms": {
      "services": {
        "signup_user_to_courses": "5bf0ae4bfd5e48e9261b9a8dc7307d10e3604668"
      },
      "hashSum": "642873a90b2ed27343ce654a838098647fdabb98"
    },
    "stripe": {
      "services": {
        "capture_charge": "a5ddd15709819304bc8526dfad0400f6717c47d0",
        "create_new_charge": "1128ebc930e817bd8754bcbb697ffcf87362a094"
      },
      "hashSum": "e52c0b1391c73c51885b137727b9e95d318ec3f0"
    },
    "sparkpost": {
      "services": {
        "send_email": "d43bf5a0f7eddb1635744fa777aca3622d7c10cd",
        "send_email_with_attachment": "4b2694c8f05cec746981212a8757a191e3fe9116",
        "send_email_with_substitution_data": "a6eaf6b895f70b0d9e19bdc299cd0e7069831407"
      },
      "hashSum": "c5b0b95cf647c2f075cd10943f73830866f07a7d"
    },
    "sms": {
      "services": {
        "send_message": "489d745224314c3288c1377637d8b3eed5677641"
      },
      "hashSum": "b7c5b66cf60465ea7259419629fbf32d7c00338e"
    },
    "slack": {
      "services": {
        "send_message": "fda07a90b5abf3d643a38010a2c8d06fd981e9a8"
      },
      "hashSum": "5dbcd3c4d792dd3f6650d1bc8a92ff7ecc8c5d86"
    },
    "shippo": {
      "services": {
        "create_shipment_label": "1c954e309a1f66b96a5d214e3a5c488e94300dcb",
        "retrieve_rates": "e6983df79e1295a46a92e56e82fd5bf0f01175ac",
        "track_shipment_status": "fc95e0de403a080f32820db66646a3e3ad95635b"
      },
      "hashSum": "8be592bfc7cfce5d15bf21c92832ee9f4dad4f1a"
    },
    "sendy": {
      "services": {
        "subscribe": "6cd6196f2b52eca7111a3f04bf70c617d07ac775"
      },
      "hashSum": "2fe4e1700b1fb3f714d85e66b360115fd92e28c2"
    },
    "sendgrid": {
      "services": {
        "send_email": "25dc05e11eb3aa43a098b6b59d51902ddb79f42d"
      },
      "hashSum": "126123829723692e70d510611940f782402388ce"
    },
    "segment": {
      "services": {
        "alias": "4bb8915ff22440a135b700b7110e67fc9fac2089",
        "group": "a526477f94e396981e64c084d182deed9d22189a",
        "identify": "d07061f6f4f85f196c87641df7294d2e195ca43d",
        "page": "8587144781bd5f26c5942632fde1323e972c78d4",
        "screen": "5080fc5d78453231e531e059735627c7c6cc113d",
        "track": "b0b4c632e008dbcb631109ff7c48dad84ba60d27"
      },
      "hashSum": "66f9d408ca8ce3c3599130336e1c60ec12fb9970"
    },
    "salesforce": {
      "services": {
        "create_record": "ded31a22b8b4af15b14896681ac1151b292c5d2c"
      },
      "hashSum": "c4e87e645577c3c73fa4e493d6bebe52c5e475f4"
    },
    "reply": {
      "services": {
        "add_person_and_push_to_campaign": "4cb9d2fae299d9427ec1d5aac12ef1d31478e1ea",
        "mark_person_as_replied": "da52f15d4f6f167bb0df8680e058f6cc680000e4",
        "push_person_to_campaign": "f0766212c1f080fbbfd17f9e0f39780adf1d0619",
        "remove_person_from_all_campaigns": "a57e1a04a5209d75a6efa85de45059273ab885f2",
        "remove_person_from_campaign_by_id": "fb1901c027665f5e428f01b220c441e9a4fdee2e"
      },
      "hashSum": "e480b3f463cf951ded198646b80cdd1181f2da42"
    },
    "postmark": {
      "services": {
        "send_transactional_email": "b35cc8bfcaa881bb97deb235b36f6c1879aae5aa"
      },
      "hashSum": "4f5e4569e1ca8d24d3892a7cf23d7a87b6ca74aa"
    },
    "pdf": {
      "services": {
        "new_document": "79279891af7f9366d3fc7e4875f16ab78f5460ab"
      },
      "hashSum": "6a18d7e2b4b9ee70b6580b4f687e57571b77fc40"
    },
    "payfast": {
      "services": {
        "form": "4a98b29a0e3c8f50eef004a2c80e290161d7025c"
      },
      "hashSum": "1ff5b34efdcae0703614fdd6bfdab6133248ea32"
    },
    "numverify": {
      "services": {
        "validate_phone_number": "2f8f11f135bb5b1f3a0a3235e61ac0777e8dc7e4"
      },
      "hashSum": "02d9b30e8b30615d6b075ad091d172cf78908a2b"
    },
    "mixpanel": {
      "services": {
        "store_user": "92dada9a3e61764c45f8e97917432ef58eeadc97",
        "track_events": "f626fc6f986e37c4f1106b95ae632520990d2308",
        "track_revenue": "411d582887d6ddb8545a91022b1f595b1145114c"
      },
      "hashSum": "cd2126ddd4fe31ed912db903db458d8f92dde91a"
    },
    "mandrill": {
      "services": {
        "send_email": "3dd6abb11e7f9bde8ea03c533ec1e9cd105e4294"
      },
      "hashSum": "00881ab1f92b1c560df583b0b410557fe4971998"
    },
    "makelearningflow": {
      "services": {
        "calculate": "463c046c7c2e928871603afab66cead0610af795",
        "certificate": "40316a2e988768ea4d0d98a23f9d1b1df804ae7a",
        "progress": "e508d7a7f9f514c28fad4f02dbffa162a92d74cf",
        "signup": "b441f1a238a3643ec7edaeb7ddfc990650eda138"
      },
      "hashSum": "1e3118b69e588ad3725ef100e2da67628c6db329"
    },
    "mailchimp": {
      "services": {
        "add_or_update_list_member": "79337f4d4b1f69d55c5f66c7f2c9ab8495c8b94d"
      },
      "hashSum": "2a8b06f44cc2e0c3448bb9ba00b69a946a628987"
    },
    "mailboxlayer": {
      "services": {
        "validate_email_address": "5ddcc6a1e04924643e40fde5781e13e0543b44c1"
      },
      "hashSum": "8435f2ed0ee27338e6d8a224deb043fa948d0486"
    },
    "kotive": {
      "services": {
        "bespoke_tasks": "2decf4e0572e7874ff0f067464cb86c8e85fd2f9",
        "contacts_add_or_update": "fdc2dce423de205bd950316cadd86b7ee5ce834d",
        "messages_send_to_roles": "7903c9a0d8febeaa5859ddaf1507b43528309907",
        "messages_send_to_tagged_and_roles": "0294b2989d479d9d8ceef88c04d77344c55ed789",
        "messages_send_to_users": "7dd9752e2dd78a8caee89e8d653e8ad0d6156ba4",
        "reactivate_or_deactivate_tasks": "47df0be03214999b3c0923bcb88afa35b95661c7",
        "referral_create": "73c17d7522b5177e89dc824b683e3ebddd98d185",
        "referral_redeem": "d540b27136ff09f127491c887110c01c4c28b8bc",
        "start_workflow": "1942335e87d66af5b0c13259b10661719494d5c8",
        "tags_group": "dcffbecfbdd817baa9e772552f6fa28bec4ae211",
        "tags_person_contact": "91c47ca1c97d45a95593b10440686e68823d3248",
        "tags_workflow": "8367688c8038aa4262b78bdb961cc561667df7af",
        "todos_assign_to_roles": "3adfd711a90818cc814d0092b24493901c6adb64",
        "todos_assign_to_users": "7f42e508a808c969ae2a90b83df486ce8c58ec66",
        "users_add": "d72d2b7fd6cba212d0daae53e8a02e597453680b"
      },
      "hashSum": "24f0a72ac7db17ffaefbbf31e51880cf168a12a6"
    },
    "kissmetrics": {
      "services": {
        "alias_user": "0352b4b2c13534518109263a72b0e09fab42c3ae"
      },
      "hashSum": "e16ecc8b7ee36efa67ea1655f94c573977ee84bb"
    },
    "intercom": {
      "services": {
        "submit_event": "c93aba9da2e1fa8104a847b2b64d4b2d206cac02"
      },
      "hashSum": "d6e94521fa940bae4ac2fb281067b61965993e62"
    },
    "ibmwatson": {
      "services": {
        "ask_question": "a924ea27d5ec74f9e7af5916e629156cdd4f9821"
      },
      "hashSum": "3a8e0c49320e02de7dcba8dbc4fb7bffa346b903"
    },
    "hunter": {
      "services": {
        "domain_search": "2053e3b20283c4cd8278e2f507d53167e09812a9",
        "email_count": "87c269954a5eea37fc84c4e9f817240164a2be57",
        "email_finder": "c0e7ed6f534319598e94b9a663d8bcb232f451d1",
        "email_verifier": "4121e4dcd337db4d16b9e5add263bd873632506f"
      },
      "hashSum": "2c93820ffd3affe333f338f1e3b6395c8315550d"
    },
    "hipchat": {
      "services": {
        "new_message": "c38916e2537b9cc00923440466b0696d4bdfc6d7"
      },
      "hashSum": "76c760e326b860dd18b3c9d456b8688c5dbf0de6"
    },
    "hellosign": {
      "services": {
        "create_embedded_with_template": "4b2078c9eeaa2e1fd5bafa511c52b9aa2d9e8e5a"
      },
      "hashSum": "4ef65101ecc491e5dda6684814b74c17a0918643"
    },
    "hackernews": {
      "services": {
        "get_item": "9f0c0b6ee860de52d61eac77f0a39999a61211ca"
      },
      "hashSum": "1a278d6235860a095554d19a790f3246d9229660"
    },
    "googlesheets4": {
      "services": {
        "values_append": "41db17a9834ff2c0f0c6bb9a8d2323b34ce5d033"
      },
      "hashSum": "e742eb553d9a2890ae1d5969cb441baf56d8382f"
    },
    "googledrive3": {
      "services": {
        "copy_file": "97688675f0ac66d3c3a5291c8c5cdcc1426123f0",
        "delete_file": "fa4a83f58ce7d92b0e38a4624ab82a3c33613f74",
        "export_file": "fd1acfd34b60bde20455cccb86c980b01af81593"
      },
      "hashSum": "b09d08bedea10ec53ecfa8c57859b0e8cb7c12b7"
    },
    "googlecontacts": {
      "services": {
        "add_contact": "0cab147e1c7b55800a9825c46689c693e900ee72"
      },
      "hashSum": "83d513dc2711ec5c079f9147d0efd0afb1ad80e9"
    },
    "googlecalendar": {
      "services": {
        "delete_event": "35c29c355cfdc3dcf37e1b7add086b49e4e51ada",
        "get_event": "0cca23bb1bd264673fd151b589c7830cd38b51e7",
        "insert_event": "c4a961a2366d3e8cb699a2f6c377bbc68bdf6064",
        "quick_add_event": "ed32cf7273e48a378d4852ed28634adb5bebbed2",
        "update_event": "5c7f269940fbd24eff5b0cb835b2aafd36dd0837"
      },
      "hashSum": "1b03dcfb6a629378ad5ab8ca7cd2e21d545d485c"
    },
    "googleanalytics": {
      "services": {
        "track_event": "380333174b36399939c990aee6ac8fe87164a28d",
        "track_page": "579c17d62cf292a9d72baf0a00fb0244c805d6ee"
      },
      "hashSum": "2229c3ebb93aa9c910e11d0a7c158fdf893002c7"
    },
    "github": {
      "services": {
        "create_issue": "cc2a739ed60351e617f6fe88c55a97641399fb3b",
        "create_pull_request": "ef69fb0fc41570ed54424d6f0ffd7d2c7b9b85b4",
        "edit_issue": "1d6e9a9802f08fab18608299585713f20865b5fc",
        "get_issue": "05c19c55acd8fad86858d038bf472b8c20733c9b",
        "get_pull_request": "45077daaa035248fcca36371d78e40acad62c329",
        "update_pull_request": "c2f2cf9cf1d2930b72a4ca631824c3db653ffe61"
      },
      "hashSum": "b7e4ab208b412fa44672c7a77f36c183efb0c6c3"
    },
    "freshbooks": {
      "services": {
        "create_invoice": "ca75240b19902208adfadfeba03588867d39515b",
        "delete_invoice": "6c4276dd95cf4b88efd497d34fe71ef4ca1f6a94",
        "get_invoice": "81c2d2b2063a2420ad620493074e7f3d14daaa27",
        "line_add_invoice": "f3130b223f57a342d593d8aaedbb0fd6c4e24b85",
        "line_delete_invoice": "822f48fadec252a7006e42cdd9dd95fd6623ea0e",
        "line_update_invoice ": "2b00cf900fbcf4acb99ebe05a997798a1aa9f878",
        "list_invoice": "90f867635c0cefb717a895a0e2a0c2f3666d6147",
        "sent_invoice_by_email": "23a2b4a18aa319bc5fefb5b757ee78a3ce95d47f",
        "sent_invoice_by_snail_mail": "46162efe7e15ff2783c626b602d3196fc3f93201",
        "update_invoice": "a601eaafde5dab842b8d827e71d965cb41dfa469"
      },
      "hashSum": "c4c86f72014f13df03a00d9b60a2bc7fa3a3934d"
    },
    "fixer": {
      "services": {
        "base_specific_currencies": "203d1b9fca7c797ba90bf419c0dc17b0d4ecfb88",
        "choose_base_currency": "ffc44dc6b14b3b8e0e7f8ef0fdb0b7b569f5e42c",
        "get_forex_rates": "61ba10ec2a35eb018dc5cd72b5fb445124ae31e9",
        "get_historical_rates": "127d9773bb828073828767926d8e3d409b8ecf1c",
        "specific_currencies": "5ad122dd0b41dc6ef8f5c802306010ad2439579d"
      },
      "hashSum": "ca82782cf27afa5869dff7f09d7215d5c3c6e818"
    },
    "email": {
      "services": {
        "send_email": "f1be1e44d54b9d095364d75630e1f7cdfbf1d6a6"
      },
      "hashSum": "8806a7087e89a547d57754a641da43330fd360b7"
    },
    "docraptor": {
      "services": {
        "new_document": "0914bf2d33f2b57e93e2e41d72ad554ab6cba5b6"
      },
      "hashSum": "da4b61f85bf5e186360c1fe4f0c5f9cc3b42dd80"
    },
    "desk": {
      "services": {
        "show_user": "8ab6b1b2bc7dc2a7e3e48a971fa4e021205fa5fc"
      },
      "hashSum": "4bb13c3edcd56ca610f822d3ac00a1d4b126fb4e"
    },
    "dateutilities": {
      "services": {
        "convert_date": "479e8d5d1732cb3f22447d8d9d20b3e249b6a3cf",
        "convert_dates": "7cfcb0699aa99ea990759b242413f8323dfee7ba",
        "convert_dates_in_text": "fd7916dcf282af4ec5420e16e4d86a4a60703e8b"
      },
      "hashSum": "0b8156e1d8eb09cded1708e72bf40cb0d4b73778"
    },
    "currencylayer": {
      "services": {
        "change_currencies_in_specific_time_frame": "497dd0c82197a08a7c4252726f3d998c576dc4e8",
        "convert_currency": "8d105f1746cce6406331dfb4e2c87a47baf5ed12",
        "convert_currency_using_historical_rates": "e5bd9a02ad1ec37310194699b01e65b9145d1830",
        "get_exchange_rates_for_time_frame": "5dad3fd427eab79e0d93ee3cc5775879971a251d",
        "get_exchange_rates_in_real_time": "260eda2350c77ec80eeaff129d6a72c887f109d1",
        "get_historical_rates": "4606205a091ac1de3315a52b6fbe8735c9c70356",
        "switch_source_currency": "188aa3aceee7414e89b47e7afa05f1bdd8eeed3d"
      },
      "hashSum": "437bdb24d0e22a1a0db3ae06ae543f5f8d0681ae"
    },
    "constantcontact": {
      "services": {
        "create_contact_list": "ab2d41da0934f10150228141fa4ee2abae45be29",
        "delete_contact_list": "769d760f6de089b0d22a1d0876f51d6939b8dbd6",
        "get_contact_list": "1c626040dc1c01b71a77f633b922a271af2949ac",
        "update_contact_list": "4f2d7e7d7efe462c8eb89d2087c49daff1529c56"
      },
      "hashSum": "4f22f118738e54059e072c1118515fb183514d09"
    },
    "clickatell": {
      "services": {
        "send_message": "f366bc5c4e0d3c155a12779b80a2063d1d9b3d70"
      },
      "hashSum": "748f87662ad98e54d75d5e887a026e0f005f7a13"
    },
    "campaignmonitor": {
      "services": {
        "add_new_subscriber": "9db192537d5eaba7817b758c9ce7d7f0660f9aad",
        "delete_subscriber": "37909e15aca4704868e2c1f7a34a56d5bb23b088",
        "get_statistics_for_lists": "b9db4a5e95fa899c8de2ad6a0070f12e2b879a1d",
        "get_subscribers_details": "88cb83dcee0ed3278fa19d7f1c214b94c81a566f",
        "get_subscribers_history": "504f2fc6098b686cec3105a3f16aeefc50b07f38",
        "send_smart_email": "c45c0cd7deb1d4071f6d4e542f669d3c61a9d164",
        "unsubscribe_subscriber": "bdcafa4b7b0eee53bc63fc100a639d3ebf360b03",
        "update_subscriber": "d346ebace5b3103105a9b40471bf5ebc6887cdc8"
      },
      "hashSum": "23303aceffd9b31ae3761d748daa1510c61c89d2"
    },
    "calculator": {
      "services": {
        "expression": "8ccab4a5ffc9e4d700fd96b206fd61d575cea74a",
        "random": "363276680aa010769ab3a40ca7bbdb2709f461ab"
      },
      "hashSum": "f33ccb032abde909fb74dbfd7bd1922ad109dc4c"
    },
    "bulksms": {
      "services": {
        "send_repliable_sms": "8f3c0b0cb6571e3248e413a1b4bdefb1b8ced5e5",
        "send_sms": "460c6ff6df6dc4a66d996ff59b0d799ded108df3"
      },
      "hashSum": "9629ffd07ef2a5edb4f5522e34794f1c616731b2"
    },
    "basecamp2": {
      "services": {
        "send_message": "b44f1a01ee342df6f98d266515a45b3d17b24487"
      },
      "hashSum": "2e8194f1ccd194534bc83e87840e03d678aed26f"
    },
    "aweber": {
      "services": {
        "create_list": "23efb9359fd524408a41d1501179a79de32042f4",
        "find_list": "b8b566f747da4510f0afa6cc6547d39375f5e856"
      },
      "hashSum": "485a85896500eebe2f56b8b01a31e92f4b2f1502"
    },
    "asana": {
      "services": {
        "create_new_task": "4fe9a35a8c6e920ad6d4760901eca7fa09bebe6a"
      },
      "hashSum": "6442d3e7ed4a40283c52d99a5ddf5324bb23775f"
    },
    "amplitude": {
      "services": {
        "event": "08637e30a4f1a49e82dddaf8e6093ca6bed271a3"
      },
      "hashSum": "11fc9fe208e344a99a96819c6b2fa6eb2cf16329"
    }
  };

}).call(this);

//# sourceMappingURL=kotive-services-hashsums.js.map


(function() {
  KotiveWebapp.RESTAdapter = DS.RESTAdapter.extend({
    namespace: 'api',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    ajax: function(url, type, hash) {
      var ref, refactoredHash, refactoredUrl;
      this.setupAuthHeaders();
      ref = this.correctUrl(url, hash), refactoredUrl = ref[0], refactoredHash = ref[1];
      return this._super(refactoredUrl, type, refactoredHash);
    },
    correctUrl: function(url, hash) {
      var ref;
      if ((hash != null ? (ref = hash.data) != null ? ref.groupId : void 0 : void 0) != null) {
        url = url.replace(/^\/api/, "/api/group/" + hash.data.groupId);
        delete hash.data.groupId;
        return [url, hash];
      } else {
        return [url, hash];
      }
    },
    setupAuthHeaders: function() {
      var authToken, hash, token, userEmail;
      userEmail = $.localStorage.get('user-email');
      authToken = $.localStorage.get('auth-token');
      if ((userEmail != null) && (authToken != null)) {
        token = userEmail + ":" + authToken;
        hash = btoa(token);
        return this.headers['Authorization'] = "Basic " + hash;
      } else {
        if (this.headers['Authorization'] != null) {
          return delete this.headers['Authorization'];
        }
      }
    }
  });

}).call(this);

//# sourceMappingURL=kotive_rest_adapter.js.map


(function() {
  KotiveDB.available((function(_this) {
    return function(available) {
      if (available) {
        return _this.KotiveWebappAdapter = GenerateKotiveDBAdapter();
      } else {
        alert('PLEASE NOTE: your browser does not support data storage. All components should work correctly, but we will not be able to save any of your work in the browser.');
        return _this.KotiveWebappAdapter = DS.FixtureAdapter.extend({
          serializer: (function() {
            return null;
          }).property()
        });
      }
    };
  })(this));

}).call(this);

//# sourceMappingURL=kotive_webapp_adapter.js.map


(function() {
  Array.prototype.flatMap = function(lambda) {
    return Array.prototype.concat.apply([], this.map(lambda));
  };

}).call(this);

//# sourceMappingURL=array_flatmap.js.map


(function() {
  $(function() {
    return $.fn.dataTableExt.sErrMode = "console";
  });

}).call(this);

//# sourceMappingURL=datatables_alert_suppress.js.map


(function() {
  Ember.View.reopen({
    didInsertElement: function() {
      this._super();
      return Ember.run.scheduleOnce('afterRender', this, this.afterRenderOnceCalled);
    },
    afterRenderOnceCalled: function() {
      this.afterRenderEvent(arguments);
      return Ember.run.schedule('afterRender', this, this.afterRerenderEvent);
    },
    afterRenderEvent: function() {},
    afterRerenderEvent: function() {}
  });

}).call(this);

//# sourceMappingURL=ember_view_extensions.js.map


(function() {
  this.KotiveAppUpdater = (function() {
    var currentVersion, doWebappVersionChecks, ensureAppVersionSet, fetchUpdatesData, getLatestUpdateInfo, isFirefox, updateReadyListeners, updateRequiredType;
    currentVersion = null;
    updateRequiredType = null;
    updateReadyListeners = [];
    isFirefox = /firefox/i.test(navigator.userAgent);
    ensureAppVersionSet = function() {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        var versionIdentifier;
        versionIdentifier = $.localStorage.get('app-version-identifier');
        if (versionIdentifier != null) {
          currentVersion = versionIdentifier.toString();
          return resolve();
        } else {
          return fetchUpdatesData().then(function(data) {
            currentVersion = data.updates[data.updates.length - 1].identifier;
            $.localStorage.set('app-version-identifier', currentVersion);
            return resolve();
          }, reject);
        }
      });
    };
    getLatestUpdateInfo = function() {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return fetchUpdatesData().then(function(data) {
          var latest, match, newVersion, updateType;
          if (currentVersion != null) {
            newVersion = null;
            updateType = 'minor';
            match = false;
            data.updates.forEach(function(upd) {
              if (match) {
                newVersion = upd.identifier;
                if (updateType !== 'major') {
                  return updateType = upd.type;
                }
              } else if (upd.identifier === currentVersion) {
                return match = true;
              }
            });
            return resolve([newVersion, updateType]);
          } else {
            latest = data.updates.pop();
            return resolve([latest.identifier, latest.type]);
          }
        }, reject);
      });
    };
    fetchUpdatesData = function() {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return $.ajax({
          url: '/scripts/webapp-updates.json',
          type: 'GET',
          cache: false,
          dataType: 'json',
          success: function(data, textStatus, jqXHR) {
            return resolve(data);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            var error;
            error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
            return reject(error);
          }
        });
      });
    };
    doWebappVersionChecks = function() {
      var checkInterval, currentlyOnline, doCheck;
      currentlyOnline = true;
      checkInterval = KotiveWebappConfigs.webappUpdatesCheckInterval * 1000;
      document.addEventListener('KotiveWebapp:offline', function() {
        return currentlyOnline = false;
      });
      document.addEventListener('KotiveWebapp:online', function() {
        return currentlyOnline = true;
      });
      doCheck = function() {
        return setTimeout(function() {
          if (currentlyOnline) {
            return getLatestUpdateInfo().then(function(data) {
              var updateType, version;
              version = data[0], updateType = data[1];
              if ((version != null) && version !== currentVersion) {
                $.localStorage.set('app-version-identifier', version);
                currentVersion = version;
                updateRequiredType = updateType;
                updateReadyListeners.forEach(function(fn) {
                  return fn(updateType);
                });
              }
              return doCheck();
            }, function(err) {
              console.error(err);
              return doCheck();
            });
          } else {
            return doCheck();
          }
        }, checkInterval);
      };
      return doCheck();
    };
    $(function() {
      return ensureAppVersionSet().then(function() {
        if (isFirefox) {
          return doWebappVersionChecks();
        } else {
          appCacheNanny.on('updateready', function() {
            return getLatestUpdateInfo().then(function(data) {
              var updateType, version;
              version = data[0], updateType = data[1];
              if (version != null) {
                $.localStorage.set('app-version-identifier', version);
                currentVersion = version;
              }
              if (updateType != null) {
                updateRequiredType = updateType;
                return updateReadyListeners.forEach(function(fn) {
                  return fn(updateType);
                });
              } else {
                return updateReadyListeners.forEach(function(fn) {
                  return fn('minor');
                });
              }
            }, function(err) {
              console.log('UNABLE TO RUN UPDATE CHECKS');
              return console.error(err);
            });
          });
          return appCacheNanny.start({
            checkInterval: KotiveWebappConfigs.checkForUpdates * 1000,
            offlineCheckInterval: 300000
          });
        }
      }, function(err) {
        console.log('!! Unable to start up app updater service !!');
        return console.error(err);
      });
    });
    return {
      addUpdateReadyListener: function(fn) {
        updateReadyListeners.pushObject(fn);
        if (updateRequiredType != null) {
          return fn(updateRequiredType);
        }
      }
    };
  })();

}).call(this);

//# sourceMappingURL=kotive_app_updater.js.map


(function() {
  var KotiveCheck,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveCheck = Ember.Component.extend({
    tagName: 'input',
    type: 'checkbox',
    attributeBindings: ['type', 'value', 'action', 'disabled', 'checkedVals', 'checked:checked', 'actionsTo'],
    checked: (function() {
      var ref;
      return (this.get('checkedVals') != null) && (ref = this.get('value'), indexOf.call(this.get('checkedVals'), ref) >= 0);
    }).property('value', 'checkedVals', 'checkedVals.@each'),
    sendTarget: (function() {
      return this.get('actionsTo') || this.get('parentView').get('controller');
    }).property('actionsTo'),
    change: function() {
      var checkedVals, value;
      if (this.get('checkedVals') == null) {
        this.set('checkedVals', []);
      }
      this.set('checked', !this.get('checked'));
      value = this.get('value');
      checkedVals = this.get('checkedVals');
      if (this.get('checked') && checkedVals) {
        if (!this.valueAlreadyPresent(value)) {
          checkedVals.pushObject(value);
        }
      } else {
        this.set('checkedVals', this.getFilteredValues(value));
      }
      if (this.get('action')) {
        return this.sendActionEvent();
      }
    },
    getFilteredValues: function(value) {
      return _.filter(this.get('checkedVals'), function(val) {
        return val !== value;
      });
    },
    valueAlreadyPresent: function(value) {
      var checkedVals;
      checkedVals = this.get('checkedVals');
      return _.any(checkedVals, function(val) {
        return val === value;
      });
    },
    sendActionEvent: function() {
      return this.get('sendTarget').send(this.get('action'), this.get('checkedVals'));
    }
  });

  Ember.Handlebars.helper('kotive-check', KotiveCheck);

}).call(this);

//# sourceMappingURL=kotive_check_handlebars_helper.js.map


(function() {
  Ember.Handlebars.helper('kotive-option-helper', function(option, selectedVal, options) {
    var makeSafe, optionString;
    if (selectedVal == null) {
      selectedVal = null;
    }
    makeSafe = function(string) {
      return string.replace(/\'/g, "\\'");
    };
    optionString = "<option value='" + (makeSafe(option.key)) + "'";
    if (option.key === selectedVal) {
      optionString += " selected";
    }
    optionString += ">" + option.value + "</option>";
    return new Ember.Handlebars.SafeString(optionString);
  });

}).call(this);

//# sourceMappingURL=kotive_select_options_helper.js.map


(function() {
  String.prototype.nthOccurrenceIndex = function(charToMatch, occurrenceIndex) {
    var char, i, index, len, matches;
    matches = 0;
    index = 0;
    for (i = 0, len = this.length; i < len; i++) {
      char = this[i];
      if (char === charToMatch) {
        matches += 1;
        if (matches === occurrenceIndex) {
          return index;
        }
      }
      index += 1;
    }
    return -1;
  };

}).call(this);

//# sourceMappingURL=nth_occurrence_string_monkeypatch.js.map


(function() {
  Ember.debouncedObserver = function(func, key, time) {
    return Em.observer((function() {
      Em.run.debounce(this, func, time);
    }), key);
  };

  Ember.throttledObserver = function(func, key, time) {
    return Em.observer((function() {
      Em.run.throttle(this, func, time);
    }), key);
  };

}).call(this);

//# sourceMappingURL=observer_utils.js.map


(function() {
  $(function() {
    var connectTimeout, dispatchOfflineEvent, dispatchOnlineEvent, executeCheck, offlineCheckInterval, onlineCheckInterval, scheduleCheck;
    onlineCheckInterval = KotiveWebappConfigs.onlineCheckInterval * 1000;
    offlineCheckInterval = KotiveWebappConfigs.offlineCheckInterval * 1000;
    connectTimeout = KotiveWebappConfigs.onlineConnectTimeout * 1000;
    dispatchOnlineEvent = function() {
      var event;
      event = new CustomEvent('KotiveWebapp:online', {
        detail: {
          message: 'Kotive API reachable, app marked as online',
          time: new Date()
        },
        bubbles: true,
        cancelable: true
      });
      return document.dispatchEvent(event);
    };
    dispatchOfflineEvent = function() {
      var event;
      event = new CustomEvent('KotiveWebapp:offline', {
        detail: {
          message: 'Kotive API unreachable, app marked as offline',
          time: new Date()
        },
        bubbles: true,
        cancelable: true
      });
      return document.dispatchEvent(event);
    };
    scheduleCheck = function() {
      var timeout;
      timeout = KotiveWebappConfigs.webappOnline ? onlineCheckInterval : offlineCheckInterval;
      return setTimeout(function() {
        return executeCheck();
      }, timeout);
    };
    executeCheck = function() {
      var error;
      try {
        return $.ajax({
          url: '/api/areyouthere',
          type: 'get',
          cache: false,
          timeout: connectTimeout,
          success: function() {
            if (KotiveWebappConfigs.webappOnline == null) {
              KotiveWebappConfigs.webappOnline = true;
            } else if (KotiveWebappConfigs.webappOnline !== true) {
              KotiveWebappConfigs.webappOnline = true;
            }
            dispatchOnlineEvent();
            return scheduleCheck();
          },
          error: function(jqXHR, textStatus, errorThrown) {
            if (KotiveWebappConfigs.webappOnline !== false) {
              KotiveWebappConfigs.webappOnline = false;
              dispatchOfflineEvent();
            }
            return scheduleCheck();
          }
        });
      } catch (_error) {
        error = _error;
        return scheduleCheck();
      }
    };
    return setTimeout(executeCheck, 3000);
  });

}).call(this);

//# sourceMappingURL=online_status_checker.js.map


(function() {
  $.extend({
    getUrlVars: function() {
      var hash, hashes, i, len, val, vars;
      vars = {};
      hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (i = 0, len = hashes.length; i < len; i++) {
        val = hashes[i];
        hash = val.split('=');
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    getUrlVar: function(name) {
      return this.getUrlVars()[name];
    }
  });

}).call(this);

//# sourceMappingURL=query_params_extension.js.map


(function() {
  var RadioButton;

  RadioButton = Ember.Component.extend({
    tagName: 'input',
    type: 'radio',
    attributeBindings: ['name', 'type', 'disabled', 'value', 'checked:checked'],
    click: function() {
      return this.set('selection', this.$().val());
    },
    checked: (function() {
      return this.get('value') === this.get('selection');
    }).property('selection')
  });

  Ember.Handlebars.helper('radio-button', RadioButton);

}).call(this);

//# sourceMappingURL=radio_button_handlebars_helper.js.map


(function() {
  Ember.Handlebars.registerBoundHelper("show-error", function(key, field_error) {
    var error, html;
    console.log(key);
    console.log(field_error);
    console.log(field_error.length);
    if (field_error && field_error.length > 0) {
      error = field_error[0];
      $('.alert.alert-warning').show();
      html = "";
      html += "<p>";
      html += key.capitalize() + " " + error;
      html += "</p>";
      return html.htmlSafe();
    } else {
      html = "";
      html += "<p></p>";
      html.htmlSafe();
      return $('.alert.alert-warning').hide();
    }
  });

  Ember.Handlebars.registerBoundHelper("show-errors", function(errors) {
    var html, keys;
    html = "";
    console.log('show-errors helper...');
    console.log(errors);
    console.log(Ember.keys(errors));
    html += "<div class='alert alert-warning'>";
    keys = Ember.keys(errors);
    keys.forEach(function(k) {
      console.log(k + " - " + errors[k]);
      if (errors[k].length > 0) {
        html += "<p>";
        html += k.capitalize() + " " + errors[k];
        return html += "</p>";
      }
    });
    html += "</div>";
    return html.htmlSafe();
  });

}).call(this);

//# sourceMappingURL=show_errors.js.map


(function() {
  String.prototype.replaceAll = function(str1, str2, ignoreCase) {
    var flags, regex;
    flags = ignoreCase ? 'mgi' : 'mg';
    regex = new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/mg, "\\$&"), flags);
    return this.replace(regex, str2);
  };

}).call(this);

//# sourceMappingURL=string_replace_all.js.map


(function() {
  KotiveWebapp.HashobjectTransform = DS.Transform.extend({
    deserialize: function(data) {
      return data;
    },
    serialize: function(data) {
      return data;
    }
  });

}).call(this);

//# sourceMappingURL=kotive_hashobject_transform.js.map


(function() {
  KotiveWebapp.KotiveStyleTransform = DS.Transform.extend({
    deserialize: function(dataString) {
      var data;
      data = JSON.parse(dataString);
      return KotiveWebapp.KotiveStyleTransform.setupStyleObject(data);
    },
    serialize: function(data) {
      var i, key, len, ref;
      ref = ['hasChanges', 'set', 'setFromService'];
      for (i = 0, len = ref.length; i < len; i++) {
        key = ref[i];
        delete data[key];
      }
      return JSON.stringify(data);
    }
  });

  KotiveWebapp.KotiveStyleTransform.setupStyleObject = function(style) {
    style.hasChanges = false;
    style.set = function(key, value) {
      if ((this[key] == null) || value !== this[key]) {
        Ember.set(this, 'hasChanges', true);
      }
      Ember.set(this, key, value);
      if (key === 'kind' && (this.classes == null) && value === 'submit') {
        Ember.set(this, 'classes', 'btn btn-align-right');
        return Ember.set(this, 'hasChanges', true);
      }
    };
    style.setFromService = function(fieldData) {
      this.set('kind', fieldData.properties.fieldType);
      if (fieldData.properties.classes != null) {
        this.set('classes', fieldData.properties.classes);
      }
      if (fieldData.properties.helptext != null) {
        this.set('helptext', fieldData.properties.helptext);
      }
      this.set('parameter', fieldData.properties.parameter);
      if (fieldData.properties.sanitize != null) {
        return this.set('sanitize', fieldData.properties.sanitize);
      }
    };
    return style;
  };

}).call(this);

//# sourceMappingURL=kotive_style_transform.js.map


(function() {
  KotiveWebapp.AddRoleToChildren = Ember.Mixin.create({
    addRoleToChildren: function(role, groupId) {
      var store;
      store = this.get('store');
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return store.find('group').then(function(groups) {
            var childGroups;
            childGroups = groups.filter(function(g) {
              return g.get('id_parent') === groupId;
            });
            return async.each(childGroups, function(group, next) {
              store.find('group-roles-link', group.get('id')).then(function(grl) {
                grl.get('roles').then(function(roles) {
                  roles.addObject(role);
                  return grl.save().then(function() {
                    return next();
                  }, next);
                });
                return next;
              });
              return next;
            }, function(err) {
              if (err != null) {
                return reject(err);
              } else {
                return async.each(childGroups, function(group, next) {
                  return _this.addRoleToChildren(role, group.get('id')).then(next, next);
                }, function(err) {
                  if (err != null) {
                    return reject(err);
                  } else {
                    return resolve();
                  }
                });
              }
            });
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=add_role_to_children.js.map


(function() {
  KotiveWebapp.AmplitudeMixin = Ember.Mixin.create({
    initAmplitude: function() {
      if ((KotiveWebappConfigs.amplitudeAppKey != null) && KotiveWebappConfigs.amplitudeAppKey !== '' && window.location.hostname !== '127.0.0.1' && window.location.hostname !== 'localhost') {
        amplitude.init(KotiveWebappConfigs.amplitudeAppKey);
        return this.linkUserAmplitude();
      }
    },
    linkUserAmplitude: function(email) {
      if ((KotiveWebappConfigs.amplitudeAppKey != null) && KotiveWebappConfigs.amplitudeAppKey !== '' && window.location.hostname !== '127.0.0.1' && window.location.hostname !== 'localhost') {
        if (email != null) {
          return amplitude.setUserId(email);
        } else if ($.localStorage.get('user-email') != null) {
          return amplitude.setUserId($.localStorage.get('user-email'));
        }
      }
    },
    trackEventAmplitude: function(eventName, metaData) {
      if ((KotiveWebappConfigs.amplitudeAppKey != null) && KotiveWebappConfigs.amplitudeAppKey !== '' && window.location.hostname !== '127.0.0.1' && window.location.hostname !== 'localhost') {
        if (metaData != null) {
          return amplitude.logEvent(eventName, metaData);
        } else {
          return amplitude.logEvent(eventName);
        }
      }
    }
  });

}).call(this);

//# sourceMappingURL=amplitude_mixin.js.map


(function() {
  KotiveWebapp.BasicAuthMixin = Ember.Mixin.create({
    create_basic_token: function(userEmail, userPassword) {
      var hash, token;
      token = userEmail + ":" + userPassword;
      hash = btoa(token);
      return "Basic " + hash;
    },
    generateBasicAuthToken: function() {
      var authToken, userEmail;
      userEmail = this.get('controllers.application.userEmail') || this.get('userEmail');
      authToken = this.get('controllers.application.authToken') || this.get('authToken');
      return this.create_basic_token(userEmail, authToken);
    }
  });

}).call(this);

//# sourceMappingURL=basic_auth_mixin.js.map


(function() {
  KotiveWebapp.FieldMatcherRegexMixin = Ember.Mixin.create({
    field_matcher_regex: /^\{field\.value\:\b[0-9a-f]+\b\}$/m,
    group_matcher_regex: /^\{group\.(id|label)+\b\}$/m,
    contact_matcher_regex: /^\{contact\.(firstname|lastname|email|mobile|uniqueid):\{group\.id\}:\{field.value:[0-9]+\b\}\}$/m,
    files_matcher_regex: /^\{files\.(html)\:\b[0-9a-f]+\b\}$/m,
    htmllist_matcher_regex: /^\{htmllist\:(\b[0-9a-zA-Z]+\b|{field\.value\:\b[0-9a-f]+\b\})\}$/m,
    currentuserid_matcher_regex: /^\{currentuser\.(id)+\b\}$/m,
    taskflow_field_matcher_regex: /^\{taskflowfield\.value\:(\b[0-9a-f]+\b|{field\.value\:\b[0-9a-f]+\b\})\:(\b[0-9a-f]+\b|{field\.value\:\b[0-9a-f]+\b\})\}$/m,
    service_response_matcher_regex: /^\{service\.response\:\b[0-9a-f]+\b\:\b[\w\-\_\.]+\b\}$/m,
    service_file_uri_matcher_regex: /^\{service\.file_uri\:\b[0-9a-f]+\b\}$/m,
    continuelink_regex: /^\{continuelink\}$/m,
    datetime_matcher_regex: /^\{datetime\:\b[0-9a-z]+\b\:\b[a-zA-Z\/\.\_\-\,\ \']+\b\}$/m,
    lookup_matcher_regexes: [/\{user\.(firstname|lastname|email|mobile)\:\{(currentuser\.id|field\.value\:\b[0-9a-f]+\b)\}\}/gm, /\{contact\.(firstname|lastname|email|mobile|uniqueid):\{group\.id\}:\{field.value:[0-9]+\b\}\}/gm, /\{taskflowfield\.value\:(\b[0-9a-f]+\b|{field\.value\:\b[0-9a-f]+\b\})\:(\b[0-9a-f]+\b|{field\.value\:\b[0-9a-f]+\b\})\}/gm, /\{htmllist\:(\b[0-9a-zA-Z]+\b|{field\.value\:\b[0-9a-f]+\b\})\}/gm, /\{files\.(html)\:\b[0-9a-f]+\b\}/gm, /\{group\.(id|label)\}/gm, /\{currentuser\.(id)\}/gm, /\{continuelink\}/gm, /\{field\.value\:\b[0-9a-f]+\b\}/gm, /\{service\.response\:\b[0-9a-f]+\b\:\b[\w\-\_\.]+\b\}/gm, /\{service\.file_uri\:\b[0-9a-f]+\b\}/gm, /\{datetime\:\b[0-9a-z]+\b\:\b[a-zA-Z\/\.\_\-\,\ \']+\b\}/gm]
  });

}).call(this);

//# sourceMappingURL=field_matcher_regex_mixin.js.map


(function() {
  KotiveWebapp.KotiveFieldFunctionsComponentMixin = Ember.Mixin.create({
    inDesignerMode: (function() {
      return this.get('mode') === "designer";
    }).property('mode'),
    inSolutionsMode: (function() {
      return this.get('mode') !== "designer";
    }).property('mode'),
    displayInline: (function() {
      var classes;
      classes = this.get('model').get('style').classes;
      return classes === 'inline';
    }).property('model.style.classes')
  });

}).call(this);

//# sourceMappingURL=kotive_field_functions_component_mixin.js.map


(function() {
  KotiveWebapp.PredefinedOptionsComponentMixin = Ember.Mixin.create({
    inflector: new Ember.Inflector(Ember.Inflector.defaultRules),
    store: (function() {
      return KotiveWebapp.__container__.lookup('store:main');
    }).property(),
    showPredefinedInfo: (function() {
      return this.get('mode') === 'designer' && this.get('model.style.optionsType') === 'predefined';
    }).property('mode', 'model.style.optionsType'),
    patternChanged: (function() {
      return this.setPredefinedDescr();
    }).observes('model.pattern'),
    setPredefinedDescr: function() {
      var end, opt, parts;
      if (this.get('showPredefinedInfo') && (this.get('model.pattern') != null)) {
        end = this.get('model.pattern').length - 9;
        opt = this.get('model.pattern').substr(5, end);
        parts = opt.split(':');
        if (/^Workflow:[0-9a-f]+\:[0-9a-f]+/m.test(opt)) {
          return this.setTaskflowPredefOpts(parts[1], parts[2]);
        } else if (/^UsersByGroupAndRoleAsSelectPattern\:\{group\.id\}\:[0-9a-f]+$/m.test(opt)) {
          return this.setUsersListForRole(parts[2]);
        } else {
          return this.set('fieldTypeDescr', (function() {
            switch (opt) {
              case 'UsersByGroupAsSelectPattern:{group.id}':
                return 'all people';
              case 'RolesByGroupAsSelectPattern:{group.id}':
                return 'all roles';
              case 'GroupsByGroupAsSelectPattern:{group.id}':
                return 'all organizations/teams';
              case 'ContactsByGroupAsSelectPattern:{group.id}':
                return 'all contacts';
              case 'DaysOfWeek':
                return 'days of the week (Monday - Sunday)';
              case 'MonthsOfYear':
                return 'months of the year';
              case 'Satisfaction':
                return 'satisfaction (very satisfied, satisfied...)';
              case 'Importance':
                return 'importance (very important, important...)';
              case 'Agreeing':
                return 'agreeing (strongly agree, agree...)';
              default:
                return opt.toLowerCase();
            }
          })());
        }
      }
    },
    setTaskflowPredefOpts: function(workflowId, templateFieldId) {
      var store;
      store = this.get('store');
      return store.find('workflow', workflowId).then((function(_this) {
        return function(workflow) {
          return store.find('template-field', templateFieldId).then(function(templateField) {
            return templateField.get('templateActivities').then(function(tas) {
              return Ember.run.next(function() {
                var label, templateActivity, typeDescr;
                templateActivity = (tas.map(function(ta) {
                  return ta;
                }))[0];
                typeDescr = ("options from the taskflow '" + (workflow.get('label')) + "', showing the '" + (templateField.get('label')) + "' from the ") + ("'" + (templateActivity.get('label')) + "' task");
                label = "Show " + typeDescr;
                if (!(_this.get('isDestroyed') || _this.get('isDestroying'))) {
                  return _this.set('fieldTypeDescr', typeDescr);
                }
              });
            }, function(err) {
              return console.error(err);
            });
          }, function(err) {
            return console.error(err);
          });
        };
      })(this), function(err) {
        return console.error(err);
      });
    },
    setUsersListForRole: function(roleId) {
      return this.get('store').find('role', roleId).then((function(_this) {
        return function(role) {
          return _this.set('fieldTypeDescr', _this.get('inflector').pluralize(role.get('label')).toLowerCase());
        };
      })(this), function(err) {
        return console.error(err);
      });
    }
  });

}).call(this);

//# sourceMappingURL=predefined_options_component_mixin.js.map


(function() {
  KotiveWebapp.FilterComparisonTypesListMixin = Ember.Mixin.create({
    init: function() {
      return this._super();
    }
  });

}).call(this);

//# sourceMappingURL=filter_comparison_types_list_controller_mixin.js.map


(function() {
  KotiveWebapp.LocalstorageIntegrationMixin = Ember.Mixin.create({
    initLocalstorage: function() {
      var authToken, companyGroup, designerSynced, systemRoles, userEmail, userFullname, userRoles;
      userFullname = $.localStorage.get('user-fullname');
      if (userFullname != null) {
        this.set('userFullname', userFullname);
      }
      userEmail = $.localStorage.get('user-email');
      if (userEmail != null) {
        this.set('userEmail', userEmail);
      }
      authToken = $.localStorage.get('auth-token');
      if (authToken != null) {
        this.set('authToken', authToken);
      }
      companyGroup = $.localStorage.get('company-group');
      if (companyGroup != null) {
        this.set('companyGroup', companyGroup.toString());
      }
      systemRoles = $.localStorage.get('system-roles');
      if (systemRoles != null) {
        this.set('systemRoles', systemRoles);
      }
      userRoles = $.localStorage.get('user-roles');
      if (userRoles != null) {
        this.set('userRoles', userRoles);
      }
      designerSynced = $.localStorage.get('designer-synced');
      if (designerSynced != null) {
        return this.set('designerSynced', designerSynced);
      }
    },
    userLoggedIn: (function() {
      return (this.get('userEmail') != null) && (this.get('authToken') != null);
    }).property('userEmail', 'authToken'),
    userAdministratorRole: (function() {
      return this.setupSystemRoleProperty('User Administrator');
    }).property('systemRoles'),
    accountOwnerRole: (function() {
      return this.setupSystemRoleProperty('Account Owner');
    }).property('systemRoles'),
    makerRole: (function() {
      return this.setupSystemRoleProperty('Maker');
    }).property('systemRoles'),
    isDesignerSynced: (function() {
      return this.get('designerSynced') != null;
    }).property('designerSynced'),
    setupSystemRoleProperty: function(label) {
      var systemRoles;
      systemRoles = this.get('systemRoles');
      if (systemRoles != null) {
        return systemRoles.find(function(r) {
          return r.label === label;
        });
      } else {
        return null;
      }
    },
    setUserFullname: function(firstname, lastname) {
      var fullname;
      if (firstname == null) {
        firstname = "";
      }
      if (lastname == null) {
        lastname = "";
      }
      fullname = (firstname + " " + lastname).trim();
      if (this.get('userFullname') !== fullname) {
        $.localStorage.set('user-fullname', fullname);
        return this.set('userFullname', fullname);
      }
    },
    setUserEmail: function(email) {
      if (this.get('userEmail') !== email) {
        $.localStorage.set('user-email', email);
        return this.set('userEmail', email);
      }
    },
    setAuthToken: function(token) {
      if (this.get('authToken') !== token) {
        $.localStorage.set('auth-token', token);
        return this.set('authToken', token);
      }
    },
    setCompanyGroup: function(groupId) {
      if (this.get('companyGroup') !== groupId) {
        $.localStorage.set('company-group', groupId.toString());
        return this.set('companyGroup', groupId.toString());
      }
    },
    setSystemRoles: function(roles) {
      $.localStorage.set('system-roles', roles);
      return this.set('systemRoles', roles);
    },
    setUserRoles: function(roles) {
      $.localStorage.set('user-roles', roles);
      return this.set('userRoles', roles);
    },
    setDesignerSync: function(timestamp) {
      $.localStorage.set('designer-synced', timestamp);
      return this.set('designerSynced', timestamp);
    },
    clearLocalStorage: function() {
      var properties, storageVals;
      properties = ['userFullname', 'userEmail', 'authToken', 'companyGroup', 'systemRoles', 'userRoles', 'designerSynced'];
      storageVals = ['user-fullname', 'user-email', 'auth-token', 'company-group', 'system-roles', 'user-roles', 'syncedGroups', 'plan-limits', 'designer-synced'];
      properties.forEach((function(_this) {
        return function(p) {
          return _this.set(p, null);
        };
      })(this));
      storageVals.forEach(function(s) {
        return $.localStorage.remove(s);
      });
      return $.localStorage.keys().forEach((function(_this) {
        return function(key) {
          if (/^metadata\-report\-columns\-\d+$/.test(key)) {
            _this.set(key, null);
            return $.localStorage.remove(key);
          } else if (/^workflow\-hash\-\d+$/.test(key)) {
            return $.localStorage.remove(key);
          } else if (/^webhook\-hash\-\d+$/.test(key)) {
            return $.localStorage.remove(key);
          }
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=localstorage_integration_mixin.js.map


(function() {
  KotiveWebapp.LoginLogicMixin = Ember.Mixin.create(Ember.Evented, KotiveWebapp.AmplitudeMixin, KotiveWebapp.MessengerMixin, KotiveWebapp.ErrorMessageMixin, KotiveWebapp.BasicAuthMixin, KotiveWebapp.SetActiveGroupMixin, {
    executeLoginLogic: function(userEmail, userPassword) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          _this.set('invalidCredentials', false);
          return _this.apiUserLogin(userEmail, userPassword).then(function(data) {
            var appController, authToken, userFirstname, userLastname;
            userFirstname = data.user.firstname;
            userLastname = data.user.lastname;
            userEmail = data.user.email;
            authToken = data.authToken;
            if (!_this.get('invalidCredentials')) {
              appController = _this.get('controllers.application');
              appController.setUserFullname(userFirstname, userLastname);
              appController.setUserEmail(userEmail);
              appController.setAuthToken(authToken);
              appController.setSystemRoles(data.systemRoles);
              appController.setUserRoles(data.userRoles);
              _this.linkUserAmplitude();
              _this.trackEventAmplitude('Logged in');
              return _this.fetchGroupsData().then(function(groups) {
                return _this.processGroupsData(groups).then(function() {
                  return resolve();
                });
              }, reject);
            }
          }, reject);
        };
      })(this));
    },
    fetchGroupsData: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return Ember.$.ajax({
            url: '/api/groups',
            type: 'GET',
            dataType: 'json',
            headers: {
              Authorization: _this.generateBasicAuthToken()
            },
            success: function(data, textStatus, jqXHR) {
              return resolve(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              console.log(error);
              return reject(error);
            }
          });
        };
      })(this));
    },
    processGroupsData: function(groups) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var defaultCompanyGroupId, defaultGroupId, userEmail;
          defaultGroupId = null;
          defaultCompanyGroupId = null;
          userEmail = $.localStorage.get('user-email');
          return async.each(groups.groups, function(groupData, next) {
            return Ember.run(function() {
              groupData.id = groupData.id.toString();
              groupData.id_parent = groupData.id_parent.toString();
              groupData.createdBy = userEmail;
              return KotiveDB.requestTransaction('groups', 'readwrite', function(err, transaction) {
                var objectstore, request;
                if (err != null) {
                  return next(err);
                }
                objectstore = transaction.objectStore('groups');
                transaction.oncomplete = function(event) {
                  return next();
                };
                transaction.onerror = function(event) {
                  return next(event.error);
                };
                return request = objectstore.add(groupData);
              });
            });
          }, function(err) {
            if (err != null) {
              console.log(err);
            }
            return _this.setActiveGroup().then(function() {
              return Ember.run.next(function() {
                return resolve();
              });
            }, reject);
          });
        };
      })(this));
    },
    apiUserLogin: function(userEmail, userPassword) {
      var basicToken;
      basicToken = this.create_basic_token(userEmail, userPassword);
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return Ember.$.ajax({
            url: "/api/login",
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json',
            headers: {
              Authorization: basicToken
            },
            success: function(data, textStatus, jqXHR) {
              return _this.clearDemoData().then(function() {
                return resolve(data);
              }, reject);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              console.log(error);
              if (jqXHR.status === 401) {
                _this.set('invalidCredentials', true);
              } else {
                _this.set('ajaxError', true);
              }
              _this.set('processingLogin', false);
              return reject(error);
            }
          });
        };
      })(this));
    },
    clearDemoData: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var store;
          KotiveSyncEngine.disable();
          store = _this.get('store');
          return async.each(['group', 'template-activity', 'template-field', 'condition', 'filter'], function(storeName, next) {
            return store.find(storeName).then(function(ms) {
              var models;
              models = ms.map(function(m) {
                return m;
              });
              return async.each(models, function(model, done) {
                if (model.get('currentState.stateName') === 'root.loading') {
                  model.transitionTo('loaded.created.uncommitted');
                }
                return model.destroyRecord().then(function() {
                  return done();
                }, done);
              }, function(err) {
                if (err != null) {
                  console.log(err);
                }
                return next(err);
              });
            }, function(err) {
              return next(err);
            });
          }, function(err) {
            KotiveSyncEngine.enable();
            if (err != null) {
              return reject(err);
            } else {
              return resolve();
            }
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=login_logic_mixin.js.map


(function() {
  KotiveWebapp.MetadataUpdatesMixin = Ember.Mixin.create({
    metaHasChanges: false,
    companyGroupMetadataChanged: (function() {
      var identifier;
      identifier = this.get('companyGroup');
      if (identifier != null) {
        return this.generateCompanyGroupData(identifier).then((function(_this) {
          return function(record) {
            if (_this.get('appOnline')) {
              return _this.updateMetaData([record]);
            } else {
              return _this.set('metaHasChanges', true);
            }
          };
        })(this), function(err) {
          return console.error(err);
        });
      }
    }).observes('companyGroup'),
    uploadMetaChanges: (function() {
      var identifier;
      if (this.get('appOnline') && this.get('metaHasChanges') && !this.get('uploadingMetadata')) {
        this.set('uploadingMetadata', true);
        identifier = this.get('companyGroup');
        if (identifier != null) {
          return this.generateCompanyGroupData(identifier).then((function(_this) {
            return function(companyGroup) {
              return _this.updateMetaData([companyGroup]);
            };
          })(this))["catch"](function(err) {
            console.error(err);
            return this.set('uploadingMetadata', false);
          });
        } else {
          return this.set('uploadingMetadata', false);
        }
      }
    }).observes('appOnline'),
    taskflowReportsLoaded: (function() {
      var reports;
      if (this.get('taskflowReportsSet')) {
        reports = this.get('taskflowReports').map(function(r) {
          return r;
        });
        return async.each(reports, (function(_this) {
          return function(report, next) {
            return _this.getServerId(report.get('id'), 'templateActivities').then(function(id) {
              var key;
              key = "metadata-report-columns-" + (report.get('id'));
              _this.set(key, $.localStorage.get(key));
              return _this.addObserver(key, _this, function(sender, property) {
                $.localStorage.set(property, _this.get(property));
                return _this.updateMetaData([
                  {
                    key: property.substr(9),
                    value: JSON.stringify(_this.get(property)),
                    valueType: 'json'
                  }
                ]);
              });
            }, next);
          };
        })(this), function(err) {
          if (err != null) {
            return console.error(err);
          }
        });
      }
    }).observes('taskflowReports'),
    generateCompanyGroupData: function(identifier) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.getServerId(identifier, 'groups').then(function(id) {
            return resolve({
              key: 'company-group',
              value: id.toString(),
              valueType: 'integer'
            });
          }, reject);
        };
      })(this));
    },
    updateMetaData: function(records) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          if ((_this.get('userEmail') != null) && (_this.get('authToken') != null)) {
            return Ember.$.ajax({
              url: '/api/user/metadata',
              type: 'PUT',
              contentType: 'application/json;charset=UTF-8',
              data: JSON.stringify(records),
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function() {
                return resolve();
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                return reject(error);
              }
            });
          } else {
            console.log('Not currently authenticated, delaying metadata update');
            return Ember.run.later(function() {
              return _this.updateMetaData(records).then(resolve, reject);
            }, 2000);
          }
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=metadata_updates_mixin.js.map


(function() {
  KotiveWebapp.PlanLimitsMixin = Ember.Mixin.create({
    companyChangedRenewPlans: (function() {
      var identifier;
      identifier = this.get('companyGroup');
      if (identifier != null) {
        if (this.get('appOnline')) {
          return this.apiGetPlanLimits(identifier);
        }
      }
    }).observes('companyGroup'),
    apiGetPlanLimits: function(groupId) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          if ((_this.get('userEmail') != null) && (_this.get('authToken') != null)) {
            return Ember.$.ajax({
              url: "/api/product_plan/" + groupId + "/limits",
              type: 'GET',
              contentType: 'application/json;charset=UTF-8',
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function(data, textStatus, jqXHR) {
                _this.refreshPlanLimits(data);
                return resolve();
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                return reject(error);
              }
            });
          } else {
            console.log('Not currently authenticated, delaying getting plan limits');
            return Ember.run.later(function() {
              return _this.getPlanLimits(groupId).then(resolve, reject);
            }, 2000);
          }
        };
      })(this));
    },
    refreshPlanLimits: function(limits) {
      var planLimits;
      if (limits != null) {
        planLimits = {};
        limits.forEach(function(limit) {
          return planLimits[limit.label] = limit.value;
        });
        return $.localStorage.set('plan-limits', planLimits);
      } else {
        return $.localStorage.set('plan-limits', '{"executions":"0","groups":"3","users":"1","task_types":"3"}');
      }
    }
  });

}).call(this);

//# sourceMappingURL=plan_limits_mixin.js.map


(function() {
  KotiveWebapp.TemplateActivityTypesListMixin = Ember.Mixin.create({
    setupActivityTypes: function() {
      return this.store.findAll('template-activity-type').then((function(_this) {
        return function(activityTypes) {
          return _this.set('templateActivityTypes', activityTypes.sortBy('order', 'label'));
        };
      })(this));
    },
    templateActivityTypes: (function() {
      return [];
    }).property('activityTypes')
  });

}).call(this);

//# sourceMappingURL=template_activity_types_list_controller_mixin.js.map


(function() {
  KotiveWebapp.TemplateFielTypesListMixin = Ember.Mixin.create({
    setupTemplateFieldTypes: function() {
      return this.store.findAll('template-field-type').then((function(_this) {
        return function(templateFieldTypes) {
          return _this.set('orderedTemplateFieldTypes', templateFieldTypes.sortBy('description', 'id').map(function(field) {
            return {
              key: field.get('kind'),
              value: field.get('description')
            };
          }));
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=template_field_types_list_controller_mixin.js.map


(function() {
  KotiveWebapp.WebappUpdatesMixin = Ember.Mixin.create({
    initUpdateListener: function() {
      this.setProperties({
        minorUpdateRequired: false,
        majorUpdateRequired: false
      });
      return KotiveAppUpdater.addUpdateReadyListener((function(_this) {
        return function(type) {
          return _this.updateRequired(type);
        };
      })(this));
    },
    updateRequired: function(type) {
      this.set('minorUpdateRequired', type === 'minor' && !this.get('majorUpdateRequired'));
      return this.set('majorUpdateRequired', type === 'major');
    },
    checkIfMajorUpdate: (function() {
      if (this.get('majorUpdateRequired')) {
        this.set('majorReloadTimeout', 30);
        return this.executeMajorReloadTick();
      }
    }).observes('majorUpdateRequired'),
    executeMajorReloadTick: function() {
      var secs;
      secs = this.get('majorReloadTimeout');
      if (secs === 0) {
        if (this.get('majorUpdateRequired')) {
          return this.send('majorReload');
        }
      } else {
        return Ember.run.later((function(_this) {
          return function() {
            _this.set('majorReloadTimeout', secs - 1);
            if (_this.get('majorUpdateRequired')) {
              return _this.executeMajorReloadTick();
            }
          };
        })(this), 1000);
      }
    }
  });

}).call(this);

//# sourceMappingURL=webapp_updates_mixin.js.map


(function() {
  KotiveWebapp.WebhookHashMixin = Ember.Mixin.create({
    getWebhookHash: function(webhookId) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var hash, key;
          key = "webhook-hash-" + webhookId;
          hash = $.localStorage.get(key);
          if (hash) {
            return resolve(hash);
          } else {
            return Ember.$.ajax({
              url: "/api/webhook/hash/" + webhookId,
              type: 'GET',
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function(hash, textStatus, jqXHR) {
                $.localStorage.set(key, hash);
                return resolve(hash);
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                console.log(error);
                return reject(error);
              }
            });
          }
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=webhook_hash_mixin.js.map


(function() {
  KotiveWebapp.WorkflowHashMixin = Ember.Mixin.create({
    getWorkflowHash: function(workflowId) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var hash, key;
          key = "workflow-hash-" + workflowId;
          hash = $.localStorage.get(key);
          if (hash) {
            return resolve(hash);
          } else {
            return Ember.$.ajax({
              url: "/api/workflow/hash/" + workflowId,
              type: 'GET',
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function(hash, textStatus, jqXHR) {
                $.localStorage.set(key, hash);
                return resolve(hash);
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                console.log(error);
                return reject(error);
              }
            });
          }
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=workflow_hash_mixin.js.map


(function() {
  KotiveWebapp.DocumentQueryMixin = Ember.Mixin.create({
    viewEl: (function() {
      return document.getElementById(this.$().attr('id'));
    }).property()
  });

}).call(this);

//# sourceMappingURL=document_query_mixin.js.map


(function() {
  KotiveWebapp.ErrorMessageMixin = Ember.Mixin.create({
    buildErrorString: function(model) {
      var errorStr;
      if ((model.get('errors.email').length > 0) && (model.get('errors.password').length > 0)) {
        errorStr = "Please ensure that you've entered a valid email address and a strong password.";
      } else if (model.get('errors.email').length > 0) {
        errorStr = "Email " + model.get('errors.email');
      } else if (model.get('errors.password').length > 0) {
        errorStr = "Password " + model.get('errors.password');
      } else if (model.get('errors.passwordConfirmation').length > 0) {
        errorStr = "Password confirmation " + model.get('errors.passwordConfirmation');
      }
      return this.set('validationMessage', errorStr);
    }
  });

}).call(this);

//# sourceMappingURL=error_message_mixin.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.GroupTreeLogicMixin = Ember.Mixin.create({
    getGroupParentTree: function(groupId) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var store;
          store = _this.get('store');
          return store.find('group').then(function(gs) {
            var fetchParentTree, group, groups;
            groups = gs.map(function(g) {
              return g;
            });
            group = groups.find(function(g) {
              return g.get('id') === groupId;
            });
            fetchParentTree = function(parentId, gids) {
              var g;
              g = groups.find(function(g) {
                return g.get('id') === parentId;
              });
              if (g != null) {
                gids.push(g.get('id'));
                return fetchParentTree(g.get('id_parent'), gids);
              } else {
                return gids;
              }
            };
            if (group != null) {
              return resolve(fetchParentTree(group.get('id_parent'), [groupId]));
            } else {
              return reject(new Error("Cannot find group for id " + groupId));
            }
          }, reject);
        };
      })(this));
    },
    getRolesForGroup: function(groupId) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.getGroupParentTree(groupId).then(function(groupIds) {
            groupIds.push('1');
            return _this.get('store').find('role').then(function(roles) {
              return resolve(roles.filter(function(r) {
                var ref;
                return ref = r.get('primaryGroupId'), indexOf.call(groupIds, ref) >= 0;
              }));
            }, reject);
          }, reject);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=group_tree_logic_mixin.js.map


(function() {
  KotiveWebapp.IntercomMixin = Ember.Mixin.create(KotiveWebapp.AmplitudeMixin, {
    notifyIntercom: function() {
      var intercomCounter, settings;
      if (($.localStorage.get('user-email') != null) && (KotiveWebappConfigs.intercomAppId != null) && KotiveWebappConfigs.intercomAppId !== '' && window.location.hostname !== '127.0.0.1' && window.location.hostname !== 'localhost') {
        settings = {
          app_id: KotiveWebappConfigs.intercomAppId,
          email: $.localStorage.get('user-email')
        };
        if ($.localStorage.get('user-fullname') != null) {
          settings.name = $.localStorage.get('user-fullname');
        }
        if (this.get('isMakerForGroup')) {
          settings.maker = 'Yes';
        }
        if (this.get('isAccountOwnerForGroup')) {
          settings.account_owner = 'Yes';
        }
        if (this.get('userAdministratorRole')) {
          settings.user_administrator = 'Yes';
        }
        intercomCounter = this.get('intercomCounter');
        if (intercomCounter === 0) {
          window.Intercom('boot', settings);
        } else if (intercomCounter === 10) {
          intercomCounter = 0;
          window.Intercom('update', settings);
        }
        return this.set('controllers.application.intercomCounter', intercomCounter + 1);
      }
    },
    trackEventIntercom: function(eventName, metaData) {
      var intercomCounter;
      if (($.localStorage.get('user-email') != null) && (KotiveWebappConfigs.intercomAppId != null) && KotiveWebappConfigs.intercomAppId !== '' && window.location.hostname !== '127.0.0.1' && window.location.hostname !== 'localhost') {
        intercomCounter = this.get('intercomCounter');
        if (intercomCounter === 0) {
          this.notifyIntercom();
        }
        if (metaData != null) {
          Intercom('trackEvent', eventName, metaData);
          return this.trackEventAmplitude(eventName, metaData);
        } else {
          Intercom('trackEvent', eventName);
          return this.trackEventAmplitude(eventName);
        }
      }
    }
  });

}).call(this);

//# sourceMappingURL=intercom_mixin.js.map


(function() {
  KotiveWebapp.KeychainProcessMixin = Ember.Mixin.create({
    getServerId: function(id, source) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var keychainCache;
          if (((_this.get('controllers.application.userEmail') != null) || (_this.get('userEmail') != null)) && ((_this.get('controllers.application.authToken') != null) || (_this.get('authToken') != null))) {
            if (_this.isServerId(id)) {
              return resolve(id);
            } else {
              KotiveWebapp.keychainCache = KotiveWebapp.keychainCache || {};
              keychainCache = KotiveWebapp.keychainCache;
              if (keychainCache[id] != null) {
                return resolve(keychainCache[id]);
              } else {
                return $.ajax({
                  url: "/api/keychain/" + source + "/" + id,
                  type: 'GET',
                  headers: {
                    Authorization: _this.generateBasicAuthToken()
                  },
                  success: function(data, textStatus, jqXHR) {
                    keychainCache[id] = data.serverId;
                    return resolve(data.serverId);
                  },
                  error: function(jqXHR, textStatus, errorThrown) {
                    var error;
                    error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                    return reject(error);
                  }
                });
              }
            }
          } else {
            console.log('NOT LOGGED IN -> not doing keychain lookup');
            return resolve(id);
          }
        };
      })(this));
    },
    isServerId: function(id) {
      return /^\d+$/.test(id);
    }
  });

}).call(this);

//# sourceMappingURL=keychain_process_mixin.js.map


(function() {
  KotiveWebapp.MessengerMixin = Ember.Mixin.create({
    hideMessages: function() {},
    setupMessenger: function() {
      return Messenger.options = {
        extraClasses: 'messenger-fixed messenger-on-bottom messenger-on-right',
        theme: 'kotive'
      };
    }
  });

}).call(this);

//# sourceMappingURL=messenger_mixin.js.map


(function() {
  KotiveWebapp.ModalHelperMixin = Ember.Mixin.create({
    renderModal: function(modalName, model) {
      var controller;
      controller = this.controllerFor(modalName);
      controller.set('model', model);
      this.render(modalName, {
        into: 'application',
        outlet: 'modal',
        controller: controller
      });
      this.set('modalController', controller);
      return this.controllerFor('application').set('modalController', controller);
    },
    disconnectModal: function() {
      this.get('modalController').send('disconnectingModal');
      return this.disconnectOutlet({
        outlet: 'modal',
        parentView: 'application'
      });
    },
    promptForSignup: function(delay) {
      var actionName, newUser, viewName;
      actionName = 'openModal';
      viewName = 'signup';
      newUser = this.get('store').createRecord('user');
      return Ember.run.later((function(_this) {
        return function() {
          return _this.send(actionName, viewName, newUser);
        };
      })(this), delay);
    }
  });

}).call(this);

//# sourceMappingURL=modal_helper_mixin.js.map


(function() {
  KotiveWebapp.ParentGroupsMixin = Ember.Mixin.create({
    findParentGroups: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('store').find('group').then(function(gs) {
            var groups;
            groups = gs.map(function(g) {
              return g;
            });
            return async.filter(groups, function(group, next) {
              return async.detect(groups, function(g, check) {
                return check(g.get('id') === group.get('id_parent'));
              }, function(result) {
                return next(result == null);
              });
            }, function(results) {
              return resolve(results);
            });
          }, reject);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=parent_groups_mixin.js.map


(function() {
  KotiveWebapp.PatternEncodingsMixin = Ember.Mixin.create({
    characterEncodings: Object.keys(KotiveWebappConfigs.charEncodings).map(function(key) {
      return [key, KotiveWebappConfigs.charEncodings[key]];
    }),
    encode: function(string) {
      if (string.indexOf('\u2028') !== -1) {
        string = string.replace(/\u2028/g, '');
      }
      if (string.indexOf('\u2029') !== -1) {
        string = string.replace(/\u2029/g, '');
      }
      string = string.trim();
      if (!this.get('bypassEncoding')) {
        _.each(this.characterEncodings, function(item) {
          var char, encodedChar, regex;
          char = item[0], encodedChar = item[1];
          char = char.replace(/\[/g, '\\[').replace(/\]/g, '\\]').replace(/\{/g, '\\{').replace(/\}/g, '\\}').replace(/\^/g, '\\^');
          regex = new RegExp(char, 'g');
          return string = string.replace(regex, encodedChar);
        });
      }
      return string;
    },
    decode: function(string) {
      if (!this.get('bypassEncoding')) {
        _.each(this.characterEncodings, function(item) {
          var char, encodedChar, regex;
          char = item[0], encodedChar = item[1];
          regex = new RegExp(encodedChar, 'g');
          return string = string.replace(regex, char);
        });
      }
      return string;
    }
  });

}).call(this);

//# sourceMappingURL=pattern_encodings_mixin.js.map


(function() {
  KotiveWebapp.RaygunMixin = Ember.Mixin.create({
    initRaygun: function() {
      if ((KotiveWebappConfigs.raygunId != null) && KotiveWebappConfigs.raygunId !== '') {
        rg4js('apiKey', KotiveWebappConfigs.raygunId);
        rg4js('options', {
          'enableCrashReporting': true,
          'saveIfOffline': true,
          'excludedHostnames': ['127.0.0.1:9000']
        });
        return this.linkUserRaygun();
      }
    },
    linkUserRaygun: function() {
      if ((KotiveWebappConfigs.raygunId != null) && KotiveWebappConfigs.raygunId !== '' && ($.localStorage.get('user-email') != null)) {
        return rg4js('setUser', {
          identifier: $.localStorage.get('user-email'),
          isAnonymous: false,
          email: $.localStorage.get('user-email'),
          fullName: $.localStorage.get('user-fullname')
        });
      }
    },
    unlinkUserRaygun: function() {
      if ((KotiveWebappConfigs.raygunId != null) && KotiveWebappConfigs.raygunId !== '') {
        return rg4js('setUser', {
          isAnonymous: false
        });
      }
    }
  });

}).call(this);

//# sourceMappingURL=raygun_mixin.js.map


(function() {
  KotiveWebapp.ReferralsMixin = Ember.Mixin.create({
    showReferrals: function() {
      var action, viewName;
      action = 'openModal';
      viewName = 'referrals';
      return this.send(action, viewName, this.get('model'));
    },
    apiGetReferralToken: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return Ember.$.ajax({
            url: '/api/referral',
            type: 'GET',
            contentType: 'application/json',
            headers: {
              Authorization: _this.generateBasicAuthToken()
            },
            success: function(data, textStatus, jqXHR) {
              _this.trackEventIntercom('Viewed referral page');
              return resolve(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              console.error(error);
              return reject(error);
            }
          });
        };
      })(this));
    },
    doGroupSelectionSetup: function() {
      var store;
      store = this.get('store');
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return store.find('group').then(function(gs) {
            var groups;
            groups = gs.map(function(g) {
              return g;
            });
            return async.filter(groups, function(g, next) {
              if (g.get('actualId') != null) {
                return next(false);
              } else {
                return store.find('groupRolesLink', g.get('id')).then(function(grl) {
                  return grl.get('roles');
                }).then(function(roles) {
                  var sysRoles;
                  sysRoles = roles.filter(function(r) {
                    var ref;
                    return (ref = r.get('id')) === '1' || ref === '2' || ref === '3';
                  });
                  return next(sysRoles.length !== 0 && g.get('level') === 'company');
                })["catch"](reject);
              }
            }, function(results) {
              _this.set('companyGroups', results);
              return resolve();
            });
          }, reject);
        };
      })(this));
    },
    doGroupSelectionUpdate: function(groupId) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.getServerId(groupId, 'groups').then(function(id) {
            return Ember.$.ajax({
              url: "/api/referral/groupLink/" + id,
              type: 'PATCH',
              contentType: 'application/json',
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function(data, textStatus, jqXHR) {
                return resolve();
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                console.error(error);
                return reject(error);
              }
            });
          }, reject);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=referrals_mixin.js.map


(function() {
  KotiveWebapp.AuthenticatedRouteMixin = Ember.Mixin.create({
    beforeModel: function(transition) {
      if (transition.targetName !== 'login') {
        return this.transitionTo('login');
      }
    }
  });

}).call(this);

//# sourceMappingURL=authenticated_route_mixin.js.map


(function() {
  KotiveWebapp.MetadataSetupMixin = Ember.Mixin.create({
    processUserMetaData: function(data) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          _this.setupReportMetaData(data);
          return _this.setupMetadataDefaultGroup(data).then(resolve, reject);
        };
      })(this));
    },
    setupMetadataDefaultGroup: function(data) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var defaultGroup;
          defaultGroup = data.userMetaData.find(function(record) {
            return record.key === 'company-group';
          });
          if (defaultGroup != null) {
            _this.controllerFor('application').setCompanyGroup(defaultGroup.value);
            return resolve();
          } else {
            return _this.setActiveGroup().then(function() {
              _this.controllerFor('application').setCompanyGroup($.localStorage.get('company-group'));
              return resolve();
            }, reject);
          }
        };
      })(this));
    },
    setupReportMetaData: function(data) {
      return data.userMetaData.filter(function(record) {
        return record.key.match(/^report\-columns\-\d+$/) && record.valueType === 'json';
      }).forEach((function(_this) {
        return function(report) {
          var key;
          key = "metadata-" + report.key;
          data = JSON.parse(report.value);
          $.localStorage.set(key, data);
          return _this.set(key, data);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=metadata_setup_mixin.js.map


(function() {
  KotiveWebapp.SaveActivityIntentRouteMixin = Ember.Mixin.create({
    runIntentToSaveActivity: function() {
      return this.modelHasChanges().then((function(_this) {
        return function(hasChanges) {
          var timer;
          if (hasChanges) {
            if (_this.get('currentlyDoingSaves')) {
              return _this.set('anotherSaveRequired', true);
            } else {
              if (_this.get('runSaveTimer') != null) {
                Ember.run.cancel(_this.get('runSaveTimer'));
              }
              timer = Ember.run.later(function() {
                return _this.doRecursiveModelSave();
              }, 1000);
              return _this.set('runSaveTimer', timer);
            }
          }
        };
      })(this));
    },
    modelHasChanges: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var model;
          model = _this.get('controller.model');
          if (model.get('isDirty')) {
            return resolve(true);
          } else {
            return model.get('templateFields').then(function(templateFields) {
              var match;
              match = false;
              templateFields.forEach(function(field) {
                if (field.get('isDirty')) {
                  return match = true;
                }
              });
              if (match) {
                return resolve(true);
              } else {
                return _this.conditionsHaveChanges().then(resolve, reject);
              }
            }, function(err) {
              return reject(err);
            });
          }
        };
      })(this));
    },
    conditionsHaveChanges: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var model;
          model = _this.get('controller.model');
          return model.get('templateConditions').then(function(templateConditions) {
            var conditions;
            conditions = templateConditions.map(function(condition) {
              return condition;
            });
            return async.detect(conditions, function(condition, next) {
              if (condition.get('isDirty')) {
                return next(true);
              } else {
                return condition.get('filters').then(function(filters) {
                  var match;
                  match = false;
                  filters.forEach(function(filter, index, array) {
                    if (filter.get('isDirty')) {
                      return match = true;
                    }
                  });
                  return next(match);
                }, function(result) {
                  return next(result != null);
                });
              }
            }, function(result) {
              return resolve(result != null);
            });
          });
        };
      })(this));
    },
    doRecursiveModelSave: function() {
      var model, promisesList, waitForPromises;
      promisesList = [];
      model = this.get('controller.model');
      waitForPromises = function(promisesList, callback) {
        var promise;
        if (promisesList.length === 0) {
          return callback();
        } else {
          promise = promisesList.popObject();
          return promise.then(function() {
            return waitForPromises(promisesList, callback);
          });
        }
      };
      this.set('currentlyDoingSaves', true);
      if (model.get('isDirty')) {
        promisesList.pushObject(model.save());
      }
      model.get('templateFields').then((function(_this) {
        return function(templateFields) {
          return templateFields.forEach(function(field) {
            if (field.get('isDirty')) {
              return promisesList.pushObject(field.save());
            }
          });
        };
      })(this));
      model.get('templateConditions').then((function(_this) {
        return function(templateConditions) {
          return templateConditions.forEach(function(condition) {
            if (condition.get('isDirty')) {
              promisesList.pushObject(condition.save());
            }
            return condition.get('filters').then(function(filters) {
              return filters.forEach(function(filter) {
                if (filter.get('isDirty')) {
                  return promisesList.pushObject(filter.save());
                }
              });
            });
          });
        };
      })(this));
      return waitForPromises(promisesList, (function(_this) {
        return function() {
          _this.set('runSaveTimer', null);
          _this.set('currentlyDoingSaves', false);
          if (_this.get('anotherSaveRequired')) {
            _this.set('anotherSaveRequired', false);
            return _this.runIntentToSaveActivity();
          }
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=save_activity_intent_route_mixin.js.map


(function() {
  KotiveWebapp.ScreenEnquireMixin = Ember.Mixin.create({
    enquireParams: {
      smallScreenMax: 900,
      mediumScreenMax: 1280
    }
  }, window.matchMedia = window.matchMedia || function() {
    return {
      matches: false,
      addListener: function() {},
      removeListener: function() {}
    };
  }, {
    initScreenEnquire: function() {
      this.registerSmallSreenChecks();
      this.registerMediumScreenChecks();
      return this.registerLargeScreenChecks();
    },
    registerSmallSreenChecks: function() {
      return enquire.register("screen and (max-width: " + this.enquireParams.smallScreenMax + "px)", {
        match: (function(_this) {
          return function() {
            return _this.set('viewType', 'mobile');
          };
        })(this)
      });
    },
    registerMediumScreenChecks: function() {
      var matchFn;
      matchFn = (function(_this) {
        return function() {
          return _this.set('viewType', 'tablet');
        };
      })(this);
      return enquire.register("screen and (min-width: " + (this.enquireParams.smallScreenMax + 1) + "px) and (max-width: " + this.enquireParams.mediumScreenMax + "px)", {
        match: matchFn
      });
    },
    registerLargeScreenChecks: function() {
      return enquire.register("screen and (min-width: " + (this.enquireParams.mediumScreenMax + 1) + "px)", {
        match: (function(_this) {
          return function() {
            return _this.set('viewType', 'desktop');
          };
        })(this)
      });
    },
    inDesktopMode: (function() {
      return this.get('viewType') === 'desktop';
    }).property('viewType'),
    inTabletMode: (function() {
      return this.get('viewType') === 'tablet';
    }).property('viewType'),
    inMobileMode: (function() {
      return this.get('viewType') === 'mobile';
    }).property('viewType')
  });

}).call(this);

//# sourceMappingURL=screen_enquire_mixin.js.map


(function() {
  KotiveWebapp.SetActiveGroupMixin = Ember.Mixin.create({
    setActiveGroup: function() {
      var activeGroup, groupToViewId;
      activeGroup = null;
      groupToViewId = ($.localStorage.get('group-to-view') || $.localStorage.get('company-group') || -1).toString();
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('store').find('group').then(function(groups) {
            groups.forEach(function(group) {
              if ((activeGroup == null) || group.get('id') === groupToViewId || (activeGroup.get('level') !== 'application' && group.get('level') === 'application' && activeGroup.get('id') !== groupToViewId)) {
                return activeGroup = group;
              }
            });
            $.localStorage.set('company-group', activeGroup.get('id'));
            $.localStorage.remove('group-to-view');
            return resolve();
          }, reject);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=set_active_group_mixin.js.map


(function() {
  KotiveWebapp.TaskflowRecipeAdder = Ember.Mixin.create({
    group: (function() {
      return this.get('controllers.group.model');
    }).property('controllers.group.model'),
    groupId: (function() {
      return this.get('group.id');
    }).property('group'),
    idExtractRegex: (function() {
      return /[\:\=\>\<]\d+[\}\=]/;
    }).property(),
    fieldRegexes: (function() {
      return [/\{field\.value\:\d+\}/mg];
    }).property(),
    generateTaskflow: function(template) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          if (_this.get('controllers.application.appOnline')) {
            return _this.processRequest(resolve, reject, template);
          } else {
            _this.appOfflineLogic();
            return reject();
          }
        };
      })(this));
    },
    appOfflineLogic: function() {
      return Messenger().post({
        id: 'online-status-message',
        singleton: false,
        hideAfter: 15,
        showCloseButton: true,
        message: 'Sorry but you need to be online in order to fetch the taskflow template data - please check your connection and try again',
        type: 'error'
      });
    },
    processRequest: function(resolve, reject, template) {
      var activityLinks, data, fieldLinks, groupRoleLink, roleLinks, store;
      store = this.get('store');
      groupRoleLink = null;
      data = null;
      roleLinks = null;
      activityLinks = null;
      fieldLinks = null;
      return store.find('groupRolesLink', this.get('groupId')).then(function(grl) {
        groupRoleLink = grl;
        return template.getSample();
      }).then((function(_this) {
        return function(d) {
          data = d;
          return _this.generateRequiredRoles(data.relatedRoles, groupRoleLink);
        };
      })(this)).then((function(_this) {
        return function(rls) {
          roleLinks = rls;
          return _this.sortActivities(data.templateActivities);
        };
      })(this)).then((function(_this) {
        return function(acts) {
          return _this.generateActivities(acts);
        };
      })(this)).then((function(_this) {
        return function(als) {
          activityLinks = als;
          return _this.generateFields(data.templateFields, data.templateActivities, activityLinks, roleLinks);
        };
      })(this)).then((function(_this) {
        return function(fls) {
          fieldLinks = fls;
          return _this.updateFieldLookups(fieldLinks, roleLinks);
        };
      })(this)).then((function(_this) {
        return function(ufls) {
          var updatedFieldLinks;
          updatedFieldLinks = ufls;
          return _this.generateConditions(data.guards, roleLinks, updatedFieldLinks, activityLinks);
        };
      })(this)).then(function() {
        return resolve();
      })["catch"](reject);
    },
    extractId: function(matcher) {
      var idExtractRegex;
      idExtractRegex = this.get('idExtractRegex');
      return parseInt(/\d+/.exec(idExtractRegex.exec(matcher)[0])[0]);
    },
    regexReplacer: function(regexes, patternStr, idFetchFn, replaceCheckFn) {
      if (replaceCheckFn == null) {
        replaceCheckFn = null;
      }
      return regexes.flatMap(function(regex) {
        return patternStr.match(regex) || [];
      }).reduce((function(_this) {
        return function(pattern, m) {
          var id, newId, newMatcher;
          id = _this.extractId(m);
          newId = idFetchFn(id);
          newMatcher = m.replace(id, newId);
          if ((replaceCheckFn == null) || replaceCheckFn(id)) {
            return pattern.replaceAll(m, newMatcher);
          } else {
            return pattern;
          }
        };
      })(this), patternStr);
    },
    generateRequiredRoles: function(relatedRoles, groupRoleLink) {
      var groupId, roleLinks, store;
      store = this.get('store');
      groupId = this.get('groupId');
      roleLinks = {};
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return groupRoleLink.get('roles').then(function(roles) {
            return async.each(relatedRoles, function(role, next) {
              var existingRole, newRole;
              existingRole = roles.find(function(r) {
                return r.get('label') === role.label;
              });
              if (existingRole != null) {
                roleLinks[role.id] = existingRole.get('id');
                return next();
              } else {
                newRole = store.createRecord('role', {
                  label: role.label,
                  primaryGroupId: groupId
                });
                return newRole.save().then(function() {
                  roles.addObject(newRole);
                  return groupRoleLink.save().then(function() {
                    return _this.addRoleToChildren(newRole, groupId).then(function() {
                      roleLinks[role.id] = newRole.get('id');
                      return next();
                    }, next);
                  }, next);
                }, next);
              }
            }, function(err) {
              if (err != null) {
                return reject(err);
              } else {
                return resolve(roleLinks);
              }
            });
          }, reject);
        };
      })(this));
    },
    sortActivities: function(activities, newActivities, id_parent) {
      if (newActivities == null) {
        newActivities = [];
      }
      if (id_parent == null) {
        id_parent = 0;
      }
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var as;
          as = activities.sortBy('id_parent', 'order', 'id').filter(function(a) {
            return a.id_parent === id_parent;
          });
          return async.eachSeries(as, function(activity, next) {
            newActivities.pushObject(activity);
            return _this.sortActivities(activities, newActivities, activity.id).then(function() {
              return next();
            }, next);
          }, function(err) {
            if (err != null) {
              return reject(err);
            } else {
              return resolve(newActivities);
            }
          });
        };
      })(this));
    },
    generateActivities: function(activities) {
      var activityLinks, group, store, workflow;
      store = this.get('store');
      group = this.get('group');
      activityLinks = {};
      workflow = null;
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return async.eachSeries(activities, function(activity, next) {
          var ta;
          if (activity.id_parent === 0) {
            workflow = store.createRecord('workflow', {
              label: activity.label,
              order: activity.order,
              publish: activity.publish,
              kind: activity.kind,
              id_root: '-1',
              id_parent: '0'
            });
            return workflow.save().then(function() {
              workflow.setProperties({
                id_root: workflow.get('id')
              });
              return workflow.get('groups').then(function(groups) {
                groups.pushObject(group);
                return group.get('workflows').then(function(workflows) {
                  workflows.addObject(workflow);
                  return workflow.save().then(function() {
                    return group.save().then(function() {
                      activityLinks[activity.id] = workflow;
                      return next();
                    });
                  }, next);
                }, next);
              }, next);
            }, next);
          } else {
            ta = store.createRecord('templateActivity', {
              label: activity.label,
              order: activity.order,
              publish: activity.publish,
              kind: activity.kind,
              id_root: workflow.get('id'),
              id_parent: activityLinks[activity.id_parent].get('id')
            });
            return ta.save().then(function() {
              return workflow.get('templateActivities').then(function(templateActivities) {
                templateActivities.addObject(ta);
                return workflow.save().then(function() {
                  activityLinks[activity.id] = ta;
                  return next();
                }, next);
              });
            }, next);
          }
        }, function(err) {
          if (err != null) {
            return reject(err);
          } else {
            return resolve(activityLinks);
          }
        });
      });
    },
    generateFields: function(fields, activities, activityLinks, roleLinks) {
      var fieldLinks, store;
      store = this.get('store');
      fieldLinks = {};
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return async.eachSeries(activities.sortBy('id_parent', 'order', 'id'), function(activity, done) {
          var taFields;
          taFields = fields.filter(function(f) {
            return f.id_tActivity === activity.id;
          });
          return async.eachSeries(taFields.sortBy('order', 'id'), function(field, next) {
            var tf;
            tf = store.createRecord('templateField', {
              pattern: field.pattern,
              visible: field.visible,
              style: JSON.parse(field.style),
              label: field.label,
              readonly: field.readonly,
              order: field.order,
              required: field.required
            });
            return tf.save().then(function() {
              var ta;
              ta = activityLinks[field.id_tActivity];
              return ta.get('templateFields').then(function(templateFields) {
                templateFields.addObject(tf);
                return tf.get('templateActivities').then(function(templateActivities) {
                  templateActivities.addObject(ta);
                  return ta.save().then(function() {
                    return tf.save().then(function() {
                      fieldLinks[field.id] = tf;
                      return next();
                    }, next);
                  }, next);
                }, next);
              });
            }, next);
          }, done);
        }, function(err) {
          if (err != null) {
            return reject(err);
          } else {
            return resolve(fieldLinks);
          }
        });
      });
    },
    updateFieldLookups: function(fieldLinks, roleLinks) {
      var fieldRegexes, roleRegexes, store, updatedFieldLinks;
      store = this.get('store');
      updatedFieldLinks = {};
      fieldRegexes = this.get('fieldRegexes');
      roleRegexes = [/\{UsersByGroupAndRoleAsSelectPattern\:.+\:\d+\}/mg, /\{UserEmailsByGroupAndRoleAsCommaSeparated\:.+\:\d+\}/mg];
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var fieldIds;
          fieldIds = Object.keys(fieldLinks).map(function(f) {
            return parseInt(f);
          });
          return async.each(fieldIds, function(fieldId, next) {
            return _this.get('store').find('template-field', fieldLinks[fieldId].id).then(function(tf) {
              var newPattern;
              newPattern = _this.regexReplacer(fieldRegexes, fieldLinks[fieldId].get('pattern'), function(id) {
                return fieldLinks[id].get('id');
              });
              newPattern = _this.regexReplacer(roleRegexes, newPattern, (function(id) {
                return roleLinks[id];
              }), (function(id) {
                return id > 3;
              }));
              tf.set('pattern', newPattern);
              return tf.save().then(function() {
                updatedFieldLinks[fieldId] = tf;
                return next();
              }, next);
            }, next);
          }, function(err) {
            if (err != null) {
              return reject(err);
            } else {
              return resolve(updatedFieldLinks);
            }
          });
        };
      })(this));
    },
    generateConditions: function(guards, roleLinks, fieldLinks, activityLinks) {
      var activityRegexes, fieldRegexes, roleRegexes, store;
      store = this.get('store');
      fieldRegexes = this.get('fieldRegexes');
      activityRegexes = [/\{activity\.id\:\d+\}/mg];
      roleRegexes = [/rid\!?[\=\<\>]\d+\=\>/mg];
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var activityIds;
          activityIds = Object.keys(activityLinks).map(function(k) {
            return parseInt(k);
          });
          return async.each(activityIds, function(activityId, activityDone) {
            var activationOrders, activityGuards, completionOrders;
            activityGuards = guards.filter(function(g) {
              return g.tActivityId === activityId;
            });
            activationOrders = 0;
            completionOrders = 0;
            return async.eachSeries(activityGuards.sortBy('id'), function(guard, done) {
              var condition, filterOrder, type;
              filterOrder = 0;
              type = guard.state === 'active' ? 'activation' : 'completion';
              condition = store.createRecord('condition', {
                name: '',
                order: type === 'activation' ? activationOrders : completionOrders,
                status: guard.active ? 'active' : 'disabled',
                type: type
              });
              return condition.save().then(function() {
                var newSpec;
                newSpec = _this.regexReplacer(fieldRegexes, guard.spec, function(id) {
                  return fieldLinks[id].get('id');
                });
                newSpec = _this.regexReplacer(activityRegexes, newSpec, function(id) {
                  return activityLinks[id].get('id');
                });
                newSpec = _this.regexReplacer(roleRegexes, newSpec, (function(id) {
                  return roleLinks[id];
                }), (function(id) {
                  return id > 3;
                }));
                return async.eachSeries(newSpec.split('~~'), function(filterString, next) {
                  var comparatorIdentifier, comparatorStr, comparison, filter, property, ref, ref1, value;
                  ref = filterString.split('=>'), comparatorStr = ref[0], comparatorIdentifier = ref[1];
                  value = comparatorStr.substring(4);
                  ref1 = (function() {
                    switch (filterString.substring(3, 4)) {
                      case '=':
                        return ['is', value];
                      case '>':
                        return ['greater than', value];
                      case '>':
                        return ['less than', value];
                      case '%':
                        return ['contains', value];
                      case '!':
                        if (filterString.substring(4, 5) === '=') {
                          return ['is not', comparatorStr.substring(5)];
                        } else {
                          return ['is', value];
                        }
                      default:
                        return ['is', value];
                    }
                  })(), comparison = ref1[0], value = ref1[1];
                  comparatorIdentifier = comparatorIdentifier.substring(1, comparatorIdentifier.length - 1);
                  property = (function() {
                    switch (comparatorIdentifier) {
                      case 'user.email:{currentuser.id}':
                        return 'current-user_email';
                      case 'currentuser.rids':
                        return 'current-user_role';
                      default:
                        if (/^activity\.id/.test(comparatorIdentifier)) {
                          return "templateActivity-" + (comparatorIdentifier.split(':')[1]);
                        } else {
                          return comparatorIdentifier.split(':')[1];
                        }
                    }
                  })();
                  filter = store.createRecord('filter', {
                    property: property,
                    comparison: comparison,
                    value: value,
                    order: filterOrder
                  });
                  return filter.save().then(function() {
                    return filter.get('conditions').then(function(conditions) {
                      conditions.addObject(condition);
                      return condition.get('filters').then(function(filters) {
                        filters.addObject(filter);
                        return condition.save().then(function() {
                          return filter.save().then(function() {
                            return next();
                          }, next);
                        }, next);
                      }, next);
                    }, next);
                  }, next);
                }, function(err) {
                  var activity;
                  if (err != null) {
                    return done(err);
                  } else {
                    if (type === 'activation') {
                      activationOrders += 1;
                    } else {
                      completionOrders += 1;
                    }
                    activity = activityLinks[activityId];
                    return condition.get('templateActivities').then(function(templateActivities) {
                      templateActivities.addObject(activity);
                      return activity.get('templateConditions').then(function(templateConditions) {
                        templateConditions.addObject(condition);
                        return activity.save().then(function() {
                          return condition.save().then(function() {
                            return done();
                          }, done);
                        }, done);
                      }, done);
                    }, done);
                  }
                });
              }, done);
            }, activityDone);
          }, function(err) {
            if (err != null) {
              return reject(err);
            } else {
              return resolve();
            }
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=taskflow_recipe_adder.js.map


(function() {
  KotiveWebapp.TaskflowRecipesMixin = Ember.Mixin.create({
    showTaskflowRecipes: function(taskflowTemplate) {
      var action, viewName;
      if (taskflowTemplate != null) {
        this.set('model.taskflowTemplate', taskflowTemplate);
      } else if ($.localStorage.get('generate-taskflow-template') != null) {
        this.set('model.taskflowTemplate', $.localStorage.get('generate-taskflow-template'));
      }
      $.localStorage.remove('generate-taskflow-template');
      action = 'openModal';
      viewName = 'taskflow-recipes';
      return this.send(action, viewName, this.get('model'));
    }
  });

}).call(this);

//# sourceMappingURL=taskflow_recipes_mixin.js.map


(function() {
  KotiveWebapp.ValidationMixin = Ember.Mixin.create({
    validationFor: function(field) {
      var kind, pattern, patternString, readonly, regex, valString, value, visible;
      readonly = field.get('readonly');
      visible = field.get('visible');
      if (readonly || !visible) {
        return null;
      }
      value = field.get('value');
      pattern = field.get('pattern');
      patternString = field.patternString;
      if (field.style) {
        kind = field.style.kind;
      } else if (field.get('style')) {
        kind = field.get('style').kind;
      }
      if (patternString != null) {
        valString = patternString;
      } else {
        valString = value;
      }
      if (!valString) {
        return null;
      }
      if (kind === 'email') {
        regex = /^\S+@\S+\.\S+$/;
        if (!valString.match(regex)) {
          return 'Please enter a valid email address';
        }
      }
      if (kind === 'number') {
        if (!this.isNumber(valString)) {
          return 'Please enter a valid number';
        }
      }
      return null;
    },
    isNumber: function(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  });

}).call(this);

//# sourceMappingURL=validation_mixin.js.map


(function() {
  KotiveWebapp.DropTooltipViewMixin = Ember.Mixin.create(KotiveWebapp.DocumentQueryMixin, {
    doDropToolTipSetup: function() {
      this.setDropShowAtListener();
      this.setDropCloseListener();
      this.setDropRepositionListener();
      return this.set('pageInitialised', true);
    },
    doDropTooltipTeardown: function() {
      if ($.contains(document, '.drop-drop-tooltip-target-placeholder')) {
        this.get('applicationDrop').destroy();
      }
      this.get('controller').off('showDropAt', this);
      this.get('controller').off('closeDrop', this);
      return this.get('controller').off('repositionDropTooltip', this);
    },
    applicationDrop: (function() {
      var viewEl;
      viewEl = this.get('viewEl');
      return new Drop({
        target: viewEl.querySelector('.drop-tooltip-target-placeholder'),
        content: viewEl.querySelector('.drop-tooltip-content'),
        openOn: 'click',
        classes: 'drop-theme-arrows',
        constrainToWindow: true,
        constrainToScrollParent: true
      });
    }).property(),
    dropPosition: (function() {
      return 'top right';
    }).property(),
    dropPositionMobile: (function() {
      return 'top right';
    }).property(),
    screenSize: (function() {
      var currentPosition, drop, isOpen;
      if (this.get('pageInitialised')) {
        drop = this.get('applicationDrop');
        if (drop != null) {
          currentPosition = this.getPositioning();
          if (drop.options.position !== currentPosition) {
            isOpen = drop.isOpened();
            drop.options.position = currentPosition;
            if (isOpen) {
              drop.close();
            }
            drop.setupTether();
            if (isOpen) {
              return drop.open();
            }
          }
        }
      }
    }).observes('controller.controllers.application.viewType'),
    pathChanged: (function() {
      var drop;
      if (this.get('pageInitialised')) {
        drop = this.get('applicationDrop');
        if ((drop != null) && drop.isOpened()) {
          return drop.close();
        }
      }
    }).observes('controller.controllers.application.currentPath'),
    setDropShowAtListener: function() {
      return this.get('controller').on('showDropAt', this, function(target, options) {
        var drop;
        drop = this.get('applicationDrop');
        if (drop != null) {
          drop.options.position = this.getPositioning(options.position, options.positionMobile);
          drop.target = target;
          drop.setupTether();
          drop.open();
          $('.drop.drop-element').addClass('drop-offscreen');
          return Ember.run.next(function() {
            drop.position();
            return $('.drop.drop-element').removeClass('drop-offscreen');
          });
        }
      });
    },
    setDropCloseListener: function() {
      return this.get('controller').on('closeDrop', this, function() {
        var drop;
        drop = this.get('applicationDrop');
        if (drop != null) {
          return drop.close();
        }
      });
    },
    getPositioning: function(position, positionMobile) {
      if (this.get('controller.controllers.application.viewType') === 'desktop') {
        return position || this.get('dropPosition');
      } else {
        return positionMobile || this.get('dropPositionMobile');
      }
    },
    setDropRepositionListener: function() {
      return this.get('controller').on('repositionDropTooltip', this, function() {
        var drop;
        drop = this.get('applicationDrop');
        if (drop != null) {
          return Ember.run.later((function(_this) {
            return function() {
              return drop.position();
            };
          })(this), 0);
        }
      });
    }
  });

}).call(this);

//# sourceMappingURL=drop_tooltip_view_mixin.js.map


(function() {
  KotiveWebapp.ElementHeightSetViewMixin = Ember.Mixin.create({
    setActivityEditorSizeEvents: function(options) {
      this.set('heightOffset', options.heightOffset);
      this.set('elementQuery', options.element);
      $(window).resize((function(_this) {
        return function() {
          return _this.setActivityEditorSize();
        };
      })(this));
      return Ember.run.schedule('afterRender', (function(_this) {
        return function() {
          return _this.setActivityEditorSize(options.element);
        };
      })(this));
    },
    setActivityEditorSize: function() {
      var elementObj, elementQuery, heightOffset;
      elementQuery = this.get('elementQuery');
      if ((elementQuery != null) && !this.get('isDestroyed')) {
        elementObj = this.$(elementQuery);
        if ((elementObj == null) || elementObj.length === 0) {
          return Ember.run.later((function(_this) {
            return function() {
              return _this.setActivityEditorSize();
            };
          })(this), 100);
        } else {
          heightOffset = this.get('heightOffset');
          return elementObj.css('max-height', $(window).height() - heightOffset);
        }
      }
    }
  });

}).call(this);

//# sourceMappingURL=element_height_set_view_mixin.js.map


(function() {
  KotiveWebapp.KotiveFlowIntegrationViewMixin = Ember.Mixin.create(KotiveWebapp.DocumentQueryMixin, KotiveWebapp.LocalstorageIntegrationMixin, {
    setupKotiveFlowDesigner: function(elementId) {
      this.initializeDesigner(elementId);
      this.set('activitiesOrderSaving', false);
      return this.set('activitiesOrderRequiresSave', false);
    },
    teardownFlowDesigner: function() {
      return this.get('controller').off('markActivityAdded', this);
    },
    initializeDesigner: function(elementId) {
      var actionName, model, viewName;
      actionName = 'openModal';
      viewName = 'template-activity-add';
      model = this.get('controller.model');
      return this.getWorkflowDataObjects().then((function(_this) {
        return function(data) {
          return KotiveFlow.initialize({
            element: elementId,
            activities: data,
            intentToAddActivity: function(element, activityData) {
              var planLimits;
              console.log('planLimits');
              planLimits = $.localStorage.get('plan-limits');
              console.log(planLimits);
              model = _this.createNewActivity(activityData);
              return Ember.run.later(function() {
                return _this.get('controller').send(actionName, viewName, model);
              }, 50);
            },
            intentToActivateActivity: function(activity) {
              return _this.get('controller').trigger('activityActivated', activity.id);
            },
            onActivityOrdersUpdated: function(activitiesHash) {
              if (_this.get('activitiesOrderSaving')) {
                _this.set('activitiesOrderRequiresSave', true);
                return _this.set('lastestOrderedActivityHash', activitiesHash);
              } else {
                return _this.updateActivitiesOrder(activitiesHash);
              }
            },
            enterSubTaskflow: function(templateActivityId, draggingEvent) {
              return _this.get('controller').trigger('activityActivated', templateActivityId);
            },
            leaveSubTaskflow: function(templateActivityId, draggingEvent) {
              var rootId;
              rootId = _this.get('controller.model.id');
              if (rootId !== templateActivityId) {
                return _this.get('controller').trigger('activityActivated', templateActivityId);
              } else {
                if (!draggingEvent) {
                  return _this.subTaskNavigated();
                }
              }
            }
          });
        };
      })(this));
    },
    getWorkflowDataObjects: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var rootId, store;
          rootId = _this.get('controller.model.id');
          store = _this.get('controller.store');
          return store.find('template-activity').then(function(tas) {
            var curOrder, idParent, order, templateActivities;
            templateActivities = tas.filter(function(ta) {
              return ta.get('id_root') === rootId;
            });
            if (templateActivities.length === 0) {
              return resolve([]);
            } else {
              curOrder = order = idParent = null;
              return resolve(templateActivities.sortBy('id_parent', 'order', 'label').map(function(ta) {
                if (ta.get('id_parent') === '0') {
                  if (ta.get('order') !== 0) {
                    ta.set('order', 0);
                  }
                } else {
                  if (idParent !== ta.get('id_parent')) {
                    curOrder = -1;
                    order = null;
                    idParent = ta.get('id_parent');
                  }
                  if (order !== ta.get('order')) {
                    curOrder += 1;
                    order = ta.get('order');
                  }
                  if (curOrder !== order) {
                    ta.set('order', curOrder);
                    ta.save();
                  }
                }
                return ta.toFlowObject();
              }));
            }
          }, reject);
        };
      })(this));
    },
    createNewActivity: function(activityData) {
      var model, originalId, store;
      originalId = activityData.id;
      delete activityData.id;
      store = this.get('controller.store');
      model = store.createRecord('template-activity', activityData);
      model.set('originalFlowId', originalId);
      return model;
    },
    subTaskNavigated: function() {
      var controller, currentPath;
      controller = this.get('controller');
      currentPath = controller.get('controllers.application.currentPath');
      if (currentPath === 'group.designer.workflow.template-activity.index') {
        return controller.transitionToRoute('workflow');
      }
    },
    setupMarkActivityAddedListener: function() {
      return this.get('controller').on('markActivityAdded', this, function(model) {
        var activityData, originalId;
        originalId = model.get('originalFlowId');
        activityData = model.toFlowObject();
        return KotiveFlow.updateActivity(originalId, activityData);
      });
    },
    updateActivitiesOrder: function(activitiesHash) {
      var model, promisesList, store, waitForPromises;
      model = this.get('controller.model');
      store = this.get('controller.store');
      promisesList = [];
      waitForPromises = (function(_this) {
        return function(promisesListObj, callback) {
          var activity;
          if (promisesListObj.length === 0) {
            return callback();
          } else {
            activity = promisesListObj[0];
            return activity.then(function() {
              return waitForPromises(promisesListObj.slice(1), callback);
            }, function(err) {
              throw new Error(err);
            });
          }
        };
      })(this);
      this.set('activitiesOrderSaving', true);
      return model.get('templateActivities').then((function(_this) {
        return function(templateActivities) {
          templateActivities.forEach(function(activity) {
            var activityData, id, originalFlowId;
            id = activity.get('id');
            originalFlowId = activity.get('originalFlowId');
            activityData = activitiesHash[id] || activitiesHash[originalFlowId];
            if (activity.get('order') !== activityData.order || activity.get('id_parent') !== activityData.id_parent) {
              activity.set('order', activityData.order);
              activity.set('id_parent', activityData.id_parent);
              return promisesList.pushObject(activity.save());
            }
          });
          return waitForPromises(promisesList, function() {
            _this.set('activitiesOrderSaving', false);
            if (_this.get('activitiesOrderRequiresSave')) {
              _this.set('activitiesOrderRequiresSave', false);
              return _this.updateActivitiesOrder(_this.get('lastestOrderedActivityHash'));
            }
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=kotive_flow_integration_view_mixin.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.ApplicationController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.ScreenEnquireMixin, KotiveWebapp.MessengerMixin, KotiveWebapp.LocalstorageIntegrationMixin, KotiveWebapp.WebappUpdatesMixin, KotiveWebapp.KeychainProcessMixin, KotiveWebapp.BasicAuthMixin, KotiveWebapp.IntercomMixin, KotiveWebapp.AmplitudeMixin, KotiveWebapp.RaygunMixin, KotiveWebapp.PlanLimitsMixin, KotiveWebapp.MetadataUpdatesMixin, {
    needs: ['application', 'group'],
    history: [],
    ignoreList: ['group.solution.taskflow', 'group.solution.taskflow.index', 'group.solution.task.full', 'group.solution.task.lite'],
    init: function() {
      this.initLocalstorage();
      if (this.get('userLoggedIn')) {
        this.initScreenEnquire();
        this.initUpdateListener();
        this.setupMessenger();
        this.set('invalidData', false);
        this.set('validationMessage', null);
        this.set('emailInvalid', false);
        this.configureForGroup();
        this.configureShowBillingUpgrade();
        this.set('inEmbeddedPath', indexOf.call(_.keys($.getUrlVars()), 'embedded') >= 0);
        this.initAmplitude();
        this.set('intercomCounter', 0);
        document.addEventListener('KotiveWebapp:online', (function(_this) {
          return function() {
            return _this.set('appOnline', true);
          };
        })(this));
        document.addEventListener('KotiveWebapp:offline', (function(_this) {
          return function() {
            return _this.set('appOnline', false);
          };
        })(this));
        if (!this.get('isDesignerSynced')) {
          return this.transitionToRoute('startup');
        }
      }
    },
    willDestroy: function() {
      document.removeEventListener('KotiveWebapp:online');
      return document.removeEventListener('KotiveWebapp:offline');
    },
    actions: {
      goTo: function(menuItem) {
        var group;
        if (menuItem.get('path')) {
          return this.transitionToRoute(menuItem.get('path'));
        } else if (menuItem.get('click') === 'manageRoles') {
          group = this.get('controllers.group.model');
          return this.get('store').find('group-roles-link', group.get('id')).then((function(_this) {
            return function(grl) {
              return _this.send('openModal', 'role-editor', grl);
            };
          })(this));
        } else if (menuItem.get('click') === 'exitDesigner') {
          return window.location.href = '/hub/';
        }
      },
      minorReload: function() {
        return window.location.reload();
      },
      majorReload: function() {
        return KotiveSyncEngine.forceSync((function(_this) {
          return function() {
            _this.clearLocalStorage();
            indexedDB.deleteDatabase('KotiveDB');
            return window.location.href = '/';
          };
        })(this));
      }
    },
    checkShouldRedirect: (function() {
      if (!this.get('userLoggedIn') && this.get('currentPath') !== 'registration') {
        return window.location.href = '/hub/';
      }
    }).observes('currentPath', 'redirectToHub'),
    appOnline: (function() {
      return KotiveWebappConfigs.webappOnline;
    }).property(),
    onlineStatusChanged: (function() {
      var hideAfter, message;
      if (this.get('firstOnlineCheckDone') || !this.get('appOnline')) {
        if (this.get('appOnline')) {
          message = 'Looks like you are back online. All online functionality has been restored.';
          hideAfter = 15;
        } else {
          message = 'You are offline. Some functionality may be unavailable. Please check your connection.';
          hideAfter = false;
        }
        Messenger().post({
          id: 'online-status-message',
          singleton: false,
          hideAfter: hideAfter,
          showCloseButton: true,
          message: message,
          type: 'info'
        });
      }
      if (!this.get('firstOnlineCheckDone')) {
        return this.set('firstOnlineCheckDone', true);
      }
    }).observes('appOnline'),
    doUpdateActiveMenu: (function() {
      if (this.get('navItems') != null) {
        return this.updateActiveMenu();
      }
    }).observes('currentPath'),
    taskflowReportsSet: (function() {
      var taskflowReports;
      taskflowReports = this.get('taskflowReports');
      return (taskflowReports != null) && (taskflowReports.map(function(t) {
        return t;
      })).length > 0;
    }).property('taskflowReports'),
    showTaskflowReports: (function() {
      var companyGroupModel, ref;
      companyGroupModel = this.get('companyGroupModel');
      return this.get('appOnline') && (companyGroupModel != null) && ((ref = companyGroupModel.get('level')) === 'application' || ref === 'organization');
    }).property('companyGroupModel', 'appOnline'),
    showTaskflowReportsOffline: (function() {
      return this.get('userLoggedIn') && !this.get('appOnline');
    }).property('userLoggedIn', 'appOnline'),
    loadingTaskflowReports: (function() {
      return this.get('taskflowReports') == null;
    }).property('taskflowReports'),
    isLogin: (function() {
      var currentPath;
      currentPath = this.get('currentPath');
      return currentPath === 'login';
    }).property('currentPath'),
    isForgot: (function() {
      var currentPath;
      currentPath = this.get('currentPath');
      return currentPath === 'forgot';
    }).property('currentPath'),
    isReset: (function() {
      var currentPath;
      currentPath = this.get('currentPath');
      return currentPath === 'reset';
    }).property('currentPath'),
    isRegistration: (function() {
      var currentPath;
      currentPath = this.get('currentPath');
      return currentPath === 'registration';
    }).property('currentPath'),
    hideNav: (function() {
      var currentPath;
      currentPath = this.get('currentPath');
      return currentPath === 'login' || currentPath === 'forgot' || currentPath === 'reset' || currentPath === 'startup' || currentPath === 'registration' || currentPath === 'group.taskflow.lite' || currentPath === 'switch' || currentPath === 'user.synchronise' || currentPath === 'user.invite-synchronise';
    }).property('currentPath'),
    isSolutionLite: (function() {
      var currentPath;
      currentPath = this.get('currentPath');
      return currentPath === 'group.solution.task.lite';
    }).property('currentPath'),
    isSolutionFull: (function() {
      var currentPath;
      currentPath = this.get('currentPath');
      return currentPath === 'group.solution.task.full';
    }).property('currentPath'),
    groupRootModel: (function() {
      return KotiveWebapp.GroupRootModel.create();
    }).property(),
    confirmSignup: (function() {
      var currentPath;
      currentPath = this.get('currentPath');
      return currentPath === 'signup';
    }).property('currentPath'),
    inDesignerPath: (function() {
      return this.runInDesignerPathLogic();
    }).observes('currentPath'),
    companyGroupChanged: (function() {
      return this.configureForGroup();
    }).observes('companyGroup', 'userLoggedIn', 'systemRoles', 'userRoles', 'hideNav'),
    updateTaskflowReports: (function() {
      return this.setTaskflowReports();
    }).observes('companyGroup', 'companyGroupModel', 'appOnline'),
    updateIntercom: (function() {
      return this.notifyIntercom();
    }).observes('currentPath'),
    setShowBillingUpgrade: (function() {
      return this.configureShowBillingUpgrade();
    }).observes('companyGroup'),
    configureShowBillingUpgrade: function() {
      if (this.get('companyGroup') != null) {
        return KotiveBatchRecordsSync.onSyncComplete(this.get('companyGroup'), (function(_this) {
          return function() {
            var group;
            group = null;
            return _this.getCompanyGroupFor(_this.get('companyGroup')).then(function(g) {
              group = g;
              return KotiveBatchRecordsSync.onSyncComplete(g.get('id'), function() {
                return _this.get('store').find('groupRolesLink', group.get('id')).then(function(grl) {
                  return grl.get('roles');
                }).then(function(roles) {
                  var accountOwnerRole;
                  accountOwnerRole = roles.find(function(r) {
                    return r.get('id') === '1';
                  });
                  if (accountOwnerRole != null) {
                    _this.set('billableUpgradeLink', "/billing/verify/" + (group.get('id')));
                  }
                  return _this.set('showBillingUpgradeLink', accountOwnerRole != null);
                })["catch"](function(err) {
                  _this.set('showBillingUpgradeLink', false);
                  if (err != null) {
                    return console.error(err);
                  }
                });
              });
            }, function(err) {
              _this.set('showBillingUpgradeLink', false);
              if (err != null) {
                return console.error(err);
              }
            });
          };
        })(this));
      }
    },
    getCompanyGroupFor: function(groupId) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('store').find('group').then(function(groups) {
            var group;
            group = groups.find(function(g) {
              return g.get('id') === groupId;
            });
            if (group != null) {
              if (group.get('level') === 'company') {
                return resolve(group);
              } else {
                return _this.getCompanyGroupFor(group.get('id_parent')).then(resolve, reject);
              }
            } else {
              return reject(null);
            }
          });
        };
      })(this));
    },
    configureForGroup: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.setHasRoleInCurrentGroup('makerRole', 'isMakerForGroup').then(function() {
            return _this.setHasRoleInCurrentGroup('accountOwnerRole', 'isAccountOwnerForGroup');
          }).then(function() {
            return _this.setHasRoleInCurrentGroup('userAdministratorRole', 'isUserAdministratorForGroup');
          }).then(function() {
            return _this.doNavigationSetup();
          }).then(function() {
            return resolve();
          })["catch"](function(err) {
            if (err != null) {
              console.log(err);
            }
            return reject(err);
          });
        };
      })(this));
    },
    runInDesignerPathLogic: function() {
      if (/^group\.designer\.workflows/.test(this.get('currentPath'))) {
        return this.trigger('notInDesignerPath');
      } else if (/^group\.designer\./.test(this.get('currentPath'))) {
        return this.trigger('inDesignerPath');
      } else {
        return this.trigger('notInDesignerPath');
      }
    },
    setTaskflowReports: function() {
      var group, ref;
      if (this.get('userLoggedIn') && this.get('appOnline')) {
        this.set('taskflowReports', []);
        group = this.get('companyGroupModel');
        if ((group != null) && group !== 'root' && ((ref = group.get('level')) === 'application' || ref === 'organization')) {
          return this.getServerId(group.get('id'), 'groups').then((function(_this) {
            return function(id) {
              return _this.get('store').find('taskflow-report', {
                groupId: id
              }).then(function(taskflowReports) {
                taskflowReports = taskflowReports.sortBy('label');
                return _this.set('taskflowReports', taskflowReports);
              });
            };
          })(this));
        }
      } else {
        return this.set('taskflowReports', []);
      }
    },
    setNavItems: function() {
      var company;
      company = this.get('companyGroupModel');
      return this.store.find('application-menu-item').then((function(_this) {
        return function(items) {
          var navItems;
          navItems = items.filter(function(item) {
            return (!_this.get('userLoggedIn') || (company != null ? company.get('level') : void 0) === 'application' || item.get('name') !== 'Designer') && (_this.get('userLoggedIn') || item.get('name') !== 'People') && ((_this.get('isMakerForGroup') && item.get('name') === 'Designer') || item.get('name') !== 'Designer') && ((_this.get('isUserAdministratorForGroup') && item.get('name') === 'People') || item.get('name') !== 'People');
          });
          _this.set('navItems', navItems);
          return _this.updateActiveMenu();
        };
      })(this));
    },
    updateActiveMenu: function() {
      var currentPath;
      currentPath = this.get('currentPath');
      return this.get('navItems').forEach(function(item) {
        return item.set('isActive', indexOf.call(item.get('matchPaths'), currentPath) >= 0);
      });
    },
    doNavigationSetup: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          if (_this.get('hideNav')) {
            return resolve();
          } else {
            return _this.setCompanyGroupModel().then(function() {
              _this.setNavItems();
              return resolve();
            }, reject());
          }
        };
      })(this));
    },
    setHasRoleInCurrentGroup: function(systemRoleName, roleProperty) {
      var discoverGroupPermission, store, systemRole, userLoggedIn, userRoles;
      userLoggedIn = this.get('userLoggedIn');
      systemRole = this.get(systemRoleName);
      userRoles = this.get('userRoles');
      store = this.get('store');
      discoverGroupPermission = (function(_this) {
        return function(groupId, groups) {
          return new Ember.RSVP.Promise(function(resolve, reject) {
            var group, role;
            group = groups.find(function(g) {
              return g.get('id') === groupId;
            });
            if (group != null) {
              role = userRoles.find(function(r) {
                return r.groupId.toString() === group.get('id') && r.role.id === systemRole.id;
              });
              if (role != null) {
                _this.set(roleProperty, true);
                return resolve();
              } else {
                return discoverGroupPermission(group.get('id_parent'), groups).then(resolve, reject);
              }
            } else {
              _this.set(roleProperty, false);
              return resolve();
            }
          });
        };
      })(this);
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var gid;
          if (userLoggedIn) {
            gid = _this.get('companyGroup');
            if ((gid != null) && (systemRole != null) && (userRoles != null)) {
              return store.find('group').then(function(groups) {
                return discoverGroupPermission(gid, groups).then(resolve, reject);
              });
            } else {
              _this.set(roleProperty, false);
              return resolve();
            }
          } else {
            _this.set(roleProperty, true);
            return resolve();
          }
        };
      })(this));
    },
    setCompanyGroupModel: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          if (_this.get('userLoggedIn')) {
            if (_this.get('companyGroup') === 'root') {
              _this.set('companyGroupModel', _this.get('groupRootModel'));
              return resolve();
            } else if (_this.get('companyGroup') != null) {
              return _this.get('store').find('group', _this.get('companyGroup')).then(function(group) {
                _this.set('companyGroupModel', group);
                return resolve();
              }, reject);
            } else {
              _this.set('companyGroupModel', null);
              return resolve();
            }
          } else {
            _this.set('companyGroupModel', null);
            return resolve();
          }
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=application_controller.js.map


(function() {
  KotiveWebapp.ConditionController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.KeychainProcessMixin, KotiveWebapp.BasicAuthMixin, {
    needs: ['application', 'workflow', 'template-activity', 'group'],
    init: function() {
      return Ember.run.scheduleOnce('afterRender', this, this.doSetup);
    },
    doSetup: function() {
      this._setupConditions();
      return this._setupGroupedFields();
    },
    actions: {
      markFilterEdited: function() {
        return this.send('markActivityEdited');
      },
      addFilter: function(condition) {
        return this._addFilter(condition);
      },
      createActivationCondition: function() {
        return this._createCondition('activation');
      },
      createCompletionCondition: function() {
        return this._createCondition('completion');
      },
      removeFilter: function(filter) {
        return this.removeFilterFromCondition(filter);
      }
    },
    conditionsChanged: (function() {
      return this._setupConditions();
    }).observes('model', 'model.templateConditions.@each'),
    templateFieldsChanged: (function() {
      return this._setupGroupedFields();
    }).observes('model', 'model.templateFields.@each', 'model.templateFields.@each.isDirty'),
    hasActCond: (function() {
      var ref;
      return ((ref = this.get('actConditions')) != null ? ref.length : void 0) !== 0;
    }).property('actConditions.@each'),
    hasCmplCond: (function() {
      var ref;
      return ((ref = this.get('cmplConditions')) != null ? ref.length : void 0) !== 0;
    }).property('cmplConditions'),
    group: (function() {
      return this.get('controllers.group.model');
    }).property('controllers.group.model'),
    userLoggedIn: (function() {
      return this.get('controllers.application.userLoggedIn');
    }).property('controllers.application.userLoggedIn'),
    removeFilterFromCondition: function(filter) {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return filter.get('conditions').then(function(conditionsObject) {
          filter.deleteRecord();
          return filter.save().then(function() {
            var conditions;
            conditions = conditionsObject.map(function(condition) {
              return condition;
            });
            return async.each(conditions, function(condition, next) {
              return condition.get('filters').then(function(filters) {
                filters.removeObject(filter);
                return condition.save().then(function() {
                  if (filters.content.length === 0) {
                    return condition.get('templateActivities').then(function(tas) {
                      condition.deleteRecord();
                      return condition.save().then(function() {
                        var templateActivities;
                        templateActivities = tas.map(function(ta) {
                          return ta;
                        });
                        return async.eachSeries(templateActivities, function(templateActivity, next) {
                          return templateActivity.get('templateConditions').then(function(conditions) {
                            conditions.removeObject(condition);
                            return templateActivity.save().then(function() {
                              templateActivity.recalculateConditionOrder(condition.get('type'));
                              return next();
                            });
                          });
                        });
                      });
                    });
                  } else {
                    condition.recalculateFiltersOrder();
                    return next();
                  }
                }, function(err) {
                  return next(err);
                });
              });
            }, function(err) {
              if (err != null) {
                return reject(err);
              } else {
                return resolve();
              }
            });
          });
        }, function(err) {
          return reject(err);
        });
      });
    },
    _setupConditions: function() {
      var model;
      model = this.get('model');
      if (model != null) {
        return model.get('templateConditions').then((function(_this) {
          return function(conditions) {
            if (!(_this.get('isDestroyed') || _this.get('isDestroying'))) {
              _this.set('actConditions', conditions.filterBy('type', 'activation').sortBy('order'));
              _this.set('cmplConditions', conditions.filterBy('type', 'completion').sortBy('order'));
              return _this.trigger('conditionChanges');
            }
          };
        })(this));
      }
    },
    _setupGroupedFields: function(callback) {
      var group, store;
      store = this.get('store');
      group = this.get('group');
      return async.parallel([
        (function(_this) {
          return function(callback) {
            return store.findAll('filter-comparison-type').then(function(filterComparisonTypes) {
              if (!(_this.get('isDestroyed') || _this.get('isDestroying'))) {
                _this.set('comparisonTypes', filterComparisonTypes.sortBy('id', 'key'));
              }
              return callback();
            });
          };
        })(this), (function(_this) {
          return function(callback) {
            var setRoles;
            setRoles = function(roles) {
              if (!(_this.get('isDestroyed') || _this.get('isDestroying'))) {
                _this.set('userRoles', roles.sortBy('label'));
              }
              return callback();
            };
            if (_this.get('userLoggedIn')) {
              return store.find('group-roles-link', group.get('id')).then(function(grl) {
                return grl.get('roles').then(function(roles) {
                  return setRoles(roles);
                });
              });
            } else {
              return store.find('static-offline-role').then(function(roles) {
                return setRoles(roles);
              });
            }
          };
        })(this), (function(_this) {
          return function(callback) {
            return store.findAll('condition-user-option').then(function(options) {
              var groupedFields, workflow;
              groupedFields = options.sortBy('order');
              workflow = _this.get('controllers.workflow.model');
              if (workflow != null) {
                return workflow.get('templateActivities').then(function(activities) {
                  return async.eachSeries(activities.sortBy('label'), function(activity, next) {
                    return activity.get('templateFields').then(function(fields) {
                      var chosenOption;
                      fields.sortBy('order').forEach(function(field) {
                        var chosenOption;
                        chosenOption = {
                          label: field.get('label'),
                          id: field.get('id'),
                          grouping: activity.get('label')
                        };
                        return groupedFields.pushObject(chosenOption);
                      });
                      chosenOption = {
                        label: 'Active Date',
                        id: "templateActivity-" + (activity.get('id')),
                        grouping: activity.get('label')
                      };
                      groupedFields.pushObject(chosenOption);
                      return next();
                    });
                  }, function(err) {
                    if (!(_this.get('isDestroyed') || _this.get('isDestroying'))) {
                      _this.set('groupedTemplateFields', groupedFields);
                    }
                    if (callback != null) {
                      return callback(err);
                    }
                  });
                });
              } else {
                if (callback != null) {
                  return callback();
                }
              }
            });
          };
        })(this)
      ], function(err, results) {
        if (err != null) {
          console.log(err);
          if (callback != null) {
            return callback(err);
          }
        }
      });
    },
    _createCondition: function(type) {
      var condition;
      condition = this.get('store').createRecord('condition', {
        type: type
      });
      return condition.save().then((function(_this) {
        return function() {
          return _this.saveTemplateCondition(condition);
        };
      })(this));
    },
    _addFilter: function(condition) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var filter;
          filter = _this.get('store').createRecord('filter');
          return condition.get('filters').then(function(filters) {
            filter.set('order', filters.content.length);
            filters.pushObject(filter);
            return filter.get('conditions').then(function(conditions) {
              conditions.pushObject(condition);
              return filter.save().then(function() {
                return condition.save().then(resolve, reject);
              }, reject);
            }, reject);
          }, reject);
        };
      })(this));
    },
    saveTemplateCondition: function(condition) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var model;
          model = _this.get('model');
          return _this._addFilter(condition).then(function() {
            return model.get('templateConditions').then(function(conditions) {
              condition.set('order', conditions.content.length);
              conditions.pushObject(condition);
              return condition.get('templateActivities').then(function(templateActivities) {
                templateActivities.pushObject(model);
                return condition.save().then(function() {
                  return templateActivities.save().then(function() {
                    model.recalculateConditionOrder(condition.get('type'));
                    return resolve();
                  }, reject);
                }, reject);
              }, reject);
            });
          }, reject);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=condition_controller.js.map


(function() {
  KotiveWebapp.DesignerWorkflowsController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.TaskflowRecipesMixin, {
    needs: ['application', 'group'],
    queryParams: ['taskflowTemplate'],
    taskflowTemplate: null,
    noWorkflows: (function() {
      var ref;
      return ((ref = this.get('sortedWorkflows')) != null ? ref.length : void 0) === 0;
    }).property('sortedWorkflows'),
    inDesktopMode: (function() {
      return this.get('controllers.application.inDesktopMode');
    }).property('controllers.application.inDesktopMode'),
    group: (function() {
      return this.get('controllers.group.model');
    }).property('controllers.group.model'),
    groupModelChanged: (function() {
      return this.fetchWorkflowsForGroup();
    }).observes('group', 'group.workflows', 'group.workflows.@each'),
    userLoggedIn: (function() {
      return this.get('controllers.application.userLoggedIn');
    }).property('controllers.application.userLoggedIn'),
    isMakerForGroup: (function() {
      return this.get('controllers.application.isMakerForGroup');
    }).property('controllers.application.isMakerForGroup'),
    loadingTaskflowReports: (function() {
      return this.get('controllers.application.loadingTaskflowReports');
    }).property('controllers.application.loadingTaskflowReports'),
    taskflowReportsSet: (function() {
      return this.get('controllers.application.taskflowReportsSet');
    }).property('controllers.application.taskflowReportsSet'),
    taskflowReports: (function() {
      return this.get('controllers.application.taskflowReports');
    }).property('controllers.application.taskflowReports'),
    showDesignerLinks: (function() {
      var group;
      group = this.get('group');
      return (group.get('level') === 'application') && this.get('isMakerForGroup');
    }).property('controllers.application.isMakerForGroup', 'group'),
    showLiveLinks: (function() {
      return this.get('controllers.application.userLoggedIn');
    }).property('controllers.application.userLoggedIn'),
    actions: {
      showAddActivityTemplateDrop: function() {
        if (this.get('userLoggedIn')) {
          return this.trigger('showDrop');
        } else {
          return this.send('openSignupModal');
        }
      },
      startNewTaskflow: function(id) {
        var model;
        model = this.get('model');
        return this.transitionToRoute('taskflow.full', model.get('id'), 'blank', {
          queryParams: {
            identifier: id
          }
        });
      }
    },
    newTemplateActivity: function() {
      return this.get('store').createRecord('workflow', KotiveWebapp.Workflow.defaults);
    },
    fetchWorkflowsForGroup: function() {
      var group;
      this.set('sortedWorkflows', []);
      group = this.get('group');
      if ((group != null) && group !== 'root' && (group.get('workflows') != null)) {
        return group.get('workflows').then((function(_this) {
          return function(workflows) {
            if (!_this.destroyed()) {
              workflows = workflows.filterBy('id_parent', '0').sortBy('label').filter(function(workflow) {
                return workflow.get('actualId') == null;
              });
              return _this.set('sortedWorkflows', workflows);
            }
          };
        })(this));
      } else {
        if (!this.destroyed()) {
          return this.set('sortedWorkflows', []);
        }
      }
    },
    destroyed: function() {
      return this.get('isDestroyed') || this.get('isDestroying');
    }
  });

}).call(this);

//# sourceMappingURL=designer_workflows_controller.js.map


(function() {
  KotiveWebapp.ForgotController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.MessengerMixin, KotiveWebapp.ErrorMessageMixin, {
    needs: ['group', 'user', 'application'],
    init: function() {
      this.set('dataValid', true);
      this.set('apiError', false);
      return this.set('errors', []);
    },
    reset: function() {
      return this.get('model').setProperties({
        email: "",
        password: "",
        passwordConfirmation: ""
      });
    },
    validationErrors: (function() {
      return !this.get('dataValid');
    }).property('dataValid', 'errors', 'controllers.application.currentPath', 'model'),
    showApiAlert: (function() {
      return this.get('apiError');
    }).property('controllers.application.currentPath', 'apiError'),
    actions: {
      userForgot: function() {
        this.send('validateForm');
        if (this.get('dataValid')) {
          this.set('processingForgot', true);
          return this.send('postForgotToApi');
        }
      },
      validateForm: function() {
        var model;
        model = this.get('model');
        model.set('company', 'xxxx');
        model.set('password', 'xxxx');
        model.set('passwordConfirmation', 'xxxx');
        model.set('company', 'xxxx');
        model.validate();
        this.set('dataValid', true);
        if (!model.get("isValid")) {
          this.set('errors', this.get('content.errors'));
          this.set('dataValid', false);
          return this.buildErrorString(model);
        }
      },
      postForgotToApi: function() {
        var controller, model, userEmail;
        controller = this;
        model = this.get('model');
        userEmail = model.get('email');
        return this.apiUserForgot(userEmail).then((function(_this) {
          return function(data) {
            _this.set('processingForgot', false);
            return controller.transitionToRoute('login');
          };
        })(this), (function(_this) {
          return function(err) {
            _this.set('processingForgot', false);
            console.log("postConfirmationToApi:  " + err);
            return controller.set('apiError', true);
          };
        })(this));
      }
    },
    apiUserForgot: function(userEmail) {
      var payload;
      payload = {
        "email": userEmail
      };
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return Messenger().run({
          errorMessage: "We're busy upgrading the server. Please try again in 10 minutes.",
          successMessage: "We've sent you an email with instructions to reset your password.",
          showCloseButton: true,
          id: 'user-signup',
          singleton: false,
          hideAfter: 5
        }, Ember.$.ajax({
          url: "/api/user/resetpassword",
          type: 'POST',
          contentType: 'application/json',
          dataType: 'text',
          data: JSON.stringify(payload),
          success: function(data, textStatus, jqXHR) {
            return resolve(data);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            var error;
            error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
            console.log(error);
            return reject(error);
          }
        }));
      });
    }
  });

}).call(this);

//# sourceMappingURL=forgot_controller.js.map


(function() {
  KotiveWebapp.GroupCreateController = Ember.Controller.extend({
    queryParams: ['level'],
    level: null,
    actions: {
      cancel: function() {
        return this.get('model').destroyRecord().then((function(_this) {
          return function() {
            return _this.send('backToPeople');
          };
        })(this));
      },
      backToPeople: function() {
        return this.transitionToRoute('people');
      }
    }
  });

}).call(this);

//# sourceMappingURL=group_create_controller.js.map


(function() {
  KotiveWebapp.GroupEditController = Ember.Controller.extend({
    queryParams: ['previous'],
    previous: null,
    actions: {
      cancel: function() {
        this.get('model').rollback();
        return this.send('backToPeople');
      },
      backToPeople: function() {
        var previous;
        previous = this.get('previous') || 'root';
        return this.transitionToRoute('people', previous);
      }
    }
  });

}).call(this);

//# sourceMappingURL=group_edit_controller.js.map


(function() {
  KotiveWebapp.GroupFormController = Ember.Controller.extend(KotiveWebapp.KeychainProcessMixin, KotiveWebapp.BasicAuthMixin, {
    needs: ['application'],
    actions: {
      save: function() {
        var isNew, model, store;
        this.set('doValidations', true);
        if (this.get('formValid')) {
          isNew = this.get('model.isNew');
          store = this.get('store');
          model = this.get('model');
          return model.save().then((function(_this) {
            return function() {
              if (isNew) {
                return KotiveSyncEngine.forceSync(function() {
                  var grl;
                  grl = store.createRecord('group-roles-link', {
                    id: _this.get('model.id')
                  });
                  return grl.save().then(function() {
                    return _this.getServerId(model.get('id'), 'groups');
                  }).then(function(id) {
                    KotiveBatchRecordsSync.setBasicAuthToken(_this.generateBasicAuthToken());
                    return KotiveBatchRecordsSync.fetchBatchRecords(id, function(err, data) {
                      var batchFetchData, groupId, roleIds;
                      groupId = data[0], batchFetchData = data[1];
                      roleIds = batchFetchData.roles.map(function(r) {
                        return r.id;
                      });
                      return store.findByIds('role', roleIds).then(function(rs) {
                        var roles;
                        roles = grl.get('roles');
                        rs.forEach(function(r) {
                          return roles.addObject(r);
                        });
                        return grl.save().then(function() {
                          _this.saveSuccessMessage();
                          return _this.send('backToPeople');
                        });
                      });
                    });
                  })["catch"](function(err) {
                    console.log(err);
                    return _this.saveErrorMessage();
                  });
                });
              } else {
                _this.saveSuccessMessage();
                return _this.send('backToPeople');
              }
            };
          })(this), (function(_this) {
            return function(err) {
              console.log(err);
              return _this.saveErrorMessage();
            };
          })(this));
        }
      }
    },
    formValid: (function() {
      return this.get('doValidations') && !this.get('missingLabel');
    }).property('doValidations', 'model.label'),
    levelCapitalized: (function() {
      var level;
      level = this.get('model.levelName');
      if (level != null) {
        return level.capitalize();
      } else {
        return '';
      }
    }).property('levelName'),
    fieldsChanged: (function() {
      if (this.get('doValidations')) {
        return this.setValidationProperties();
      }
    }).observes('doValidations', 'model.label'),
    setValidationProperties: function() {
      return this.setProperties({
        missingLabel: (this.get('model.label') == null) || this.get('model.label') === ''
      });
    },
    saveSuccessMessage: function() {
      return Messenger().post({
        id: 'group-create-success',
        singleton: false,
        hideAfter: 5,
        showCloseButton: true,
        message: "The " + (this.get('model.levelName')) + " \"" + (this.get('model.label')) + "\" has been saved successfully.",
        type: 'success'
      });
    },
    saveErrorMessage: function() {
      return Messenger().post({
        id: 'group-create-error',
        singleton: false,
        hideAfter: 10,
        showCloseButton: true,
        message: "Sorry, but we had some issues creating you new " + (this.get('model.level')),
        type: 'error'
      });
    },
    getRolesForGroup: function(groupId) {}
  });

}).call(this);

//# sourceMappingURL=group_form_controller.js.map


(function() {
  KotiveWebapp.IndexController = Ember.Controller.extend(Ember.Evented, {
    needs: ['application']
  });

}).call(this);

//# sourceMappingURL=index_controller.js.map


(function() {
  KotiveWebapp.LoginController = Ember.Controller.extend(KotiveWebapp.LoginLogicMixin, KotiveWebapp.SetActiveGroupMixin, KotiveWebapp.ErrorMessageMixin, KotiveWebapp.RaygunMixin, {
    queryParams: ['next', 'pathType'],
    next: 'index',
    pathType: 'webapp',
    needs: ['application'],
    validationErrors: (function() {
      this.get('validationMessage');
      return !this.get('dataValid');
    }).property('dataValid'),
    credentialErrors: (function() {
      return this.get('invalidCredentials');
    }).property('invalidCredentials'),
    showAjaxError: (function() {
      return this.get('ajaxError');
    }).property('ajaxError'),
    actions: {
      userLogin: function() {
        this.send('validateForm');
        if (this.get('dataValid')) {
          this.set('processingLogin', true);
          return this.send('postLoginToApi');
        }
      },
      validateForm: function() {
        var model;
        model = this.get('model');
        if (model.get('email') == null) {
          model.set('email', '');
        }
        if (model.get('password') == null) {
          model.set('password', '');
        }
        model.set('passwordConfirmation', model.get('password'));
        model.set('company', 'xxxx');
        model.validate();
        this.set('dataValid', true);
        if (!model.get("isValid")) {
          this.set('errors', this.get('content.errors'));
          this.set('dataValid', false);
          this.set('ajaxError', false);
          return this.buildErrorString(model);
        }
      },
      postLoginToApi: function() {
        return this.executeLoginLogic(this.get('model.email'), this.get('model.password')).then((function(_this) {
          return function() {
            return _this.transitionToRoute('user.synchronise', {
              queryParams: {
                next: _this.get('next'),
                pathType: _this.get('pathType')
              }
            });
          };
        })(this), (function(_this) {
          return function(err) {
            console.log(err);
            Messenger().post({
              message: "Something went wrong while processing your login details",
              type: "error",
              showCloseButton: true,
              hideAfter: 5
            });
            return _this.transitionToRoute('login');
          };
        })(this));
      }
    }
  });

}).call(this);

//# sourceMappingURL=login_controller.js.map


(function() {
  KotiveWebapp.OfflineController = Ember.Controller.extend({
    needs: ['application'],
    init: function() {
      return document.addEventListener('KotiveWebapp:online', (function(_this) {
        return function() {
          if (_this.get('controllers.application.currentPath') === 'offline') {
            return _this.transitionToRoute('index');
          }
        };
      })(this));
    },
    willDestroy: function() {
      return document.removeEventListener('KotiveWebapp:online');
    }
  });

}).call(this);

//# sourceMappingURL=offline_controller.js.map


(function() {
  KotiveWebapp.PeopleCreateController = Ember.Controller.extend(KotiveWebapp.MessengerMixin, KotiveWebapp.KeychainProcessMixin, {
    needs: ['application', 'group', 'people'],
    actions: {
      doPersonSave: function(callback) {
        var model, people;
        people = this.get('controllers.people.model');
        model = this.get('model');
        return this.getServerId(this.get('group.id'), 'groups').then(function(id) {
          model.set('groupId', parseInt(id));
          model.set('email', model.get('username'));
          model.set('password', '');
          return model.save();
        }).then(function() {
          people.addObject(model);
          if (callback != null) {
            return callback();
          }
        })["catch"]((function(_this) {
          return function(err) {
            console.log(err);
            return _this.createPersonError();
          };
        })(this));
      }
    },
    group: (function() {
      return this.get('controllers.group.model');
    }).property('controllers.group.model'),
    createPersonError: function() {
      return Messenger().post({
        id: 'person-create-error',
        singleton: false,
        hideAfter: 10,
        showCloseButton: true,
        message: 'Sorry but something went wrong while attempting to create the new person\'s record',
        type: 'error'
      });
    }
  });

}).call(this);

//# sourceMappingURL=people_create_controller.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.PeopleIndexController = Ember.ArrayController.extend(KotiveWebapp.KeychainProcessMixin, KotiveWebapp.ParentGroupsMixin, {
    needs: ['group', 'application'],
    init: function() {
      var paths;
      this._super(arguments);
      this.setupBreadCrumbs();
      paths = ['group.people.index', 'group.people.create', 'group.create', 'group.edit', 'group.person.edit'];
      return document.addEventListener('KotiveWebapp:offline', (function(_this) {
        return function() {
          var ref;
          if (ref = _this.get('controllers.application.currentPath'), indexOf.call(paths, ref) >= 0) {
            return _this.transitionToRoute('offline');
          }
        };
      })(this));
    },
    willDestroy: function() {
      return document.removeEventListener('KotiveWebapp:offline');
    },
    actions: {
      editRoles: function() {
        var group;
        group = this.get('group');
        return this.get('store').find('group-roles-link', group.get('id')).then((function(_this) {
          return function(grl) {
            return _this.send('openModal', 'role-editor', grl);
          };
        })(this));
      },
      createGroup: function() {
        return this.transitionToRoute('group.create', this.get('group'), {
          queryParams: {
            level: this.get('addLevel')
          }
        });
      }
    },
    group: (function() {
      return this.get('controllers.group.model');
    }).property('controllers.group.model'),
    groupIdentifier: (function() {
      var group;
      group = this.get('group');
      if (group === 'root') {
        return 'root';
      } else {
        return group.get('id');
      }
    }).property('group'),
    showManageRoles: (function() {
      return this.get('group.level') === 'application';
    }).property('group'),
    showCreatePeople: (function() {
      return this.get('group') !== 'root';
    }).property('group'),
    addLevel: (function() {
      if (this.get('group') === 'root') {
        return 'company';
      } else {
        if (this.get('group.level') === 'company') {
          return 'application';
        } else {
          return 'organization';
        }
      }
    }).property('group'),
    addLevelName: (function() {
      switch (this.get('addLevel')) {
        case 'company':
          return 'Maker account';
        case 'application':
          return 'App';
        case 'organization':
          return 'Organization/Team';
        default:
          return 'Organization/Team';
      }
    }).property('addLevel'),
    noPeopleData: (function() {
      return this.get('group') !== 'root' && this.get('model').content.length === 0;
    }).property('model', 'model.@each'),
    noGroupData: (function() {
      return (this.get('subGroups') != null) && this.get('subGroups').length === 0;
    }).property('subGroups', 'subGroups.@each'),
    noPeopleGroupData: (function() {
      return this.get('noPeopleData') && this.get('noGroupData') && !this.get('stillLoading');
    }).property('noPeopleData', 'noGroupData'),
    hasPeopleGroupData: (function() {
      return !this.get('noPeopleGroupData');
    }).property('noPeopleGroupData'),
    reportColumns: (function() {
      return [
        {
          title: ''
        }, {
          title: 'Name'
        }, {
          title: 'Email'
        }, {
          title: 'Mobile'
        }, {
          title: ''
        }
      ];
    }).property(),
    orderRows: (function() {
      return [[4, 'desc'], [1, 'asc']];
    }).property(),
    avatarService: (function() {
      return KotiveWebapp.XAvatarComponent.create();
    }).property(),
    dataRows: (function() {
      var avatarService, group, rows;
      if ((this.get('model') != null) && (this.get('subGroups') != null)) {
        rows = [];
        avatarService = this.get('avatarService');
        group = this.get('group');
        this.get('model').forEach(function(person) {
          var nameCol, updateCol;
          nameCol = (avatarService.getHtml(person.get('email'))) + "&nbsp;&nbsp;<strong>" + (Ember.String.htmlSafe(person.get('fullName'))) + "</strong>";
          updateCol = "<a href=\"#/group/" + (group.get('id')) + "/person/" + (person.get('id')) + "/edit\">update Person</a>";
          return rows.pushObject([
            '', nameCol, person.get('email'), person.get('mobile') || '-', updateCol, {
              'DT_RowId': person.get('id')
            }
          ]);
        });
        this.get('subGroups').forEach((function(_this) {
          return function(group) {
            var link, nameCol, updateCol, updateLink;
            link = "<a href=\"#/group/" + (group.get('id')) + "/people\">" + (Ember.String.htmlSafe(group.get('label'))) + "</a>";
            nameCol = "<img src=\"" + (group.get('iconImage')) + "\" class=\"img-rounded\"/>&nbsp;&nbsp;" + link;
            updateLink = "#/group/" + (group.get('id')) + "/edit";
            if (_this.get('group') !== 'root') {
              updateLink += "?previous=" + (_this.get('group.id'));
            }
            updateCol = "<a href=\"" + updateLink + "\">update " + (group.get('levelName')) + "</a>";
            rows.pushObject(['', nameCol, '-', '-', updateCol]);
            return rows['DT_RowId'] = group.get('id');
          };
        })(this));
        return rows;
      } else {
        return null;
      }
    }).property('model', 'model.@each', 'subGroups', 'subGroups.@each'),
    companyGroup: (function() {
      return this.get('controllers.application.companyGroup');
    }).property('controllers.application.companyGroup'),
    updateSubGroups: (function() {
      return this.setupSubGroups();
    }).observes('group'),
    updateBreadCrumbs: (function() {
      return this.setupBreadCrumbs();
    }).observes('group'),
    setupSubGroups: function() {
      if (this.get('group') === 'root') {
        return this.generateParentGroupsList();
      } else {
        return this.generateSubGroupsList();
      }
    },
    generateSubGroupsList: function() {
      return this.get('store').find('group').then((function(_this) {
        return function(groups) {
          _this.set('subGroups', groups.filterBy('id_parent', _this.get('group.id')).sortBy('label'));
          return _this.set('stillLoading', false);
        };
      })(this));
    },
    generateParentGroupsList: function(gs) {
      return this.findParentGroups().then((function(_this) {
        return function(groups) {
          _this.set('subGroups', groups.sortBy('label'));
          return _this.set('stillLoading', false);
        };
      })(this));
    },
    setupBreadCrumbs: function() {
      var crumbs, group;
      group = this.get('group');
      if (group === 'root') {
        crumbs = [
          {
            group: {
              label: 'People',
              id: 'root'
            },
            active: true
          }
        ];
        return this.set('breadCrumbs', crumbs);
      } else {
        return this.generateBreadCrumbs(group);
      }
    },
    generateBreadCrumbs: function(group) {
      var crumbs, prependGroups;
      crumbs = [
        {
          group: group,
          active: true
        }
      ];
      prependGroups = (function(_this) {
        return function(group) {
          var id;
          if (group.get('id') === _this.get('companyGroup') || group.get('id_parent') === "1") {
            return _this.set('breadCrumbs', crumbs);
          } else {
            id = group.get('id_parent');
            return _this.get('store').find('group', id).then(function(g) {
              crumbs.unshift({
                group: g,
                active: false
              });
              return prependGroups(g);
            });
          }
        };
      })(this);
      return prependGroups(group);
    }
  });

}).call(this);

//# sourceMappingURL=people_index_controller.js.map


(function() {
  KotiveWebapp.PersonEditController = Ember.Controller.extend({
    actions: {
      doPersonSave: function(callback) {
        if (callback != null) {
          return callback();
        }
      }
    }
  });

}).call(this);

//# sourceMappingURL=person_edit_controller.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.PersonFormController = Ember.Controller.extend(KotiveWebapp.MessengerMixin, KotiveWebapp.BasicAuthMixin, KotiveWebapp.KeychainProcessMixin, KotiveWebapp.IntercomMixin, {
    needs: ['application', 'group', 'people'],
    emailRegex: /^\S+@\S+\.\S+$/,
    doValidations: false,
    init: function() {
      this._super(arguments);
      this.set('savingPerson', false);
      this.getRoles();
      return this.setPersonRoles();
    },
    actions: {
      save: function() {
        var afterSaveCallback;
        afterSaveCallback = (function(_this) {
          return function() {
            return _this.saveRelatedPersonData().then(function() {
              return _this.transitionToRoute('people');
            });
          };
        })(this);
        if (this.get('model.isNew')) {
          this.set('doValidations', true);
          if (this.get('formValid')) {
            this.setInitialSavingState();
            return this.send('doPersonSave', afterSaveCallback);
          }
        } else {
          this.setInitialSavingState();
          return this.send('doPersonSave', afterSaveCallback);
        }
      }
    },
    formValid: (function() {
      return this.get('doValidations') && !this.get('emailInvalid') && !this.get('duplicateEmailForGroup') && !this.get('missingFirstName') && !this.get('missingLastName');
    }).property('doValidations', 'emailInvalid', 'missingFirstName', 'missingLastName'),
    group: (function() {
      return this.get('controllers.group.model');
    }).property('controllers.group.model'),
    selectedRoles: (function() {
      if (this.get('personRoles') != null) {
        return this.get('personRoles').map(function(personRole) {
          return personRole.get('roleId').toString();
        });
      } else {
        return [];
      }
    }).property('personRoles'),
    currentPath: (function() {
      return this.get('controllers.application.currentPath');
    }).property('controllers.application.currentPath'),
    updateSortedRoles: (function() {
      var disabledRoles, roles;
      if (this.get('roles') != null) {
        roles = this.get('roles').sortBy('label').map(function(r) {
          return r;
        });
        disabledRoles = ['1', '3'];
        return async.map(roles, (function(_this) {
          return function(role, next) {
            return _this.getServerId(role.get('id'), 'roles').then(function(id) {
              return next(null, {
                key: id.toString(),
                value: role.get('label'),
                isDisabled: indexOf.call(disabledRoles, id) >= 0 ? true : void 0
              });
            }, next);
          };
        })(this), (function(_this) {
          return function(err, rs) {
            if (err != null) {
              return console.error(err);
            } else {
              return _this.set('sortedRoles', rs);
            }
          };
        })(this));
      } else {
        return this.set('sortedRoles', []);
      }
    }).observes('roles', 'roles.@each'),
    updatePersonRoles: (function() {
      return this.setPersonRoles();
    }).observes('model', 'group'),
    fieldsChanged: (function() {
      if (this.get('doValidations')) {
        return this.setValidationProperties();
      }
    }).observes('doValidations', 'model.username', 'model.firstname', 'model.lastname'),
    updateRolesForGroup: (function() {
      return this.getRoles();
    }).observes('group'),
    duplicateEmailForGroup: (function() {
      var duplicatePerson, model;
      model = this.get('model');
      duplicatePerson = this.get('controllers.people.model').filter(function(person) {
        return person.get('id') !== model.get('id') && person.get('username') === model.get('username');
      });
      return duplicatePerson.length > 0;
    }).property('model', 'model.username'),
    showInvalidEmailMessage: (function() {
      return this.get('doValidations') && (this.get('duplicateEmailForGroup') || this.get('emailInvalid'));
    }).property('duplicateEmailForGroup', 'emailInvalid'),
    invalidEmailMessage: (function() {
      if (this.get('duplicateEmailForGroup')) {
        return "a user with the same email address is already linked to this " + (this.get('group.levelName'));
      } else {
        return 'valid email required';
      }
    }).property('duplicateEmailForGroup'),
    saveRelatedPersonData: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.createNewRoleLinks().then(function(rolesCreated) {
            return _this.deleteOldRoleLinks(rolesCreated);
          }).then(function(rolesChanged) {
            return new Ember.RSVP.Promise(function(resolve, reject) {
              if (rolesChanged) {
                if (_this.get('model.email') === _this.get('controllers.application.userEmail')) {
                  Messenger().post({
                    id: 'person-modify-self',
                    singleton: false,
                    hideAfter: 30,
                    showCloseButton: true,
                    message: 'You have just modified your own user account. Please log out and log in again to see these changes take effect on your account.',
                    type: 'info'
                  });
                }
                return _this.queryPersonRoles().then(function(personRoles) {
                  _this.set('personRoles', personRoles);
                  return resolve();
                });
              } else {
                return resolve();
              }
            });
          }).then(function() {
            return _this.sendEmailRequests();
          }).then(function() {
            _this.showSuccessMessage();
            return resolve();
          })["catch"](function(err) {
            console.error(err);
            Messenger().post({
              id: 'person-modify-error',
              singleton: false,
              hideAfter: 10,
              showCloseButton: true,
              message: 'Sorry but something went wrong while attempting to create the new person\'s record',
              type: 'error'
            });
            return reject();
          });
        };
      })(this));
    },
    createNewRoleLinks: function() {
      var created;
      this.set('savingStatusMessage', 'Updating role information...');
      created = false;
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var group, model, personRoles;
          personRoles = _this.get('personRoles');
          model = _this.get('model');
          group = _this.get('group');
          return _this.getServerId(group.get('id'), 'groups').then(function(groupId) {
            return async.each(_this.get('selectedRoles'), function(roleIdentifier, next) {
              return _this.getServerId(roleIdentifier, 'roles').then(function(roleId) {
                var matchingRoles, personRole;
                matchingRoles = personRoles.filter(function(personRole) {
                  return personRole.get('roleId').toString() === roleId;
                });
                if (matchingRoles.length === 0) {
                  personRole = _this.get('store').createRecord('personRole', {
                    userId: model.get('id'),
                    roleId: roleId,
                    groupId: groupId
                  });
                  return personRole.save().then(function(personRole) {
                    created = true;
                    return next();
                  }, next);
                } else {
                  return next();
                }
              }, next);
            }, function(err) {
              if (err != null) {
                return reject(err);
              } else {
                return resolve(created);
              }
            });
          });
        };
      })(this));
    },
    deleteOldRoleLinks: function(created) {
      var deleted;
      deleted = false;
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var personRoles, selectedRoles;
          selectedRoles = _this.get('selectedRoles').map(function(id) {
            return parseInt(id);
          });
          personRoles = _this.get('personRoles').filter(function(pr) {
            return !pr.get('isDeleted');
          });
          return async.each(personRoles, function(personRole, next) {
            var ref;
            if (ref = personRole.get('roleId'), indexOf.call(selectedRoles, ref) < 0) {
              return personRole.destroyRecord().then(function() {
                deleted = true;
                return next();
              }, next);
            } else {
              return next();
            }
          }, function(err) {
            if (err != null) {
              return reject(err);
            } else {
              return resolve(deleted || created);
            }
          });
        };
      })(this));
    },
    sendEmailRequests: function() {
      var sendInvite, sendPasswordReset;
      sendInvite = (function(_this) {
        return function() {
          return new Ember.RSVP.Promise(function(resolve, reject) {
            if (_this.get('sendInviteEmail')) {
              return _this.getServerId(_this.get('group.id'), 'groups').then(function(id) {
                var url;
                _this.set('savingStatusMessage', 'Sending invite email request...');
                url = "/api/user/" + (_this.get('model.id')) + "/invite/to/" + id;
                return Ember.$.ajax({
                  url: url,
                  type: 'POST',
                  headers: {
                    Authorization: _this.generateBasicAuthToken()
                  },
                  success: function(data, textStatus, jqXHR) {
                    var trackingMetadata;
                    _this.set('sendInviteEmail', false);
                    trackingMetadata = {
                      to: _this.get('model.email')
                    };
                    _this.trackEventIntercom('Sent an invite email', trackingMetadata);
                    return resolve();
                  },
                  error: function(jqXHR, textStatus, errorThrown) {
                    var error;
                    error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                    console.error(error);
                    return reject(error);
                  }
                });
              });
            } else {
              return resolve();
            }
          });
        };
      })(this);
      sendPasswordReset = (function(_this) {
        return function() {
          return new Ember.RSVP.Promise(function(resolve, reject) {
            if (_this.get('sendPasswordResetEmail')) {
              _this.set('savingStatusMessage', 'Sending password reset email request...');
              return Ember.$.ajax({
                url: '/api/user/resetpassword',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                  email: _this.get('model.username')
                }),
                success: function(data, textStatus, jqXHR) {
                  var trackingMetadata;
                  _this.set('sendPasswordResetEmail', false);
                  trackingMetadata = {
                    to: _this.get('model.email')
                  };
                  _this.trackEventIntercom('Sent a password reset email', trackingMetadata);
                  return resolve();
                },
                error: function(jqXHR, textStatus, errorThrown) {
                  var error;
                  error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                  console.log(error);
                  return reject(error);
                }
              });
            } else {
              return resolve();
            }
          });
        };
      })(this);
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return sendInvite().then(function() {
          return sendPasswordReset();
        }).then(function() {
          return resolve();
        })["catch"](function(err) {
          return reject(err);
        });
      });
    },
    setInitialSavingState: function() {
      this.set('savingPerson', true);
      return this.set('savingStatusMessage', 'Saving person\'s details...');
    },
    getRoles: function() {
      var store;
      store = this.get('store');
      return store.find('group-roles-link', this.get('group.id')).then(function(grl) {
        return grl.get('roles');
      }).then((function(_this) {
        return function(roles) {
          return _this.set('roles', roles);
        };
      })(this))["catch"](function(err) {
        return console.log(err);
      });
    },
    setPersonRoles: function() {
      if (this.get('model.alreadyExists')) {
        return this.queryPersonRoles().then((function(_this) {
          return function(personRoles) {
            return _this.set('personRoles', personRoles);
          };
        })(this));
      } else {
        return this.set('personRoles', []);
      }
    },
    queryPersonRoles: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.getServerId(_this.get('group.id'), 'groups').then(function(id) {
            var personId;
            personId = _this.get('model.id');
            return _this.get('store').find('personRole', {
              personId: personId,
              groupId: id
            }).then(function(prs) {
              var personRoles;
              personRoles = prs.map(function(pr) {
                return pr;
              });
              return resolve(personRoles);
            });
          });
        };
      })(this));
    },
    setValidationProperties: function() {
      return this.setProperties({
        emailInvalid: !this.get('emailRegex').test(this.get('model.username')),
        missingFirstName: this.get('model.firstname') === '',
        missingLastName: this.get('model.lastname') === ''
      });
    },
    showSuccessMessage: function() {
      return Messenger().post({
        id: 'person-modify-success',
        singleton: false,
        hideAfter: 5,
        showCloseButton: true,
        message: (this.get('model.descriptor')) + " saved successfully.",
        type: 'success'
      });
    }
  });

}).call(this);

//# sourceMappingURL=person_form_controller.js.map


(function() {
  KotiveWebapp.ReferralsController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.ReferralsMixin, KotiveWebapp.IntercomMixin, KotiveWebapp.ErrorMessageMixin, KotiveWebapp.BasicAuthMixin, KotiveWebapp.KeychainProcessMixin, {
    needs: ['application'],
    actions: {
      openingModal: function() {
        this.set('loadingReferral', true);
        return this.getReferralToken().then((function(_this) {
          return function() {
            return _this.doGroupSelectionSetup();
          };
        })(this)).then((function(_this) {
          return function() {
            return _this.set('loadingReferral', false);
          };
        })(this))["catch"](function(err) {
          return console.error(err);
        });
      },
      highlightReferralToken: function() {
        return this.trigger('highlightReferralToken');
      }
    },
    getReferralToken: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.apiGetReferralToken().then(function(token) {
            _this.set('referralToken', token.token);
            return _this.get('store').find('group', token.linkedGroupId);
          }).then(function(group) {
            _this.set('linkedGroup', group);
            return resolve();
          })["catch"](reject);
        };
      })(this));
    },
    showCompanySelector: (function() {
      return (this.get('companyGroups') != null) && this.get('companyGroups').length > 1;
    }).property('companyGroups'),
    hasCompanyGroup: (function() {
      return (this.get('companyGroups') != null) && this.get('companyGroups').length !== 0;
    }).property('companyGroups'),
    companyOptions: (function() {
      if (this.get('companyGroups') != null) {
        return this.get('companyGroups').map(function(g) {
          return {
            key: g.get('id'),
            value: g.get('label')
          };
        });
      } else {
        return [];
      }
    }).property('companyGroups'),
    selectedCompanyId: (function() {
      var group;
      group = this.get('linkedGroup');
      if (group.get('actualId') != null) {
        return group.get('actualId');
      } else {
        return group.get('id');
      }
    }).property('linkedGroup'),
    referralLink: (function() {
      return "https://www.kotive.com/r#" + (this.get('referralToken'));
    }).property('referralToken'),
    encodedReferralLink: (function() {
      return "" + (encodeURIComponent(this.get('referralLink')));
    }).property('referralLink'),
    emailLink: (function() {
      var userEmail;
      userEmail = $.localStorage.get('user-email');
      return "mailto:?bcc=" + userEmail + "&subject=Have you heard of this?&body=Hey,%0A%0AI think you might find this interesting.%0A%0AI\'ve come across Kotive. It is a new way to build, share and run e-processes for your business or life. They say they make-tasks-flow.%0A%0AYou\'ll receive an extra 100 free task executions when you sign up using this link: " + (this.get('encodedReferralLink')) + "%0A%0A";
    }).property('referralLink'),
    twitterLink: (function() {
      return "https://twitter.com/intent/tweet?text=Awesome! Build and run e-processes with Kotive. Get (125%2B100) tasks to run for free.&url=" + (this.get('encodedReferralLink')) + "&via=kotiveHQ&hashtags=smallbusiness";
    }).property('referralLink'),
    facebookLink: (function() {
      return "https://www.facebook.com/sharer/sharer.php?u=" + (this.get('encodedReferralLink'));
    }).property('referralLink'),
    linkedInLink: (function() {
      return "https://www.linkedin.com/shareArticle?mini=true&url=" + (this.get('encodedReferralLink')) + "&title=Kotive is a new way to build, share and run e-processes for your business or life. Make-tasks-flow. Get (125%2B100) tasks to run for free.";
    }).property('referralLink'),
    googlePlusLink: (function() {
      return "https://plus.google.com/share?url=" + (this.get('encodedReferralLink'));
    }).property('referralLink'),
    selectedCompanyChanged: (function() {
      var newGroupId;
      newGroupId = this.get('selectedCompanyId');
      return this.doGroupSelectionUpdate(newGroupId).then(function() {
        return true;
      }, function(err) {
        return Messenger().post({
          id: 'group-link-update-error',
          singleton: false,
          hideAfter: 30,
          showCloseButton: true,
          message: 'Sory but something went wrong while attempting to update your group information - please try again in a few minutes',
          type: 'error'
        });
      });
    }).observes('selectedCompanyId')
  });

}).call(this);

//# sourceMappingURL=referrals_controller.js.map


(function() {
  KotiveWebapp.RegistrationController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.MessengerMixin, KotiveWebapp.ErrorMessageMixin, KotiveWebapp.BasicAuthMixin, KotiveWebapp.SetActiveGroupMixin, KotiveWebapp.AmplitudeMixin, KotiveWebapp.KeychainProcessMixin, KotiveWebapp.TaskflowRecipesMixin, {
    needs: ['user', 'application'],
    init: function() {
      this.set('dataValid', true);
      return this.set('ajaxError', false);
    },
    validationErrors: (function() {
      return !this.get('dataValid');
    }).property('controllers.application.currentPath', 'dataValid'),
    actions: {
      validateToken: function() {
        var model, userToken;
        model = this.get('model');
        userToken = model.get('token');
        return this.apiValidateToken(userToken).then(function(data) {
          var userEmail;
          userEmail = data.email;
          return model.set('email', userEmail);
        }, function(err) {
          return console.log("validateToken:  " + err);
        });
      },
      confirmSignup: function() {
        this.send('validateForm', 'confirmation');
        if (this.get('dataValid')) {
          this.set('processingRegistration', true);
          return this.send('postConfirmationToApi');
        } else {
          if (this.get('passwordInvalid')) {
            return this.trigger('confirmationPasswordInvalid');
          } else if (this.get('companyInvalid')) {
            return this.trigger('confirmationCompanyInvalid');
          }
        }
      },
      validateForm: function() {
        var model, password;
        this.set('errors', []);
        this.set('dataValid', true);
        this.set('passwordInvalid', false);
        this.set('companyInvalid', false);
        model = this.get('model');
        password = model.get('password');
        model.set('passwordConfirmation', password);
        model.validate();
        if (!model.get("isValid")) {
          this.set('errors', this.get('model.errors'));
          if (this.get('errors.password').length > 0) {
            this.set('passwordInvalid', true);
          }
          if (this.get('errors.company').length > 0) {
            this.set('companyInvalid', true);
          }
          this.set('dataValid', false);
          return this.buildErrorString(model);
        }
      },
      postConfirmationToApi: function() {
        var showErr;
        showErr = (function(_this) {
          return function(err) {
            console.error("postConfirmationToApi: " + err);
            _this.set('processingRegistration', false);
            return _this.trigger('apiError');
          };
        })(this);
        return this.apiCompleteRegistration().then((function(_this) {
          return function(data) {
            var authToken, basicAuthToken, trackingMetadata;
            authToken = data.authToken;
            _this.set('userEmail', _this.get('model.email'));
            _this.set('authToken', authToken);
            basicAuthToken = _this.create_basic_token(_this.get('model.email'), authToken);
            KotiveBatchRecordsSync.setBasicAuthToken(basicAuthToken);
            KotiveBatchRecordsSync.setUserEmail(_this.get('model.email'));
            trackingMetadata = {
              email: _this.get('model.email')
            };
            _this.trackEventAmplitude('Completed signup for Maker account', trackingMetadata);
            return _this.doGroupLinkups(_this.get('model.email'), data, function() {
              var appController;
              appController = _this.get('controllers.application');
              appController.setUserEmail(_this.get('model.email'));
              appController.setAuthToken(authToken);
              appController.setSystemRoles(data.systemRoles);
              appController.setUserRoles(data.userRoles);
              appController.setUserFullname(_this.get('model.fullName'));
              return KotiveSyncEngine.forceSync(function() {
                return _this.get('store').find('group').then(function(gs) {
                  var groupsToSync;
                  groupsToSync = gs.filter(function(g) {
                    return _this.isServerId(g.get('id'));
                  });
                  return async.each(groupsToSync, function(group, next) {
                    var id;
                    id = group.get('id');
                    KotiveBatchRecordsSync.onSyncComplete(id, function() {
                      return next();
                    });
                    return KotiveBatchRecordsSync.batchSyncGroups(id);
                  }, function(err) {
                    if (err != null) {
                      return showErr(err);
                    } else {
                      return _this.setupNewGroupRoles().then(function() {
                        _this.set('processingRegistration', false);
                        _this.transitionToRoute('index');
                        return _this.showTaskflowRecipes();
                      }, showErr);
                    }
                  });
                });
              });
            });
          };
        })(this), showErr);
      }
    },
    setupNewGroupRoles: function() {
      var store;
      store = this.get('store');
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return store.find('group').then(function(gs) {
            var newGroups;
            newGroups = gs.filter(function(g) {
              return !_this.isServerId(g.get('id'));
            });
            return async.each(newGroups, function(group, next) {
              var rolesLink;
              rolesLink = store.createRecord('groupRolesLink', {
                id: group.get('id')
              });
              window.testing = rolesLink;
              return store.find('groupRolesLink', group.get('id_parent')).then(function(parent) {
                return parent.get('roles');
              }).then(function(roles) {
                return new Ember.RSVP.Promise(function(res, rej) {
                  return rolesLink.get('roles').then(function(linkRoles) {
                    roles.forEach(function(r) {
                      return linkRoles.addRecord(r);
                    });
                    return rolesLink.save().then(res, rej);
                  });
                });
              }).then(function() {
                return next();
              })["catch"](next);
            }, function(err) {
              if (err != null) {
                return reject(err);
              } else {
                return resolve();
              }
            });
          }, reject);
        };
      })(this));
    },
    apiValidateToken: function(userToken) {
      var route;
      route = this;
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return Ember.$.ajax({
          url: "/api/user/registration/" + userToken,
          type: 'GET',
          contentType: 'application/json',
          success: function(data, textStatus, jqXHR) {
            return resolve(data);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            var error;
            error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
            console.log(error);
            if (jqXHR.status === 401 || jqXHR.status === 404) {
              Messenger().post({
                id: 'invalid-registration-token',
                singleton: false,
                hideAfter: 10,
                showCloseButton: true,
                message: "Sorry, but your registration is incorrect or has expired, please try sign up again or contact support@kotive.com",
                type: 'error'
              });
              route.transitionToRoute('index');
            }
            return reject(error);
          }
        });
      });
    },
    apiCompleteRegistration: function() {
      var api_url;
      api_url = "/api/user/registration/" + (this.get('model.token'));
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return Messenger().run({
            action: Ember.$.ajax,
            errorMessage: 'Sorry, something went wrong - we could not complete your registration. Please try again.',
            successMessage: 'Thank you for confirming your account with Kotive. You\'re now logged in.',
            showCloseButton: true,
            id: 'user-signup',
            singleton: false,
            hideAfter: 5
          }, {
            url: api_url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(_this.get('model').toRegistration()),
            success: function(data, textStatus, jqXHR) {
              resolve(data);
              return true;
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              console.log(error);
              reject(error);
              return true;
            }
          });
        };
      })(this));
    },
    doGroupLinkups: function(userEmail, signupData, callback) {
      return Ember.$.ajax({
        url: '/api/groups',
        type: 'GET',
        headers: {
          Authorization: this.generateBasicAuthToken()
        },
        success: (function(_this) {
          return function(data, textStatus, jqXHR) {
            var groupData, groupId;
            groupData = data.groups[0];
            groupId = groupData.id.toString();
            return _this.createParentGroup(userEmail, groupData).then(function() {
              return _this.updateGroupParents(groupId);
            }).then(function() {
              return _this.setActiveGroup();
            }).then(function() {
              return _this.createAppGroupIfRequired();
            }).then(function() {
              if (callback != null) {
                return callback();
              }
            })["catch"](function(err) {
              if (err != null) {
                return callback(err);
              }
            });
          };
        })(this),
        error: (function(_this) {
          return function(jqXHR, textStatus, errorThrown) {
            var error;
            error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
            console.log(error);
            _this.trigger('tokenInvalid');
            return _this.transitionToRoute('index');
          };
        })(this)
      });
    },
    createParentGroup: function(userEmail, groupData) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var group;
          group = _this.get('store').createRecord('group', {
            id: groupData.id.toString(),
            createdBy: userEmail,
            id_parent: groupData.id_parent.toString(),
            label: groupData.label,
            status: groupData.status,
            level: groupData.level
          });
          return group.save().then(function() {
            return resolve();
          }, function(err) {
            return reject(err);
          });
        };
      })(this));
    },
    updateGroupParents: function(parentId) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('store').findAll('group').then(function(gs) {
            var groups;
            groups = gs.map(function(g) {
              return g;
            });
            return async.each(groups, function(group, callback) {
              if (group.get('id') !== parentId) {
                return Ember.run(function() {
                  group.set('id_parent', parentId);
                  return group.save().then(function() {
                    return callback();
                  }, function(err) {
                    return callback(err);
                  });
                });
              } else {
                return callback();
              }
            }, function(err) {
              if (err != null) {
                return reject(err);
              } else {
                return resolve();
              }
            });
          }, reject);
        };
      })(this));
    },
    createAppGroupIfRequired: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var store;
          store = _this.get('store');
          return store.find('group').then(function(groups) {
            var companyGroup, group, noAppGroups;
            noAppGroups = groups.every(function(g) {
              return g.get('level') !== 'application';
            });
            if (noAppGroups) {
              companyGroup = groups.find(function(g) {
                return g.get('level') === 'company';
              });
              if (companyGroup != null) {
                group = store.createRecord('group', {
                  label: 'My App',
                  level: 'application',
                  id_parent: companyGroup.get('id')
                });
                return group.save().then(function(g) {
                  _this.get('controllers.application').setCompanyGroup(g.get('id'));
                  return resolve();
                }, reject);
              } else {
                return resolve();
              }
            } else {
              return resolve();
            }
          }, reject);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=registration_controller.js.map


(function() {
  KotiveWebapp.ReportColumnChooserController = Ember.Controller.extend(KotiveWebapp.KeychainProcessMixin, KotiveWebapp.BasicAuthMixin, {
    needs: ['application'],
    columnChangeTimer: null,
    actions: {
      applyColumnChanges: function() {
        return this.applyColumnOptionChanges();
      },
      closeDrop: function() {
        return this.set('columnsLoaded', null);
      }
    },
    templateActivitiesChanged: (function() {
      if (this.get('columnsLoaded') !== false) {
        return this.setReportColumnOptions();
      }
    }).observes('model', 'model.workflow.templateActivities.@each'),
    chosenComponentVisible: (function() {
      if (this.get('columnsLoaded')) {
        return Ember.run.next((function(_this) {
          return function() {
            return $('.column-options-selections .chosen-select').chosen().change(function(e) {
              return _this.set('model.columnsChanged', true);
            }).trigger('chosen:updated');
          };
        })(this));
      }
    }).observes('columnsLoaded'),
    applyColumnOptionChanges: function() {
      var headings, model, options, searchChoices;
      this.set('model.reportHeadingLoaded', false);
      this.set('model.reportDataLoaded', false);
      if (this.get('columnChangeTimer') != null) {
        clearTimeout(this.get('columnChangeTimer'));
      }
      options = [];
      $('.column-options-selections .chosen-select').children().each(function(index, optGrp) {
        options.push(optGrp);
        return $(optGrp).children().each(function(index, opt) {
          return options.push(opt);
        });
      });
      searchChoices = $('.column-options-selections .chosen-container ul.chosen-choices li.search-choice');
      model = this.get('model');
      headings = [];
      this.send('closeDropTooltip');
      return this.set('columnChangeTimer', setTimeout(function() {
        searchChoices.each(function(index, choice) {
          var activityId, fieldId, option, ref;
          index = $(choice).find('a').data('option-array-index');
          option = $(options[index]);
          ref = option.val().split('_'), activityId = ref[0], fieldId = ref[1];
          return headings.pushObject({
            label: option.text(),
            templateActivityId: activityId,
            templateFieldId: fieldId
          });
        });
        return model.set('taskflowHeadings', headings);
      }, 1000));
    },
    setReportColumnOptions: function() {
      var headings;
      this.set('columnsLoaded', false);
      headings = this.get('model.taskflowHeadings');
      return this.get('model.workflow.templateActivities').then((function(_this) {
        return function(tas) {
          var activities;
          activities = tas.sortBy('order', 'label').map(function(ta) {
            return ta;
          });
          return async.mapSeries(activities, function(activity, next) {
            return _this.getServerId(activity.get('id'), 'templateActivities').then(function(activityId) {
              var taHeadings;
              taHeadings = headings.filter(function(h) {
                return h.templateActivityId === activityId.toString();
              });
              return activity.get('templateFields').then(function(tfs) {
                var fields;
                fields = tfs.sortBy('order').filter(function(tf) {
                  var isDisplayField, ref;
                  isDisplayField = (ref = tf._data.style.kind) === 'heading' || ref === 'divider' || ref === 'paragraph' || ref === 'section' || ref === 'uploadshow';
                  return !isDisplayField;
                });
                return async.mapSeries(fields, function(field, done) {
                  return _this.getServerId(field.get('id'), 'templateFields').then(function(fieldId) {
                    return done(null, {
                      id: activityId + "_" + fieldId,
                      label: field.get('label'),
                      selected: (taHeadings.find(function(h) {
                        return h.templateFieldId === fieldId.toString();
                      })) != null
                    });
                  }, done);
                }, function(err, fields) {
                  if (err != null) {
                    next(err);
                  }
                  return next(null, {
                    label: activity.get('label'),
                    fields: fields
                  });
                });
              }, next);
            }, next);
          }, function(err, results) {
            if (err != null) {
              console.error(err);
            } else {
              _this.set('columnOptions', results);
            }
            return _this.set('columnsLoaded', true);
          });
        };
      })(this), console.error);
    }
  });

}).call(this);

//# sourceMappingURL=report_column_chooser_controller.js.map


(function() {
  KotiveWebapp.ReportController = Ember.Controller.extend(Ember.Evented, {
    needs: ['application', 'group'],
    init: function() {
      return document.addEventListener('KotiveWebapp:offline', (function(_this) {
        return function() {
          if (_this.get('controllers.application.currentPath') === 'group.report') {
            return _this.transitionToRoute('offline');
          }
        };
      })(this));
    },
    willDestroy: function() {
      return document.removeEventListener('KotiveWebapp:offline');
    },
    actions: {
      createTaskflow: function() {
        var model;
        model = this.get('model');
        return this.transitionToRoute('taskflow.full', model.get('group'), 'blank', {
          queryParams: {
            identifier: model.get('workflow.id')
          }
        });
      },
      showReportColumnChooser: function() {
        return this.trigger('showReportColumnChooserDrop');
      },
      showDeleteDrop: function() {
        return this.trigger('deleteReportTaskflows');
      }
    },
    workflowSet: (function() {
      return this.get('model.workflow') != null;
    }).property('model.workflow'),
    group: (function() {
      return this.get('controllers.group.model');
    }).property('controllers.group.model'),
    showReportTable: (function() {
      return this.get('controllers.application.currentPath') === 'group.report.index';
    }).property('controllers.application.currentPath'),
    updateReportColumns: (function() {
      var columns;
      if (this.get('model.taskflowHeadings') != null) {
        this.set('model.reportHeadingLoaded', false);
        columns = [];
        columns.pushObject({
          title: ''
        });
        this.get('model.taskflowHeadings').forEach(function(heading) {
          return columns.pushObject({
            title: heading.label
          });
        });
        columns.pushObject({
          title: 'Updated At'
        });
        columns.pushObject({
          title: ''
        });
        $('.panel-body').css('min-height', $('.panel-body').height());
        this.set('reportColumns', columns);
        return Ember.run.later((function(_this) {
          return function() {
            $('.panel-body').css('min-height', '');
            return _this.set('model.reportHeadingLoaded', true);
          };
        })(this), 300);
      }
    }).observes('model', 'model.taskflowHeadings'),
    reportColumnsChanged: (function() {
      if (this.get('model.reportHeadingLoaded') && this.get('model.columnsChanged')) {
        this.set('model.columnsChanged', false);
        return this.set("controllers.application.metadata-report-columns-" + (this.get('model.workflowId')), this.get('model.taskflowHeadings'));
      }
    }).observes('model.taskflowHeadings', 'model.reportHeadingLoaded'),
    updateDataRows: (function() {
      var dataRows, group, loaded, workflowId;
      if (this.get('model.elasticAuditProcessActivities') != null) {
        loaded = this.get('model.elasticAuditProcessActivities').reduce(function(result, parent) {
          return result && parent.get('reportFieldsAvailable');
        }, true);
        if (loaded) {
          group = this.get('controllers.group.model');
          workflowId = this.get('model.workflowId');
          dataRows = this.get('model.elasticAuditProcessActivities').map((function(_this) {
            return function(parent) {
              var actionLink, row;
              row = ['&nbsp;'];
              parent.get('reportFields').map(function(f) {
                return row.pushObject(f || '');
              });
              row.pushObject(parent.get('lastUpdateDateString'));
              if (parent.get('isFailedStatus')) {
                actionLink = "&nbsp;|&nbsp;<a href=\"/#/group/" + (parent.get('_source.groupId')) + "/taskflow/" + (parent.get('processId')) + "/retry?do=retry&prev=report\" title=\"Retry the failed task within this taskflow\" class=\"danger\">Retry?</a>";
              } else {
                actionLink = (function() {
                  switch (parent.get('_source.activityData.phase')) {
                    case 'done':
                      return '&nbsp;';
                    default:
                      return "&nbsp;|&nbsp;<a href=\"/#/group/" + (parent.get('_source.groupId')) + "/taskflow/" + (parent.get('processId')) + "/full\" title=\"Continue with this taskflow\">Continue&nbsp;&rarr;</a>";
                  }
                })();
              }
              row.pushObject("<a href=\"/#/group/" + (_this.get('group.id')) + "/report/" + workflowId + "/history/" + (parent.get('processId')) + "\" title=\"View the history of this taskflow\">History</a>" + actionLink);
              row['DT_RowId'] = parent.get('processId');
              return row;
            };
          })(this));
          return this.set('dataRows', dataRows);
        }
      }
    }).observes('model', 'model.elasticAuditProcessActivities.@each.reportFieldsAvailable')
  });

}).call(this);

//# sourceMappingURL=report_controller.js.map


(function() {
  KotiveWebapp.ReportHistoryController = Ember.Controller.extend({
    needs: ['application', 'report'],
    historyShow: 'last',
    init: function() {
      return document.addEventListener('KotiveWebapp:offline', (function(_this) {
        return function() {
          if (_this.get('controllers.application.currentPath') === 'group.report.report-history') {
            return _this.transitionToRoute('offline');
          }
        };
      })(this));
    },
    willDestroy: function() {
      return document.removeEventListener('KotiveWebapp:offline');
    },
    actions: {
      showCompletedTasks: function() {
        return this.set('historyShow', 'last');
      },
      showFullTasks: function() {
        return this.set('historyShow', 'all');
      },
      retryTaskflow: function() {
        var model;
        model = this.get('model');
        if (model.records[0].activityData.processId) {
          return this.transitionToRoute('taskflow.retry', model.group, model.records[0].activityData.processId, {
            queryParams: {
              "do": 'retry',
              prev: 'history'
            }
          });
        }
      }
    },
    report: (function() {
      return this.get('controllers.report.model');
    }).property('controllers.report.model'),
    reportDataLoading: (function() {
      return !(this.get('historyShow') === 'last' ? this.get('model.auditDataFetched') : this.get('model.historicalDataFetched'));
    }).property('historyShow', 'model.auditDataFetched', 'model.historicalDataFetched'),
    taskViewchanged: (function() {
      return this.setupTaskView();
    }).observes('historyShow', 'model'),
    setupTaskView: function() {
      var model;
      model = this.get('model');
      if (this.get('historyShow') === 'last') {
        return model.ensureAuditsFetched();
      } else {
        return model.ensureHistoricalFetched();
      }
    }
  });

}).call(this);

//# sourceMappingURL=report_history_controller.js.map


(function() {
  KotiveWebapp.ReportTaskflowsDeleteController = Ember.Controller.extend(KotiveWebapp.MessengerMixin, KotiveWebapp.BasicAuthMixin, {
    needs: ['application', 'group', 'report'],
    actions: {
      dropOpened: function() {
        var model;
        model = this.get('model');
        return this.set('noTaskflowsToDelete', $('.dataTable').DataTable().rows('.selected').ids().length === 0 ? true : false);
      },
      deleteAction: function() {
        var count, groupId, message, model, processIdsToDelete, workflowId;
        model = this.get('model');
        groupId = model.get('groupServerId');
        workflowId = model.get('workflowId');
        processIdsToDelete = [];
        $('.dataTable').DataTable().rows('.selected').ids().map(function(id) {
          return processIdsToDelete.push(parseInt(id));
        });
        count = processIdsToDelete.length;
        message = count === 1 ? "The taskflow has been deleted." : count + " taskflows have been deleted.";
        return new Ember.RSVP.Promise((function(_this) {
          return function(resolve, reject) {
            return _this.apiDeleteProcesses(groupId, workflowId, processIdsToDelete).then(function(res) {
              $('.dataTable').DataTable().rows('.selected').remove().draw();
              _this.send('closeDropTooltip');
              Ember.run.later(function() {
                return Messenger().post({
                  id: 'report-taskflows-deleted',
                  singleton: false,
                  hideAfter: 5,
                  showCloseButton: true,
                  message: message,
                  type: 'info'
                });
              }, 150);
              return resolve();
            })["catch"](reject);
          };
        })(this));
      }
    },
    apiDeleteProcesses: function(groupId, workflowId, processIds) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return Ember.$.ajax({
            url: "/api/group/" + groupId + "/taskflows/" + workflowId,
            type: 'DELETE',
            contentType: 'application/json',
            dataType: 'text',
            data: JSON.stringify(processIds),
            headers: {
              Authorization: _this.generateBasicAuthToken()
            },
            success: function(data, textStatus, jqXHR) {
              return resolve(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              console.error(error);
              return reject(error);
            }
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=report_taskflows_delete_controller.js.map


(function() {
  KotiveWebapp.ResetController = Ember.Controller.extend(KotiveWebapp.ErrorMessageMixin, KotiveWebapp.LoginLogicMixin, KotiveWebapp.SetActiveGroupMixin, KotiveWebapp.RaygunMixin, {
    needs: ['group', 'user', 'application'],
    init: function() {
      this.set('dataValid', true);
      return this.set('ajaxError', false);
    },
    validationErrors: (function() {
      return !this.get('dataValid');
    }).property('controllers.application.currentPath', 'dataValid'),
    showApiAlert: (function() {
      return this.get('apiError');
    }).property('controllers.application.currentPath', 'apiError'),
    actions: {
      validateToken: function() {
        var controller, model;
        controller = this;
        model = this.get('model');
        return this.apiValidateToken(model.get('reset-token')).then(function(data) {
          var userEmail;
          userEmail = data.email;
          model.set('email', userEmail);
          return controller.set('tokenValidated', true);
        }, function(err) {
          console.log("validateToken:  " + err);
          return controller.set('tokenValidated', false);
        });
      },
      userReset: function() {
        this.send('validateForm');
        if (this.get('dataValid')) {
          return this.send('postResetToApi');
        }
      },
      validateForm: function() {
        var model;
        model = this.get('model');
        model.set('company', 'xxxx');
        model.validate();
        this.set('dataValid', true);
        if (!model.get("isValid")) {
          this.set('errors', this.get('content.errors'));
          this.set('dataValid', false);
          return this.buildErrorString(model);
        }
      },
      postResetToApi: function() {
        var model, userPassword;
        model = this.get('model');
        userPassword = model.get('password');
        return this.apiPasswordReset(userPassword).then((function(_this) {
          return function(data) {
            return _this.executeLoginLogic(model.get('email'), model.get('password'));
          };
        })(this)).then((function(_this) {
          return function() {
            return _this.transitionToRoute('user.synchronise');
          };
        })(this))["catch"](function(err) {
          console.log("postConfirmationToApi:  " + err);
          return controller.set('apiError', true);
        });
      }
    },
    apiValidateToken: function(userToken) {
      var route;
      route = this;
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return Ember.$.ajax({
          url: "/api/user/resetpassword/" + userToken,
          type: 'GET',
          contentType: 'application/json',
          success: function(data, textStatus, jqXHR) {
            return resolve(data);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            var error;
            error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
            console.log(error);
            if (jqXHR.status === 401 || jqXHR.status === 404) {
              route.trigger('tokenInvalid');
              route.transitionToRoute('index');
            }
            return reject(error);
          }
        });
      });
    },
    apiPasswordReset: function(userPassword) {
      var api_url, payload, userToken;
      userToken = this.get('model.reset-token');
      payload = {
        password: userPassword,
        passwordConfirm: userPassword
      };
      api_url = "/api/user/resetpassword/" + userToken;
      return new Ember.RSVP.Promise(function(resolve, reject) {
        var showMessage;
        showMessage = function(type, message) {
          return Messenger().post({
            message: message,
            type: type,
            showCloseButton: true,
            id: 'user-signup',
            singleton: false,
            hideAfter: 5
          });
        };
        return Ember.$.ajax({
          url: api_url,
          type: 'PUT',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify(payload),
          success: function(data, textStatus, jqXHR) {
            showMessage('success', 'Your password has been reset. You are now logged in and ready to use your account.');
            return resolve(data);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            var error;
            error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
            console.log(error);
            showMessage('error', 'Sorry, something went wrong. We could not complete your password reset this time round. Please try again.');
            return reject(error);
          }
        });
      });
    }
  });

}).call(this);

//# sourceMappingURL=reset_controller.js.map


(function() {
  KotiveWebapp.RoleAddController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.IntercomMixin, {
    needs: ['role-editor'],
    actions: {
      dropOpened: function() {
        return this.trigger('readyToFocus');
      },
      cancel: function() {
        return this.send('closeDropTooltip');
      },
      save: function() {
        var model;
        model = this.get('model');
        if (model.get('label') !== '') {
          model.save().then((function(_this) {
            return function(model) {
              return _this.get('controllers.role-editor').send('roleAdded', model);
            };
          })(this));
          return this.send('closeDropTooltip');
        }
      }
    }
  });

}).call(this);

//# sourceMappingURL=role_add_controller.js.map


(function() {
  KotiveWebapp.RoleDeleteController = Ember.Controller.extend({
    needs: ['role-editor'],
    actions: {
      deleteAction: function() {
        var group, model;
        group = this.get('controllers.role-editor.group');
        model = this.get('model');
        return this.removeChildRoleLinks(group.get('id')).then((function(_this) {
          return function() {
            _this.get('controllers.role-editor').send('roleDeleted', model);
            return _this.send('closeDropTooltip');
          };
        })(this), function(err) {
          return console.log(err);
        });
      }
    },
    removeChildRoleLinks: function(groupId) {
      var role, store;
      role = this.get('model');
      store = this.get('store');
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return store.find('group').then(function(groups) {
            var childGroups;
            childGroups = groups.filter(function(g) {
              return g.get('id_parent') === groupId;
            });
            return async.each(childGroups, function(group, next) {
              return store.find('group-roles-link', group.get('id')).then(function(grl) {
                return grl.get('roles').then(function(roles) {
                  roles.removeObject(role);
                  return grl.save().then(function() {
                    return next();
                  }, next);
                }, next);
              }, next);
            }, function(err) {
              if (err != null) {
                return reject(err);
              } else {
                return async.each(childGroups, function(group, next) {
                  return _this.removeChildRoleLinks(role, group.get('id')).then(next, next);
                }, function(err) {
                  if (err != null) {
                    return reject(err);
                  } else {
                    return resolve();
                  }
                });
              }
            });
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=role_delete_controller.js.map


(function() {
  KotiveWebapp.RoleEditorController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.KeychainProcessMixin, KotiveWebapp.AddRoleToChildren, {
    needs: ['application', 'group'],
    actions: {
      createRole: function() {
        var newRole;
        newRole = this.get('store').createRecord('role', {
          primaryGroupId: this.get('group.id'),
          label: ''
        });
        return this.trigger('addNewRole', newRole);
      },
      roleAdded: function(role) {
        return this.get('model.roles').then((function(_this) {
          return function(roles) {
            roles.addObject(role);
            return _this.get('model').save().then(function() {
              return _this.addRoleToChildren(role, _this.get('group.id')).then(function() {
                return _this.trigger('roleAdded', role.get('id'));
              });
            });
          };
        })(this));
      },
      deleteRole: function(role) {
        return this.trigger('deleteRole', role);
      },
      roleDeleted: function(role) {
        var model;
        model = this.get('model');
        return model.get('roles').then(function(roles) {
          roles.removeObject(role);
          return model.save().then(function() {
            return role.destroyRecord();
          });
        });
      },
      updateRole: function(role) {
        return this.trigger('updatingRole', role);
      }
    },
    sortedRoles: (function() {
      return this.get('model.roles').sortBy('label');
    }).property('model.roles.@each'),
    group: (function() {
      return this.get('controllers.group.model');
    }).property('controllers.group.model'),
    currentPathChanged: (function() {
      return this.send('closeModal');
    }).observes('controllers.application.currentPath'),
    configureEditableRoles: (function() {
      var group;
      group = this.get('group');
      return this.get('model.roles').forEach(function(role) {
        return role.set('currentGroup', group);
      });
    }).observes('model.roles.@each')
  });

}).call(this);

//# sourceMappingURL=role_editor_controller.js.map


(function() {
  KotiveWebapp.RoleUpdateController = Ember.Controller.extend(Ember.Evented, {
    actions: {
      dropOpened: function() {
        this.set('updating', false);
        return this.trigger('readyToFocus');
      },
      save: function() {
        this.set('updating', true);
        return this.get('model').save().then((function(_this) {
          return function() {
            _this.set('updating', false);
            return _this.send('closeDropTooltip');
          };
        })(this));
      },
      cancel: function() {
        return this.send('closeDropTooltip');
      },
      closeDropTooltip: function() {
        this.get('model').rollback();
        return true;
      }
    }
  });

}).call(this);

//# sourceMappingURL=role_update_controller.js.map


(function() {
  KotiveWebapp.SettingsController = Ember.Controller.extend({
    publishFlagChanged: (function() {
      return this.send('markActivityEdited');
    }).observes('model.publish')
  });

}).call(this);

//# sourceMappingURL=settings_controller.js.map


(function() {
  KotiveWebapp.SignupController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.MessengerMixin, KotiveWebapp.ErrorMessageMixin, KotiveWebapp.AmplitudeMixin, {
    needs: ['group', 'user', 'application'],
    init: function() {
      return this.set('model', this.get('store').createRecord('user'));
    },
    validationErrors: (function() {
      return !this.get('dataValid');
    }).property('controllers.application.currentPath', 'dataValid'),
    confirmSignup: (function() {
      var currentPath;
      currentPath = this.get('controllers.application.currentPath');
      if (currentPath === 'signup') {
        this.send('validateToken');
      }
      return currentPath === 'signup';
    }).property('controllers.application.currentPath'),
    actions: {
      closeModal: function() {
        return true;
      },
      submitSignup: function() {
        this.send('validateForm');
        if (this.get('dataValid')) {
          this.set('processingSignup', true);
          return this.send('postSignupToApi');
        } else {
          return this.trigger('signupEmailInvalid');
        }
      },
      validateForm: function() {
        var model;
        this.set('errors', []);
        this.set('dataValid', true);
        this.set('passwordInvalid', false);
        this.set('companyInvalid', false);
        model = this.get('model');
        model.set('company', 'xxxx');
        model.set('password', 'xxxx');
        model.set('passwordConfirmation', 'xxxx');
        model.validate();
        if (!model.get("isValid")) {
          this.set('errors', this.get('model.errors'));
          this.set('dataValid', false);
          return this.buildErrorString(model);
        }
      },
      postSignupToApi: function() {
        var messengerConfig, model, userEmail;
        messengerConfig = {
          id: 'user-signup',
          singleton: true,
          hideAfter: 5,
          showCloseButton: true
        };
        model = this.get('model');
        userEmail = this.get('model').get('email');
        return this.apiSubmitSignup(userEmail).then((function(_this) {
          return function(data) {
            var trackingMetadata;
            _this.set('processingSignup', false);
            $('.modal').modal('hide');
            trackingMetadata = {
              email: userEmail
            };
            _this.trackEventAmplitude('Signed up', trackingMetadata);
            _this.linkUserAmplitude(userEmail);
            messengerConfig.message = "Great! We've sent you an email to activate your account. Please check your inbox.";
            messengerConfig.type = 'success';
            return Messenger().post(messengerConfig);
          };
        })(this), (function(_this) {
          return function(err) {
            _this.set('processingSignup', false);
            $('.modal').modal('hide');
            messengerConfig.message = "We're busy upgrading the server. Please try again in a couple of minutes.";
            messengerConfig.type = 'error';
            return Messenger().post(messengerConfig);
          };
        })(this));
      }
    },
    apiSubmitSignup: function(user_email) {
      var KotiveReferralCookie, payload, register_url;
      payload = {
        "email": user_email
      };
      register_url = '/api/user/register';
      if (typeof Cookies !== "undefined" && Cookies !== null) {
        KotiveReferralCookie = Cookies.noConflict();
        if (KotiveReferralCookie.get('referral-token') != null) {
          register_url += '?referral=' + KotiveReferralCookie.get('referral-token');
          KotiveReferralCookie.remove('referral-token', {
            domain: '.kotive.com'
          });
        }
      }
      return Ember.$.ajax({
        url: register_url,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(payload)
      });
    }
  });

}).call(this);

//# sourceMappingURL=signup_controller.js.map


(function() {
  KotiveWebapp.StartupController = Ember.Controller.extend(KotiveWebapp.LoginLogicMixin, KotiveWebapp.SetActiveGroupMixin, KotiveWebapp.ErrorMessageMixin, KotiveWebapp.RaygunMixin, {
    needs: ['group', 'user', 'application'],
    init: function() {
      return this.executeStartupLogic().then((function(_this) {
        return function() {
          return _this.transitionToRoute('user.synchronise');
        };
      })(this));
    },
    executeStartupLogic: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.fetchGroupsData().then(function(groups) {
            return _this.processGroupsData(groups).then(function() {
              return resolve();
            })["catch"](function(err) {
              console.log("executeStartupLogic:  " + err);
              return controller.set('apiError', true);
            });
          }, reject);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=startup_controller.js.map


(function() {
  KotiveWebapp.SwitchController = Ember.Controller.extend(KotiveWebapp.MessengerMixin, KotiveWebapp.KeychainProcessMixin, {
    needs: ['application'],
    actions: {
      setActive: function(group) {
        if (group.get('level') === 'application' && this.isServerId(group.get('id'))) {
          this.set('syncingApp', true);
          return KotiveBatchRecordsSync.onSyncComplete(group.get('id'), (function(_this) {
            return function() {
              _this.set('syncingApp', false);
              return _this.setActiveGroup(group);
            };
          })(this));
        } else {
          return this.setActiveGroup(group);
        }
      },
      cancel: function() {
        return window.history.back();
      }
    },
    activeGroupId: (function() {
      return this.get('controllers.application.companyGroup');
    }).property('controllers.application.companyGroup'),
    setActiveGroup: function(group) {
      return group.reload().then((function(_this) {
        return function(group) {
          var controller;
          controller = _this.get('controllers.application');
          controller.setCompanyGroup(group.get('id'));
          _this.sendMessage(group);
          if (group.get('level') === 'company') {
            return _this.transitionTo('people', group);
          } else {
            return _this.transitionTo('designer.workflows', group);
          }
        };
      })(this));
    },
    setGroups: function() {
      return this.get('store').find('group').then((function(_this) {
        return function(groups) {
          return _this.set('groups', groups);
        };
      })(this));
    },
    sendMessage: function(group) {
      return Messenger().post({
        id: 'group-changed-message',
        singleton: false,
        hideAfter: 5,
        showCloseButton: true,
        message: "You are now viewing information for " + (group.get('level')) + " \"" + (group.get('label')) + "\"",
        type: 'info'
      });
    }
  });

}).call(this);

//# sourceMappingURL=switch_controller.js.map


(function() {
  KotiveWebapp.TaskflowController = Ember.Controller.extend(KotiveWebapp.MessengerMixin, {
    needs: ['application'],
    queryParams: ['identifier', 'do', 'prev'],
    retriedTaskflow: (function() {
      var model;
      model = this.get('model');
      if (model.retriedTaskflow) {
        return Ember.run.later((function(_this) {
          return function() {
            var message;
            if (_this.get('prev') === 'history') {
              message = "We have retried this taskflow.<br/>It can take a minute or two for its status to update. <strong>You might need to refresh this page to see if it was successful.</strong>";
            } else {
              message = "We have retried this taskflow.<br/>It can take a minute or two for its status to update. <strong>You might need to refresh or view its 'history' to see if it was successful.</strong>";
            }
            Messenger().post({
              message: message,
              actions: {
                refresh: {
                  label: '<span class="btn btn-success"><i class="glyphicon glyphicon-refresh"></i> Refresh</span>',
                  action: function() {
                    return document.location.reload();
                  }
                }
              },
              showCloseButton: true,
              hideAfter: 10
            });
            model.set('retriedTaskflow', false);
            return history.back();
          };
        })(this), 1500);
      }
    }).observes('model.retriedTaskflow')
  });

}).call(this);

//# sourceMappingURL=taskflow_controller.js.map


(function() {
  KotiveWebapp.TaskflowRecipesController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.IntercomMixin, KotiveWebapp.TaskflowRecipeAdder, KotiveWebapp.AddRoleToChildren, KotiveWebapp.TaskflowRecipesMixin, {
    needs: ['application', 'group'],
    init: function() {
      return KotiveWebapp.TaskflowTemplate.fetch().then((function(_this) {
        return function(templates) {
          var model;
          _this.set('templates', templates);
          model = _this.get('model');
          return templates.forEach(function(template) {
            if (model.taskflowTemplate === template.template) {
              return template.selected = true;
            }
          });
        };
      })(this), function(err) {
        throw err;
      });
    },
    loadingTemplates: (function() {
      return this.get('templates') == null;
    }).property('templates'),
    selectedTemplate: (function() {
      var model;
      model = this.get('model');
      this.set('selectedTemplate', null);
      if ((model.taskflowTemplate != null)) {
        return this.set('selectedTemplate', this.get('templates').findBy('selected', true));
      }
    }).property('model.taskflowTemplate', 'templates'),
    actions: {
      skipGenerateFromTemplate: function() {
        this.set('controllers.application.intercomCounter', 10);
        this.trackEventIntercom('Skipped onboarding');
        return this.send('closeModal');
      },
      generateFromTemplate: function(template) {
        this.set('generating', true);
        return this.generateTaskflow(template).then((function(_this) {
          return function() {
            _this.set('controllers.application.intercomCounter', 10);
            _this.trackEventIntercom('Onboarding: ' + template.label);
            _this.set('generating', false);
            _this.send('closeModal');
            return _this.send('workflowsModified');
          };
        })(this), (function(_this) {
          return function(err) {
            if (err != null) {
              console.error(err);
            }
            _this.set('generating', false);
            _this.send('closeModal');
            return Messenger().post({
              id: 'template-clone-error',
              singleton: false,
              hideAfter: 5,
              showCloseButton: true,
              message: 'Sorry, something went wrong while trying to generate your template',
              type: 'error'
            });
          };
        })(this));
      }
    }
  });

}).call(this);

//# sourceMappingURL=taskflow_recipes_controller.js.map


(function() {
  KotiveWebapp.TasksController = Ember.Controller.extend({
    needs: ['application'],
    init: function() {
      return this.set('saving', false);
    },
    actions: {
      cancel: function() {
        return history.back();
      },
      save: function() {
        this.set('saving', true);
        return this.get('model').save().then((function(_this) {
          return function(taskflowCreated) {
            var path;
            Messenger().post({
              showCloseButton: true,
              hideAfter: 5,
              message: 'Your task has been saved.',
              type: 'info'
            });
            _this.set('saving', false);
            if (taskflowCreated) {
              path = _this.get('controllers.application.currentPath').substring(6);
              return _this.transitionToRoute(path, _this.get('model.taskflowId'));
            }
          };
        })(this), (function(_this) {
          return function(err) {
            var message;
            if (err === 402) {
              message = 'Credits depleted. Sorry, you cannot submit the form at this time because the account\'s credits have been depleted. The account manager has been notified. Please try again later.';
              _this.showErrMsg(message);
            } else {
              console.log(err);
              message = 'Sorry, an error occurrred while attempting to save your task. Please check your Internet connection. If this is not the issue then please contact support.';
              _this.showErrMsg(message);
            }
            return _this.set('saving', false);
          };
        })(this));
      }
    },
    showErrMsg: function(message) {
      return Messenger().post({
        showCloseButton: true,
        message: message,
        type: 'error'
      });
    }
  });

}).call(this);

//# sourceMappingURL=tasks_controller.js.map


(function() {
  KotiveWebapp.TemplateActivityAddController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.TemplateActivityTypesListMixin, {
    needs: ['application', 'workflow'],
    init: function() {
      this.setupActivityTypes();
      this.set('hasActivitySelected', false);
      this.set('templateActivityTypesUpdated', false);
      this.set('templateActivitySubTypes', []);
      return KotiveServices.updated((function(_this) {
        return function() {
          return Ember.run(function() {
            return _this.set('templateActivityTypesUpdated', true);
          });
        };
      })(this));
    },
    actions: {
      disconnectingModal: function() {
        return this.actionCancelled();
      },
      closeModal: function() {
        this.actionCancelled();
        return true;
      },
      templateActivityTypeSelected: function(templateActivityType) {
        return this.set('templateActivityType', templateActivityType);
      },
      submit: function() {
        return this._createTemplateActivity();
      },
      createTemplateActivity: function() {
        return this._createTemplateActivity();
      }
    },
    _createTemplateActivity: function() {
      var model, subType, workflow;
      if (this.get('templateActivityValid')) {
        workflow = this.get('controllers.workflow.model');
        model = this.get('model');
        if (this.get('hasTemplateActivitySubTypes')) {
          subType = this.get('templateActivitySubTypes').findBy('id', this.get('selectedTemplateActivitySubTypeId'));
          model.set('kind', subType.get('name'));
        }
        return model.save().then((function(_this) {
          return function() {
            workflow.get('templateActivities').addObject(model);
            return workflow.save().then(function() {
              return _this.createTemplateActivityServiceFields(function() {
                _this.trigger('markActivityAdded', model);
                _this.unsetTemplateActivityTypeSelected();
                _this.get('controllers.application').send('closeModal');
                return _this.get('controllers.workflow').trigger('activityActivated', model.id);
              });
            });
          };
        })(this));
      }
    },
    createTemplateActivityServiceFields: function(callback) {
      var data, model, ref, subType;
      model = this.get('model');
      if ((ref = model.get('kind')) === 'form' || ref === 'subtree') {
        return callback();
      } else {
        subType = this.get('templateActivitySubTypes').findBy('id', this.get('selectedTemplateActivitySubTypeId'));
        data = subType.get('fields');
        return this.createActivityFields(data, [], function(fieldModels) {
          return model.get('templateFields').then(function(templateFields) {
            _.each(fieldModels, function(fieldModel) {
              return templateFields.pushObject(fieldModel);
            });
            return model.save().then(function() {
              return callback();
            }, function(err) {
              throw new Error(err);
            });
          });
        });
      }
    },
    createActivityFields: function(fieldsData, fieldModels, callback) {
      var fieldData, fieldModel, order;
      if (fieldsData.length === 0) {
        return callback(fieldModels);
      } else {
        fieldData = fieldsData[fieldsData.length - 1];
        if (fieldData.order) {
          order = fieldData.order;
        } else {
          order = fieldsData.length;
        }
        fieldModel = this.get('store').createRecord('template-field', {
          label: fieldData.label,
          order: order,
          readonly: fieldData.readonly,
          required: fieldData.required,
          visible: fieldData.visible
        });
        fieldModel.get('style').setFromService(fieldData);
        fieldModel.setPatternFromService(fieldData);
        return fieldModel.get('templateActivities').then((function(_this) {
          return function(templateActivities) {
            templateActivities.addObject(_this.get('model'));
            return fieldModel.save().then(function() {
              fieldModels.pushObject(fieldModel);
              return _this.createActivityFields(fieldsData.slice(0, -1), fieldModels, callback);
            });
          };
        })(this));
      }
    },
    unsetTemplateActivityTypeSelected: function() {
      $('.template-activity-type-block').children('.selected').removeClass('selected');
      this.set('templateActivityType', null);
      this.set('hasActivitySelected', false);
      this.set('templateActivitySubTypes', []);
      return this.set('hasTemplateActivitySubTypes', false);
    },
    templateActivityTypeChanged: (function() {
      var templateActivityType;
      templateActivityType = this.get('templateActivityType');
      if (templateActivityType != null) {
        if (templateActivityType.get('disabled')) {
          this.showActivityDisabledMessage(templateActivityType.get('label'));
          return this.unsetTemplateActivityTypeSelected();
        } else {
          this.trigger('activityTypeSelected', templateActivityType.get('name'));
          this.set('hasActivitySelected', true);
          return templateActivityType.get('templateActivitySubTypes').then((function(_this) {
            return function(tasts) {
              var subType, templateActivitySubTypes;
              templateActivitySubTypes = tasts.map(function(tast) {
                return tast;
              });
              if (templateActivitySubTypes.length !== 0) {
                _this.get('model').set('kind', null);
                _this.set('templateActivitySubTypes', templateActivitySubTypes);
                subType = templateActivitySubTypes[0];
                _this.set('selectedTemplateActivitySubTypeId', subType.get('id'));
                return _this.set('hasTemplateActivitySubTypes', true);
              } else {
                _this.set('model.kind', templateActivityType.get('name'));
                _this.set('templateActivitySubTypes', []);
                _this.set('selectedTemplateActivitySubTypeId', null);
                _this.send('repositionDropTooltip');
                return _this.set('hasTemplateActivitySubTypes', false);
              }
            };
          })(this));
        }
      } else {
        return this.unsetTemplateActivityTypeSelected();
      }
    }).observes('templateActivityType'),
    templateActivityValid: (function() {
      var ref;
      return ((ref = this.get('model').get('label')) != null ? ref.trim() : void 0) !== '' && (!this.get('hasTemplateActivitySubTypes') || (this.get('selectedTemplateActivitySubTypeId') != null));
    }).property('model.label', 'model.kind', 'selectedTemplateActivitySubTypeId'),
    actionCancelled: function() {
      var id, unused;
      this.unsetTemplateActivityTypeSelected();
      id = this.get('model').get('id');
      unused = this.get('model').get('originalFlowId');
      if (!id) {
        KotiveFlow.removeActivity(unused);
        return this.get('model').rollback();
      }
    },
    showActivityDisabledMessage: function(label) {
      var message;
      message = "We are still integrating the <b>" + label + "</b> service into Kotive. We'll let you know when new services become available. Get in contact if you cannot wait any longer...";
      return Messenger().post({
        id: 'kotive-service-disabled',
        singleton: false,
        hideAfter: 10,
        showCloseButton: true,
        message: message,
        type: 'info'
      });
    },
    isFormActivity: (function() {
      return this.get('model').get('kind') === 'form';
    }).property('model.kind')
  });

}).call(this);

//# sourceMappingURL=template_activity_add_controller.js.map


(function() {
  KotiveWebapp.TemplateActivityAuthAddController = Ember.Controller.extend(KotiveWebapp.BasicAuthMixin, {
    needs: ['application'],
    hasErrors: false,
    actions: {
      disconnectingModal: function() {
        if (this.get('model.isNew')) {
          return this.get('model').rollback();
        }
      },
      cancel: function() {
        return this.send('closeModal');
      },
      save: function() {
        this.set('hasErrors', this.get('fields').reduce(function(hasErrors, f) {
          if (f.get('required') && f.get('patternString').trim() === '') {
            f.set('hasError', true);
            return true;
          } else {
            f.set('hasError', false);
            return hasErrors;
          }
        }, false));
        if (!this.get('hasErrors')) {
          return this.saveAuthDetails().then((function(_this) {
            return function() {
              return _this.send('closeModal');
            };
          })(this), (function(_this) {
            return function(err) {
              console.error(err);
              return _this.showLoadErrorMessage();
            };
          })(this));
        }
      }
    },
    addTitle: (function() {
      return "Connect your " + (this.get('model.service').capitalize()) + " account";
    }).property('model'),
    serviceName: (function() {
      return this.get('model.service').capitalize();
    }).property('model'),
    requiresOAuth2: (function() {
      return (this.get('fields') != null) && ((this.get('fields').find(function(f) {
        return f.get('style.kind') === 'OAuth2';
      })) != null);
    }).property('fields.@each'),
    oauth2Field: (function() {
      if (this.get('requiresOAuth2')) {
        return this.get('fields').find(function(f) {
          return f.get('style.kind') === 'OAuth2';
        });
      } else {
        return null;
      }
    }).property('fields.@each'),
    modelChanged: (function() {
      return this.getActivityType().then((function(_this) {
        return function(activityType) {
          _this.set('activityType', activityType);
          return _this.getFieldAuthObjects();
        };
      })(this)).then((function(_this) {
        return function(fields) {
          return _this.set('fields', fields);
        };
      })(this))["catch"]((function(_this) {
        return function(err) {
          console.error(err);
          _this.showLoadErrorMessage();
          return _this.send('closeModal');
        };
      })(this));
    }).observes('model'),
    getActivityType: function() {
      var model;
      model = this.get('model');
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('store').find('template-activity-type').then(function(tats) {
            var activityType;
            activityType = tats.find(function(tat) {
              return tat.get('name') === model.get('service');
            });
            if (activityType != null) {
              return resolve(activityType);
            } else {
              return reject("Cannot find activity type for '" + (model.get('service')) + "'");
            }
          }, reject);
        };
      })(this));
    },
    getFieldAuthObjects: function() {
      var store;
      store = this.get('store');
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var fieldModels, labelField;
          labelField = store.createRecord('template-field', {
            label: 'Account label',
            order: 0,
            readonly: false,
            required: true,
            visible: true,
            serviceId: 'description',
            style: {
              kind: 'text',
              helptext: 'Give the account a descriptive label so you can identify it'
            }
          });
          fieldModels = [labelField].concat(_this.generateStandardFields());
          if (_this.get('activityType.auth.fields') != null) {
            return resolve(_this.get('activityType.auth.fields').reduce(function(fields, fieldData, index) {
              var field;
              field = store.createRecord('template-field', {
                label: fieldData.label,
                order: index + fieldModels.length,
                readonly: fieldData.readonly,
                required: fieldData.required,
                visible: fieldData.visible,
                serviceId: "auth.field." + fieldData.properties.parameter,
                style: {
                  kind: fieldData.properties.fieldType,
                  helptext: fieldData.properties.helptext
                }
              });
              if (fieldData.properties["default"] != null) {
                field.set('patternString', fieldData.properties["default"]);
              }
              return fields.concat(field);
            }, fieldModels));
          } else {
            return resolve(fieldModels);
          }
        };
      })(this));
    },
    generateStandardFields: function() {
      var fields, passwordField, store, usernameField;
      switch (this.get('activityType.auth.method')) {
        case 'Basic':
          store = this.get('store');
          fields = [];
          if ((this.get('activityType.auth.username') != null) && (this.get('activityType.auth.password') != null)) {
            usernameField = store.createRecord('template-field', {
              label: 'Username',
              order: 1,
              readonly: false,
              required: false,
              visible: true,
              serviceId: 'username',
              style: {
                kind: 'text',
                helptext: 'The username for Basic Authorization'
              }
            });
            passwordField = store.createRecord('template-field', {
              label: 'Password',
              order: 2,
              readonly: false,
              required: false,
              visible: true,
              serviceId: 'password',
              style: {
                kind: 'text',
                helptext: 'The password for Basic Authorization'
              }
            });
            fields = [usernameField].concat(passwordField);
          }
          return fields;
        case 'Custom':
          return [];
        case 'OAuth2':
          return [
            this.get('store').createRecord('template-field', {
              order: '-1',
              readonly: false,
              required: true,
              visible: true,
              serviceId: 'tokenData',
              authParams: this.get('activityType.auth'),
              style: {
                kind: 'OAuth2'
              }
            })
          ];
        default:
          return [];
      }
    },
    saveAuthDetails: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.fetchKeyData().then(function(pubKey) {
            var authData, data, encrypt, fieldLabel, model;
            model = _this.get('model');
            encrypt = new JSEncrypt();
            fieldLabel = _this.get('fields').find(function(f) {
              return f.get('serviceId') === 'description';
            });
            encrypt.setPublicKey(pubKey);
            _this.set('model.label', fieldLabel.get('patternString'));
            authData = _this.get('fields').filter(function(f) {
              return f.get('serviceId') !== 'description';
            }).map(function(f) {
              var value;
              value = f.get('patternString');
              if (f.get('style.kind') !== 'OAuth2') {
                value = encrypt.encrypt(value);
              }
              return {
                key: f.get('serviceId'),
                value: value
              };
            });
            data = {
              groupId: parseInt(model.get('groupId')),
              service: model.get('service'),
              method: _this.get('activityType.auth.method'),
              label: model.get('label'),
              attributes: authData
            };
            return $.ajax({
              url: "/api/group/" + (model.get('groupId')) + "/designer/auth",
              method: 'POST',
              dataType: 'json',
              contentType: 'application/json;charset=UTF-8',
              data: JSON.stringify(data),
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function(data) {
                model.set('id', data.id.toString());
                return model.save().then(function() {
                  return resolve();
                }, reject);
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                return reject(error);
              }
            });
          }, reject);
        };
      })(this));
    },
    fetchKeyData: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          if (_this.get('publicKey') != null) {
            return resolve(_this.get('publicKey'));
          } else {
            return $.ajax({
              url: '/kotive-attributes-key-pub.pem',
              method: 'GET',
              dataType: 'text',
              success: function(data) {
                _this.set('publicKey', data);
                return resolve(data);
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                return reject(error);
              }
            });
          }
        };
      })(this));
    },
    showLoadErrorMessage: function() {
      return Messenger().post({
        id: 'template-activity-auth-add-error',
        singleton: false,
        hideAfter: 15,
        showCloseButton: true,
        message: 'Sorry, something went wrong while trying to load authentication data, please try again.',
        type: 'error'
      });
    }
  });

}).call(this);

//# sourceMappingURL=template_activity_auth_add_controller.js.map


(function() {
  KotiveWebapp.TemplateActivityAuthController = Ember.Controller.extend(KotiveWebapp.BasicAuthMixin, KotiveWebapp.KeychainProcessMixin, {
    needs: ['application', 'group'],
    init: function() {
      this.set('loading', true);
      return this.setAuthRecordsList().then((function(_this) {
        return function() {
          return _this.set('loading', false);
        };
      })(this), (function(_this) {
        return function(err) {
          console.error(err);
          return _this.showLoadErrorMsg();
        };
      })(this));
    },
    actions: {
      createNewAuth: function() {
        var groupIdentifier;
        groupIdentifier = this.get('controllers.group.model.id');
        return this.getServerId(groupIdentifier, 'groups').then((function(_this) {
          return function(groupId) {
            var auth;
            auth = _this.get('store').createRecord('template-activity-auth', {
              label: '',
              service: _this.get('service'),
              groupId: groupId
            });
            _this.send('openModal', 'template-activity-auth-add', auth);
            return auth.one('didCreate', function() {
              _this.set('loading', true);
              _this.set('model.templateActivityAuthId', auth.get('id'));
              return _this.get('model').save().then(function() {
                return _this.setAuthRecordsList().then(function() {
                  return _this.set('loading', false);
                }, function(err) {
                  console.error(err);
                  return _this.showLoadErrorMsg();
                });
              }, function(err) {
                console.error(err);
                return _this.showLoadErrorMsg();
              });
            });
          };
        })(this), function(err) {
          return console.error(err);
        });
      },
      authSelected: function(auth) {
        this.set('model.templateActivityAuthId', auth.get('id'));
        return this.get('model').save().then((function(_this) {
          return function() {
            return _this.setAuthRecordsList().then(function() {
              return _this.set('loading', false);
            }, function(err) {
              console.error(err);
              return _this.showLoadErrorMsg();
            });
          };
        })(this), function(err) {
          console.error(err);
          return this.showLoadErrorMsg();
        });
      }
    },
    hasAuthRecords: (function() {
      return (this.get('authRecords') != null) && this.get('authRecords').length !== 0;
    }).property('model', 'authRecords'),
    service: (function() {
      return this.get('model.kind').split('/')[0];
    }).property('model'),
    serviceName: (function() {
      return this.get('model.kind').split('/')[0].capitalize();
    }).property('model'),
    serviceIcon: (function() {
      var kind;
      kind = this.get('model.kind').split('/');
      return "images/icons/" + kind[0] + "/icon32x32.png";
    }).property('model'),
    modelChanged: (function() {
      if (this.get('model.isService')) {
        this.set('loading', true);
        return this.setAuthRecordsList().then((function(_this) {
          return function() {
            return _this.set('loading', false);
          };
        })(this), (function(_this) {
          return function(err) {
            console.error(err);
            return _this.showLoadErrorMsg();
          };
        })(this));
      }
    }).observes('model'),
    setAuthRecordsList: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var groupIdentifier, setAuthId;
          groupIdentifier = _this.get('controllers.group.model.id');
          setAuthId = _this.get('model.templateActivityAuthId');
          return _this.getServerId(groupIdentifier, 'groups').then(function(groupId) {
            return _this.get('store').find('template-activity-auth').then(function(as) {
              var auths;
              auths = as.filter(function(a) {
                return parseInt(a.get('groupId')) === parseInt(groupId) && a.get('service') === _this.get('service');
              }).map(function(a) {
                return a.set('isActiveAuth', a.get('id') === setAuthId);
              });
              _this.set('authRecords', auths.sortBy('label'));
              return resolve();
            }, reject);
          }, reject);
        };
      })(this));
    },
    showLoadErrorMsg: function() {
      return Messenger().post({
        id: 'template-activity-auth-failure',
        singleton: false,
        hideAfter: 15,
        showCloseButton: true,
        message: 'Sorry something went wrong while trying to load authentication data, please try reloading the page',
        type: 'error'
      });
    }
  });

}).call(this);

//# sourceMappingURL=template_activity_auth_controller.js.map


(function() {
  KotiveWebapp.TemplateActivityController = Ember.Controller.extend(Ember.Evented, {
    needs: ['application'],
    queryParams: ['section'],
    section: 'main',
    actions: {
      setActivityEditorSize: function() {
        return this.trigger('setActivityEditorSize');
      },
      newTemplateFieldCreated: function(templateField, doScroll) {
        if (doScroll == null) {
          doScroll = true;
        }
        return this.trigger('newTemplateFieldCreated', templateField, doScroll);
      },
      templateFieldSelected: function(templateField) {
        return this.trigger('templateFieldSelected', templateField);
      },
      editTaskLabel: function() {
        this.set('updatedLabel', this.get('model.label'));
        this.set('editingLabel', true);
        return this.trigger('editingLabelActivated');
      },
      editTaskLabelCancel: function() {
        this.get('model').rollback();
        return this.set('editingLabel', false);
      },
      updateTaskLabel: function() {
        var model, originalId, taskData;
        model = this.get('model');
        model.set('label', this.get('updatedLabel'));
        this.send('markActivityEdited');
        originalId = model.get('id');
        taskData = model.toFlowObject();
        KotiveFlow.updateActivity(originalId, taskData);
        return this.set('editingLabel', false);
      },
      deleteTask: function() {
        return this.trigger('deleteTask');
      }
    },
    modelChanged: Ember.debouncedObserver(function() {
      this.trigger('setActivityEditorSize');
      return this.set('editingLabel', false);
    }, 'model', 100),
    isFormActivity: (function() {
      return this.get('model').get('kind') === 'form';
    }).property('model.kind'),
    inTabletMode: (function() {
      return this.get('controllers.application.inTabletMode');
    }).property('controllers.application.inTabletMode'),
    showActivityEditor: (function() {
      var currentPath, inDesktopMode, inTabletMode;
      inDesktopMode = this.get('controllers.application.inDesktopMode');
      inTabletMode = this.get('controllers.application.inTabletMode');
      currentPath = this.get('controllers.application.currentPath');
      return inDesktopMode || currentPath === 'group.designer.workflow.template-activity.index' || (inTabletMode && currentPath === 'group.designer.workflow.template-activity.template-field');
    }).property('controllers.application.currentPath', 'controllers.application.viewType')
  });

}).call(this);

//# sourceMappingURL=template_activity_controller.js.map


(function() {
  KotiveWebapp.TemplateActivityDeleteController = Ember.Controller.extend(KotiveWebapp.MessengerMixin, {
    needs: ['application', 'group', 'workflow', 'condition', 'template-activity'],
    actions: {
      dropOpened: function() {
        return this.checkForChildActivities();
      },
      deleteAction: function() {
        var id, label, model, store, workflow;
        store = this.get('store');
        model = this.get('model');
        id = model.get('id');
        label = model.get('label');
        workflow = this.get('controllers.workflow.model');
        return new Ember.RSVP.Promise((function(_this) {
          return function(resolve, reject) {
            _this.send('closeDropTooltip');
            _this.transitionToRoute('workflow', workflow.get('id'));
            Ember.run.later(function() {
              return Messenger().post({
                id: 'template-activity-deleted',
                singleton: false,
                message: "Please wait while we delete the '" + label + "' task. (This might take a couple of seconds...)",
                type: 'info'
              });
            }, 150);
            return _this.removeConditions(model).then(function() {
              return _this.removeFields(model);
            }).then(function() {
              return _this.removeTemplateActivity(model, workflow, id);
            }).then(function() {
              Messenger().post({
                id: 'template-activity-deleted',
                singleton: false,
                hideAfter: 5,
                showCloseButton: true,
                message: "The '" + label + "' task has been deleted from this taskflow.",
                type: 'info'
              });
              return resolve();
            }, reject);
          };
        })(this));
      }
    },
    removeFields: function(templateActivity) {
      var condition, store;
      store = this.get('store');
      condition = this.get('controllers.condition');
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return templateActivity.get('templateFields').then(function(tfs) {
          var templateFields;
          templateFields = tfs.map(function(tf) {
            return tf;
          });
          return async.eachSeries(templateFields, function(field, done) {
            return store.findAll('filter').then(function(fs) {
              var filters;
              filters = fs.filterBy('property', field.id);
              return async.eachSeries(filters, function(filter, next) {
                condition.removeFilterFromCondition(filter);
                return next();
              }, function(err) {
                if (err != null) {
                  return done(err);
                } else {
                  field.deleteRecord();
                  return field.save().then(function() {
                    return done();
                  }, done);
                }
              });
            });
          }, function(err) {
            if (err != null) {
              return reject(err);
            } else {
              return resolve();
            }
          });
        }, function(err) {
          if (err != null) {
            return reject(err);
          } else {
            return resolve();
          }
        }, reject);
      });
    },
    removeConditions: function(templateActivity) {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return templateActivity.get('templateConditions').then(function(tcs) {
          var conditions;
          conditions = tcs.map(function(tc) {
            return tc;
          });
          return async.eachSeries(conditions, function(condition, done) {
            return condition.get('filters').then(function(cfs) {
              var filters;
              filters = cfs.map(function(cf) {
                return cf;
              });
              return async.eachSeries(filters, function(filter, next) {
                filter.deleteRecord();
                return filter.save().then(function() {
                  return next();
                });
              }, function(err) {
                if (err != null) {
                  return done(err);
                } else {
                  condition.deleteRecord();
                  return condition.save().then(function() {
                    return done();
                  });
                }
              });
            });
          }, function(err) {
            if (err != null) {
              return reject(err);
            } else {
              return resolve();
            }
          });
        }, reject);
      });
    },
    removeTemplateActivity: function(templateActivity, workflow, id) {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        var kind;
        kind = templateActivity.get('kind');
        workflow.get('templateActivities').removeObject(templateActivity);
        return workflow.save().then(function() {
          templateActivity.deleteRecord();
          return templateActivity.save().then(function() {
            if (kind === 'subtree') {
              KotiveFlow.removeActivity(id, true);
            } else {
              KotiveFlow.removeActivity(id);
            }
            return resolve();
          }, function(err) {
            if (err != null) {
              return reject(err);
            } else {
              return resolve();
            }
          });
        }, function(err) {
          if (err != null) {
            return reject(err);
          } else {
            return resolve();
          }
        });
      });
    },
    checkForChildActivities: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var model;
          model = _this.get('model');
          _this.set('cannotDeleteTask', false);
          if (model.get('kind') === 'subtree') {
            return _this.get('store').find('template-activity').then(function(tas) {
              var templateActivities;
              templateActivities = tas.filter(function(ta) {
                return ta.get('id_parent') === model.get('id');
              });
              _this.set('cannotDeleteTask', templateActivities.length !== 0);
              return resolve();
            }, reject);
          }
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=template_activity_delete_controller.js.map


(function() {
  KotiveWebapp.TemplateActivityFormController = Ember.Controller.extend(Ember.Evented, {
    needs: ['application', 'condition', 'template-field-add', 'workflow', 'template-activity'],
    init: function() {
      this.setupTemplateFieldsSortListener();
      this.setOrderedFieldsProperty();
      return this.set('activeTab', 'form');
    },
    actions: {
      activityLoaded: function() {
        return this.trigger('activityLoaded');
      },
      addNewTemplateField: function() {
        var actionName, newTemplateField, viewName;
        actionName = 'openModal';
        viewName = 'template-field-add';
        newTemplateField = KotiveWebapp.TemplateField.newTemplateField(this.get('model'));
        return Ember.run.later((function(_this) {
          return function() {
            return _this.send(actionName, viewName, newTemplateField);
          };
        })(this), 50);
      },
      templateFieldEdit: function(templateField) {
        var actionName, viewName;
        actionName = 'openModal';
        viewName = 'template-field';
        return Ember.run.later((function(_this) {
          return function() {
            return _this.send(actionName, viewName, templateField);
          };
        })(this), 50);
      },
      formTabActivated: function() {
        return this.set('activeTab', 'form');
      },
      conditionsTabActivated: function() {
        return this.set('activeTab', 'conditions');
      },
      settingsTabActivated: function() {
        return this.set('activeTab', 'settings');
      }
    },
    noFields: (function() {
      var ref;
      return ((ref = this.get('orderedTemplateFields')) != null ? ref.length : void 0) === 0;
    }).property('orderedTemplateFields'),
    orderedTemplateFieldsChanged: (function() {
      return this.setOrderedFieldsProperty();
    }).observes('model.templateFields.@each'),
    taskIcon: (function() {
      return 'images/icons/form.png';
    }).property(),
    mainSelected: (function() {
      var ref;
      return (ref = this.get('controllers.template-activity.section')) === 'main' || ref === 'authentication';
    }).property('controllers.template-activity.section'),
    conditionsSelected: (function() {
      return this.get('controllers.template-activity.section') === 'conditions';
    }).property('controllers.template-activity.section'),
    settingsSelected: (function() {
      return this.get('controllers.template-activity.section') === 'settings';
    }).property('controllers.template-activity.section'),
    formTabActive: (function() {
      return this.get('activeTab') === 'form';
    }).property('activeTab'),
    viewFormTabOnEmpty: (function() {
      if (this.get('noFields')) {
        return this.set('activeTab', 'form');
      }
    }).observes('noFields'),
    modelChanged: (function() {
      return this.send('formTabActivated');
    }).observes('model'),
    newTemplateField: function() {
      return KotiveWebapp.TemplateField.newTemplateField(this.get('model'));
    },
    setupTemplateFieldsSortListener: function() {
      return this.on('templateFieldReordered', this, (function(_this) {
        return function(index, id) {
          return _this.store.find('template-field', id).then(function(templateField) {
            templateField.set('order', index);
            return _this.send('markActivityEdited');
          });
        };
      })(this));
    },
    setOrderedFieldsProperty: function() {
      var model;
      model = this.get('model');
      if (model != null) {
        return model.get('templateFields').then((function(_this) {
          return function(fields) {
            if (!(_this.get('isDestroying') || _this.get('isDestroyed'))) {
              return _this.set('orderedTemplateFields', fields.sortBy('order', 'label'));
            }
          };
        })(this));
      }
    }
  });

}).call(this);

//# sourceMappingURL=template_activity_form_controller.js.map


(function() {
  KotiveWebapp.TemplateActivityServiceController = Ember.Controller.extend(Ember.Evented, {
    needs: ['application', 'condition', 'template-activity', 'template-field', 'workflow'],
    prompt: 'Please select an option...',
    init: function() {
      this.set('activityEdited', false);
      this.setOrderedFieldsProperty();
      this.updateShowAccountDetails();
      return this.updateShowSettings();
    },
    orderedTemplateFieldsChanged: (function() {
      return this.setOrderedFieldsProperty();
    }).observes('model.templateFields.@each'),
    serviceIcon: (function() {
      var kind;
      if (this.get('model').get('kind') !== 'form') {
        kind = this.get('model').get('kind').split('/');
        return "images/icons/" + kind[0] + "/icon32x32.png";
      }
    }).property('model.kind'),
    serviceNameCapitalised: (function() {
      return this.get('serviceName').capitalize();
    }).property('serviceName'),
    serviceName: (function() {
      var kind;
      kind = this.get('model').get('kind').split('/');
      return kind[0];
    }).property('model.kind'),
    subServiceName: (function() {
      var kind;
      kind = this.get('model').get('kind').split('/');
      return kind[1];
    }).property('model.kind'),
    workflow: (function() {
      return this.get('controllers.workflow.model');
    }).property('controllers.workflow.model'),
    templateActivity: (function() {
      return this.get('controllers.template-activity.model');
    }).property('controllers.template-activity.model'),
    isSubTaskflow: (function() {
      return this.get('serviceName') === 'subtree';
    }).property('serviceName'),
    mainSelected: (function() {
      var ref;
      return (ref = this.get('controllers.template-activity.section')) === 'main' || ref === 'settings';
    }).property('controllers.template-activity.section'),
    conditionsSelected: (function() {
      return this.get('controllers.template-activity.section') === 'conditions';
    }).property('controllers.template-activity.section'),
    authenticationSelected: (function() {
      return this.get('controllers.template-activity.section') === 'authentication';
    }).property('controllers.template-activity.section'),
    settingsSelected: (function() {
      return this.get('controllers.template-activity.section') === 'settings';
    }).property('controllers.template-activity.section'),
    isSubTaskFlowOrConditionsSelected: (function() {
      return this.get('isSubTaskflow') || this.get('conditionsSelected');
    }).property('isSubTaskflow', 'conditionsSelected'),
    setShowAccountDetails: (function() {
      return this.updateShowAccountDetails();
    }).observes('model'),
    setShowSettings: (function() {
      return this.updateShowSettings();
    }).observes('model'),
    activityEditedCheck: (function() {
      var model;
      model = this.get('model');
      if (model.get('isDirty')) {
        return this.send('markActivityEdited');
      } else {
        return model.get('templateFields').then((function(_this) {
          return function(templateFields) {
            var foundDirty;
            foundDirty = false;
            templateFields.forEach(function(field) {
              if (field.get('isDirty')) {
                return foundDirty = true;
              }
            });
            if (foundDirty) {
              return _this.send('markActivityEdited');
            }
          };
        })(this));
      }
    }).observes('model.templateFields.@each.pattern'),
    updateShowAccountDetails: function() {
      var serviceName;
      serviceName = this.get('serviceName');
      if (serviceName === 'email' || serviceName === 'subtree' || serviceName === 'webhook') {
        return this.set('showAccountDetails', false);
      } else {
        return this.get('store').find('templateActivityType').then((function(_this) {
          return function(tats) {
            var templateActivityType;
            templateActivityType = tats.find(function(tat) {
              return tat.get('name') === serviceName;
            });
            if (!((templateActivityType == null) || _this.get('isDestroying') || _this.get('isDestroyed'))) {
              return _this.set('showAccountDetails', templateActivityType.get('auth.method') !== 'none');
            }
          };
        })(this));
      }
    },
    updateShowSettings: function() {
      var serviceName, subServiceName;
      serviceName = this.get('serviceName');
      subServiceName = this.get('subServiceName');
      console.log(subServiceName);
      if (subServiceName !== 'form') {
        return this.set('showSettings', false);
      } else {
        return this.get('store').find('templateActivityType').then((function(_this) {
          return function(tats) {
            var templateActivityType;
            templateActivityType = tats.find(function(tat) {
              return tat.get('name') === serviceName;
            });
            if (!((templateActivityType == null) || _this.get('isDestroying') || _this.get('isDestroyed'))) {
              return _this.set('showSettings', true !== 'none');
            }
          };
        })(this));
      }
    },
    setOrderedFieldsProperty: function() {
      return this.get('model').get('templateFields').then((function(_this) {
        return function(fields) {
          if (!(_this.get('isDestroying') || _this.get('isDestroyed'))) {
            return _this.set('orderedTemplateFields', fields.sortBy('order', 'label'));
          }
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=template_activity_service_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldAddController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.TemplateFielTypesListMixin, {
    needs: ['application', 'condition', 'template-activity-form', 'template-activity', 'template-field', 'workflow'],
    init: function() {
      this.setupTemplateFieldTypes();
      return this.set('model', this.get('template-field.model'));
    },
    actions: {
      openingModal: function() {
        if ($.localStorage.get('default-new-field')) {
          return this.set('selectedFieldKind', $.localStorage.get('default-new-field'));
        }
      },
      disconnectingModal: function() {
        return this.get('model').rollback();
      },
      closeModal: function() {
        this.get('model').rollback();
        return true;
      },
      saveField: function() {
        return this.saveTemplateField((function(_this) {
          return function() {
            _this.get('controllers.template-activity').send('newTemplateFieldCreated', _this.get('model'));
            return _this.send('closeModal');
          };
        })(this));
      },
      saveFieldAndAddNext: function() {
        return this.saveTemplateField((function(_this) {
          return function() {
            var templateField;
            templateField = _this.store.createRecord('templateField');
            return _this.get('model').get('templateActivities').then(function(templateActivities) {
              var templateActivity;
              templateActivity = templateActivities.objectAt(0);
              _this.get('controllers.template-activity').send('newTemplateFieldCreated', _this.get('model'));
              return _this.set('model', KotiveWebapp.TemplateField.newTemplateField(templateActivity));
            });
          };
        })(this));
      }
    },
    modelChanged: (function() {
      var model;
      model = this.get('model');
      this.set('modelUpdating', true);
      this.setCommondynamicProperties();
      this.set('selectedFieldKind', $.localStorage.get('default-new-field' != null) ? $.localStorage.get('default-new-field') : model.get('style').kind);
      this.setProperties({
        capitalizedType: this.get('selectedFieldKind').capitalize(),
        helptext: model.get('style').helptext
      });
      return this.set('modelUpdating', false);
    }).observes('model'),
    workflow: (function() {
      return this.get('controllers.workflow.model');
    }).property('controllers.workflow.model'),
    templateActivity: (function() {
      return this.get('controllers.template-activity.model');
    }).property('controllers.template-activity.model'),
    helpTextChanged: (function() {
      if (!this.get('modelUpdating')) {
        return this.get('model').get('style').set('helptext', this.get('helptext'));
      }
    }).observes('helptext'),
    selectedFieldKindChanged: (function() {
      var model, opt, ref;
      if ((this.get('selectedFieldKind') != null) && !this.get('modelUpdating')) {
        model = this.get('model');
        model.get('style').set('kind', this.get('selectedFieldKind'));
        $.localStorage.set('default-new-field', this.get('selectedFieldKind'));
        opt = (ref = this.get('selectedFieldKind')) === 'paragraph' || ref === 'heading' || ref === 'divider' || ref === 'section';
        if (opt) {
          this.set('model.required', false);
        }
        return this.setCommondynamicProperties();
      }
    }).observes('selectedFieldKind'),
    templateFieldsValidate: (function() {
      var model, ref;
      model = this.get('model');
      if ((model.get('style') != null) && ((ref = model.get('style').kind) === 'divider' || ref === 'heading' || ref === 'paragraph' || ref === 'section')) {
        return true;
      }
      return (model.get('label') != null) && this.get('model').get('label').trim() !== '' && (model.get('style') != null);
    }).property('model.label', 'model.style.kind'),
    setCommondynamicProperties: function() {
      var model, ref, ref1, ref2, ref3, ref4, ref5, ref6, style;
      model = this.get('model');
      style = model.get('style');
      if ($.localStorage.get('default-new-field' != null)) {
        style.set('kind', $.localStorage.get('default-new-field'));
      }
      this.setProperties({
        headingField: style.kind === 'heading',
        paragraphField: style.kind === 'paragraph',
        sectionField: style.kind === 'section',
        submitField: style.kind === 'submit',
        multipleSelectField: style.kind === 'check',
        singleSelectField: (ref = style.kind) === 'radio' || ref === 'select',
        radioCheckField: (ref1 = style.kind) === 'radio' || ref1 === 'check',
        optionsField: (ref2 = style.kind) === 'radio' || ref2 === 'check' || ref2 === 'select',
        uploadField: (ref3 = style.kind) === 'upload',
        uploadshowField: (ref4 = style.kind) === 'uploadshow',
        defaultStringValue: (ref5 = style.kind) === 'text' || ref5 === 'date' || ref5 === 'datetime' || ref5 === 'email' || ref5 === 'number' || ref5 === 'password' || ref5 === 'tel' || ref5 === 'time' || ref5 === 'url',
        defaultMultilineValue: (ref6 = style.kind) === 'textarea'
      });
      this.set('showDefaultValueInput', this.get('defaultStringValue') || this.get('defaultMultilineValue'));
      this.setLabelEditor();
      return this.setShowFieldEditableOptions();
    },
    setLabelEditor: function() {
      var opt, ref;
      opt = (ref = this.get('model').get('style').kind) === 'paragraph' || ref === 'heading' || ref === 'divider' || ref === 'section';
      return this.set('showLabelEditField', !opt);
    },
    setShowFieldEditableOptions: function() {
      var model, opt, ref;
      model = this.get('model');
      opt = (ref = this.get('model').get('style').kind) === 'paragraph' || ref === 'submit' || ref === 'heading' || ref === 'divider' || ref === 'section' || ref === 'uploadshow';
      return this.set('showFieldEditableOptions', !opt);
    },
    saveTemplateField: function(callback) {
      var model, templateActivity;
      if (this.get('templateFieldsValidate')) {
        model = this.get('model');
        templateActivity = this.get('controllers.template-activity.model');
        return model.save().then(function() {
          return templateActivity.get('templateFields').then(function(templateFields) {
            model.set('order', templateFields.content.length);
            templateFields.pushObject(model);
            return model.get('templateActivities').then(function(templateActivities) {
              templateActivities.pushObject(templateActivity);
              return model.save().then(function() {
                return templateActivity.save().then(callback);
              });
            });
          });
        });
      }
    }
  });

}).call(this);

//# sourceMappingURL=template_field_add_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldController = Ember.Controller.extend(KotiveWebapp.TemplateFielTypesListMixin, Ember.Evented, {
    needs: ['application', 'template-activity', 'workflow'],
    init: function() {
      return this.setupTemplateFieldTypes();
    },
    actions: {
      deleteTemplateField: function() {
        return this.trigger('deleteTemplateField');
      },
      duplicateTemplateField: function() {
        this.get('model').duplicate().then((function(_this) {
          return function(newTemplateField) {
            var templateActivity;
            templateActivity = _this.get('templateActivity');
            return templateActivity.addDuplicatedField(newTemplateField).then(function() {
              var controller;
              controller = _this.get('controllers.template-activity');
              _this.send('markActivityEdited');
              controller.send('newTemplateFieldCreated', newTemplateField, false);
              controller.send('templateFieldSelected', _this.get('model'));
              return _this.send('closeModal');
            });
          };
        })(this));
        if (this.get('controllers.application.inMobileMode')) {
          return this.transitionToRoute('template-activity');
        }
      }
    },
    inTabletMode: (function() {
      return this.get('controllers.application.inTabletMode');
    }).property('controllers.application.inTabletMode'),
    helptext: (function() {
      return this.get('model').get('style').helptext;
    }).property(),
    workflow: (function() {
      return this.get('controllers.workflow.model');
    }).property('controllers.workflow.model'),
    templateActivity: (function() {
      return this.get('controllers.template-activity.model');
    }).property('controllers.template-activity.model'),
    routeChanged: (function() {
      return this.send('closeModal');
    }).observes('controllers.application.currentPath'),
    modelChanged: (function() {
      var model;
      model = this.get('model');
      this.set('modelUpdating', true);
      this.setCommondynamicProperties();
      this.setProperties({
        selectedFieldKind: model.get('style').kind,
        capitalizedType: model.get('style').kind.capitalize(),
        helptext: model.get('style').helptext
      });
      return this.set('modelUpdating', false);
    }).observes('model', 'model.pattern'),
    fieldEdited: (function() {
      if (this.get('model').get('isDirty')) {
        return this.send('markActivityEdited');
      }
    }).observes('model.label', 'model.required', 'model.visible', 'model.readonly', 'model.pattern', 'model.style.hasChanges'),
    helpTextChanged: (function() {
      var helptext, ref;
      if (!this.get('modelUpdating')) {
        helptext = this.get('helptext');
        if (((ref = this.get('model.style')) != null ? ref.set : void 0) != null) {
          return this.get('model.style').set('helptext', helptext);
        }
      }
    }).observes('helptext'),
    selectedFieldKindChanged: (function() {
      var opt, ref;
      if ((this.get('selectedFieldKind') != null) && !this.get('modelUpdating')) {
        this.set('model.style.kind', this.get('selectedFieldKind'));
        opt = (ref = this.get('selectedFieldKind')) === 'paragraph' || ref === 'heading' || ref === 'divider' || ref === 'section';
        if (opt) {
          this.set('model.required', false);
        }
        this.get('model').send('becomeDirty');
        this.setCommondynamicProperties();
        return this.send('markActivityEdited');
      }
    }).observes('selectedFieldKind'),
    setCommondynamicProperties: function() {
      var model, ref, ref1, ref2, ref3, ref4, ref5, ref6, style;
      model = this.get('model');
      style = model.get('style');
      this.setProperties({
        headingField: style.kind === 'heading',
        paragraphField: style.kind === 'paragraph',
        sectionField: style.kind === 'section',
        submitField: style.kind === 'submit',
        multipleSelectField: style.kind === 'check',
        singleSelectField: (ref = style.kind) === 'radio' || ref === 'select',
        radioCheckField: (ref1 = style.kind) === 'radio' || ref1 === 'check',
        optionsField: (ref2 = style.kind) === 'radio' || ref2 === 'check' || ref2 === 'select',
        uploadField: (ref3 = style.kind) === 'upload',
        uploadshowField: (ref4 = style.kind) === 'uploadshow',
        defaultStringValue: (ref5 = style.kind) === 'text' || ref5 === 'date' || ref5 === 'datetime' || ref5 === 'email' || ref5 === 'number' || ref5 === 'password' || ref5 === 'tel' || ref5 === 'time' || ref5 === 'url',
        defaultMultilineValue: (ref6 = style.kind) === 'textarea'
      });
      this.set('showDefaultValueInput', this.get('defaultStringValue') || this.get('defaultMultilineValue'));
      this.setLabelEditor();
      return this.setShowFieldEditableOptions();
    },
    setLabelEditor: function() {
      var opt, ref;
      opt = (ref = this.get('model').get('style').kind) === 'paragraph' || ref === 'heading' || ref === 'divider' || ref === 'section';
      return this.set('showLabelEditField', !opt);
    },
    setShowFieldEditableOptions: function() {
      var model, opt, ref;
      model = this.get('model');
      opt = (ref = this.get('model').get('style').kind) === 'paragraph' || ref === 'submit' || ref === 'heading' || ref === 'divider' || ref === 'section' || ref === 'uploadshow';
      return this.set('showFieldEditableOptions', !opt);
    }
  });

}).call(this);

//# sourceMappingURL=template_field_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldDeleteController = Ember.Controller.extend({
    needs: ['condition', 'template-activity'],
    actions: {
      deleteAction: function() {
        var model, templateActivity;
        templateActivity = this.get('controllers.template-activity.model');
        model = this.get('model');
        return this.removeField(templateActivity, model).then((function(_this) {
          return function() {
            _this.send('closeDropTooltip');
            return _this.send('closeModal');
          };
        })(this));
      }
    },
    removeField: function(templateActivity, templateField) {
      var condition, store;
      store = this.get('store');
      condition = this.get('controllers.condition');
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return store.findAll('filter').then(function(fs) {
          var filters;
          filters = fs.filterBy('property', templateField.id);
          return async.eachSeries(filters, function(filter, next) {
            condition.removeFilterFromCondition(filter);
            return next();
          }, function(err) {
            if (err != null) {
              if (err != null) {
                return reject(err);
              } else {
                return resolve();
              }
            } else {
              templateField.deleteRecord();
              return templateField.save().then(function() {
                templateActivity.get('templateFields').removeObject(templateField);
                return templateActivity.save().then(function() {
                  return resolve();
                }, function(err) {
                  if (err != null) {
                    return reject(err);
                  } else {
                    return resolve();
                  }
                });
              });
            }
          }, function(err) {
            if (err != null) {
              return reject(err);
            } else {
              return resolve();
            }
          }, reject);
        });
      });
    }
  });

}).call(this);

//# sourceMappingURL=template_field_delete_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorHeadingController = Ember.Controller.extend({
    needs: ['workflow', 'template-activity'],
    workflow: (function() {
      return this.get('controllers.workflow.model');
    }).property('controllers.workflow.model'),
    templateActivity: (function() {
      return this.get('controllers.template-activity.model');
    }).property('controllers.template-activity.model')
  });

}).call(this);

//# sourceMappingURL=template_field_editor_heading_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorMultipleOptionsController = Ember.Controller.extend(Ember.Evented, {
    needs: ['application', 'template-field', 'template-field-add'],
    init: function() {
      this.initOptionsListDisplay();
      return this.initOptionsDefaults();
    },
    actions: {
      checkedDefault: function(checkedVals) {
        var defaults, newDefaults, options;
        newDefaults = [];
        options = this.get('options');
        defaults = checkedVals;
        _.each(defaults, function(val) {
          return newDefaults.push(options[val].key);
        });
        this.get('model').setPattern({
          "default": newDefaults
        });
        this.initOptionsListDisplay();
        this.initOptionsDefaults();
        return this.get('model').refreshPatternString();
      },
      clearDefaultOption: function() {
        return this.set('defaultOptions', null);
      },
      addOption: function() {
        var index, options;
        options = this.get('options');
        index = options.length;
        options.pushObject({
          key: '',
          value: '',
          index: index.toString()
        });
        return this.send('markActivityEdited');
      },
      removeOptionAtIndex: function(indexToRemove) {
        var defaultOptions, indexReached, options;
        indexToRemove = parseInt(indexToRemove);
        indexReached = false;
        options = _.reject(this.get('options'), function(option) {
          var currentIndex;
          currentIndex = parseInt(option.index);
          if (currentIndex === indexToRemove) {
            indexReached = true;
            return true;
          } else {
            Ember.run(function() {
              if (indexReached) {
                return Ember.set(option, 'index', (currentIndex - 1).toString());
              }
            });
            return false;
          }
        });
        if (options.length === 0) {
          options.pushObject({
            key: '',
            value: ''
          });
          defaultOptions = null;
        }
        this.set('options', options);
        this.get('model').setPattern({
          selections: options
        });
        if (defaultOptions != null) {
          this.initOptionsDefaults();
        }
        return this.send('markActivityEdited');
      },
      setPredefinedOptions: function() {
        this.get('model.style').set('optionsType', 'predefined');
        this.set('model.prevCustomPattern', this.get('model.pattern'));
        if (this.get('model.prevPredefPattern') != null) {
          this.set('model.pattern', this.get('model.prevPredefPattern'));
        } else {
          this.set('pattern', (this.get('model.patternOptions.type')) + "[][]");
        }
        this.set('showCustomOptionsType', false);
        return this.send('markActivityEdited');
      },
      setCustomOptions: function() {
        this.get('model.style').set('optionsType', 'custom');
        this.set('model.prevPredefPattern', this.get('model.pattern'));
        if (this.get('model.prevCustomPattern') != null) {
          this.set('model.pattern', this.get('model.prevCustomPattern'));
        } else {
          this.set('pattern', (this.get('model.patternOptions.type')) + "[][]");
        }
        this.set('showCustomOptionsType', true);
        return this.send('markActivityEdited');
      }
    },
    hasDefault: (function() {
      return this.get('defaultOptions') != null;
    }).property('defaultOptions'),
    modelChanged: (function() {
      this.set('modelUpdating', true);
      this.initOptionsListDisplay();
      return this.set('modelUpdating', false);
    }).observes('model'),
    optionsValuesChanged: (function() {
      var options;
      options = this.get('options');
      if (!this.get('modelUpdating')) {
        this.get('model').setPattern({
          selections: _.map(options, function(option) {
            return {
              key: option.key,
              value: option.key
            };
          })
        });
        this.initOptionsDefaults();
        return this.send('markActivityEdited');
      }
    }).observes('options.pattern', 'options.@each.index', 'options.@each.key', 'options.@each.value'),
    initOptionsListDisplay: function() {
      var options;
      options = this.get('model').get('patternOptions').selections;
      if (options.length === 0) {
        options.pushObject({
          key: '',
          value: ''
        });
      }
      _.each(options, function(option, index) {
        return Ember.run(function() {
          return Ember.set(option, 'index', index.toString());
        });
      });
      this.set('options', options);
      return this.set('showCustomOptionsType', this.get('model.style.optionsType') !== 'predefined');
    },
    initOptionsDefaults: function() {
      var defaultOptions, defaults, found, options;
      options = this.get('options');
      defaultOptions = [];
      defaults = this.get('model').getPatternDefault();
      if (defaults) {
        if (defaults.length) {
          _.each(defaults, function(option, index) {
            var found;
            found = _.findWhere(options, {
              key: option.key
            });
            if (found) {
              return defaultOptions.push(found.index);
            }
          });
        } else {
          found = _.findWhere(options, {
            key: defaults.key
          });
          if (found) {
            defaultOptions.push(found.index);
          }
        }
        return this.set('defaultOptions', defaultOptions != null ? defaultOptions : []);
      }
    },
    elementsReordered: function(elementsOrder) {
      var defaultOptions, i, index, len, option, options, pos, sortedOptions;
      options = this.get('options');
      defaultOptions = this.get('defaultOptions');
      sortedOptions = [];
      pos = 0;
      for (i = 0, len = elementsOrder.length; i < len; i++) {
        index = elementsOrder[i];
        option = options[index];
        Ember.run(function() {
          return Ember.set(option, 'index', pos.toString());
        });
        sortedOptions.pushObject(option);
        pos += 1;
      }
      this.set('options', sortedOptions);
      this.get('model').setPattern({
        selections: sortedOptions
      });
      if (defaultOptions != null) {
        this.initOptionsDefaults();
      }
      return this.send('markActivityEdited');
    }
  });

}).call(this);

//# sourceMappingURL=template_field_editor_multiple_options_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorParagraphController = Ember.Controller.extend({
    needs: ['workflow', 'template-activity'],
    workflow: (function() {
      return this.get('controllers.workflow.model');
    }).property('controllers.workflow.model'),
    templateActivity: (function() {
      return this.get('controllers.template-activity.model');
    }).property('controllers.template-activity.model')
  });

}).call(this);

//# sourceMappingURL=template_field_editor_paragraph_controller.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.TemplateFieldEditorPredefinedOptionsController = Ember.Controller.extend(KotiveWebapp.GroupTreeLogicMixin, {
    needs: ['group'],
    inflector: new Ember.Inflector(Ember.Inflector.defaultRules),
    fieldSelectorRegex: /^Workflow\:[0-9a-f]+$/m,
    init: function() {
      return this.setupPredefinedOptions();
    },
    currentGroup: (function() {
      return this.get('controllers.group.model');
    }).property('controllers.group.model'),
    miscellaneous: (function() {
      return [
        {
          key: 'Salutations',
          value: 'Salutations (Mr, Mrs, Dr, Prof...)'
        }, {
          key: 'DaysOfWeek',
          value: 'Days of the week (Monday - Sunday)'
        }, {
          key: 'MonthsOfYear',
          value: 'Months of the year'
        }, {
          key: 'Timezones',
          value: 'Timezones'
        }, {
          key: 'Countries',
          value: 'Countries'
        }, {
          key: 'CountriesWithCode',
          value: 'Countries with code (eg. US,United States)'
        }, {
          key: 'Satisfaction',
          value: 'Satisfaction (very satisfied, satisfied...)'
        }, {
          key: 'Importance',
          value: 'Importance (very important, important...)'
        }, {
          key: 'Agreeing',
          value: 'Agreeing (strongly agree, agree...)'
        }
      ].map(function(m) {
        m.grouping = 'Miscellaneous';
        return m;
      });
    }).property(),
    roleOptionsGrouping: (function() {
      return 'From within the current organization/team, show...';
    }).property(),
    fieldType: (function() {
      if (this.get('model.style.kind') === 'check') {
        return 'mse';
      } else {
        return 'sse';
      }
    }).property('model', 'model.style.kind'),
    predefinedValueChanged: (function() {
      if (this.get('fieldSelectorRegex').test(this.get('optSelection'))) {
        this.set('showFieldSelector', true);
        return this.setupFieldOptions();
      } else {
        this.get('model').set('patternString', (this.get('fieldType')) + "[{" + (this.get('optSelection')) + "}][]");
        this.set('showFieldSelector', false);
        this.set('fieldOptSelection', null);
        return this.send('markActivityEdited');
      }
    }).observes('optSelection'),
    predefinedFieldChanged: (function() {
      if ((this.get('fieldOptSelection') != null) && this.get('fieldOptSelection') !== '<<loading>>' && this.get('fieldSelectorRegex').test(this.get('optSelection'))) {
        this.get('model').set('patternString', (this.get('fieldType')) + "[{" + (this.get('optSelection')) + ":" + (this.get('fieldOptSelection')) + "}][]");
        return this.send('markActivityEdited');
      }
    }).observes('fieldOptSelection'),
    setupPredefinedOptions: function() {
      var promises;
      promises = [this.setupRoleOptionsList(), this.setupWorkflowOptionsList()];
      return Ember.RSVP.all(promises).then((function(_this) {
        return function(results) {
          var groupRoles, miscellaneous, workflows;
          groupRoles = results[0], workflows = results[1];
          miscellaneous = _this.get('miscellaneous');
          groupRoles.unshift({
            key: 'UsersByGroupAsSelectPattern:{group.id}',
            value: 'All people',
            grouping: _this.get('roleOptionsGrouping')
          });
          [
            {
              key: 'GroupsByGroupAsSelectPattern:{group.id}',
              value: 'All organizations/teams'
            }, {
              key: 'RolesByGroupAsSelectPattern:{group.id}',
              value: 'All roles'
            }, {
              key: 'ContactsByGroupAsSelectPattern:{group.id}',
              value: 'All contacts'
            }
          ].forEach(function(opt) {
            opt.grouping = _this.get('roleOptionsGrouping');
            return groupRoles.push(opt);
          });
          _this.set('predefinedOptions', groupRoles.concat(workflows).concat(miscellaneous));
          return _this.setOptionSelectionFromModel();
        };
      })(this), (function(_this) {
        return function(err) {
          console.error(err);
          _this.send('closeModal');
          return _this.transitionToRoute('something-went-wrong');
        };
      })(this));
    },
    setupRoleOptionsList: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.getRolesForGroup(_this.get('currentGroup.id')).then(function(roles) {
            return resolve(roles.sortBy('label', 'id').map(function(r) {
              return {
                key: "UsersByGroupAndRoleAsSelectPattern:{group.id}:" + (r.get('id')),
                value: _this.get('inflector').pluralize(r.get('label')),
                grouping: _this.get('roleOptionsGrouping')
              };
            }));
          }, reject);
        };
      })(this));
    },
    setupWorkflowOptionsList: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('currentGroup.workflows').then(function(workflows) {
            return resolve(workflows.sortBy('label', 'id').map(function(w) {
              return {
                key: "Workflow:" + (w.get('id')),
                value: _this.get('inflector').pluralize(w.get('label')),
                grouping: 'Taskflow instances available to the logged-in user\'s organization/team'
              };
            }));
          }, reject);
        };
      })(this));
    },
    setOptionSelectionFromModel: function() {
      var endPos, opt, parts, pattern;
      pattern = this.get('model.pattern');
      if (/^[sm]se\[\{.*\}\]\[\]$/m.test(pattern)) {
        endPos = pattern.length - 9;
        opt = pattern.substr(5, endPos);
        if (/^Workflow\:[0-9a-f]+\:[0-9a-f]+$/m.test(opt)) {
          parts = opt.split(':');
          return this.setProperties({
            optSelection: parts[0] + ":" + parts[1],
            fieldOptSelection: parts[2]
          });
        } else {
          return this.set('optSelection', opt);
        }
      } else {
        return this.set('optSelection', 'UsersByGroupAsSelectPattern:{group.id}');
      }
    },
    setupFieldOptions: function() {
      if (this.get('showFieldSelector')) {
        this.set('fieldOptions', [
          {
            key: '<<loading>>',
            value: 'Loading field data...',
            taskflowName: 'Fetching taskflows'
          }
        ]);
        return this.setFieldOptionsForWorkflow().then((function(_this) {
          return function(fieldOpts) {
            var keys, ref;
            keys = fieldOpts.map(function(f) {
              return f.key;
            });
            _this.set('fieldOptions', fieldOpts);
            if (_this.get('fieldOptSelection') === '<<loading>>' || !(ref = _this.get('fieldOptSelection'), indexOf.call(keys, ref) >= 0)) {
              return _this.set('fieldOptSelection', fieldOpts[0].key);
            }
          };
        })(this), function(err) {
          console.log(err);
          this.send('closeModal');
          return this.transitionToRoute('something-went-wrong');
        });
      }
    },
    setFieldOptionsForWorkflow: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var workflowId;
          workflowId = _this.getWorkflowIdentifier();
          if (workflowId != null) {
            return _this.get('store').find('workflow', workflowId).then(function(workflow) {
              return workflow.get('templateActivities').then(function(tas) {
                var taskflows;
                taskflows = tas.sortBy('label').map(function(t) {
                  return t;
                });
                return async.map(taskflows, function(taskflow, done) {
                  return taskflow.get('templateFields').then(function(fields) {
                    return done(null, fields.sortBy('label', 'order').map(function(field) {
                      return {
                        key: field.get('id'),
                        value: field.get('label'),
                        taskflowName: taskflow.get('label')
                      };
                    }));
                  }, reject);
                }, function(err, fields) {
                  if (err != null) {
                    return reject(err);
                  } else {
                    return resolve([].concat.apply([], fields));
                  }
                });
              }, reject);
            }, reject);
          } else {
            return reject(new Error("Could not extract workflow identifier from predefined option " + (_this.get('optSelection'))));
          }
        };
      })(this));
    },
    getWorkflowIdentifier: function() {
      if (this.get('fieldSelectorRegex').test(this.get('optSelection'))) {
        return this.get('optSelection').split(':')[1];
      } else {
        return null;
      }
    }
  });

}).call(this);

//# sourceMappingURL=template_field_editor_predefined_options_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorRadioCheckController = Ember.Controller.extend({
    needs: ['application', 'template-field', 'template-field-add'],
    init: function() {
      var model;
      model = this.get('model');
      return this.set('displayType', model.get('style').classes === 'inline' ? 'horizontal' : 'vertical');
    },
    modelChanged: (function() {
      var model;
      this.set('modelChanging', true);
      model = this.get('model');
      this.set('displayType', model.get('style').classes === 'inline' ? 'horizontal' : 'vertical');
      return this.set('modelChanging', false);
    }).observes('model'),
    setDisplayClass: (function() {
      var classVal, model, ref;
      if (!this.get('modelChanging')) {
        model = this.get('model');
        if ((ref = model.get('style').kind) === 'radio' || ref === 'check') {
          classVal = this.get('displayType') === 'horizontal' ? 'inline' : '';
          model.get('style').set('classes', classVal);
          return this.send('markActivityEdited');
        }
      }
    }).observes('displayType')
  });

}).call(this);

//# sourceMappingURL=template_field_editor_radio_check_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorSectionController = Ember.Controller.extend({
    needs: ['workflow', 'template-activity'],
    workflow: (function() {
      return this.get('controllers.workflow.model');
    }).property('controllers.workflow.model'),
    templateActivity: (function() {
      return this.get('controllers.template-activity.model');
    }).property('controllers.template-activity.model')
  });

}).call(this);

//# sourceMappingURL=template_field_editor_section_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorSingleOptionsController = Ember.Controller.extend(Ember.Evented, {
    needs: ['application', 'template-field', 'template-field-add'],
    init: function() {
      return this.initOptionsListDisplay();
    },
    actions: {
      clearDefaultOption: function() {
        return this.set('defaultIndex', null);
      },
      addOption: function() {
        var index, options;
        options = this.get('options');
        index = options.length;
        options.pushObject({
          key: '',
          value: '',
          index: index.toString()
        });
        return this.send('markActivityEdited');
      },
      removeOptionAtIndex: function(indexToRemove) {
        var defaultIndex, indexReached, options;
        indexToRemove = parseInt(indexToRemove);
        defaultIndex = parseInt(this.get('defaultIndex'));
        indexReached = false;
        options = _.reject(this.get('options'), function(option) {
          var currentIndex;
          currentIndex = parseInt(option.index);
          if (currentIndex === indexToRemove) {
            indexReached = true;
            return true;
          } else {
            Ember.run(function() {
              if (indexReached) {
                return Ember.set(option, 'index', (currentIndex - 1).toString());
              }
            });
            return false;
          }
        });
        if (options.length === 0) {
          options.pushObject({
            key: '',
            value: ''
          });
          defaultIndex = null;
        }
        this.set('options', options);
        this.get('model').setPattern({
          selections: options
        });
        if ((defaultIndex != null) && defaultIndex >= indexToRemove) {
          this.set('defaultIndex', defaultIndex === indexToRemove ? null : (defaultIndex - 1).toString());
        }
        return this.send('markActivityEdited');
      },
      setPredefinedOptions: function() {
        this.get('model.style').set('optionsType', 'predefined');
        this.set('model.prevCustomPattern', this.get('model.pattern'));
        if (this.get('model.prevPredefPattern') != null) {
          this.set('model.pattern', this.get('model.prevPredefPattern'));
        } else {
          this.set('pattern', (this.get('model.patternOptions.type')) + "[][]");
        }
        this.set('showCustomOptionsType', false);
        return this.send('markActivityEdited');
      },
      setCustomOptions: function() {
        this.get('model.style').set('optionsType', 'custom');
        this.set('model.prevPredefPattern', this.get('model.pattern'));
        if (this.get('model.prevCustomPattern') != null) {
          this.set('model.pattern', this.get('model.prevCustomPattern'));
        } else {
          this.set('pattern', (this.get('model.patternOptions.type')) + "[][]");
        }
        this.set('showCustomOptionsType', true);
        return this.send('markActivityEdited');
      }
    },
    hasDefault: (function() {
      return this.get('defaultIndex') != null;
    }).property('defaultIndex'),
    modelChanged: (function() {
      this.set('modelUpdating', true);
      this.initOptionsListDisplay();
      return this.set('modelUpdating', false);
    }).observes('model'),
    defaultIndexChanged: (function() {
      var defaultIndex, model;
      if (!this.get('modelUpdating')) {
        defaultIndex = this.get('defaultIndex');
        model = this.get('model');
        if (defaultIndex != null) {
          model.setPatternDefaultByIndex(parseInt(defaultIndex));
        } else {
          model.clearPatternDefault();
        }
        model.refreshPatternString();
        return this.send('markActivityEdited');
      }
    }).observes('defaultIndex'),
    optionsValuesChanged: (function() {
      if (!this.get('modelUpdating')) {
        this.get('model').setPattern({
          selections: _.map(this.get('options'), function(option) {
            return {
              key: option.key,
              value: option.key
            };
          })
        });
        return this.send('markActivityEdited');
      }
    }).observes('options.@each.key', 'options.@each.value'),
    initOptionsListDisplay: function() {
      var defaultIndex, options;
      options = this.get('model').get('patternOptions').selections;
      if (options.length === 0) {
        options.pushObject({
          key: '',
          value: ''
        });
      }
      _.each(options, function(option, index) {
        return Ember.set(option, 'index', index.toString());
      });
      this.set('options', options);
      defaultIndex = this.get('model').getPatternDefaultIndex();
      this.set('defaultIndex', defaultIndex != null ? defaultIndex.toString() : null);
      return this.set('showCustomOptionsType', this.get('model.style.optionsType') !== 'predefined');
    },
    elementsReordered: function(elementsOrder) {
      var defaultIndex, i, index, len, newDefaultIndex, option, options, pos, sortedOptions;
      options = this.get('options');
      defaultIndex = this.get('defaultIndex');
      newDefaultIndex = null;
      sortedOptions = [];
      pos = 0;
      for (i = 0, len = elementsOrder.length; i < len; i++) {
        index = elementsOrder[i];
        option = options[index];
        if (defaultIndex === index.toString()) {
          newDefaultIndex = pos.toString();
        }
        Ember.run(function() {
          return Ember.set(option, 'index', pos.toString());
        });
        sortedOptions.pushObject(option);
        pos += 1;
      }
      this.set('options', sortedOptions);
      this.get('model').setPattern({
        selections: sortedOptions
      });
      this.set('defaultIndex', newDefaultIndex);
      return this.send('markActivityEdited');
    }
  });

}).call(this);

//# sourceMappingURL=template_field_editor_single_options_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorSubmitController = Ember.Controller.extend({
    init: function() {
      this.setButtonStyleActivators();
      return this.setButtonStyleAlignment();
    },
    actions: {
      setButtonStyle: function(styleName) {
        var currentClasses, model, newClass;
        model = this.get('model');
        currentClasses = model.get('style').classes || '';
        newClass = 'btn';
        _.each(['right', 'left'], function(alignVal) {
          var alignClass;
          alignClass = "btn-align-" + alignVal;
          if (currentClasses.indexOf(alignClass) !== -1) {
            return newClass = newClass + " " + alignClass;
          }
        });
        if (styleName !== '') {
          newClass = newClass + " btn-" + styleName;
        }
        model.get('style').set('classes', newClass);
        this.send('markActivityEdited');
        return this.setButtonStyleActivators();
      },
      setButtonAlignment: function(styleName) {
        var currentClasses, model, newClass;
        model = this.get('model');
        currentClasses = model.get('style').classes || '';
        newClass = 'btn';
        _.each(['default', 'primary', 'success', 'info', 'warning', 'danger', 'link'], function(styleVal) {
          var styleClass;
          styleClass = "btn-" + styleVal;
          if (currentClasses.indexOf(styleClass) !== -1) {
            return newClass = newClass + " " + styleClass;
          }
        });
        if (styleName !== '') {
          newClass = newClass + " btn-align-" + styleName;
        }
        model.get('style').set('classes', newClass);
        this.send('markActivityEdited');
        return this.setButtonStyleAlignment();
      }
    },
    setButtonStyleActivators: function() {
      var optionsList;
      optionsList = [['btn-default', 'selectedStyleDefault'], ['btn-primary', 'selectedStylePrimary'], ['btn-success', 'selectedStyleSuccess'], ['btn-info', 'selectedStyleInfo'], ['btn-warning', 'selectedStyleWarning'], ['btn-danger', 'selectedStyleDanger'], ['btn-link', 'selectedStyleLink']];
      return this.setDynamicButtonProperties(optionsList, 'selectedStyleNoClass');
    },
    setButtonStyleAlignment: function() {
      var optionsList;
      optionsList = [['btn-align-left', 'selectedStyleAlignLeft'], ['btn-align-right', 'selectedStyleAlignRight']];
      return this.setDynamicButtonProperties(optionsList, 'selectedStyleAlignCentre');
    },
    setDynamicButtonProperties: function(optionsList, defaultNoMatch) {
      var classes, matchFound;
      if (defaultNoMatch == null) {
        defaultNoMatch = null;
      }
      classes = this.get('model').get('style').classes || '';
      matchFound = false;
      _.each(optionsList, (function(_this) {
        return function(item) {
          var classVal, match, property;
          classVal = item[0], property = item[1];
          match = classes.indexOf(classVal) !== -1;
          _this.set(property, match);
          return matchFound = matchFound || match;
        };
      })(this));
      if (defaultNoMatch != null) {
        return this.set(defaultNoMatch, !matchFound);
      }
    }
  });

}).call(this);

//# sourceMappingURL=template_field_editor_submit_controller.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorUploadshowController = Ember.Controller.extend(Ember.Evented, {
    needs: ['application', 'workflow', 'template-activity', 'template-field', 'template-field-add'],
    init: function() {
      this.set('uploadFieldOptions', []);
      return this.setUploadFields();
    },
    setUploadFields: function() {
      var options;
      options = [
        {
          key: '',
          value: 'Please select a field...'
        }
      ];
      return this.get('workflow').get('templateActivities').then((function(_this) {
        return function(tas) {
          var templateActivities;
          templateActivities = tas.sortBy('order').filter(function(ta) {
            return ta.get('id') !== _this.get('templateActivity.id');
          });
          async.eachSeries(templateActivities, function(templateActivity, done) {
            return templateActivity.get('templateFields').then(function(tfs) {
              var templateFields;
              templateFields = tfs.sortBy('label').filter(function(tf) {
                var ref;
                return (ref = tf.get('style.kind')) === 'upload';
              });
              return async.eachSeries(templateFields, function(templateField, next) {
                options.pushObject({
                  key: '{field.value:' + templateField.get('id') + '}',
                  value: templateField.get('label')
                });
                return next();
              }, function(err) {
                return done(err);
              });
            });
          });
          return _this.set('uploadFieldOptions', options, function(err) {
            if (err != null) {
              return console.error(err);
            }
          });
        };
      })(this));
    },
    hasUploadFields: (function() {
      return (this.get('uploadFieldOptions') != null) && this.get('uploadFieldOptions').length !== 0;
    }).property('uploadFieldOptions'),
    modelChanged: (function() {
      this.set('modelUpdating', true);
      this.setUploadFields();
      return this.set('modelUpdating', false);
    }).observes('model', 'model.pattern'),
    workflow: (function() {
      return this.get('controllers.workflow.model');
    }).property('controllers.workflow.model'),
    templateActivity: (function() {
      return this.get('controllers.template-activity.model');
    }).property('controllers.template-activity.model')
  });

}).call(this);

//# sourceMappingURL=template_field_editor_uploadshow_controller.js.map


(function() {
  KotiveWebapp.UserSynchroniseController = Ember.Controller.extend({
    queryParams: ['next', 'pathType'],
    next: 'index',
    pathType: 'webapp'
  });

}).call(this);

//# sourceMappingURL=user_synchronise_controller.js.map


(function() {
  KotiveWebapp.WorkflowController = Ember.Controller.extend(Ember.Evented, {
    needs: ['group', 'application', 'template-activity'],
    init: function() {
      return this.on('activityActivated', function(id) {
        return this.get('store').find('template-activity', id).then((function(_this) {
          return function(templateActivity) {
            return _this.transitionToRoute('template-activity', templateActivity);
          };
        })(this));
      });
    },
    currentUserIsLoggedIn: (function() {
      var userEmail;
      userEmail = this.get('controllers.application.userEmail');
      return (userEmail != null ? userEmail.length : void 0) > 0;
    }).property('controllers.application.userEmail'),
    actions: {
      createTaskflow: function() {
        return this.get('model.templateActivities').then((function(_this) {
          return function(templateActivities) {
            return _this.get('store').find('templateActivityType').then(function(tats) {
              var group, unauthed;
              unauthed = templateActivities.sortBy('order', 'label').find(function(ta) {
                var serviceName, tat;
                if (ta.get('isService')) {
                  serviceName = ta.get('kind').split('/')[0];
                  tat = tats.find(function(ta) {
                    return ta.get('name') === serviceName;
                  });
                  return tat.get('auth.method') !== 'none' && (ta.get('templateActivityAuthId') == null);
                } else {
                  return false;
                }
              });
              if (unauthed != null) {
                _this.cannotPreviewMessage(unauthed);
                return _this.transitionToRoute('template-activity.index', unauthed, {
                  queryParams: {
                    section: 'authentication'
                  }
                });
              } else {
                group = _this.get('controllers.group.model');
                return _this.transitionToRoute('taskflow.full', group, 'blank', {
                  queryParams: {
                    identifier: _this.get('model.id')
                  }
                });
              }
            }, function(err) {
              console.error(err);
              throw err;
            });
          };
        })(this));
      },
      editSettings: function() {
        var action, viewName;
        action = 'openModal';
        viewName = 'workflow-settings';
        return this.send(action, viewName, this.get('model'));
      },
      editWorkflowLabel: function() {
        this.set('updatedLabel', this.get('model.label'));
        this.set('editingLabel', true);
        return this.trigger('editingLabelActivated');
      },
      editWorkflowLabelCancel: function() {
        this.get('model').rollback();
        return this.set('editingLabel', false);
      },
      updateWorkflowLabel: function() {
        this.set('editingLabel', false);
        this.set('updatingLabel', true);
        this.set('model.label', this.get('updatedLabel'));
        return this.get('model').save().then((function(_this) {
          return function() {
            _this.set('updatingLabel', false);
            return _this.send('workflowsModified');
          };
        })(this), function(err) {
          return Ember.Logger.error(err);
        });
      }
    },
    showFlowDesigner: (function() {
      var currentPath, inDesktopMode, inTabletMode;
      inDesktopMode = this.get('controllers.application.inDesktopMode');
      inTabletMode = this.get('controllers.application.inTabletMode');
      currentPath = this.get('controllers.application.currentPath');
      return inDesktopMode || currentPath === 'group.designer.workflow.index' || (inTabletMode && currentPath === 'group.designer.workflow.template-activity.index');
    }).property('controllers.application.currentPath', 'controllers.application.viewType'),
    inTabletMode: (function() {
      return this.get('controllers.application.inTabletMode');
    }).property('controllers.application.inTabletMode'),
    cannotPreviewMessage: function(templateActivity) {
      return Messenger().post({
        id: 'workflow-auth-incomplete',
        singleton: false,
        hideAfter: 15,
        showCloseButton: true,
        message: "You need to connect a <strong>" + (templateActivity.get('kind').split('/')[0].capitalize()) + " account</strong> to task \"<strong>" + (templateActivity.get('label')) + "</strong>\" before this taskflow can be previewed or run.",
        type: 'info'
      });
    }
  });

}).call(this);

//# sourceMappingURL=workflow_controller.js.map


(function() {
  KotiveWebapp.WorkflowDeleteController = Ember.Controller.extend(KotiveWebapp.MessengerMixin, {
    needs: ['application', 'group', 'condition', 'template-activity'],
    actions: {
      dropOpened: function() {
        return this.checkForChildActivities();
      },
      deleteAction: function() {
        var id, label, model;
        model = this.get('model');
        id = model.get('id');
        label = model.get('label');
        model.deleteRecord();
        return model.save().then((function(_this) {
          return function() {
            var group;
            group = _this.get('controllers.group.model');
            group.get('workflows').removeObject(model);
            group.save();
            _this.send('closeDropTooltip');
            _this.send('closeModal');
            _this.send('workflowsModified');
            _this.transitionToRoute('designer.workflows', group);
            return Ember.run.later(function() {
              return Messenger().post({
                id: 'workflow-deleted',
                singleton: false,
                hideAfter: 5,
                showCloseButton: true,
                message: "The '" + label + "' taskflow has been deleted.",
                type: 'info'
              });
            }, 150);
          };
        })(this));
      }
    },
    checkForChildActivities: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var model, taskflow_id;
          model = _this.get('model');
          taskflow_id = model.get('id_root');
          return model.get('templateActivities').then(function(templateActivities) {
            var items;
            items = templateActivities.filter(function(ta) {
              return ta.get('id_root') === taskflow_id && ta.get('id') !== taskflow_id;
            });
            _this.set('canDeleteTaskflow', items.length === 0);
            return resolve();
          }, reject);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=workflow_delete_controller.js.map


(function() {
  KotiveWebapp.WorkflowSettingsController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.BasicAuthMixin, KotiveWebapp.KeychainProcessMixin, KotiveWebapp.WorkflowHashMixin, KotiveWebapp.WebhookHashMixin, {
    needs: ['application', 'group'],
    actions: {
      openingModal: function() {
        this.set('loading', true);
        return this.checkForAllowEmbeddingAndGetFirstFields().then((function(_this) {
          return function() {
            return _this.setWorkflowHash();
          };
        })(this)).then((function(_this) {
          return function() {
            return _this.setWebhookHash();
          };
        })(this)).then((function(_this) {
          return function() {
            return _this.setLinkedGroup();
          };
        })(this)).then((function(_this) {
          return function() {
            return _this.getAllGroups();
          };
        })(this)).then((function(_this) {
          return function() {
            _this.set('enableJavascript', true);
            _this.set('customCss', '');
            _this.set('customSaveBtn', '');
            _this.set('customThanksTitle', '');
            _this.set('customThanksMessage', '');
            _this.set('customOptions', '');
            _this.set('loading', false);
            return Ember.run.next(function() {
              return _this.trigger('setViewListeners');
            });
          };
        })(this))["catch"](function(err) {
          console.error(err);
          return Messenger().post({
            id: 'taskflow-setting-setup-error',
            singleton: false,
            hideAfter: 15,
            showCloseButton: true,
            message: 'Sorry, something went wrong while attempting fetch settings for this taskflow. Please try again in a few minutes',
            type: 'info'
          });
        });
      },
      deleteWorkflow: function() {
        return this.trigger('deleteWorkflow');
      }
    },
    baseEmbedUrl: (function() {
      return 'https://webapp.kotive.com/hub/taskflow/new';
    }).property(),
    directLink: (function() {
      var customParams;
      customParams = this.get('customOptions') !== '' ? "?" + (this.get('customOptions')) : "";
      return (this.get('baseEmbedUrl')) + "/" + (this.get('linkedGroupId')) + "/" + (this.get('workflowHash')) + "/" + (this.get('viewType')) + customParams;
    }).property('linkedGroupId', 'workflowHash', 'viewType', 'customOptions'),
    webhookLink: (function() {
      return "https://webapp.kotive.com/hub/hooks/s/" + (this.get('linkedGroupId')) + "/" + (this.get('workflowHash')) + "/" + (this.get('webhookHash')) + "?" + (this.get('prefilledParams'));
    }).property('linkedGroupId', 'workflowHash', 'webhookHash', 'prefilledParams'),
    autofillLink: (function() {
      var customParams;
      customParams = this.get('customOptions') !== '' ? (this.get('customOptions')) + "&" : "";
      return (this.get('baseEmbedUrl')) + "/" + (this.get('linkedGroupId')) + "/" + (this.get('workflowHash')) + "/" + (this.get('viewType')) + "?" + customParams + (this.get('prefilledParams'));
    }).property('linkedGroupId', 'workflowHash', 'viewType', 'customOptions', 'prefilledParams'),
    setCustomOptions: (function() {
      var customOptions;
      customOptions = [];
      if (this.get('customCss') && (this.get('customCss') !== '') && (this.get('customCss').indexOf('https://') === 0)) {
        customOptions.push("css=" + (encodeURIComponent(this.get('customCss'))));
      }
      if (this.get('customSaveBtn') && (this.get('customSaveBtn') !== '')) {
        customOptions.push("saveBtn=" + (encodeURIComponent(this.get('customSaveBtn'))));
      }
      if (this.get('customThanksTitle') && (this.get('customThanksTitle') !== '')) {
        customOptions.push("thanksTitle=" + (encodeURIComponent(this.get('customThanksTitle'))));
      }
      if (this.get('customThanksMessage') && (this.get('customThanksMessage') !== '')) {
        customOptions.push("thanksMessage=" + (encodeURIComponent(this.get('customThanksMessage'))));
      }
      return this.set('customOptions', customOptions.length > 0 ? customOptions.join('&') : '');
    }).observes('customCss', 'customSaveBtn', 'customThanksTitle', 'customThanksMessage'),
    prefilledParams: (function() {
      var params;
      if (this.get('autoFillFields') != null) {
        params = this.get('autoFillFields').map(function(field) {
          if (field.get('style').kind === 'check') {
            return "_" + (field.get('id')) + "[]=(" + (field.get('label')) + ")";
          } else {
            return "_" + (field.get('id')) + "=(" + (field.get('label')) + ")";
          }
        }).join('&');
        return "" + params;
      } else {
        return "";
      }
    }).property('autoFillFields'),
    emailLink: (function() {
      var userEmail;
      userEmail = $.localStorage.get('user-email');
      return "mailto:" + userEmail + "?subject=Have a look at my taskflow&body=Hey! Check out this new taskflow I\'ve designed with Kotive:%0A%0A" + (this.get('directLink'));
    }).property('directLink'),
    twitterLink: (function() {
      return "https://twitter.com/home?status=" + (this.get('directLink')) + "&via=kotivehq";
    }).property('directLink'),
    facebookLink: (function() {
      return "https://www.facebook.com/sharer/sharer.php?u=" + (this.get('directLink'));
    }).property('directLink'),
    linkedInLink: (function() {
      return "https://www.linkedin.com/shareArticle?mini=true&url=" + (this.get('directLink')) + "&title=Check out this new taskflow I\'ve designed with Kotive";
    }).property('directLink'),
    googlePlusLink: (function() {
      return "https://plus.google.com/share?url=" + (this.get('directLink'));
    }).property('directLink'),
    embedWordpress: (function() {
      return "[kotive groupid=\"" + (this.get('linkedGroupId')) + "\" taskflowhash=\"" + (this.get('workflowHash')) + "\" height=\"400\"]";
    }).property('linkedGroupId', 'workflowHash'),
    embedJavascript: (function() {
      var customParams, linkedGroupId, viewType, workflowHash;
      linkedGroupId = this.get('linkedGroupId');
      workflowHash = this.get('workflowHash');
      viewType = this.get('viewType');
      customParams = this.get('customOptions') !== '' ? "?" + (this.get('customOptions')) : "";
      return "<div id=\"kotive-taskflow-container\" style=\"width:100%;height:400px;\">\n<iframe\n  id=\"kotive-embedded-" + workflowHash + "\"\n  src=\"" + (this.get('baseEmbedUrl')) + "/" + linkedGroupId + "/" + workflowHash + "/" + viewType + "/embed" + customParams + "\"\n  frameborder=\"none\"\n  style=\"width:100%;border:0px;\"\n></iframe>\n<script type=\"text/javascript\">\n!function(){function e(e){var t=e.target||e.srcElement;t.__resizeRAF__&&_(t.__resizeRAF__),t.__resizeRAF__=r(function(){var i=t.__resizeTrigger__;i.__resizeListeners__.forEach(function(t){t.call(i,e)})})}function t(){this.contentDocument.defaultView.__resizeTrigger__=this.__resizeElement__,this.contentDocument.defaultView.addEventListener(\"resize\",e)}var i=document.attachEvent,n=navigator.userAgent.match(/Trident/),r=function(){var e=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||function(e){return window.setTimeout(e,20)};return function(t){return e(t)}}(),_=function(){var e=window.cancelAnimationFrame||window.mozCancelAnimationFrame||window.webkitCancelAnimationFrame||window.clearTimeout;return function(t){return e(t)}}();window.addResizeListener=function(r,_){if(!r.__resizeListeners__)if(r.__resizeListeners__=[],i)r.__resizeTrigger__=r,r.attachEvent(\"onresize\",e);else{\"static\"==getComputedStyle(r).position&&(r.style.position=\"relative\");var o=r.__resizeTrigger__=document.createElement(\"object\");o.setAttribute(\"style\",\"display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;\"),o.__resizeElement__=r,o.onload=t,o.type=\"text/html\",n&&r.appendChild(o),o.data=\"about:blank\",n||r.appendChild(o)}r.__resizeListeners__.push(_)},window.removeResizeListener=function(t,n){t.__resizeListeners__.splice(t.__resizeListeners__.indexOf(n),1),t.__resizeListeners__.length||(i?t.detachEvent(\"onresize\",e):(t.__resizeTrigger__.contentDocument.defaultView.removeEventListener(\"resize\",e),t.__resizeTrigger__=!t.removeChild(t.__resizeTrigger__)))}}(),function(){function e(e){var t=e.target||e.srcElement;t.__resizeRAF__&&_(t.__resizeRAF__),t.__resizeRAF__=r(function(){var i=t.__resizeTrigger__;i.__resizeListeners__.forEach(function(t){t.call(i,e)})})}function t(){this.contentDocument.defaultView.__resizeTrigger__=this.__resizeElement__,this.contentDocument.defaultView.addEventListener(\"resize\",e)}var i=document.attachEvent,n=navigator.userAgent.match(/Trident/),r=function(){var e=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||function(e){return window.setTimeout(e,20)};return function(t){return e(t)}}(),_=function(){var e=window.cancelAnimationFrame||window.mozCancelAnimationFrame||window.webkitCancelAnimationFrame||window.clearTimeout;return function(t){return e(t)}}();addResizeListener=function(r,_){if(!r.__resizeListeners__)if(r.__resizeListeners__=[],i)r.__resizeTrigger__=r,r.attachEvent(\"onresize\",e);else{\"static\"==getComputedStyle(r).position&&(r.style.position=\"relative\");var o=r.__resizeTrigger__=document.createElement(\"object\");o.setAttribute(\"style\",\"display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;\"),o.__resizeElement__=r,o.onload=t,o.type=\"text/html\",n&&r.appendChild(o),o.data=\"about:blank\",n||r.appendChild(o)}r.__resizeListeners__.push(_)},removeResizeListener=function(t,n){t.__resizeListeners__.splice(t.__resizeListeners__.indexOf(n),1),t.__resizeListeners__.length||(i?t.detachEvent(\"onresize\",e):(t.__resizeTrigger__.contentDocument.defaultView.removeEventListener(\"resize\",e),t.__resizeTrigger__=!t.removeChild(t.__resizeTrigger__)))};var o=document.getElementById(\"kotive-embedded-" + workflowHash + "\"),s=o.parentElement,a=function(){var e=s.clientHeight;o.setAttribute(\"height\",e)},c=null;addResizeListener(s,function(){c&&window.clearTimeout(c),c=window.setTimeout(function(){a(),c=null},100)}),a()}();\n</script>\n</div>";
    }).property('linkedGroupId', 'workflowHash', 'viewType', 'customOptions'),
    embedIframe: (function() {
      var customParams, linkedGroupId, viewType, workflowHash;
      linkedGroupId = this.get('linkedGroupId');
      workflowHash = this.get('workflowHash');
      viewType = this.get('viewType');
      customParams = this.get('customOptions') !== '' ? "?" + (this.get('customOptions')) : "";
      return "<iframe\nid=\"kotive-embedded-" + workflowHash + "\"\nsrc=\"" + (this.get('baseEmbedUrl')) + "/" + linkedGroupId + "/" + workflowHash + "/" + viewType + "/embed" + customParams + "\"\nframeborder=\"none\"\nstyle=\"width:100%;border:0px;\"\nheight=\"400\"\n></iframe>";
    }).property('linkedGroupId', 'workflowHash', 'viewType', 'customOptions'),
    setViewType: (function() {
      return this.set('viewType', this.get('enableJavascript') ? 'full' : 'simple');
    }).observes('enableJavascript'),
    checkForAllowEmbeddingAndGetFirstFields: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var model;
          model = _this.get('model');
          return model.get('templateActivities').then(function(templateActivities) {
            var autoFillFields, items;
            items = templateActivities.filter(function(ta) {
              return ta.get('id_parent') === model.get('id') && ta.get('order') === 0 && ta.get('publish');
            });
            if (items.length === 0) {
              _this.set('canEmbed', false);
            } else {
              _this.set('canEmbed', true);
              autoFillFields = [];
              items[0].get('templateFields').then(function(tfs) {
                var fields;
                fields = tfs.sortBy('order').filter(function(tf) {
                  var isDisplayField, ref;
                  isDisplayField = (ref = tf._data.style.kind) === 'heading' || ref === 'divider' || ref === 'paragraph' || ref === 'section' || ref === 'upload' || ref === 'uploadshow';
                  return !isDisplayField;
                });
                async.mapSeries(fields, function(field, done) {
                  return _this.getServerId(field.get('id'), 'templateFields').then(function(fieldId) {
                    var param;
                    if (field.get('style').kind === 'check') {
                      param = "_" + fieldId + "[]=" + (field.get('label'));
                    } else {
                      param = "_" + fieldId + "=" + (field.get('label'));
                    }
                    return done(null, {
                      param: param
                    });
                  }, done);
                }, function(err, fields) {
                  if (err != null) {
                    return console.error(err);
                  } else {
                    return fields;
                  }
                });
                return _this.set('autoFillFields', fields);
              });
            }
            return resolve();
          }, reject);
        };
      })(this));
    },
    setWorkflowHash: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.getServerId(_this.model.get('id'), 'templateActivities').then(function(id) {
            return _this.getWorkflowHash(id);
          }).then(function(hash) {
            _this.set('workflowHash', hash);
            return resolve();
          })["catch"](reject);
        };
      })(this));
    },
    setWebhookHash: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.getServerId(_this.model.get('id'), 'templateActivities').then(function(id) {
            return _this.getWebhookHash(id);
          }).then(function(hash) {
            _this.set('webhookHash', hash);
            return resolve();
          })["catch"](reject);
        };
      })(this));
    },
    setLinkedGroup: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('model').get('groups').then(function(groups) {
            var group;
            group = groups.objectAt(0);
            return _this.getServerId(group.get('id'), 'groups').then(function(id) {
              _this.set('linkedGroupId', id);
              return resolve();
            }, reject);
          }, reject);
        };
      })(this));
    },
    getAllGroups: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('model').get('groups').then(function(gs) {
            var group;
            group = gs.objectAt(0);
            return _this.get('store').find('group').then(function(groups) {
              return _this.getGroupOpt(group).then(function(opt) {
                var opts;
                opts = [opt];
                return _this.getChildren(group.get('id'), groups).then(function(childOpts) {
                  childOpts.forEach(function(opt) {
                    return opts.push(opt);
                  });
                  _this.set('groupOptions', opts.sortBy('label'));
                  return resolve();
                }, reject);
              }, reject);
            }, reject);
          }, reject);
        };
      })(this));
    },
    getChildren: function(parentId, groups) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var children, opts;
          opts = [];
          children = groups.filter(function(g) {
            return g.get('id_parent') === parentId;
          });
          return async.each(children, function(g, next) {
            return _this.getGroupOpt(g).then(function(opt) {
              opts.push(opt);
              return _this.getChildren(g.get('id'), groups).then(function(childOpts) {
                childOpts.forEach(function(opt) {
                  return opts.push(opt);
                });
                return next();
              }, next);
            }, next);
          }, function(err) {
            if (err != null) {
              return reject(err);
            } else {
              return resolve(opts);
            }
          });
        };
      })(this));
    },
    getGroupOpt: function(group) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.getServerId(group.get('id'), 'groups').then(function(id) {
            return resolve({
              id: id,
              label: (group.get('label')) + " (" + (group.get('level')) + ")"
            });
          }, reject);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=workflow_settings_controller.js.map


(function() {
  KotiveWebapp.WorkflowsAddController = Ember.Controller.extend(Ember.Evented, KotiveWebapp.ModalHelperMixin, KotiveWebapp.TaskflowRecipesMixin, {
    needs: ['application', 'condition', 'group'],
    titleUpdated: (function() {
      return this.send('validateTitle');
    }).observes('model.label'),
    invalidTitle: (function() {
      return !this.get('titleIsValid');
    }).property('titleIsValid'),
    actions: {
      dropOpened: function() {
        return this.trigger('readyToFocus');
      },
      submit: function() {
        var group, model;
        this.send('validateTitle');
        if (this.get('titleIsValid')) {
          model = this.get('model');
          group = this.get('controllers.group.model');
          return model.save().then((function(_this) {
            return function() {
              model.setProperties({
                id_root: model.get('id'),
                id_parent: '0',
                order: 0
              });
              return model.get('groups').then(function(groups) {
                groups.pushObject(group);
                return group.get('workflows').then(function(workflows) {
                  workflows.addObject(model);
                  return model.save().then(function() {
                    return group.save().then(function() {
                      _this.send('workflowAddedIndicate', model);
                      _this.send('closeDropTooltip');
                      return _this.send('workflowsModified');
                    });
                  });
                });
              });
            };
          })(this));
        }
      },
      showTaskflowRecipes: function() {
        this.send('closeDropTooltip');
        return this.showTaskflowRecipes();
      },
      validateTitle: function() {
        var model;
        model = this.get('model');
        if (model.get('label') == null) {
          model.set('label', '');
        }
        this.set('titleIsValid', this.get('model').get('label').trim() !== '');
        return false;
      }
    }
  });

}).call(this);

//# sourceMappingURL=workflows_add_controller.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.TemplateFieldModelPatternMixin = Ember.Mixin.create(KotiveWebapp.PatternEncodingsMixin, {
    allowedPatternTypes: ['str', 'sse', 'mse', 'num', ''],
    patternOptions: (function() {
      var generateCompletedSelectionsList, options, pattern;
      pattern = this.get('pattern');
      options = {};
      options.type = this.getPatternType(pattern);
      if (this.get('style.optionsType') === 'predefined' && /^[sm]se\[\{.*\}\]\[\]$/.test(pattern)) {
        options.selections = [];
        options.completedSelections = [];
        options["default"] = '';
      } else {
        generateCompletedSelectionsList = function() {
          return _.filter(options.selections, function(selection) {
            return (selection.key != null) && selection.key !== '' && selection.value !== '';
          });
        };
        options.selections = this.getPatternSelectionsFor(pattern);
        options.completedSelections = generateCompletedSelectionsList();
        options["default"] = this.getPatternDefault();
      }
      return options;
    }).property('pattern'),
    patternString: (function() {
      return this.generatePatternString();
    }).property(),
    isOptionField: (function() {
      var ref;
      return (ref = this.get('style.kind')) === 'select' || ref === 'radio' || ref === 'check';
    }).property('style.kind'),
    styleKindChanged: (function() {
      var patternType, ref, ref1, ref2;
      if (!this.get('isOptionField') && ((ref = this.get('patternOptions.type')) === 'sse' || ref === 'mse')) {
        this.set('style.optionsType', 'custom');
        this.setPattern({
          type: 'str',
          selections: [],
          clearDefault: true
        });
        return this.set('patternString', '');
      } else if (this.get('isOptionField') && !((ref1 = this.get('patternOptions.type')) === 'sse' || ref1 === 'mse')) {
        patternType = this.get('style.kind') === 'check' ? 'mse' : 'sse';
        return this.setPattern({
          type: patternType,
          selections: [],
          clearDefault: true
        });
      } else if (this.get('isOptionField')) {
        if (this.get('style.kind') === 'check' && this.get('patternOptions').type !== 'mse') {
          return this.setPattern({
            type: 'mse'
          });
        } else if (((ref2 = this.get('style.kind')) === 'select' || ref2 === 'radio') && this.get('patternOptions').type !== 'sse') {
          return this.setPattern({
            type: 'sse',
            clearDefault: true
          });
        }
      }
    }).observes('style.kind'),
    patternStringUpdate: (function() {
      var newPatternString, patternString;
      if (this.get('style.optionsType') === 'predefined') {
        return this.setPattern({
          pattern: this.get('patternString')
        });
      } else {
        if (this.get('patternOptions').type === 'str') {
          patternString = this.get('patternString');
          newPatternString = "str[" + patternString + "][]";
          if (this.get('pattern') !== newPatternString) {
            return this.set('pattern', newPatternString);
          }
        } else if (this.get('style').kind === 'check') {
          return this.setPattern({
            "default": this.get('patternString').split('^')
          });
        } else if (this.get('patternOptions')["default"] !== this.get('patternString')) {
          return this.setPattern({
            "default": this.get('patternString')
          });
        }
      }
    }).observes('patternString'),
    refreshPatternString: function() {
      return this.set('patternString', this.generatePatternString());
    },
    generatePatternString: function() {
      var end, kind, pattern, start;
      pattern = this.get('pattern') || 'str[][]';
      kind = pattern.substring(0, 3);
      if (pattern.match(/^str\[[^\]]*\]/m) != null) {
        start = pattern.indexOf('[');
        end = pattern.indexOf(']');
        return pattern.substring(start + 1, end);
      } else {
        start = pattern.nthOccurrenceIndex('[', 2);
        end = pattern.nthOccurrenceIndex(']', 2);
        if (start === -1 || end === -1) {
          return '';
        } else {
          return pattern.substring(start + 1, end);
        }
      }
    },
    setPatternOptionType: function(type) {
      var patternOptions;
      if (indexOf.call(this.allowedPatternTypes, type) < 0) {
        throw new Error("Unknown pattern type received - " + type);
      }
      patternOptions = this.get('patternOptions');
      patternOptions.type = type;
      return this.setPattern(patternOptions);
    },
    setPatternOptionSelection: function(key, value) {
      var patternOptions;
      if (value == null) {
        value = null;
      }
      value = value || key;
      patternOptions = this.get('patternOptions');
      patternOptions.selections.pushObject({
        key: key,
        value: value
      });
      return this.setPattern(patternOptions);
    },
    setPattern: function(patternOptions) {
      var defaultVal, optionToString, patternDefault, patternSelections, selections, type;
      if (patternOptions == null) {
        patternOptions = {};
      }
      patternSelections = function(selections) {
        if ((selections == null) || selections.length === 0) {
          return '';
        }
        return _.map(selections, function(selection) {
          return optionToString(selection);
        }).join('^');
      };
      patternDefault = (function(_this) {
        return function(defaultObj) {
          var selectionKeys;
          if ((defaultObj == null) || patternOptions.clearDefault) {
            return '';
          }
          selectionKeys = (patternOptions.selections || _this.get('patternOptions').selections).map(function(s) {
            return s.key;
          });
          if (typeof defaultObj === 'string') {
            if (defaultObj.indexOf('^' === -1)) {
              return _this.encode(defaultObj);
            } else {
              return defaultObj;
            }
          } else {
            if (defaultObj instanceof Array) {
              if (typeof defaultObj === 'string') {
                if (indexOf.call(selectionKeys, defaultObj) >= 0) {
                  return _this.encode(defaultObj);
                } else {
                  return '';
                }
              } else {
                return defaultObj.filter(function(d) {
                  var ref;
                  if (d.key != null) {
                    return ref = d.key, indexOf.call(selectionKeys, ref) >= 0;
                  } else {
                    return indexOf.call(selectionKeys, d) >= 0;
                  }
                }).map(function(d) {
                  if (d.key != null) {
                    return _this.encode(d.key);
                  } else {
                    return _this.encode(d);
                  }
                }).join('^');
              }
            } else if (defaultObj instanceof Object) {
              if (defaultObj.key != null) {
                return _this.encode(defaultObj.key);
              } else {
                return _this.encode(defaultObj);
              }
            } else {
              return optionToString(defaultObj);
            }
          }
        };
      })(this);
      optionToString = (function(_this) {
        return function(option) {
          if ((option.value == null) || option.key === option.value || option.value === '') {
            return _this.encode(option.key);
          } else {
            return (_this.encode(option.key)) + ":" + (_this.encode(option.value));
          }
        };
      })(this);
      if (this.get('style.optionsType') === 'predefined') {
        return this.set('pattern', patternOptions.pattern);
      } else {
        type = patternOptions.type || this.figureOutPatternType();
        selections = patternSelections(patternOptions.selections || this.get('patternOptions').selections);
        defaultVal = patternDefault(patternOptions["default"] || this.get('patternOptions')["default"]);
        if (type === 'str') {
          return this.set('pattern', type + "[" + defaultVal + "][]");
        } else {
          return this.set('pattern', type + "[" + selections + "][" + defaultVal + "]");
        }
      }
    },
    setPatternFromService: function(fieldData) {
      var patternOptions;
      patternOptions = {
        type: this.figureOutPatternType(fieldData.properties.fieldType)
      };
      patternOptions.selections = _.map(fieldData.properties.choices, function(choice) {
        if (typeof choice === 'string') {
          return {
            key: choice,
            value: choice
          };
        } else {
          return choice;
        }
      });
      if (fieldData.properties["default"] != null) {
        if (patternOptions.type === 'str') {
          patternOptions["default"] = fieldData.properties["default"];
        } else {
          patternOptions["default"] = _.findWhere(patternOptions.selections, {
            key: fieldData.properties["default"]
          });
        }
      }
      return this.setPattern(patternOptions);
    },
    getPatternType: function(patternStr) {
      if ((patternStr == null) || patternStr === '') {
        return this.figureOutPatternType();
      } else {
        return patternStr.substring(0, 3);
      }
    },
    figureOutPatternType: function(kind) {
      kind = kind || this.get('style').kind;
      if (kind === 'check') {
        return 'mse';
      } else if (kind === 'radio' || kind === 'select') {
        return 'sse';
      } else {
        return 'str';
      }
    },
    getPatternSelections: function() {
      var pattern;
      pattern = this.get('pattern');
      return this.getPatternSelectionsFor(pattern);
    },
    getPatternSelectionsFor: function(patternStr) {
      var end, selectionsStr, start;
      if (patternStr == null) {
        return [];
      }
      start = patternStr.indexOf('[');
      end = patternStr.indexOf(']');
      if (start === -1 || end === -1) {
        return [];
      }
      selectionsStr = patternStr.substring(start + 1, end);
      if (selectionsStr === '') {
        return [];
      }
      return _.map(selectionsStr.split('^'), (function(_this) {
        return function(optBlock) {
          var key, ref, value;
          if (optBlock.indexOf(':') === -1) {
            value = _this.decode(optBlock);
            return {
              key: value,
              value: value
            };
          } else {
            ref = optBlock.split(':'), key = ref[0], value = ref[1];
            return {
              key: _this.decode(key),
              value: _this.decode(value)
            };
          }
        };
      })(this));
    },
    getPatternDefaultIndex: function() {
      var defaultObj;
      defaultObj = this.getPatternDefault();
      if (defaultObj == null) {
        return null;
      }
      return _.reduce(this.getPatternSelections(), function(memo, option) {
        if (!memo.match) {
          if (_.isEqual(defaultObj, option)) {
            memo.match = true;
            memo.index = memo.pos;
          }
          memo.pos += 1;
        }
        return memo;
      }, {
        index: null,
        pos: 0,
        match: false
      }).index;
    },
    getPatternDefault: function() {
      var defaultStr, defaultVal, end, patternStr, start;
      patternStr = this.get('pattern');
      if (patternStr == null) {
        return null;
      }
      start = patternStr.nthOccurrenceIndex('[', 2);
      end = patternStr.nthOccurrenceIndex(']', 2);
      if (start === -1 || end === -1) {
        return null;
      }
      defaultStr = patternStr.substring(start + 1, end);
      if (defaultStr === '') {
        return null;
      }
      defaultVal = _.map(defaultStr.split('^'), (function(_this) {
        return function(stringVal) {
          var key, ref, value;
          if (stringVal.indexOf(':') === -1) {
            value = _this.decode(stringVal);
            return {
              key: value,
              value: value
            };
          } else {
            ref = stringVal.split(':'), key = ref[0], value = ref[1];
            return {
              key: _this.decode(key),
              value: _this.decode(value)
            };
          }
        };
      })(this));
      if (defaultVal.length === 1) {
        return defaultVal[0];
      } else {
        return defaultVal;
      }
    },
    setPatternDefaultByIndex: function(index) {
      var option;
      option = this.get('patternOptions').selections[index];
      if (option == null) {
        throw new Error('Cannot set default pattern for pattern index that does not exist');
      }
      return this.setPatternDefault(option);
    },
    setPatternDefaultByOptions: function(options) {},
    setPatternDefault: function(patternObj) {
      var exists, selections;
      selections = this.get('patternOptions').selections;
      exists = _.any(selections, function(option) {
        return option.key === patternObj.key && option.value === patternObj.value;
      });
      if (!exists) {
        throw new Error('Cannot set default pattern for pattern that does not exist');
      }
      this.setPattern({
        "default": patternObj
      });
      if (this.get('patternOptions').type !== 'str') {
        return this.set('patternString', patternObj.key);
      }
    },
    clearPatternDefault: function() {
      return this.setPattern({
        clearDefault: true
      });
    }
  });

}).call(this);

//# sourceMappingURL=_template_field_pattern_mixin.js.map


(function() {
  KotiveWebapp.Data = KotiveWebapp.Data || {};

  KotiveWebapp.Data.menuItems = [
    {
      icon: 'glyphicon-arrow-left',
      name: 'Exit the Designer',
      path: false,
      click: 'exitDesigner',
      matchPaths: []
    }, {
      name: 'Design Taskflows',
      path: 'designers',
      click: false,
      matchPaths: ['designers', 'group.designer.workflows', 'group.designer.workflow.index', 'group.designer.workflow.template-activity.index']
    }, {
      name: 'Manage Roles',
      path: false,
      click: 'manageRoles',
      matchPaths: []
    }
  ];

  KotiveWebapp.ApplicationMenuItemAdapter = DS.FixtureAdapter;

  KotiveWebapp.ApplicationMenuItem = DS.Model.extend({
    isActive: false,
    icon: DS.attr('string'),
    name: DS.attr('string'),
    path: DS.attr('string'),
    click: DS.attr('string'),
    matchPaths: DS.attr()
  });

  KotiveWebapp.ApplicationMenuItem.FIXTURES = _.map(KotiveWebapp.Data.menuItems, function(item, index) {
    item.id = index;
    return item;
  });

}).call(this);

//# sourceMappingURL=application_menu_item.js.map


(function() {
  KotiveWebapp.ConditionAdapter = KotiveWebappAdapter;

  KotiveWebapp.Condition = DS.Model.extend({
    actualId: DS.attr('string'),
    name: DS.attr('string', {
      defaultValue: ''
    }),
    type: DS.attr('string'),
    order: DS.attr('number'),
    createdBy: DS.attr('string'),
    status: DS.attr('string', {
      defaultValue: 'active'
    }),
    templateActivities: DS.hasMany('template-activity', {
      async: true
    }),
    filters: DS.hasMany('filter', {
      async: true
    }),
    recalculateFiltersOrder: function() {
      return this.get('filters').then(function(filters) {
        return filters.sortBy('order').forEach(function(filter, index) {
          if (filter.get('order') !== index) {
            filter.set('order', index);
            return filter.save();
          }
        });
      });
    }
  });

  KotiveWebapp.Condition.FIXTURES = [];

}).call(this);

//# sourceMappingURL=condition.js.map


(function() {
  KotiveWebapp.Data = KotiveWebapp.Data || {};

  KotiveWebapp.Data.conditionUserOptions = [
    {
      id: 'current-user_role',
      label: 'Role',
      order: 2,
      grouping: 'Current user'
    }, {
      id: 'current-user_email',
      label: 'Email',
      order: 4,
      grouping: 'Current user'
    }
  ];

  KotiveWebapp.ConditionUserOptionAdapter = DS.FixtureAdapter;

  KotiveWebapp.ConditionUserOption = DS.Model.extend({
    label: DS.attr('string'),
    order: DS.attr('number'),
    grouping: DS.attr('string')
  });

  KotiveWebapp.ConditionUserOption.FIXTURES = KotiveWebapp.Data.conditionUserOptions;

}).call(this);

//# sourceMappingURL=condition_user_option.js.map


(function() {
  KotiveWebapp.ElasticAuditActivity = Ember.Object.extend({
    init: function() {
      this.set('fieldsProcessed', false);
      return async.map(this.get('fields'), function(fieldData, next) {
        var field;
        field = KotiveWebapp.ElasticAuditActivityField.create(fieldData);
        return next(null, field);
      }, (function(_this) {
        return function(err, fields) {
          _this.set('fields', fields);
          return _this.set('fieldsProcessed', true);
        };
      })(this));
    },
    valueForField: function(templatefieldId) {
      var field;
      field = this.get('fields').find(function(field) {
        return field.get('templateFieldId').toString() === templatefieldId.toString();
      });
      if (field != null) {
        if (field.get('value') === '') {
          return '-';
        } else {
          return field.get('value');
        }
      } else {
        return '-';
      }
    }
  });

}).call(this);

//# sourceMappingURL=elastic_audit_activity.js.map


(function() {
  KotiveWebapp.ElasticAuditActivityField = Ember.Object.extend();

}).call(this);

//# sourceMappingURL=elastic_audit_activity_field.js.map


(function() {
  KotiveWebapp.ElasticAuditProcessActivity = Ember.Object.extend({
    init: function() {
      var parentActivity;
      this.set('processingData', true);
      this.set('reportFieldsAvailable', false);
      parentActivity = KotiveWebapp.ElasticAuditActivity.create(this.get('_source.activityData'));
      parentActivity.set('timeStamp', this.get('_source.timeStamp'));
      return this.set('activities', [parentActivity]);
    },
    processId: (function() {
      return this.get('_source.activityData.processId');
    }).property('_source.activityData.processId'),
    updateReportFields: (function() {
      var headings, reportFields;
      if (!this.get('processingData') && (this.get('parent.taskflowHeadings') != null)) {
        this.set('reportFieldsAvailable', false);
        headings = this.get('parent.taskflowHeadings');
        reportFields = headings.map((function(_this) {
          return function(heading) {
            return _this.valueFor(heading.templateActivityId, heading.templateFieldId);
          };
        })(this));
        this.set('reportFields', reportFields);
        return this.set('reportFieldsAvailable', true);
      }
    }).observes('parent.taskflowHeadings', 'processingData'),
    lastUpdateDateString: (function() {
      var activities, d, formatNumber, lastEpoch;
      activities = this.get('activities');
      formatNumber = function(n) {
        if (n < 10) {
          return "0" + n;
        } else {
          return n.toString();
        }
      };
      if (activities != null) {
        lastEpoch = activities.reduce(function(lastEpoch, activity) {
          var timeStamp;
          timeStamp = activity.get('timeStamp');
          if ((timeStamp != null) && timeStamp > lastEpoch) {
            return timeStamp;
          } else {
            return lastEpoch;
          }
        }, 0);
        if (lastEpoch === 0) {
          return '<not available>';
        } else {
          d = new Date(lastEpoch);
          return (d.getYear() + 1900) + "-" + (formatNumber(d.getMonth() + 1)) + "-" + (formatNumber(d.getDate())) + " " + (formatNumber(d.getHours())) + ":" + (formatNumber(d.getMinutes())) + ":" + (formatNumber(d.getSeconds()));
        }
      } else {
        return '(updating)';
      }
    }).property('activities.@each'),
    isFailedStatus: (function() {
      var activities, failedStatus;
      activities = this.get('activities');
      if (activities != null) {
        return failedStatus = activities.reduce(function(failedStatus, activity) {
          var status;
          status = activity.get('status');
          if (((status != null) && status === 'failed') || failedStatus) {
            return true;
          } else {
            return false;
          }
        }, false);
      } else {
        return false;
      }
    }).property('activities.@each'),
    addChildActivity: function(record) {
      var activity;
      activity = KotiveWebapp.ElasticAuditActivity.create(record._source.activityData);
      activity.set('timeStamp', record._source.timeStamp);
      return this.get('activities').pushObject(activity);
    },
    doneLoading: function() {
      return this.set('processingData', false);
    },
    valueFor: function(templateActivityId, templateFieldId) {
      var activities, activity;
      if ((templateActivityId != null) && (templateFieldId != null)) {
        activities = this.get('activities');
        activity = activities.find(function(activity) {
          return activity.get('templateActivityId').toString() === templateActivityId.toString();
        });
        if (activity != null) {
          return activity.valueForField(templateFieldId);
        } else {
          return '(no data)';
        }
      } else {
        return '';
      }
    }
  });

}).call(this);

//# sourceMappingURL=elastic_audit_process_activity.js.map


(function() {
  KotiveWebapp.FilterAdapter = KotiveWebappAdapter;

  KotiveWebapp.Filter = DS.Model.extend({
    property: DS.attr('string', {
      defaultValue: 'current-user_role'
    }),
    comparison: DS.attr('string', {
      defaultValue: 'is'
    }),
    value: DS.attr('string', {
      defaultValue: ''
    }),
    order: DS.attr('number', {
      defaultValue: 0
    }),
    createdBy: DS.attr('string'),
    conditions: DS.hasMany('condition', {
      async: true
    }),
    orderIncrement: function() {
      return this.set('order', this.get('order') + 1);
    },
    firstFilter: (function() {
      return this.get('order') === 0;
    }).property('order'),
    notFirstFilter: (function() {
      return !this.get('firstFilter');
    }).property('firstFilter')
  });

  KotiveWebapp.Filter.FIXTURES = [];

}).call(this);

//# sourceMappingURL=filter.js.map


(function() {
  KotiveWebapp.Data = KotiveWebapp.Data || {};

  KotiveWebapp.Data.filterComparisonTypes = [
    {
      key: 'is'
    }, {
      key: 'is not'
    }, {
      key: 'greater than'
    }, {
      key: 'less than'
    }, {
      key: 'contains'
    }
  ];

  KotiveWebapp.FilterComparisonTypeAdapter = DS.FixtureAdapter;

  KotiveWebapp.FilterComparisonType = DS.Model.extend({
    key: DS.attr('string')
  });

  KotiveWebapp.FilterComparisonType.FIXTURES = _.map(KotiveWebapp.Data.filterComparisonTypes, function(item, index) {
    item.id = index;
    return item;
  });

}).call(this);

//# sourceMappingURL=filter_comparison_type.js.map


(function() {
  KotiveWebapp.GroupAdapter = KotiveWebappAdapter;

  KotiveWebapp.Group = DS.Model.extend({
    actualId: DS.attr('string'),
    createdBy: DS.attr('string'),
    id_parent: DS.attr('string', {
      defaultValue: '1'
    }),
    label: DS.attr('string', {
      defaultValue: ''
    }),
    status: DS.attr('string', {
      defaultValue: 'active'
    }),
    level: DS.attr('string', {
      defaultValue: 'application'
    }),
    workflows: DS.hasMany('workflow', {
      async: true
    }),
    extend_id: DS.attr('number'),
    workflowsSorting: ['label'],
    sortedworkflows: Ember.computed.sort('workflows', 'workflowsSorting'),
    iconImage: (function() {
      switch (this.get('level')) {
        case 'company':
          return '/images/4d4ba665.people-groups-company.png';
        case 'application':
          return '/images/d12ff87f.people-groups-application.png';
        case 'organization':
          return '/images/d8709640.people-groups-organization.png';
        default:
          return '/images/d8709640.people-groups.png';
      }
    }).property('level'),
    levelName: (function() {
      switch (this.get('level')) {
        case 'company':
          return 'Maker account';
        case 'application':
          return 'App';
        case 'organization':
          return 'Organization/Team';
        default:
          return 'Organization/Team';
      }
    }).property('level')
  });

  KotiveWebapp.Group.FIXTURES = [];

  KotiveWebapp.GroupRootModel = Ember.Object.extend({
    label: '(People index view)',
    iconImage: '/images/d8709640.people-groups.png'
  });

}).call(this);

//# sourceMappingURL=group.js.map


(function() {
  KotiveWebapp.GroupRolesLinkAdapter = KotiveWebappAdapter;

  KotiveWebapp.GroupRolesLink = DS.Model.extend({
    actualId: DS.attr('string'),
    createdBy: DS.attr('string'),
    roles: DS.hasMany('roles', {
      async: true
    })
  });

}).call(this);

//# sourceMappingURL=group_roles_link.js.map


(function() {
  KotiveWebapp.PersonAdapter = KotiveWebapp.RESTAdapter.extend();

  KotiveWebapp.Person = DS.Model.extend({
    email: DS.attr('string'),
    username: DS.attr('string'),
    firstname: DS.attr('string', {
      defaultValue: ''
    }),
    lastname: DS.attr('string', {
      defaultValue: ''
    }),
    mobile: DS.attr('string', {
      defaultValue: ''
    }),
    password: DS.attr('string', {
      defaultValue: ''
    }),
    groupId: DS.attr('number'),
    fullName: (function() {
      return ((this.get('firstname')) + " " + (this.get('lastname'))).trim();
    }).property('firstname', 'lastname'),
    descriptor: (function() {
      var fullName;
      fullName = this.get('fullName');
      if (fullName === '') {
        return this.get('email');
      } else {
        return fullName;
      }
    }).property('firstname', 'lastname', 'email'),
    alreadyExists: (function() {
      return !this.get('isNew');
    }).property('isNew')
  });

}).call(this);

//# sourceMappingURL=person.js.map


(function() {
  KotiveWebapp.PersonRoleAdapter = KotiveWebapp.RESTAdapter.extend();

  KotiveWebapp.PersonRole = DS.Model.extend({
    userId: DS.attr('number'),
    roleId: DS.attr('number'),
    groupId: DS.attr('number')
  });

}).call(this);

//# sourceMappingURL=person_role.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.Report = Ember.Object.extend(KotiveWebapp.BasicAuthMixin, KotiveWebapp.KeychainProcessMixin, {
    fieldsToDisplay: 3,
    processIncludeFields: ['timeStamp', 'activityData.phase', 'activityData.status', 'activityData.processId', 'activityData.templateActivityId', 'groupId'],
    activityIncludeFields: ['timeStamp', 'activityData.phase', 'activityData.status', 'activityData.processId', 'activityData.templateActivityId', 'activityData.fields.value', 'activityData.fields.templateFieldId', 'groupId'],
    processRecordsLimit: 10000,
    activityRecordsLimit: 10000,
    doneLoadingCallbacks: [],
    init: function() {
      this.set('reportHeadingLoaded', false);
      this.set('reportDataLoaded', false);
      this.set('columnsChanged', false);
      this.set('processIds', []);
      this.set('templateActivityIds', []);
      this.set('workflow', false);
      this.fetchWorkflow();
      return this.getServerIds().then((function(_this) {
        return function() {
          return _this.fetchProcessesFromAuditsData();
        };
      })(this), (function(_this) {
        return function(err) {
          console.log(err);
          return _this.showErrorMessage();
        };
      })(this));
    },
    reportLoaded: (function() {
      return this.get('reportHeadingLoaded') && this.get('reportDataLoaded');
    }).property('reportHeadingLoaded', 'reportDataLoaded'),
    processIncludeFieldsQuery: (function() {
      return this.get('processIncludeFields').join(',');
    }).property('processIncludeFields.@each'),
    activityIncludeFieldsQuery: (function() {
      return this.get('activityIncludeFields').join(',');
    }).property('activityIncludeFields.@each'),
    elasticAuditsActivityPath: (function() {
      return "/api/group/" + (this.get('groupServerId')) + "/reports/audits/search/activity";
    }).property('group'),
    setTaskflowHeadings: (function() {
      if (this.get('workflow') != null) {
        return this.generateTaskflowHeading();
      } else {
        return this.set('taskflowHeadings', []);
      }
    }).observes('workflow'),
    setTemplateActivityIds: (function() {
      var templateActivityIds;
      if ((this.get('workflow') != null) && (this.get('taskflowHeadings') != null)) {
        templateActivityIds = [];
        this.set('reportDataLoaded', false);
        this.get('taskflowHeadings').forEach(function(taskflowHeading) {
          var ref;
          if (taskflowHeading.templateActivityId != null) {
            if (ref = parseInt(taskflowHeading.templateActivityId), indexOf.call(templateActivityIds, ref) < 0) {
              return templateActivityIds.push(parseInt(taskflowHeading.templateActivityId));
            }
          }
        });
        this.set('templateActivityIds', templateActivityIds);
        if (this.get('processIds').length === 0) {
          return this.set('reportDataLoaded', true);
        } else {
          return this.fetchActivitiesForProcesses();
        }
      }
    }).observes('workflow', 'processIds', 'taskflowHeadings'),
    onceDoneLoading: function(fn) {
      if (this.get('reportLoaded')) {
        return fn();
      } else {
        return this.get('doneLoadingCallbacks').pushObject(fn);
      }
    },
    getServerIds: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var groupIdentifier, workflowIdentifier;
          groupIdentifier = _this.get('group.id');
          workflowIdentifier = _this.get('workflowId');
          return _this.getServerId(groupIdentifier, 'groups').then(function(id) {
            _this.set('groupServerId', id);
            return _this.getServerId(workflowIdentifier, 'templateActivities');
          }).then(function(id) {
            _this.set('workflowServerId', id);
            return resolve();
          })["catch"](reject);
        };
      })(this));
    },
    generateTaskflowHeading: function() {
      var fieldsToDisplay, headings, key, reportColumns, workflow;
      key = "metadata-report-columns-" + (this.get('workflowId'));
      reportColumns = $.localStorage.get(key);
      this.set('reportHeadingLoaded', false);
      if (reportColumns != null) {
        return this.set('taskflowHeadings', reportColumns);
      } else {
        workflow = this.get('workflow');
        fieldsToDisplay = this.get('fieldsToDisplay');
        headings = [];
        return workflow.get('templateActivities').then((function(_this) {
          return function(tas) {
            var templateActivities;
            templateActivities = tas.sortBy('order', 'label').map(function(ta) {
              return ta;
            });
            return async.eachSeries(templateActivities, function(templateActivity, next) {
              return _this.getServerId(templateActivity.get('id'), 'templateActivities').then(function(id) {
                var templateActivityServerId;
                templateActivityServerId = id;
                return templateActivity.get('templateFields').then(function(tfs) {
                  var templateFields;
                  templateFields = tfs.sortBy('order').filter(function(tf) {
                    var isDisplayField, ref;
                    isDisplayField = (ref = tf._data.style.kind) === 'heading' || ref === 'divider' || ref === 'paragraph' || ref === 'section';
                    return !isDisplayField;
                  });
                  return async.eachSeries(templateFields, function(templateField, next) {
                    return _this.getServerId(templateField.get('id'), 'templateFields').then(function(id) {
                      headings.pushObject({
                        label: templateField.get('label'),
                        templateActivityId: templateActivityServerId,
                        templateFieldId: id
                      });
                      if (headings.length === fieldsToDisplay) {
                        return next('done');
                      } else {
                        return next(null);
                      }
                    }, function(err) {
                      throw err;
                    });
                  }, function(err) {
                    return next(err);
                  });
                });
              }, function(err) {
                throw err;
              });
            }, function(err) {
              while (headings.length < fieldsToDisplay) {
                headings.pushObject({
                  label: ''
                });
              }
              return _this.set('taskflowHeadings', headings);
            });
          };
        })(this));
      }
    },
    fetchWorkflow: function() {
      return this.get('store').find('workflow', this.get('workflowId')).then((function(_this) {
        return function(workflow) {
          return _this.set('workflow', workflow);
        };
      })(this));
    },
    fetchProcessesFromAuditsData: function() {
      var query, url;
      query = this.elasticProcessQuery();
      url = (this.get('elasticAuditsActivityPath')) + "?includeFields=" + (encodeURIComponent(this.get('processIncludeFieldsQuery'))) + "&size=" + (this.get('processRecordsLimit'));
      return $.ajax({
        url: url,
        type: 'post',
        data: JSON.stringify(query),
        contentType: 'application/json',
        headers: {
          Authorization: this.generateBasicAuthToken()
        },
        success: (function(_this) {
          return function(data, textStatus, jqXHR) {
            var processActivities, processIds;
            processActivities = {};
            processIds = [];
            return async.each(data.hits.hits, function(record, next) {
              record.parent = _this;
              processActivities[record._source.activityData.processId] = KotiveWebapp.ElasticAuditProcessActivity.create(record);
              processIds.pushObject(record._source.activityData.processId);
              return next(null);
            }, function(err) {
              _this.set('elasticAuditProcessActivities', Object.keys(processActivities).map(function(key) {
                return processActivities[key];
              }));
              _this.set('elasticAuditProcessActivitiesMapped', processActivities);
              return _this.set('processIds', processIds);
            });
          };
        })(this),
        error: (function(_this) {
          return function(jqXHR, textStatus, errorThrown) {
            var error;
            error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
            console.log(error);
            return _this.showErrorMessage();
          };
        })(this)
      });
    },
    elasticProcessQuery: function() {
      return {
        filtered: {
          filter: {
            bool: {
              must: {
                term: {
                  "activityData.templateActivityId": parseInt(this.get('workflowServerId'))
                }
              },
              must_not: {
                term: {
                  "activityData.phase": ["deleted"]
                }
              }
            }
          }
        },
        sort: [
          {
            "timeStamp": "desc"
          }
        ]
      };
    },
    showErrorMessage: function() {
      return Messenger().post({
        message: "We could not retrieve your reports. <br/>Are you perhaps offline?",
        type: "error",
        showCloseButton: true,
        hideAfter: 5
      });
    },
    fetchActivitiesForProcesses: function() {
      var query, url;
      query = this.elasticActivitiesQuery();
      url = (this.get('elasticAuditsActivityPath')) + "?includeFields=" + (encodeURIComponent(this.get('activityIncludeFieldsQuery'))) + "&size=" + (this.get('activityRecordsLimit'));
      return $.ajax({
        url: url,
        type: 'post',
        data: JSON.stringify(query),
        contentType: 'application/json',
        headers: {
          Authorization: this.generateBasicAuthToken()
        },
        success: (function(_this) {
          return function(data, textStatus, jqXHR) {
            return async.each(data.hits.hits, function(record, next) {
              var parent, processId;
              processId = record._source.activityData.processId;
              parent = _this.get('elasticAuditProcessActivitiesMapped')[processId];
              parent.addChildActivity(record);
              return next(null);
            }, function(err) {
              var callbacks, fn;
              _this.get('elasticAuditProcessActivities').forEach(function(parent) {
                return parent.doneLoading();
              });
              callbacks = _this.get('doneLoadingCallbacks');
              while (callbacks.length !== 0) {
                fn = callbacks.popObject();
                fn();
              }
              return _this.set('reportDataLoaded', true);
            });
          };
        })(this),
        error: (function(_this) {
          return function(jqXHR, textStatus, errorThrown) {
            var error;
            error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
            console.log(error);
            return _this.showErrorMessage();
          };
        })(this)
      });
    },
    elasticActivitiesQuery: function() {
      return {
        filtered: {
          filter: {
            bool: {
              must: [
                {
                  terms: {
                    "activityData.processId": this.get('processIds')
                  }
                }
              ],
              should: [
                {
                  terms: {
                    "activityData.templateActivityId": this.get('templateActivityIds')
                  }
                }, {
                  terms: {
                    "activityData.status": ["failed"]
                  }
                }
              ],
              must_not: {
                term: {
                  "activityData.templateActivityId": parseInt(this.get('workflowServerId'))
                }
              }
            }
          }
        }
      };
    }
  });

}).call(this);

//# sourceMappingURL=report.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.ReportHistory = Ember.Object.extend(KotiveWebapp.BasicAuthMixin, KotiveWebapp.KeychainProcessMixin, {
    auditDataFetched: false,
    historicalDataFetched: false,
    fetchingAuditData: false,
    fetchingHistoricalData: false,
    includeFields: ['timeStamp', 'activityData.status', 'activityData.processId', 'activityData.label', 'activityData.templateActivityId', 'activityData.fields.label', 'activityData.fields.value', 'activityData.fields.pattern', 'activityData.fields.templateFieldId', 'activityData.fields.required', 'userId', 'activityData.kind', 'activityData.serviceResponses.key', 'activityData.serviceResponses.value'],
    recordsLimit: 10000,
    includeFieldsQuery: (function() {
      return this.get('includeFields').join(',');
    }).property(),
    ensureAuditsFetched: function() {
      if (!(this.get('auditDataFetched') || this.get('fetchingAuditData'))) {
        return this.getAuditsData();
      }
    },
    ensureHistoricalFetched: function() {
      if (!(this.get('historicalDataFetched') || this.get('fetchingHistoricalData'))) {
        return this.getHistoricalData();
      }
    },
    getAuditsData: function() {
      return this.getData('audits');
    },
    getHistoricalData: function() {
      return this.getData('historical');
    },
    getData: function(type) {
      this.set((type === 'audits' ? 'fetchingAuditData' : 'fetchingHistoricalData'), true);
      return this.getServerId(this.get('group.id'), 'groups').then((function(_this) {
        return function(groupId) {
          return _this.getServerId(_this.get('workflowId'), 'templateActivities').then(function(workflowId) {
            var url;
            url = "/api/group/" + groupId + "/reports/" + type + "/search/activity?includeFields=" + (encodeURIComponent(_this.get('includeFieldsQuery'))) + "&size=" + (_this.get('recordsLimit'));
            return Ember.$.ajax({
              url: url,
              type: 'post',
              data: JSON.stringify(_this.reportQuery(workflowId)),
              contentType: 'application/json',
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function(data, textStatus, jqXHR) {
                var records;
                if (data.hits.total > 0) {
                  records = data.hits.hits.map(function(r) {
                    var dateStamp, found, iconPath, kind, record;
                    record = r._source;
                    kind = record.activityData.kind;
                    iconPath = kind === 'form' ? 'form' : (kind.split('/')[0]) + "/icon";
                    record.icon = "/images/icons/" + iconPath + ".png";
                    dateStamp = moment.unix(record.timeStamp / 1000);
                    record.date = dateStamp.format('ddd, D MMM YYYY');
                    record.time = dateStamp.format('HH:mm:ss (Z)');
                    if (record.activityData.serviceResponses) {
                      found = _.findWhere(record.activityData.serviceResponses, {
                        key: "kotive_request_status"
                      });
                      if (found && (found.value === 'success')) {
                        record.responseSuccess = true;
                      }
                    }
                    if (kind === 'docraptor/new_document') {
                      record.activityData.fields.forEach(function(field, idx) {
                        if (field.label === 'Document content') {
                          return record.activityData.fields.splice(idx, 1);
                        }
                      });
                    }
                    return record;
                  }).sortBy('timeStamp');
                  return _this.fetchUserData(records, type).then(function(updatedRecords) {
                    _this.set('records', updatedRecords);
                    return _this.markFetchComplete(type);
                  }, function(err) {
                    console.error(err);
                    return _this.showErrorMessage();
                  });
                } else {
                  _this.set('records', []);
                  return _this.markFetchComplete(type);
                }
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                console.error(error);
                return _this.showErrorMessage();
              }
            });
          }, function(err) {
            console.error(err);
            return this.showErrorMessage();
          });
        };
      })(this), function(err) {
        console.error(err);
        return this.showErrorMessage();
      });
    },
    reportQuery: function(workflowId) {
      return {
        filtered: {
          filter: {
            bool: {
              must: {
                term: {
                  'activityData.processId': parseInt(this.get('processId'))
                }
              },
              must_not: {
                term: {
                  'activityData.templateActivityId': parseInt(workflowId)
                }
              }
            }
          }
        }
      };
    },
    markFetchComplete: function(type) {
      this.set((type === 'audits' ? 'auditDataFetched' : 'historicalDataFetched'), true);
      return this.set((type === 'audits' ? 'fetchingAuditData' : 'fetchingHistoricalData'), false);
    },
    fetchUserData: function(records, type) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var userIds;
          userIds = records.reduce(function(userIds, record) {
            var ref;
            if (ref = record.userId, indexOf.call(userIds, ref) < 0) {
              userIds.push(record.userId);
            }
            return userIds;
          }, []);
          return _this.getServerId(_this.get('group.id'), 'groups').then(function(groupId) {
            var url;
            url = "/api/user/group/" + groupId + "/users?ids=" + (userIds.join(','));
            return Ember.$.ajax({
              url: url,
              type: 'get',
              contentType: 'application/json',
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function(data, textStatus, jqXHR) {
                var emptyUser, updatedRecords, users;
                emptyUser = {
                  email: '(user not found)',
                  firstname: '',
                  lastname: '',
                  mobile: '',
                  password: '****',
                  username: '(user not found)'
                };
                users = data.users.map(function(u) {
                  var displayName;
                  displayName = (u.firstname + " " + u.lastname).trim();
                  u.displayName = displayName === '' ? u.email : displayName;
                  return u;
                });
                updatedRecords = records.map(function(record) {
                  var user;
                  user = users.find(function(u) {
                    return u.id === record.userId;
                  });
                  record.user = user != null ? user : emptyUser;
                  return record;
                });
                return resolve(updatedRecords);
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                return reject(error);
              }
            });
          }, function(err) {
            return reject(err);
          });
        };
      })(this));
    },
    showErrorMessage: function() {
      return Messenger().post({
        message: "Sorry, something went wrong and we could not retrieve your report data. Please try again by refreshing your browser.",
        type: "error",
        showCloseButton: true,
        hideAfter: 5
      });
    }
  });

}).call(this);

//# sourceMappingURL=report_history.js.map


(function() {
  KotiveWebapp.RoleAdapter = KotiveWebappAdapter;

  KotiveWebapp.Role = DS.Model.extend({
    actualId: DS.attr('string'),
    createdBy: DS.attr('string'),
    label: DS.attr('string'),
    primaryGroupId: DS.attr('string'),
    identifier: (function() {
      return this.get('id').toString();
    }).property('id'),
    setIsEditable: (function() {
      return this.set('isEditable', this.get('currentGroup.id') === this.get('primaryGroupId'));
    }).observes('currentGroup', 'primaryGroupId')
  });

}).call(this);

//# sourceMappingURL=role.js.map


(function() {
  KotiveWebapp.StaticOfflineRoleAdapter = DS.FixtureAdapter;

  KotiveWebapp.StaticOfflineRole = DS.Model.extend({
    label: DS.attr('string'),
    groupId: DS.attr('number'),
    roleId: DS.attr('number'),
    identifier: (function() {
      return this.get('id').toString();
    }).property('id'),
    setIsEditable: (function() {
      return this.set('isEditable', this.get('currentGroupServerId') === this.get('groupId').toString());
    }).observes('currentGroupServerId'),
    setGroupServerId: (function() {
      return this.set('currentGroupServerId', this.get('currentGroup.id'));
    }).observes('currentGroup')
  });

  KotiveWebapp.StaticOfflineRole.FIXTURES = [
    {
      id: 1,
      label: 'Account Owner',
      groupId: 1,
      roleId: 1
    }, {
      id: 2,
      label: 'User Administrator',
      groupId: 1,
      roleId: 2
    }, {
      id: 3,
      label: 'Maker',
      groupId: 1,
      roleId: 3
    }
  ];

}).call(this);

//# sourceMappingURL=static_offline_role.js.map


(function() {
  KotiveWebapp.Task = Ember.Object.extend(KotiveWebapp.BasicAuthMixin, {
    abbreviatedLength: 15,
    init: function() {
      return async.mapSeries(this.get('fieldsData'), (function(_this) {
        return function(field, callback) {
          var fieldObj;
          fieldObj = KotiveWebapp.TaskField.create(field);
          fieldObj.set('parent', _this);
          return callback(null, fieldObj);
        };
      })(this), (function(_this) {
        return function(err, fields) {
          if (err != null) {
            console.error(err);
          }
          return _this.set('fields', fields);
        };
      })(this));
    },
    abbreviatedLabel: (function() {
      var label;
      label = this.get('label');
      if (label.length > this.abbreviatedLength) {
        return (label.substr(0, this.abbreviatedLength - 3)) + "...";
      } else {
        return label;
      }
    }).property('label'),
    firstTask: (function() {
      return this.get('positionId') === 'task0';
    }).property('id'),
    hrefId: (function() {
      return "#" + (this.get('positionId'));
    }).property('id'),
    isIncomplete: (function() {
      var ref;
      return (ref = this.get('status')) === 'incomplete' || ref === 'failed';
    }).property('status'),
    save: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.toJson(function(json) {
            return _this.postTask(json).then(resolve, reject);
          });
        };
      })(this));
    },
    toJson: function(callback) {
      var json;
      json = this.getProperties('id_process', 'id_t');
      json.id_owning_process = -1;
      if (this.get('id') != null) {
        json.id = this.get('id');
      }
      return async.filter(this.get('fields'), function(field, next) {
        var isDisplayField, ref;
        isDisplayField = (ref = field.get('style').kind) === 'heading' || ref === 'divider' || ref === 'paragraph' || ref === 'section';
        return next(!isDisplayField);
      }, function(filteredFields) {
        return async.map(filteredFields, function(field, next) {
          return next(null, field.toJson());
        }, function(err, fields) {
          json.fields = fields;
          return callback(json);
        });
      });
    },
    postTask: function(data) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return $.ajax({
            url: _this.generateTaskUrl(),
            method: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json;charset=UTF-8',
            headers: {
              Authorization: _this.generateBasicAuthToken()
            },
            success: function(data, textStatus, jqXHR) {
              return resolve(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              if (jqXHR.status === 402) {
                return reject(402);
              } else {
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                return reject(error);
              }
            }
          });
        };
      })(this));
    },
    generateTaskUrl: function() {
      var groupId, processPath, taskflowId;
      taskflowId = this.get('parent.taskflowId');
      groupId = this.get('parent.groupId');
      processPath = taskflowId === 'blank' ? '' : "/" + taskflowId + "/activity";
      return "/api/group/" + groupId + "/process" + processPath;
    }
  });

}).call(this);

//# sourceMappingURL=task.js.map


(function() {
  KotiveWebapp.TaskField = Ember.Object.extend(KotiveWebapp.TemplateFieldModelPatternMixin, {
    init: function() {
      this.set('style', JSON.parse(this.get('style')));
      if (/^\-1\_/.test(this.get('id')) && this.get('value') === '') {
        return this.set('value', this.decode(this.get('patternString')));
      }
    },
    isOptional: (function() {
      var opt, ref;
      opt = (ref = this.get('style').kind) === 'paragraph' || ref === 'divider' || ref === 'submit' || ref === 'section';
      return !this.get('required') && !opt;
    }).property('style.kind', 'required'),
    isInvalid: (function() {
      var opt, ref, taskStatus, value;
      value = this.get('value');
      taskStatus = this.get('taskStatus');
      opt = (ref = this.get('style').kind) === 'paragraph' || ref === 'divider' || ref === 'submit' || ref === 'section';
      return (this.get('required') && !value && !opt && (taskStatus === 'incomplete' || taskStatus === 'failed')) || (this.get('hasError'));
    }).property('style.kind', 'value', 'required'),
    hasError: (function() {
      return this.get('required') && this.get('value') === '' && this.get('parent.isIncomplete') && !this.get('optField');
    }).property('parent.isIncomplete', 'value', 'required'),
    optField: (function() {
      var ref;
      return (ref = this.get('style').kind) === 'paragraph' || ref === 'divider' || ref === 'submit' || ref === 'section';
    }).property('style'),
    toJson: function() {
      this.set('value', this.get('value').trim());
      return this.getProperties('id', 'value');
    }
  });

}).call(this);

//# sourceMappingURL=task_field.js.map


(function() {
  KotiveWebapp.Taskflow = Ember.Object.extend(KotiveWebapp.BasicAuthMixin, KotiveWebapp.KeychainProcessMixin, KotiveWebapp.IntercomMixin, {
    init: function() {
      if (this.get('taskflowId') === 'blank') {
        if (this.get('workflowIdentifier') == null) {
          throw new Error('Unable to create new taskflow without workflow identifier value');
        }
        return this.createNewTaskflow();
      } else if (this.get('do') === 'retry') {
        this.set('retriedTaskflow', false);
        return this.retryTaskflow();
      } else {
        return this.setupTaskflow();
      }
    },
    setDisplayableTasks: (function() {
      return async.filter(this.get('tasksList'), function(task, callback) {
        var ref;
        return callback(((ref = task.get('fields')) != null ? ref.length : void 0) !== 0);
      }, (function(_this) {
        return function(tasks) {
          return _this.set('tasks', tasks);
        };
      })(this));
    }).observes('tasksList.@each'),
    setWorkflow: (function() {
      var fetchWorkflow, store;
      store = this.get('store');
      fetchWorkflow = (function(_this) {
        return function(id) {
          return _this.get('store').find('workflow', id).then(function(workflow) {
            if (workflow.get('id_parent') === '0') {
              return _this.set('workflow', workflow);
            } else {
              return fetchWorkflow(workflow.get('id_parent'));
            }
          });
        };
      })(this);
      return fetchWorkflow(this.get('workflowId'));
    }).observes('workflowId'),
    store: (function() {
      return KotiveWebapp.__container__.lookup('store:main');
    }).property(),
    hasNoTasks: (function() {
      var ref;
      return ((ref = this.get('tasks')) != null ? ref.length : void 0) === 0;
    }).property('tasks.@each'),
    hasMultipleTasks: (function() {
      var ref;
      return ((ref = this.get('tasks')) != null ? ref.length : void 0) > 1;
    }).property('tasks.@each'),
    requiresUserInput: (function() {
      var ref;
      return ((ref = this.get('tasks')) != null ? ref.length : void 0) > 0;
    }).property('tasks.@each'),
    setupTaskflow: function() {
      return KotiveSyncEngine.forceSync((function(_this) {
        return function() {
          return _this.getServerId(_this.get('group.id'), 'groups').then(function(id) {
            _this.set('hubUrl', "/hub/group/" + id + "/taskflow/" + (_this.get('taskflowId')) + "/app/embed");
            return _this.set('hubHeight', $(window).height() - 54);
          })["catch"](function(err) {
            throw new Error(err);
          });
        };
      })(this));
    },
    createNewTaskflow: function() {
      var identifier;
      identifier = this.get('workflowIdentifier');
      return KotiveSyncEngine.forceSync((function(_this) {
        return function() {
          return _this.getServerId(identifier, 'templateActivities').then(function(id) {
            _this.set('workflowId', id);
            return _this.getServerId(_this.get('group.id'), 'groups');
          }).then(function(id) {
            _this.set('groupId', id);
            _this.set('hubUrl', "/hub/group/" + id + "/taskflow/new/" + (_this.get('workflowId')) + "/app/embed");
            return _this.set('hubHeight', $(window).height() - 54);
          })["catch"](function(err) {
            throw new Error(err);
          });
        };
      })(this));
    },
    setupTaskflow_discontinued: function() {
      return KotiveSyncEngine.forceSync((function(_this) {
        return function() {
          return _this.getServerId(_this.get('group.id'), 'groups').then(function(id) {
            _this.set('groupId', id);
            return Ember.$.ajax({
              url: "/api/group/" + id + "/process/" + (_this.get('taskflowId')) + "/next",
              type: 'GET',
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function(data, textStatus, jqXHR) {
                _this.updateTasksList(data);
                if (data instanceof Array && data.length !== 0) {
                  return _this.set('workflowId', data[0].id_t);
                }
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                throw error;
              }
            });
          })["catch"](function(err) {
            throw new Error(err);
          });
        };
      })(this));
    },
    createNewTaskflow_discontinued: function() {
      var identifier;
      identifier = this.get('workflowIdentifier');
      return KotiveSyncEngine.forceSync((function(_this) {
        return function() {
          return _this.getServerId(identifier, 'templateActivities').then(function(id) {
            _this.set('workflowId', id);
            return _this.getServerId(_this.get('group.id'), 'groups');
          }).then(function(id) {
            _this.set('groupId', id);
            return _this.fetchBlankProcess();
          }).then(function(activityData) {
            return _this.processCreateTaskData(activityData);
          })["catch"](function(err) {
            throw new Error(err);
          });
        };
      })(this));
    },
    fetchBlankProcess: function() {
      var groupId, workflowId;
      workflowId = this.get('workflowId');
      groupId = this.get('groupId');
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return $.ajax({
            url: "/api/group/" + groupId + "/process/" + workflowId + "/blank",
            type: 'GET',
            cache: false,
            headers: {
              Authorization: _this.generateBasicAuthToken()
            },
            success: function(data, textStatus, jqXHR) {
              return resolve(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              return reject(error);
            }
          });
        };
      })(this));
    },
    processCreateTaskData: function(data) {
      var tasks;
      tasks = [this.generateTaskObject(data.activity)];
      if (data.childActivities != null) {
        this.trackEventIntercom('Viewed a new live taskflow');
        data.childActivities.forEach((function(_this) {
          return function(activity, index) {
            return tasks.pushObject(_this.generateTaskObject(activity, index));
          };
        })(this));
      }
      return this.set('tasksList', tasks);
    },
    generateTaskObject: function(activity, index) {
      activity.fieldsData = activity.fields;
      activity.parent = this;
      activity.positionId = "task" + index;
      activity.userEmail = this.get('userEmail');
      activity.authToken = this.get('authToken');
      delete activity.fields;
      return KotiveWebapp.Task.create(activity);
    },
    save: function() {
      var savingBlankTaskflow;
      savingBlankTaskflow = this.get('taskflowId') === 'blank';
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return async.reduce(_this.get('tasksList'), null, function(lastResponse, task, next) {
            return task.save().then(function(response) {
              if (_this.get('taskflowId') === 'blank') {
                _this.set('taskflowId', response.id_process || response[0].id_process);
              }
              return next(null, response);
            }, function(err) {
              return next(err);
            });
          }, function(err, finalResponse) {
            if (err != null) {
              if (savingBlankTaskflow) {
                _this.set('taskflowId', 'blank');
              }
              return reject(err);
            } else {
              resolve({
                taskflowCreated: savingBlankTaskflow
              });
              if (savingBlankTaskflow) {
                return _this.trackEventIntercom('Started a new live taskflow');
              } else {
                _this.trackEventIntercom('Saved a task in a live taskflow');
                return _this.updateTasksList(finalResponse);
              }
            }
          });
        };
      })(this));
    },
    updateTasksList: function(taskData) {
      var tasks;
      if (taskData instanceof Array) {
        tasks = taskData.map((function(_this) {
          return function(task, index) {
            return _this.generateTaskObject(task, index);
          };
        })(this));
        if (tasks.length !== 0) {
          this.trackEventIntercom('Continued a live taskflow');
        }
        return this.set('tasksList', tasks);
      } else {
        return this.set('tasksList', []);
      }
    },
    retryTaskflow: function() {
      return KotiveSyncEngine.forceSync((function(_this) {
        return function() {
          return _this.getServerId(_this.get('group.id'), 'groups').then(function(id) {
            _this.set('groupId', id);
            return Ember.$.ajax({
              url: "/api/group/" + id + "/process/" + (_this.get('taskflowId')) + "/retry",
              type: 'GET',
              headers: {
                Authorization: _this.generateBasicAuthToken()
              },
              success: function(data, textStatus, jqXHR) {
                return _this.set('retriedTaskflow', true);
              },
              error: function(jqXHR, textStatus, errorThrown) {
                var error;
                error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
                throw error;
              }
            });
          })["catch"](function(err) {
            throw new Error(err);
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=taskflow.js.map


(function() {
  KotiveWebapp.TaskflowReportAdapter = KotiveWebapp.RESTAdapter.extend();

  KotiveWebapp.TaskflowReport = DS.Model.extend({
    label: DS.attr('string')
  });

}).call(this);

//# sourceMappingURL=taskflow_report.js.map


(function() {
  var templateConfigs;

  templateConfigs = null;

  KotiveWebapp.TaskflowTemplate = Ember.Object.extend({
    image: (function() {
      return "/images/taskflow_templates/" + (this.get('template')) + ".png";
    }).property('template'),
    getSample: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return Ember.$.ajax({
            url: "/taskflow_templates/" + (_this.get('template')) + ".json",
            dataType: 'json',
            success: function(data, textStatus, jqXHR) {
              return resolve(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              console.log(error);
              return reject(error);
            }
          });
        };
      })(this));
    }
  });

  KotiveWebapp.TaskflowTemplate.reopenClass({
    fetch: function() {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return Ember.$.ajax({
          url: '/scripts/taskflow_template_configs.json',
          success: function(data, textStatus, jqXHR) {
            return resolve(data.templates.filter(function(t) {
              return t.enabled;
            }).reverse().map(function(t) {
              return KotiveWebapp.TaskflowTemplate.create(t);
            }));
          },
          error: function(jqXHR, textStatus, errorThrown) {
            var error;
            error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
            console.log(error);
            return reject(error);
          }
        });
      });
    }
  });

}).call(this);

//# sourceMappingURL=taskflow_template.js.map


(function() {
  var ActivityCommon;

  KotiveWebapp.TemplateActivityAdapter = KotiveWebappAdapter;

  ActivityCommon = DS.Model.extend({
    actualId: DS.attr('string'),
    createdBy: DS.attr('string'),
    id_parent: DS.attr('string'),
    id_root: DS.attr('string'),
    kind: DS.attr('string', {
      defaultValue: 'form'
    }),
    label: DS.attr('string', {
      defaultValue: ''
    }),
    order: DS.attr('number'),
    publish: DS.attr('boolean', {
      defaultValue: false
    }),
    toFlowObject: function() {
      return this.getProperties('id', 'id_parent', 'id_root', 'order', 'label', 'kind');
    }
  });

  KotiveWebapp.TemplateActivity = ActivityCommon.extend({
    templateActivityAuthId: DS.attr('string', {
      defaultValue: null
    }),
    templateFields: DS.hasMany('template-field', {
      async: true
    }),
    templateConditions: DS.hasMany('condition', {
      async: true
    }),
    recalculateConditionOrder: function(type) {
      return this.get('templateConditions').then(function(conditions) {
        return conditions.filterBy('type', type).sortBy('order').forEach(function(condition, index) {
          if (condition.get('order') !== index) {
            condition.set('order', index);
            return condition.save();
          }
        });
      });
    },
    addDuplicatedField: function(newTemplateField) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('templateFields').then(function(templateFields) {
            templateFields.forEach(function(templateField) {
              if (templateField.get('order') >= newTemplateField.get('order')) {
                return templateField.orderIncrement();
              }
            });
            templateFields.pushObject(newTemplateField);
            return newTemplateField.get('templateActivities').then(function(templateActivities) {
              templateActivities.pushObject(_this);
              newTemplateField.set('label', (newTemplateField.get('label')) + " (copy)");
              return newTemplateField.save().then(function() {
                return _this.save().then(resolve, reject);
              }, reject);
            }, reject);
          }, reject);
        };
      })(this));
    },
    isNotService: (function() {
      var ref;
      return (ref = this.get('kind')) === 'form' || ref === 'subtree' || ref === 'email/send_email';
    }).property('kind'),
    isService: (function() {
      return !this.get('isNotService');
    }).property('kind')
  });

  KotiveWebapp.TemplateActivity.FIXTURES = [];

  KotiveWebapp.TemplateActivity.createWorkflow = function(group) {
    var store;
    store = KotiveWebapp.__container__.lookup('store:main');
    return new Ember.RSVP.Promise(function(resolve, reject) {
      return Ember.run(function() {
        var workflow;
        workflow = store.createRecord('workflow', KotiveWebapp.Workflow.defaults);
        workflow.set('id_root', workflow.get('id'));
        return workflow.get('groups').then(function(groups) {
          groups.addObject(group);
          return group.get('workflows').then(function(templateActivities) {
            templateActivities.addObject(workflow);
            return resolve(workflow);
          }, function(err) {
            return reject(err);
          });
        }, function(err) {
          return reject(err);
        });
      });
    });
  };

  KotiveWebapp.WorkflowAdapter = KotiveWebappAdapter;

  KotiveWebapp.Workflow = ActivityCommon.extend({
    "private": DS.attr('boolean', {
      defaultValue: true
    }),
    groups: DS.hasMany('group', {
      async: true
    }),
    templateActivities: DS.hasMany('template-activity', {
      async: true
    }),
    templateConditions: DS.hasMany('condition', {
      async: true
    }),
    templateActivitiesOrderBy: ['order', 'label'],
    orderedTemplateActivities: (function() {
      return this.get('templateActivities').sortBy('order', 'label');
    }).property('templateActivities.@each'),
    cleanupTemplateActivityDelete: function(done) {
      return this.get('groups').then((function(_this) {
        return function(groups) {
          groups.forEach(function(group) {
            return group.get('templateActivities').then(function(templateActivities) {
              templateActivities.removeObject(_this);
              return group.save();
            });
          });
          return done();
        };
      })(this));
    },
    destroyRecord: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this._super().then(function() {
            return _this.cleanupTemplateActivityDelete(resolve);
          }, function(err) {
            return reject(err);
          });
        };
      })(this));
    }
  });

  KotiveWebapp.Workflow.defaults = {
    id_parent: '0',
    id_root: '-1',
    kind: 'form',
    label: '',
    order: 0
  };

  KotiveWebapp.Workflow.FIXTURES = [];

}).call(this);

//# sourceMappingURL=template_activity.js.map


(function() {
  KotiveWebapp.TemplateActivityAuthAdapter = KotiveWebappAdapter;

  KotiveWebapp.TemplateActivityAuth = DS.Model.extend({
    label: DS.attr('string'),
    service: DS.attr('string'),
    groupId: DS.attr('string')
  });

}).call(this);

//# sourceMappingURL=template_activity_auth.js.map


(function() {
  KotiveWebapp.TemplateActivitySubTypeAdapter = KotiveWebappAdapter;

  KotiveWebapp.TemplateActivitySubType = DS.Model.extend({
    name: DS.attr('string'),
    label: DS.attr('string'),
    description: DS.attr('string'),
    documentation: DS.attr('string'),
    hashSum: DS.attr('string'),
    serviceParent: DS.attr('string'),
    fields: DS.attr('hashobject'),
    response: DS.attr('hashobject')
  });

  KotiveWebapp.TemplateActivitySubType.FIXTURES = [];

}).call(this);

//# sourceMappingURL=template_activity_sub_type.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.TemplateActivityTypeAdapter = KotiveWebappAdapter;

  KotiveWebapp.TemplateActivityType = DS.Model.extend({
    name: DS.attr('string'),
    label: DS.attr('string'),
    description: DS.attr('string'),
    authMethod: DS.attr('string'),
    domain: DS.attr('string'),
    hashSum: DS.attr('string'),
    order: DS.attr('number'),
    auth: DS.attr('hashobject'),
    templateActivitySubTypes: DS.hasMany('template-activity-sub-types', {
      async: true
    }),
    activityTypeIcon: (function() {
      if (this.get('name') === 'form') {
        return 'images/icons/form.png';
      } else if (this.get('name') === 'subtree') {
        return 'images/d2ecf22e.subtree-dark.png';
      } else {
        return "images/icons/" + (this.get('name')) + "/icon.png";
      }
    }).property('name'),
    disabled: (function() {
      var ref;
      return ref = this.get('name'), indexOf.call(KotiveWebappConfigs.disabledKotiveServices, ref) >= 0;
    }).property(),
    templateActivityTypesOrderBy: ['order', 'label']
  });

  KotiveWebapp.TemplateActivityType.FIXTURES = [];

}).call(this);

//# sourceMappingURL=template_activity_type.js.map


(function() {
  KotiveWebapp.TemplateFieldAdapter = KotiveWebappAdapter;

  KotiveWebapp.TemplateField = DS.Model.extend(KotiveWebapp.TemplateFieldModelPatternMixin, {
    actualId: DS.attr('string'),
    createdBy: DS.attr('string'),
    label: DS.attr('string', {
      defaultValue: ''
    }),
    pattern: DS.attr('string', {
      defaultValue: 'str[][]'
    }),
    style: DS.attr('kotive-style'),
    order: DS.attr('number'),
    readonly: DS.attr('boolean', {
      defaultValue: false
    }),
    required: DS.attr('boolean', {
      defaultValue: false
    }),
    visible: DS.attr('boolean', {
      defaultValue: true
    }),
    templateActivities: DS.hasMany('template-activity', {
      async: true
    }),
    isOptional: (function() {
      var opt, ref;
      opt = (ref = this.get('style').kind) === 'paragraph' || ref === 'divider' || ref === 'submit' || ref === 'section';
      return !this.get('required') && !opt;
    }).property('style.kind', 'required'),
    htmlSafeLabel: (function() {
      return new Handlebars.SafeString(this.get('label'));
    }).property('label'),
    fieldStyleChanged: (function() {
      if (this.get('style').hasChanges) {
        return this.send('becomeDirty');
      }
    }).observes('style.hasChanges'),
    save: function() {
      var patternOptions;
      patternOptions = this.get('patternOptions');
      if (!(patternOptions.type === 'str' || this.get('style.optionsType') === 'predefined')) {
        this.setPattern(patternOptions);
      }
      return this._super(arguments);
    },
    destroyRecord: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.cleanupTemplateActivityReferences(function() {
            _this._super();
            return resolve();
          });
        };
      })(this));
    },
    get: function(key) {
      if (key === 'style') {
        if (Ember.get(this, key) == null) {
          this.set(key, KotiveWebapp.KotiveStyleTransform.setupStyleObject({
            kind: 'text'
          }));
        }
      }
      return Ember.get(this, key);
    },
    cleanupTemplateActivityReferences: function(done) {
      return this.get('templateActivities').then((function(_this) {
        return function(templateActivities) {
          var templateActivitiesList;
          templateActivitiesList = [];
          templateActivities.forEach(function(templateActivity) {
            return templateActivitiesList.pushObject(templateActivity);
          });
          return _this.cleanupTemplateActivity(done, templateActivitiesList);
        };
      })(this));
    },
    cleanupTemplateActivity: function(callback, templateActivitiesList) {
      var templateActivity;
      if (templateActivitiesList.length === 0) {
        return callback();
      } else {
        templateActivity = templateActivitiesList.popObject();
        return templateActivity.get('templateFields').then((function(_this) {
          return function(templateFields) {
            templateFields.removeObject(_this);
            return templateActivity.save().then(function() {
              return _this.cleanupTemplateActivity(callback, templateActivitiesList);
            });
          };
        })(this));
      }
    },
    duplicate: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var templateField;
          templateField = _this.store.createRecord('template-field', {
            label: _this.get('label'),
            order: _this.get('order') + 1,
            pattern: _this.get('pattern'),
            readonly: _this.get('readonly'),
            required: _this.get('required'),
            visible: _this.get('visible'),
            style: _this.get('style')
          });
          return templateField.save().then(function() {
            return resolve(templateField);
          }, function(err) {
            return reject(err);
          });
        };
      })(this));
    },
    orderIncrement: function() {
      return this.set('order', this.get('order') + 1);
    }
  });

  KotiveWebapp.TemplateField.newTemplateField = function() {
    var store, templateField;
    store = KotiveWebapp.__container__.lookup('store:main');
    templateField = store.createRecord('template-field');
    return templateField;
  };

  KotiveWebapp.TemplateField.FIXTURES = [];

}).call(this);

//# sourceMappingURL=template_field.js.map


(function() {
  KotiveWebapp.Data = KotiveWebapp.Data || {};

  KotiveWebapp.Data.templateFieldTypes = [
    {
      description: 'Text',
      kind: 'text'
    }, {
      description: 'Select (Dropdown)',
      kind: 'select'
    }, {
      description: 'Radiobuttons',
      kind: 'radio'
    }, {
      description: 'Checkboxes',
      kind: 'check'
    }, {
      description: 'Textarea',
      kind: 'textarea'
    }, {
      description: 'Files - upload',
      kind: 'upload'
    }, {
      description: 'Files - retrieve',
      kind: 'uploadshow'
    }, {
      description: 'Date',
      kind: 'date'
    }, {
      description: 'Date & time',
      kind: 'datetime'
    }, {
      description: 'Heading',
      kind: 'heading'
    }, {
      description: 'Paragraph text',
      kind: 'paragraph'
    }, {
      description: 'Divider',
      kind: 'divider'
    }, {
      description: 'Form section',
      kind: 'section'
    }, {
      description: 'Email',
      kind: 'email'
    }, {
      description: 'Number',
      kind: 'number'
    }, {
      description: 'Password',
      kind: 'password'
    }, {
      description: 'Telephone',
      kind: 'tel'
    }, {
      description: 'Web address',
      kind: 'url'
    }, {
      description: 'Time',
      kind: 'time'
    }
  ];

  KotiveWebapp.TemplateFieldTypeAdapter = DS.FixtureAdapter;

  KotiveWebapp.TemplateFieldType = DS.Model.extend({
    description: DS.attr('string'),
    kind: DS.attr('string')
  });

  KotiveWebapp.TemplateFieldType.stringFields = ['text', 'textarea', 'date', 'email', 'number', 'password', 'tel', 'url', 'time'];

  KotiveWebapp.TemplateFieldType.FIXTURES = _.map(KotiveWebapp.Data.templateFieldTypes, function(item, index) {
    item.id = index;
    return item;
  });

}).call(this);

//# sourceMappingURL=template_field_type.js.map


(function() {
  KotiveWebapp.UserAdapter = DS.FixtureAdapter;

  KotiveWebapp.User = DS.Model.extend(Ember.Validations.Mixin);

  KotiveWebapp.User.reopen({
    firstname: DS.attr('string', {
      defaultValue: ''
    }),
    lastname: DS.attr('string', {
      defaultValue: ''
    }),
    company: DS.attr('string'),
    email: DS.attr('string'),
    username: DS.attr('string'),
    password: DS.attr('string'),
    passwordConfirmation: DS.attr('string'),
    token: DS.attr('string'),
    mobile: DS.attr('string'),
    fullName: (function() {
      return ((this.get('firstname')) + " " + (this.get('lastname'))).trim();
    }).property('firstname', 'lastname'),
    descriptor: (function() {
      var fullName;
      fullName = this.get('fullName');
      if (fullName === '') {
        return this.get('email');
      } else {
        return fullName;
      }
    }).property('firstname', 'lastname', 'email'),
    validations: {
      email: {
        presence: true,
        format: {
          "with": /^\S+@\S+\.\S+$/,
          message: "is not correct, please ensure you have entered a valid address",
          allowBlank: false
        }
      },
      company: {
        presence: true
      },
      password: {
        presence: true,
        length: {
          minimum: 4,
          allowBlank: false,
          messages: {
            blank: "is not correct, please ensure you have entered a strong password",
            empty: "is not correct, please ensure you have entered a strong password",
            tooShort: "is not correct, please ensure you have entered a strong password"
          }
        },
        confirmation: true
      }
    },
    toRegistration: function() {
      return {
        email: this.get('email'),
        firstname: this.get('firstname'),
        lastname: this.get('lastname'),
        password: this.get('password'),
        passwordConfirm: this.get('password'),
        group: {
          label: this.get('company'),
          status: "active",
          level: "company"
        }
      };
    }
  });

  KotiveWebapp.User.FIXTURES = [];

}).call(this);

//# sourceMappingURL=user.js.map


(function() {
  KotiveWebapp.ApplicationRoute = Ember.Route.extend(KotiveWebapp.ModalHelperMixin, KotiveWebapp.AmplitudeMixin, KotiveWebapp.ReferralsMixin, {
    actions: {
      error: function(error, transition) {
        var controller, path;
        if (/^assertion failed\:.*the adapter\'s response did not have any data$/i.test(error.message)) {
          controller = this.controllerFor('application');
          if (controller.get('userLoggedIn')) {
            return this.transitionTo('no-access');
          } else {
            path = transition.intent.url;
            return this.transitionTo('login', {
              queryParams: {
                next: path
              }
            });
          }
        } else {
          console.error(error);
          return this.transitionTo('something-went-wrong');
        }
      },
      openModal: function(modalName, model) {
        this.renderModal(modalName, model);
        return Ember.run.next((function(_this) {
          return function() {
            return _this.get('controller').trigger('showModal');
          };
        })(this));
      },
      closeModal: function() {
        this.disconnectModal();
        return this.get('controller').trigger('hideModal');
      },
      openDropTooltip: function(target, dropViewName, model, options) {
        var controller;
        if (options == null) {
          options = {};
        }
        controller = this.controllerFor(dropViewName);
        controller.set('model', model);
        this.render(dropViewName, {
          into: 'application',
          outlet: 'drop',
          controller: controller
        });
        this.get('controller').trigger('showDropAt', target, options);
        return Ember.run.next(function() {
          return controller.send('dropOpened');
        });
      },
      closeDropTooltip: function() {
        return this.get('controller').trigger('closeDrop');
      },
      dropOpened: function() {
        return false;
      },
      disconnectingModal: function() {
        return false;
      },
      openingModal: function() {
        return false;
      },
      repositionDropTooltip: function() {
        return this.get('controller').trigger('repositionDropTooltip');
      },
      openSignupModal: function() {
        this.trackEventAmplitude('Viewed signup page');
        return this.promptForSignup(50);
      },
      workflowAddedIndicate: function(model) {
        var controller;
        controller = this.controllerFor('designer.workflows');
        return controller.trigger('workflowAddedIndicate', model);
      },
      signupEmailInvalid: function() {
        return this.set('emailInvalid', true);
      },
      workflowsModified: function() {
        return KotiveSyncEngine.forceSync((function(_this) {
          return function() {
            return _this.controllerFor('application').setTaskflowReports();
          };
        })(this));
      },
      openReferralModal: function() {
        return this.showReferrals();
      },
      markActivityEdited: function() {
        console.error('WARNING - markActivityEdited event called outside of the templateActivity route - message will be ignored');
        return false;
      }
    },
    showSignupAlert: (function() {
      return this.get('emailInvalid');
    }).property('controllers.application.currentPath', 'emailInvalid')
  });

}).call(this);

//# sourceMappingURL=application_route.js.map


(function() {
  KotiveWebapp.DesignerWorkflowsRoute = Ember.Route.extend({
    activate: function() {
      return this.controllerFor('designer.workflows').fetchWorkflowsForGroup();
    }
  });

}).call(this);

//# sourceMappingURL=designer_workflows_route.js.map


(function() {
  KotiveWebapp.DesignersRoute = Ember.Route.extend(KotiveWebapp.SetActiveGroupMixin, {
    activate: function() {
      var controller, groupId;
      controller = this.controllerFor('application');
      if (controller.get('userLoggedIn')) {
        groupId = controller.get('companyGroup');
        if (groupId != null) {
          return this.processDesignerLogic(groupId);
        } else {
          return this.setActiveGroup().then((function(_this) {
            return function() {
              controller.setCompanyGroup($.localStorage.get('company-group'));
              return _this.processDesignerLogic(controller.get('companyGroup'));
            };
          })(this), function(err) {
            console.error(err);
            return this.transitionTo('something-went-wrong');
          });
        }
      } else {

      }
    },
    processDesignerLogic: function(groupId) {
      return this.get('store').find('group', groupId).then((function(_this) {
        return function(group) {
          if (group.get('level') === 'company') {
            return _this.transitionTo('people', group);
          } else {
            return _this.transitionTo('designer.workflows', group);
          }
        };
      })(this));
    },
    executeDemoPathLogic: function() {
      return this.get('store').find('group').then((function(_this) {
        return function(groups) {
          if (groups.content.length === 0) {
            return _this.createDefault().then(function(group) {
              return _this.transitionTo('designer.workflows', group);
            });
          } else {
            return _this.doWorkflowRedirectLogic(groups);
          }
        };
      })(this));
    },
    doWorkflowRedirect: function(groups) {
      var group, pos, results;
      pos = 0;
      if ((groups != null ? groups.content : void 0) != null) {
        results = [];
        while (pos < groups.content.length) {
          group = groups.objectAtContent(pos);
          if (group.get('level') === 'application') {
            this.transitionTo('designer.workflows', group);
            break;
          } else {
            pos += 1;
            if (pos === groups.content.length) {
              results.push(this.createDefault().then((function(_this) {
                return function(group) {
                  return _this.transitionTo('designer.workflows', group);
                };
              })(this)));
            } else {
              results.push(void 0);
            }
          }
        }
        return results;
      } else {
        return this.createDefault().then((function(_this) {
          return function(group) {
            return _this.transitionTo('designer.workflows', group);
          };
        })(this));
      }
    },
    createDefault: function() {
      var group;
      group = this.store.createRecord('group');
      return this.initGroupRecord(group);
    },
    initGroupRecord: function(group) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var companyGroup;
          companyGroup = _this.controllerFor('application').get('companyGroup');
          group.set('label', 'My App');
          group.set('level', 'application');
          if (companyGroup != null) {
            group.set('id_parent', companyGroup);
          }
          return group.save().then(function() {
            KotiveSyncEngine.sync();
            return resolve(group);
          });
        };
      })(this));
    },
    doWorkflowRedirectLogic: function(groups) {
      var groupId;
      groupId = this.controllerFor('application').get('applicationGroup');
      if (groupId != null) {
        return this.get('store').find('group', groupId).then((function(_this) {
          return function(group) {
            return _this.transitionTo('designer.workflows', group);
          };
        })(this), (function(_this) {
          return function(err) {
            console.log(err);
            return _this.doWorkflowRedirect(groups);
          };
        })(this));
      } else {
        return this.doWorkflowRedirect(groups);
      }
    }
  });

}).call(this);

//# sourceMappingURL=designers_route.js.map


(function() {
  KotiveWebapp.ForgotRoute = Ember.Route.extend({
    model: function(params) {
      return this.get('store').createRecord('user');
    }
  });

}).call(this);

//# sourceMappingURL=forgot_route.js.map


(function() {
  KotiveWebapp.GenerateTaskflowRoute = Ember.Route.extend(KotiveWebapp.SetActiveGroupMixin, {
    beforeModel: function(transition) {
      var controller, groupId, taskflow_template;
      taskflow_template = transition.params['generate-taskflow'].taskflow_template;
      controller = this.controllerFor('application');
      if (controller.get('userLoggedIn')) {
        groupId = controller.get('companyGroup');
        return this.processGenerateTaskflowLogic(groupId, taskflow_template);
      } else {
        $.localStorage.set('generate-taskflow-template', taskflow_template);
        return this.transitionTo('login', {
          queryParams: {
            next: '/generate-taskflow/' + taskflow_template,
            signup: true
          }
        });
      }
    },
    processGenerateTaskflowLogic: function(groupId, template) {
      if (groupId != null) {
        return this.get('store').find('group', groupId).then((function(_this) {
          return function(group) {
            if (group.get('level') !== 'application') {
              $.localStorage.remove('company-group');
              return _this.setActiveGroup().then(function() {
                return _this.transitionTo('designer.workflows', group, {
                  queryParams: {
                    taskflowTemplate: template
                  }
                });
              }, function(err) {
                console.error(err);
                return this.transitionTo('something-went-wrong');
              });
            } else {
              return _this.transitionTo('designer.workflows', group, {
                queryParams: {
                  taskflowTemplate: template
                }
              });
            }
          };
        })(this));
      } else {
        return this.setActiveGroup().then((function(_this) {
          return function() {
            return _this.transitionTo('designer.workflows', group, {
              queryParams: {
                taskflowTemplate: template
              }
            });
          };
        })(this), function(err) {
          console.error(err);
          return this.transitionTo('something-went-wrong');
        });
      }
    }
  });

}).call(this);

//# sourceMappingURL=generate_taskflow_route.js.map


(function() {
  KotiveWebapp.GroupCreateRoute = Ember.Route.extend({
    model: function(params) {
      var group, groupId;
      group = this.modelFor('group');
      groupId = group === 'root' ? '1' : group.get('id');
      return this.get('store').createRecord('group', {
        level: params.level,
        id_parent: groupId
      });
    },
    activate: function() {
      return this.controllerFor('group.create').setProperties({
        doValidations: false,
        missingLabel: false
      });
    }
  });

}).call(this);

//# sourceMappingURL=group_create_route.js.map


(function() {
  KotiveWebapp.GroupRoute = Ember.Route.extend({
    model: function(params) {
      if (params.group_id === 'root') {
        return 'root';
      } else {
        return this.get('store').find('group', params.group_id);
      }
    }
  });

}).call(this);

//# sourceMappingURL=group_route.js.map


(function() {
  KotiveWebapp.IndexRoute = Ember.Route.extend({
    actions: {
      didTransition: function() {
        var appController, next;
        next = 'designers';
        appController = this.controllerFor('application');
        if (appController.get('userLoggedIn')) {
          if (appController.get('isMakerForGroup')) {
            next = 'designers';
          } else if (appController.get('isUserAdministratorForGroup')) {
            next = 'people';
          }
        } else {
          next = 'designers';
        }
        return this.transitionTo(next);
      }
    }
  });

}).call(this);

//# sourceMappingURL=index.js.map


(function() {
  KotiveWebapp.InviteSynchroniseRoute = Ember.Route.extend(KotiveWebapp.BasicAuthMixin, {
    beforeModel: function(transition) {
      var appController, groupId;
      appController = this.controllerFor('application');
      groupId = transition.params['invite-synchronise'].invite_synchronise_identifier;
      if (appController.get('userLoggedIn')) {
        this.set('userEmail', appController.get('userEmail'));
        this.set('authToken', appController.get('authToken'));
        return this.addGroupInfo(groupId, appController).then((function(_this) {
          return function(groupIds) {
            KotiveBatchRecordsSync.onSyncComplete(groupId, function() {
              appController.set('companyGroup', groupId);
              _this.showGroupSyncedMessage();
              return _this.transitionTo('index');
            });
            KotiveBatchRecordsSync.setBasicAuthToken(_this.generateBasicAuthToken());
            return KotiveBatchRecordsSync.batchSyncGroups(groupIds);
          };
        })(this), (function(_this) {
          return function(err) {
            console.log(err);
            return _this.transitionTo('index');
          };
        })(this));
      } else {
        this.showLogInMessage();
        $.localStorage.set('group-to-view', groupId);
        return this.transitionTo('login');
      }
    },
    showLogInMessage: function() {
      return Messenger().post({
        id: 'invite-login-message',
        singleton: false,
        hideAfter: 30,
        showCloseButton: true,
        message: 'Please log in to view your new account',
        type: 'info'
      });
    },
    addGroupInfo: function(groupId, appController) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return Ember.$.ajax({
            url: '/api/user',
            type: 'GET',
            headers: {
              Authorization: _this.generateBasicAuthToken()
            },
            success: function(data, textStatus, jqXHR) {
              var groupIds, newGroupIds;
              groupIds = data.groupsIndex.map(function(gi) {
                return {
                  id: gi.id.toString(),
                  parentId: gi.parentId.toString()
                };
              });
              newGroupIds = _this.filterNewGroupTree(groupId, groupIds);
              return async.each(newGroupIds, function(groupId, next) {
                return _this.ensureGroupCreated(groupId).then(function() {
                  return next();
                }, next);
              }, function(err) {
                if (err != null) {
                  return reject(err);
                } else {
                  appController.setSystemRoles(data.systemRoles);
                  appController.setUserRoles(data.userRoles);
                  return resolve(newGroupIds);
                }
              });
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              return reject(error);
            }
          });
        };
      })(this));
    },
    filterNewGroupTree: function(groupId, groupIds, filteredIds) {
      var children;
      if (filteredIds == null) {
        filteredIds = [];
      }
      filteredIds.pushObject(groupId);
      children = groupIds.filter(function(gids) {
        return gids.parentId === groupId;
      });
      children.forEach((function(_this) {
        return function(child) {
          return _this.filterNewGroupTree(child.id, groupIds, filteredIds);
        };
      })(this));
      return filteredIds;
    },
    ensureGroupCreated: function(groupId) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return Ember.$.ajax({
            url: "/api/group/" + groupId,
            type: 'GET',
            headers: {
              Authorization: _this.generateBasicAuthToken()
            },
            success: function(data, textStatus, jqXHR) {
              return KotiveDB.requestTransaction('groups', 'readwrite', function(error, transaction) {
                var groupData, objectstore, request;
                if (error != null) {
                  return reject(error);
                }
                groupData = data.group;
                groupData.id = groupData.id.toString();
                groupData.createdBy = _this.get('userEmail');
                objectstore = transaction.objectStore('groups');
                transaction.oncomplete = function(event) {
                  return resolve();
                };
                transaction.onerror = function(event) {
                  return reject(event.error);
                };
                return request = objectstore.put(groupData);
              });
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              return reject(error);
            }
          });
        };
      })(this));
    },
    showGroupSyncedMessage: function() {
      return Messenger().post({
        id: 'invite-synced-message',
        singleton: false,
        hideAfter: 30,
        showCloseButton: true,
        message: 'Your list of Accounts have been successfully updated.',
        type: 'info'
      });
    }
  });

}).call(this);

//# sourceMappingURL=invite_synchronise_route.js.map


(function() {
  KotiveWebapp.LoginRoute = Ember.Route.extend(KotiveWebapp.ModalHelperMixin, {
    beforeModel: function(transition) {
      var controller;
      controller = this.controllerFor('application');
      if (controller.get('userLoggedIn')) {
        return this.transitionTo(this.controllerFor('login').get('next'));
      } else if (transition.queryParams['signup']) {
        return this.controllerFor('login').set('showSignup', true);
      }
    },
    model: function(params) {
      return this.get('store').createRecord('user');
    },
    activate: function() {
      var controller;
      controller = this.controllerFor('login');
      controller.set('ajaxError', null);
      controller.set("errorMessage", null);
      controller.set("validationMessage", null);
      controller.set('dataValid', true);
      controller.set('invalidCredentials', false);
      controller.set('processingLogin', false);
      controller.set('errors', []);
      if (controller.get('showSignup')) {
        return this.send('openSignupModal');
      }
    }
  });

}).call(this);

//# sourceMappingURL=login_route.js.map


(function() {
  KotiveWebapp.LogoutRoute = Ember.Route.extend(KotiveWebapp.RaygunMixin, {
    activate: function() {
      var appController;
      appController = this.controllerFor('application');
      if ((appController.get('userEmail') != null) && (appController.get('authToken') != null)) {
        return KotiveSyncEngine.forceSync((function(_this) {
          return function(err) {
            var basicToken, email, token;
            if (err != null) {
              console.error(err);
            }
            email = appController.get('userEmail');
            token = appController.get('authToken');
            basicToken = _this.create_basic_token(email, token);
            return Ember.$.ajax({
              url: '/api/logout',
              type: 'GET',
              headers: {
                Authorization: basicToken
              },
              success: function(data, textStatus, jqXHR) {
                return _this.userLoggedOut();
              },
              error: function(jqXHR, textStatus, errorThrown) {
                console.error(errorThrown);
                return _this.userLoggedOut();
              }
            });
          };
        })(this));
      } else {
        return this.transitionTo('index');
      }
    },
    userLoggedOut: function() {
      return KotiveSyncEngine.userDidLogOut((function(_this) {
        return function() {
          Intercom('shutdown');
          _this.controllerFor('application').clearLocalStorage();
          return location.href = '/';
        };
      })(this));
    },
    create_basic_token: function(userEmail, userPassword) {
      var hash, token;
      token = userEmail + ':' + userPassword;
      hash = btoa(token);
      return "Basic " + hash;
    }
  });

}).call(this);

//# sourceMappingURL=logout_route.js.map


(function() {
  KotiveWebapp.PeopleCreateRoute = Ember.Route.extend({
    beforeModel: function() {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return KotiveSyncEngine.forceSync(function(err) {
          if (err != null) {
            return reject(err);
          } else {
            return resolve();
          }
        });
      });
    },
    model: function() {
      var group;
      group = this.modelFor('group');
      return this.get('store').createRecord('person', {
        group: group
      });
    }
  });

}).call(this);

//# sourceMappingURL=people_create_route.js.map


(function() {
  KotiveWebapp.PeopleIndexRoute = Ember.Route.extend({
    setupController: function(controller, model) {
      this._super(controller, model);
      controller.set('stillLoading', true);
      return controller.setupSubGroups();
    }
  });

}).call(this);

//# sourceMappingURL=people_index_route.js.map


(function() {
  KotiveWebapp.PeopleManagementRoute = Ember.Route.extend(KotiveWebapp.IntercomMixin, {
    afterModel: function(model, transition) {
      var appController, appGroup, companyGroup;
      appController = this.controllerFor('application');
      if (appController.get('userLoggedIn')) {
        this.trackEventIntercom('Viewed people');
        companyGroup = appController.get('companyGroup');
        if (companyGroup != null) {
          return this.transitionTo('people', companyGroup);
        } else {
          appGroup = appController.get('applicationGroup');
          if (appGroup != null) {
            return this.transitionTo('people', appGroup);
          }
        }
      }
    }
  });

}).call(this);

//# sourceMappingURL=people_management_route.js.map


(function() {
  KotiveWebapp.PeopleRoute = Ember.Route.extend(KotiveWebapp.BasicAuthMixin, KotiveWebapp.KeychainProcessMixin, {
    beforeModel: function(transition) {
      if (!KotiveWebappConfigs.webappOnline) {
        return this.transitionTo('offline');
      }
    },
    model: function(params) {
      var application, group;
      group = this.modelFor('group');
      application = this.controllerFor('application');
      this.set('userEmail', application.get('userEmail'));
      this.set('authToken', application.get('authToken'));
      if (group === 'root') {
        return [];
      } else {
        return new Ember.RSVP.Promise((function(_this) {
          return function(resolve, reject) {
            return _this.getServerId(group.get('id'), 'groups').then(function(id) {
              return _this.get('store').find('person', {
                groupId: id
              });
            }).then(function(people) {
              return resolve(people);
            })["catch"](reject);
          };
        })(this));
      }
    }
  });

}).call(this);

//# sourceMappingURL=people_route.js.map


(function() {
  KotiveWebapp.PersonEditRoute = Ember.Route.extend({
    beforeModel: function() {
      return new Ember.RSVP.Promise(function(resolve, reject) {
        return KotiveSyncEngine.forceSync(function(err) {
          if (err != null) {
            return reject(err);
          } else {
            return resolve();
          }
        });
      });
    }
  });

}).call(this);

//# sourceMappingURL=person_edit_route.js.map


(function() {
  KotiveWebapp.ReferralsRoute = Ember.Route.extend(KotiveWebapp.ReferralsMixin, {
    activate: function() {
      return this.showReferrals();
    }
  });

}).call(this);

//# sourceMappingURL=referrals_route.js.map


(function() {
  KotiveWebapp.RegistrationRoute = Ember.Route.extend(KotiveWebapp.AmplitudeMixin, {
    beforeModel: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var controller;
          controller = _this.controllerFor('application');
          if (controller.get('userLoggedIn')) {
            return KotiveSyncEngine.forceSync(function() {
              controller.clearLocalStorage();
              indexedDB.deleteDatabase('KotiveDB');
              return location.reload();
            });
          } else {
            return resolve();
          }
        };
      })(this));
    },
    model: function(params) {
      return this.get('store').createRecord('user', {
        token: params.token
      });
    },
    setupController: function(controller, model) {
      this.trackEventAmplitude('Validated signup token');
      controller.set('model', model);
      return controller.send('validateToken');
    }
  });

}).call(this);

//# sourceMappingURL=registration_route.js.map


(function() {
  KotiveWebapp.ReportHistoryRoute = Ember.Route.extend({
    model: function(params) {
      var appController;
      appController = this.controllerFor('application');
      return KotiveWebapp.ReportHistory.create({
        store: this.get('store'),
        group: this.modelFor('group'),
        workflowId: this.modelFor('report').get('workflowId'),
        userEmail: appController.get('userEmail'),
        authToken: appController.get('authToken'),
        processId: params.report_history_id
      });
    }
  });

}).call(this);

//# sourceMappingURL=report_history_route.js.map


(function() {
  KotiveWebapp.ReportRoute = Ember.Route.extend(KotiveWebapp.IntercomMixin, {
    model: function(params) {
      var appController, group;
      group = this.modelFor('group');
      appController = this.controllerFor('application');
      return KotiveWebapp.Report.create({
        group: group,
        workflowId: params.report_id,
        store: this.get('store'),
        userEmail: appController.get('userEmail'),
        authToken: appController.get('authToken')
      });
    },
    afterModel: function(model, transition) {
      return this.trackEventIntercom('Viewed a live taskflow report');
    }
  });

}).call(this);

//# sourceMappingURL=report_route.js.map


(function() {
  KotiveWebapp.ResetRoute = Ember.Route.extend({
    model: function(params) {
      var model;
      model = this.get('store').createRecord('user');
      model.set('reset-token', params.token);
      return model;
    },
    setupController: function(controller, model) {
      this._super(controller, model);
      return controller.send('validateToken');
    },
    activate: function() {
      return {
        isReset: (function() {
          return true;
        }).property(),
        hideNav: (function() {
          return true;
        }).property()
      };
    }
  });

}).call(this);

//# sourceMappingURL=reset_route.js.map


(function() {
  KotiveWebapp.SignupRoute = Ember.Route.extend({
    activate: function() {
      return {
        confirmSignup: (function() {
          return true;
        }).property()
      };
    }
  });

}).call(this);

//# sourceMappingURL=signup_route.js.map


(function() {
  KotiveWebapp.StartupRoute = Ember.Route.extend({
    setupController: function(controller, model) {
      return this._super(controller, model);
    }
  });

}).call(this);

//# sourceMappingURL=startup_route.js.map


(function() {
  KotiveWebapp.SwitchRoute = Ember.Route.extend(KotiveWebapp.ParentGroupsMixin, {
    model: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.findParentGroups().then(function(groups) {
            return resolve(groups.sortBy('label'));
          }, reject);
        };
      })(this));
    },
    setupController: function(controller, model) {
      this._super(controller, model);
      return controller.setGroups();
    }
  });

}).call(this);

//# sourceMappingURL=switch_route.js.map


(function() {
  KotiveWebapp.TaskflowRoute = Ember.Route.extend({
    model: function(params) {
      var appController, group;
      group = this.modelFor('group');
      appController = this.controllerFor('application');
      return KotiveWebapp.Taskflow.create({
        group: group,
        taskflowId: params.taskflow_id,
        workflowIdentifier: params.identifier,
        "do": params["do"],
        prev: params.prev,
        userEmail: appController.get('userEmail'),
        authToken: appController.get('authToken')
      });
    }
  });

}).call(this);

//# sourceMappingURL=taskflow_route.js.map


(function() {
  KotiveWebapp.TemplateActivityRoute = Ember.Route.extend(KotiveWebapp.SaveActivityIntentRouteMixin, {
    actions: {
      markActivityEdited: function() {
        return this.runIntentToSaveActivity();
      }
    },
    activate: function() {
      var controller;
      controller = this.controllerFor('template-activity');
      return controller.set('editingLabel', false);
    }
  });

}).call(this);

//# sourceMappingURL=template_activity_route.js.map


(function() {
  KotiveWebapp.UserSynchroniseRoute = Ember.Route.extend(KotiveWebapp.BasicAuthMixin, KotiveWebapp.SetActiveGroupMixin, KotiveWebapp.MetadataSetupMixin, {
    activate: function() {
      var controller;
      controller = this.controllerFor('application');
      this.set('userEmail', controller.get('userEmail'));
      this.set('authToken', controller.get('authToken'));
      return this.syncMetaData().then((function(_this) {
        return function() {
          return _this.doDatasync();
        };
      })(this), (function(_this) {
        return function(err) {
          console.error(err);
          return _this.doDatasync();
        };
      })(this));
    },
    doDatasync: function() {
      var appGroup, basicAuthtoken, controller;
      controller = this.controllerFor('application');
      appGroup = controller.get('companyGroup');
      basicAuthtoken = this.create_basic_token(this.get('userEmail'), this.get('authToken'));
      KotiveBatchRecordsSync.setBasicAuthToken(basicAuthtoken);
      KotiveBatchRecordsSync.setUserEmail(this.get('userEmail'));
      KotiveBatchRecordsSync.onSyncComplete(appGroup, (function(_this) {
        return function() {
          return _this.syncGroups(controller);
        };
      })(this));
      return KotiveBatchRecordsSync.batchSyncGroups(appGroup);
    },
    syncMetaData: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return Ember.$.ajax({
            url: '/api/user/metadata',
            type: 'GET',
            headers: {
              Authorization: _this.generateBasicAuthToken()
            },
            success: function(data, textStatus, jqXHR) {
              return _this.processUserMetaData(data).then(resolve, reject);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var error;
              error = "Cannot process request [" + jqXHR.status + "] (" + textStatus + "): " + errorThrown;
              console.error(error);
              return reject(error);
            }
          });
        };
      })(this));
    },
    syncGroups: function(controller) {
      return KotiveDB.requestTransaction('groups', 'readonly', (function(_this) {
        return function(error, transaction) {
          var cursorRequest, groupIds, objectstore;
          if (error != null) {
            return console.log(error);
          } else {
            groupIds = [];
            objectstore = transaction.objectStore('groups');
            transaction.oncomplete = function(event) {
              return Ember.run.next(function() {
                var next, pathType;
                next = _this.controllerFor('user.synchronise').get('next');
                pathType = _this.controllerFor('user.synchronise').get('pathType');
                if (pathType === 'absolute') {
                  return location.href = next;
                } else {
                  return _this.transitionTo(next);
                }
              });
            };
            cursorRequest = objectstore.openCursor();
            cursorRequest.onerror = function(error) {
              return console.log(error);
            };
            return cursorRequest.onsuccess = function(event) {
              var cursor;
              cursor = event.target.result;
              if (cursor != null) {
                groupIds.pushObject(cursor.value.id);
                return cursor["continue"]();
              }
            };
          }
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=user_synchronise_route.js.map


(function() {
  KotiveWebapp.WorkflowRoute = Ember.Route.extend({
    activate: function() {
      return Ember.run.later((function(_this) {
        return function() {
          var appController, controller;
          appController = _this.controllerFor('application');
          if (!appController.get('isMakerForGroup')) {
            return _this.transitionTo('no-access');
          } else {
            controller = _this.controllerFor('workflow');
            controller.set('editingLabel', false);
            return controller.set('updatingLabel', false);
          }
        };
      })(this), 1000);
    }
  });

}).call(this);

//# sourceMappingURL=workflow_route.js.map


(function() {
  KotiveWebapp.AtwhoContentComponent = Ember.Component.extend(KotiveWebapp.FieldMatcherRegexMixin, {
    tagName: 'span',
    classNames: ['atwho', 'text-cursor'],
    parsedValue: '',
    setParsedTimer: null,
    didInsertElement: function() {
      return this.setParsedValue();
    },
    click: function() {
      return this.sendAction();
    },
    valueChanged: (function() {
      var timer;
      if (this.get('setParsedTimer') != null) {
        Ember.run.cancel(this.get('setParsedTimer'));
      }
      timer = Ember.run.later((function(_this) {
        return function() {
          _this.setParsedValue();
          return _this.set('setParsedTimer', null);
        };
      })(this), 500);
      return this.set('setParsedTimer', timer);
    }).observes('value'),
    setParsedValue: function() {
      var matchers, parsedValue, parts;
      matchers = [];
      parsedValue = this.get('value');
      parts = [].concat.apply([], this.get('lookup_matcher_regexes').map((function(_this) {
        return function(regex) {
          return _this.get('value').match(regex) || [];
        };
      })(this)));
      parts.forEach(function(str, idx) {
        parsedValue = parsedValue.replace(str.trim(), "<##" + idx + "##>");
        return matchers.pushObject([str.trim(), idx]);
      });
      return async.each(matchers, (function(_this) {
        return function(data, next) {
          var fieldId, fieldLabel, html, idx, matcher, matcherElements, serviceTemplateId;
          matcher = data[0], idx = data[1];
          if (_this.get('field_matcher_regex').test(matcher)) {
            fieldId = matcher.match(/\b[0-9a-f]+\b/)[0];
            return _this.get('store').find('templateField', fieldId).then(function(templateField) {
              return templateField.get('templateActivities').then(function(templateActivity) {
                var activityLabel, fieldLabel, html;
                fieldLabel = templateField.get('label');
                activityLabel = templateActivity.objectAt(0).get('label');
                html = "<span class=\"label label-default\">" + fieldLabel + " <small>(" + activityLabel + ")</small></span>";
                parsedValue = parsedValue.replace("<##" + idx + "##>", html);
                return next();
              }, next);
            }, function(err) {
              var html;
              if (err != null) {
                console.log(err);
              }
              html = "<span class=\"label label-danger\">(Unknown field)</span>";
              parsedValue = parsedValue.replace("<##" + idx + "##>", html);
              return next();
            });
          } else if (_this.get('group_matcher_regex').test(matcher)) {
            matcherElements = matcher.split('.');
            fieldLabel = matcherElements[1].replace(/\}$/, '');
            html = "<span class=\"label label-default\">Current organization/team\'s " + fieldLabel + " </span>";
            parsedValue = parsedValue.replace("<##" + idx + "##>", html);
            return next();
          } else if (_this.get('contact_matcher_regex').test(matcher)) {
            matcherElements = matcher.split(':');
            matcherElements = matcherElements[0].split('.');
            fieldLabel = matcherElements[1].replace(/\}$/, '');
            html = "<span class=\"label label-default\">Contact\'s " + fieldLabel + " </span>";
            parsedValue = parsedValue.replace("<##" + idx + "##>", html);
            return next();
          } else if (_this.get('files_matcher_regex').test(matcher)) {
            fieldId = matcher.match(/\b[0-9a-f]+\b/)[0];
            return _this.get('store').find('templateField', fieldId).then(function(templateField) {
              return templateField.get('templateActivities').then(function(templateActivity) {
                var activityLabel;
                fieldLabel = templateField.get('label');
                activityLabel = templateActivity.objectAt(0).get('label');
                html = "<span class=\"label label-default\">Show list of files: " + fieldLabel + " <small>(" + activityLabel + ")</small></span>";
                parsedValue = parsedValue.replace("<##" + idx + "##>", html);
                return next();
              }, next);
            }, function(err) {
              if (err != null) {
                console.log(err);
              }
              html = "<span class=\"label label-danger\">(Unknown field)</span>";
              parsedValue = parsedValue.replace("<##" + idx + "##>", html);
              return next();
            });
          } else if (_this.get('currentuserid_matcher_regex').test(matcher)) {
            matcherElements = matcher.split('.');
            fieldLabel = matcherElements[1].replace(/\}$/, '');
            html = "<span class=\"label label-default\">Current user\'s " + fieldLabel + " </span>";
            parsedValue = parsedValue.replace("<##" + idx + "##>", html);
            return next();
          } else if (_this.get('taskflow_field_matcher_regex').test(matcher)) {
            matcherElements = matcher.split(':');
            fieldId = matcherElements[matcherElements.length - 1].replace(/\}$/, '');
            return _this.get('store').find('templateField', fieldId).then(function(templateField) {
              return templateField.get('templateActivities').then(function(templateActivity) {
                var activityLabel;
                fieldLabel = templateField.get('label');
                activityLabel = templateActivity.objectAt(0).get('label');
                html = "<span class=\"label label-info\">&#8886; " + fieldLabel + " <small>(" + activityLabel + ")</small></span>";
                parsedValue = parsedValue.replace("<##" + idx + "##>", html);
                return next();
              }, next);
            }, function(err) {
              if (err != null) {
                console.log(err);
              }
              html = "<span class=\"label label-danger\">(Unknown field)</span>";
              parsedValue = parsedValue.replace("<##" + idx + "##>", html);
              return next();
            });
          } else if (_this.get('service_response_matcher_regex').test(matcher)) {
            serviceTemplateId = matcher.match(/\b[0-9a-f]+\b/);
            return _this.get('store').find('templateActivity', serviceTemplateId).then(function(templateActivity) {
              var activityLabel, responseKey;
              responseKey = matcher.split(':')[2].replace(/\}$/, '');
              activityLabel = templateActivity.get('label');
              html = "<span class=\"label label-default\">" + responseKey + " <small>(\"" + activityLabel + "\" response)</small></span>";
              parsedValue = parsedValue.replace("<##" + idx + "##>", html);
              return next();
            }, next);
          } else if (_this.get('service_file_uri_matcher_regex').test(matcher)) {
            serviceTemplateId = matcher.match(/\b[0-9a-f]+\b/);
            return _this.get('store').find('templateActivity', serviceTemplateId).then(function(templateActivity) {
              var activityLabel;
              activityLabel = templateActivity.get('label');
              html = "<span class=\"label label-default\"><span class=\"glyphicon glyphicon-link\"></span>&nbsp;Link to newly rendered file <small>(\"" + activityLabel + "\" response)</small></span>";
              parsedValue = parsedValue.replace("<##" + idx + "##>", html);
              return next();
            }, next);
          } else if (_this.get('htmllist_matcher_regex').test(matcher)) {
            html = "<span class=\"label label-default\">Field values as html</span>";
            parsedValue = parsedValue.replace("<##" + idx + "##>", html);
            return next();
          } else if (_this.get('datetime_matcher_regex').test(matcher)) {
            html = "<span class=\"label label-default\">Now <small>Date & time</small></span>";
            parsedValue = parsedValue.replace("<##" + idx + "##>", html);
            return next();
          } else if (_this.get('continuelink_regex').test(matcher)) {
            html = "<span class=\"label label-default\">Link to continue the taskflow</span>";
            parsedValue = parsedValue.replace("<##" + idx + "##>", html);
            return next();
          } else {
            return _this.generateUserLabel(matcher).then(function(res) {
              var infoText, invalidLookup;
              fieldLabel = res[0], infoText = res[1], invalidLookup = res[2];
              html = ("<span class=\"label label-default" + (invalidLookup ? ' label-danger' : '') + "\">") + (fieldLabel + " <small>(" + infoText + ")</small></span>");
              parsedValue = parsedValue.replace("<##" + idx + "##>", html);
              return next();
            }, next);
          }
        };
      })(this), (function(_this) {
        return function(err) {
          if (err != null) {
            return console.error(err);
          } else {
            parsedValue = parsedValue.replace(/\&curlleft\;/gm, '{').replace(/\&curlright\;/gm, '}').replace(/\n/gm, '<br/>');
            parsedValue = parsedValue.replace(/\&sqrleft\;/mg, '[').replace(/\&sqrright\;/mg, ']');
            parsedValue = parsedValue.replace(/\&colon\;/mg, ':');
            parsedValue = parsedValue.replace(/\&kappie\;/mg, '^');
            if (!(_this.get('isDestroying') || _this.get('isDestroyed'))) {
              return _this.set('parsedValue', parsedValue);
            }
          }
        };
      })(this));
    },
    generateUserLabel: function(matcher) {
      var store;
      store = this.get('store');
      return new Ember.RSVP.Promise(function(resolve, reject) {
        var fieldId, fieldLabel;
        fieldLabel = matcher.indexOf('{user.firstname:') !== -1 ? 'Firstname' : matcher.indexOf('{user.lastname:') !== -1 ? 'Lastname' : matcher.indexOf('{user.email:') !== -1 ? 'Email' : matcher.indexOf('{user.mobile:') !== -1 ? 'Mobile' : '&lt;Unknown&gt;';
        if (matcher.indexOf(':{currentuser.id}}') !== -1) {
          return resolve([fieldLabel, 'logged-in person', false]);
        } else {
          fieldId = matcher.match(/\b[0-9a-f]+\b/)[0];
          return store.find('templateField', fieldId).then(function(field) {
            return field.get('templateActivities').then(function(tas) {
              var inValid, label, templateActivity;
              templateActivity = tas.objectAt(0);
              label = (field.get('label')) + " - " + (fieldLabel.toLowerCase());
              inValid = field.get('style.optionsType') === 'predefined' && (!/^sse\[\{UsersByGroup(AndRole)?AsSelectPattern\:.*\}\]\[.*\]$/m.test(field.get('pattern')));
              return resolve([label, templateActivity.get('label'), inValid]);
            }, reject);
          }, reject);
        }
      });
    }
  });

}).call(this);

//# sourceMappingURL=atwho_content_component.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.AtwhoFieldComponent = Ember.Component.extend(KotiveWebapp.FieldMatcherRegexMixin, {
    showEditor: false,
    blurTimeoutEvent: null,
    defaultLookups: [
      {
        id: '{currentuser.id}',
        name: 'Id',
        activityLabel: 'logged-in person'
      }, {
        id: '{user.firstname:{currentuser.id}}',
        name: 'Firstname',
        activityLabel: 'logged-in person'
      }, {
        id: '{user.lastname:{currentuser.id}}',
        name: 'Lastname',
        activityLabel: 'logged-in person'
      }, {
        id: '{user.email:{currentuser.id}}',
        name: 'Email',
        activityLabel: 'logged-in person'
      }, {
        id: '{user.mobile:{currentuser.id}}',
        name: 'Mobile',
        activityLabel: 'logged-in person'
      }, {
        id: '{contact.firstname:{group.id}:{field.value:0}}',
        name: 'Firstname',
        activityLabel: 'contact'
      }, {
        id: '{contact.lastname:{group.id}:{field.value:0}}',
        name: 'Lastname',
        activityLabel: 'contact'
      }, {
        id: '{contact.email:{group.id}:{field.value:0}}',
        name: 'Email',
        activityLabel: 'contact'
      }, {
        id: '{contact.mobile:{group.id}:{field.value:0}}',
        name: 'Mobile',
        activityLabel: 'contact'
      }, {
        id: '{contact.uniqueid:{group.id}:{field.value:0}}',
        name: 'UniqueId',
        activityLabel: 'contact'
      }, {
        id: '{continuelink}',
        name: 'Link to continue the taskflow',
        activityLabel: ''
      }, {
        id: '{datetime:now:yyyy-MM-dd}',
        name: 'Today\'s date',
        activityLabel: 'Date & time'
      }, {
        id: '{datetime:now:HH\'h\'mm}',
        name: 'Current time',
        activityLabel: 'Date & time'
      }, {
        id: '{taskflowfield.value:0:0}',
        name: 'Taskflow ref',
        activityLabel: 'Field ref'
      }, {
        id: '{group.id}',
        name: 'Id',
        activityLabel: 'Current organization/team'
      }, {
        id: '{group.label}',
        name: 'Name',
        activityLabel: 'Current organization/team'
      }, {
        id: '{files.html:0}',
        name: 'List of files',
        activityLabel: 'Field ref'
      }, {
        id: '{htmllist:string}',
        name: 'Field values as html',
        activityLabel: 'String'
      }
    ],
    actions: {
      editField: function() {
        this.set('textAreaHeight', this.$('span').height());
        return this.set('showEditor', true);
      }
    },
    didInsertElement: function() {
      this.set('fields', []);
      return this.setFields();
    },
    willDestroyElement: function() {
      return this.get('field').set('bypassEncoding', false);
    },
    displayRows: (function() {
      if (this.get('rows')) {
        return this.get('rows');
      } else {
        return "1";
      }
    }).property('rows'),
    editorToggled: (function() {
      if (this.get('showEditor')) {
        this.setParsedValue();
        this.get('field').set('bypassEncoding', true);
        return Ember.run.next((function(_this) {
          return function() {
            _this.$('textarea').atwho({
              at: '{',
              data: _this.get('fields'),
              displayTpl: '<li>${name} <small>${activityLabel}</small></li>',
              insertTpl: '${id}',
              limit: 200
            });
            _this.$('textarea').on('inserted.atwho', function() {
              var timeoutEvent;
              timeoutEvent = _this.get('blurTimeoutEvent');
              if (timeoutEvent != null) {
                Ember.run.cancel(timeoutEvent);
                _this.setupBlurTimeout();
              }
              _this.$('textarea').focus();
              return _this.set('blurTimeoutEvent', null);
            });
            _this.$('textarea').focus();
            _this.setTextareaHeightAdjustment();
            return _this.setupBlurTimeout();
          };
        })(this));
      }
    }).observes('showEditor'),
    parsedValueChanged: (function() {
      var matchers, parsedValue, parts;
      matchers = [];
      parsedValue = this.get('parsedValue');
      parts = [].concat.apply([], this.get('lookup_matcher_regexes').map(function(regex) {
        return parsedValue.match(regex) || [];
      }));
      parts.forEach(function(str, idx) {
        parsedValue = parsedValue.replace(str.trim(), "<##" + idx + "##>");
        return matchers.pushObject(str.trim());
      });
      parsedValue = parsedValue.replace(/\{\{/gm, '&curlleft;').replace(/\}\}/gm, '&curlright;').replace(/[\{\}]/gm, '');
      parsedValue = parsedValue.replace(/\[/mg, '&sqrleft;').replace(/\]/mg, '&sqrright;');
      parsedValue = parsedValue.replace(/\:/mg, '&colon;');
      parsedValue = parsedValue.replace(/\^/mg, '&kappie;');
      matchers.forEach(function(str, idx) {
        return parsedValue = parsedValue.replace("<##" + idx + "##>", str);
      });
      return this.set('value', parsedValue);
    }).observes('parsedValue'),
    setParsedValue: function() {
      var parsedValue, value;
      value = this.get('value');
      parsedValue = value.replace(/\&curlleft\;/mg, '{{').replace(/\&curlright\;/mg, '}}');
      parsedValue = parsedValue.replace(/\&sqrleft\;/mg, '[').replace(/\&sqrright\;/mg, ']');
      parsedValue = parsedValue.replace(/\&colon\;/mg, ':');
      parsedValue = parsedValue.replace(/\&kappie\;/mg, '^');
      return this.set('parsedValue', parsedValue);
    },
    setFields: function() {
      var excludeFieldTypes, fieldData;
      fieldData = [];
      excludeFieldTypes = ['divider', 'paragraph', 'heading', 'section', 'uploadshow'];
      return this.get('workflow').get('templateActivities').then((function(_this) {
        return function(tas) {
          var templateActivities;
          templateActivities = tas.sortBy('order').filter(function(ta) {
            return ta.get('id') !== _this.get('templateActivity.id');
          });
          return async.eachSeries(templateActivities, function(templateActivity, done) {
            return templateActivity.get('templateFields').then(function(tfs) {
              var templateFields;
              templateFields = tfs.sortBy('label').filter(function(tf) {
                var ref;
                return !(ref = tf.get('style.kind'), indexOf.call(excludeFieldTypes, ref) >= 0);
              });
              return async.eachSeries(templateFields, function(templateField, next) {
                fieldData.pushObject({
                  id: "{field.value:" + (templateField.get('id')) + "}",
                  name: templateField.get('label'),
                  activityLabel: templateActivity.get('label')
                });
                return next();
              }, function(err) {
                return done(err);
              });
            });
          }, function(err) {
            if (err != null) {
              return console.error(err);
            } else {
              if (_this.get('workflow') != null) {
                return _this.getServiceResponses().then(function(servicesData) {
                  if (!(_this.get('isDestroying') || _this.get('isDestroyed'))) {
                    return _this.set('fields', fieldData.concat(_this.get('defaultLookups').concat(servicesData)));
                  }
                }, function(err) {
                  return console.error(err);
                });
              }
            }
          });
        };
      })(this));
    },
    getServiceResponses: function() {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          return _this.get('workflow').get('templateActivities').then(function(tas) {
            return _this.get('store').find('templateActivitySubType').then(function(tasts) {
              var servicesData;
              servicesData = [].concat.apply([], tas.filter(function(ta) {
                var ref;
                return ta.get('id') !== _this.get('templateActivity.id') && !((ref = ta.get('kind')) === 'form' || ref === 'email' || ref === 'subtree');
              }).map(function(ta) {
                var lookups, tast;
                lookups = [
                  {
                    id: "{service.response:" + (ta.get('id')) + ":kotive_request_status}",
                    name: 'Response Status',
                    activityLabel: ta.get('label')
                  }
                ];
                tast = tasts.find(function(tast) {
                  return tast.get('name') === ta.get('kind');
                });
                if ((tast != null) && tast.get('response.type') === 'file') {
                  lookups.push({
                    id: "{service.file_uri:" + (ta.get('id')) + "}",
                    name: 'Link to newly rendered file',
                    activityLabel: ta.get('label')
                  });
                  [].forEach(function(d) {
                    return lookups.push({
                      id: "{service.response:" + (ta.get('id')) + ":" + d[0] + "}",
                      name: d[1],
                      activityLabel: ta.get('label')
                    });
                  });
                }
                return lookups;
              }));
              return resolve(servicesData);
            }, reject);
          }, reject);
        };
      })(this));
    },
    setupBlurTimeout: function() {
      return this.$('textarea').one('blur', (function(_this) {
        return function() {
          var timeoutEvent;
          timeoutEvent = Ember.run.later(function() {
            if (!(_this.get('isDestroying') || _this.get('isDestroyed'))) {
              _this.set('showEditor', false);
              _this.get('field').set('bypassEncoding', false);
              return _this.set('blurTimeoutEvent', null);
            }
          }, 300);
          return _this.set('blurTimeoutEvent', timeoutEvent);
        };
      })(this));
    },
    setTextareaHeightAdjustment: function() {
      return this.$('textarea').height(this.get('textAreaHeight'));
    }
  });

}).call(this);

//# sourceMappingURL=atwho_field_component.js.map


(function() {
  KotiveWebapp.ConditionAddActivationComponent = Ember.Component.extend({
    actions: {
      createActivationCondition: function() {
        return this.get('parentView').get('controller').send('createActivationCondition');
      }
    }
  });

}).call(this);

//# sourceMappingURL=condition_add_activation_component.js.map


(function() {
  KotiveWebapp.ConditionAddCompletionComponent = Ember.Component.extend({
    actions: {
      createCompletionCondition: function() {
        return this.get('parentView').get('controller').send('createCompletionCondition');
      }
    }
  });

}).call(this);

//# sourceMappingURL=condition_add_completion_component.js.map


(function() {
  KotiveWebapp.ConditionFilterlineAddComponent = Ember.Component.extend({
    actions: {
      addFilter: function(condition) {
        return this.get('parentView').get('controller').send('addFilter', condition);
      }
    }
  });

}).call(this);

//# sourceMappingURL=condition_filterline_add_component.js.map


(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  KotiveWebapp.ConditionFilterlineComponent = Ember.Component.extend({
    didInsertElement: function() {
      if (this.get('filterObj.isLoaded')) {
        return this.setupFilter();
      } else {
        return this.get('filterObj').didLoad = (function(_this) {
          return function() {
            return _this.setupFilter();
          };
        })(this);
      }
    },
    setupFilter: function() {
      if (this.get('filter') == null) {
        this.set('filter', this.get('filterObj'));
      }
      this.set('previousProperty', this.get('filter').get('property'));
      return this.set('elementInserted', Date.now());
    },
    getStore: function() {
      if (this.get('store') == null) {
        this.set('store', KotiveWebapp.__container__.lookup('store:main'));
      }
      return this.get('store');
    },
    fetchTemplateField: function(id) {
      return new Ember.RSVP.Promise((function(_this) {
        return function(resolve, reject) {
          var store;
          if ((id == null) || id.match(/^current\-user\_/) || id.match(/^templateActivity\-/)) {
            return resolve(null);
          } else {
            store = _this.getStore();
            return store.find('template-field', id).then(function(templateField) {
              return resolve(templateField);
            }, function(err) {
              return reject(err);
            });
          }
        };
      })(this));
    },
    filterChanged: (function() {
      var controller;
      if (this.get('parentView')) {
        controller = this.get('parentView').get('controller');
      }
      if (controller && this.get('filter').get('isDirty')) {
        return controller.send('markFilterEdited');
      }
    }).observes('filter.property', 'filter.comparison', 'filter.value'),
    changedToFieldSelect: (function() {
      var keys, value, valueOptions;
      valueOptions = this.get('valueOptions');
      if (this.get('fieldSelect') && (valueOptions != null) && valueOptions.length !== 0) {
        keys = valueOptions.map(function(option) {
          return option.key;
        });
        value = this.get('filter').get('value');
        if (indexOf.call(keys, value) < 0) {
          return this.get('filter').set('value', valueOptions[0].key);
        }
      }
    }).observes('fieldSelect', 'valueOptions'),
    changedToRoleSelect: (function() {
      var keys, roleOptions, value;
      roleOptions = this.get('roleOptions');
      if (this.get('roleSelect') && (roleOptions != null) && roleOptions.length !== 0) {
        keys = roleOptions.map(function(option) {
          return option.key;
        });
        value = this.get('filter').get('value');
        if (indexOf.call(keys, value) < 0) {
          return this.get('filter').set('value', '0');
        }
      }
    }).observes('roleSelect', 'roleOptions'),
    changedToTextField: (function() {
      var previous;
      previous = this.get('previousProperty');
      if ((this.get('textField') != null) && this.get('textField') && (previous != null) && previous !== this.get('filter.property')) {
        this.get('filter').set('value', '');
      }
      return this.set('previousProperty', this.get('filter.property'));
    }).observes('textField'),
    changedToDatePicker: (function() {
      var filter, value;
      filter = this.get('filter');
      value = filter.get('value');
      if (this.get('datePicker') && !/^\d\d\d\d\-\d\d\-\d\d$/.test(value)) {
        return filter.set('value', '');
      }
    }).observes('datePicker'),
    roleSelect: (function() {
      var property, ref;
      property = (ref = this.get('filter')) != null ? ref.get('property') : void 0;
      return (property != null) && property === 'current-user_role';
    }).property('filter.property', 'elementInserted'),
    isFieldSelect: (function() {
      var property;
      property = this.get('filter').get('property');
      if ((property != null) && (/^templateActivity\-/.test(property) || /^current\_user\_/.test(property))) {
        return this.set('fieldSelect', false);
      } else {
        return this.fetchTemplateField(property).then((function(_this) {
          return function(templateField) {
            var ref;
            return _this.set('fieldSelect', templateField != null ? (ref = templateField.get('style').kind) === 'radio' || ref === 'select' || ref === 'check' : false);
          };
        })(this));
      }
    }).observes('filter.property', 'elementInserted'),
    isTextField: (function() {
      var property;
      property = this.get('filter').get('property');
      if (property === 'current-user_email') {
        return this.set('textField', true);
      } else {
        return this.fetchTemplateField(property).then((function(_this) {
          return function(templateField) {
            var ref;
            return _this.set('textField', templateField != null ? (ref = templateField.get('style').kind) !== 'radio' && ref !== 'select' && ref !== 'check' && ref !== 'date' : false);
          };
        })(this));
      }
    }).observes('filter.property', 'elementInserted'),
    isDatePicker: (function() {
      var property;
      property = this.get('filter').get('property');
      if (property != null ? property.match(/^templateActivity\-/) : void 0) {
        return this.set('datePicker', true);
      } else {
        return this.fetchTemplateField(property).then((function(_this) {
          return function(templateField) {
            return _this.set('datePicker', templateField != null ? templateField.get('style').kind === 'date' : false);
          };
        })(this));
      }
    }).observes('filter.property', 'elementInserted'),
    propertyOptions: (function() {
      var extractValues, groupName, groupOptions, groupedOptions;
      groupedOptions = [];
      groupName = null;
      groupOptions = [];
      extractValues = function(field) {
        if (field.get != null) {
          return {
            key: field.get('id'),
            value: field.get('label'),
            grouping: field.get('grouping')
          };
        } else {
          return {
            key: field.id,
            value: field.label,
            grouping: field.grouping
          };
        }
      };
      if (this.get('templateFields') != null) {
        this.get('templateFields').forEach(function(field) {
          var values;
          values = extractValues(field);
          if (values.grouping !== groupName) {
            if (groupName != null) {
              groupedOptions.push({
                label: groupName,
                options: groupOptions
              });
            }
            groupName = values.grouping;
            groupOptions = [];
          }
          return groupOptions.push(values);
        });
      }
      if (groupName != null) {
        groupedOptions.push({
          label: groupName,
          options: groupOptions
        });
      }
      return groupedOptions;
    }).property('templateFields', 'templateFields.@each'),
    comparisonOptions: (function() {
      var comparisonTypes;
      comparisonTypes = this.get('comparisonTypes');
      if (comparisonTypes != null) {
        return comparisonTypes.map(function(comparison) {
          return {
            key: comparison.get('key'),
            value: comparison.get('key')
          };
        });
      } else {
        return [];
      }
    }).property('comparisonTypes.@each'),
    roleOptions: (function() {
      var userRoles;
      userRoles = this.get('userRoles');
      if (userRoles != null) {
        return userRoles.map(function(role) {
          return {
            key: role.get('id'),
            value: role.get('label')
          };
        });
      } else {
        return [];
      }
    }).property('userRoles.@each'),
    setValueOptions: (function() {
      var property;
      property = this.get('filter').get('property');
      if (this.get('fieldSelect')) {
        return this.fetchTemplateField(property).then((function(_this) {
          return function(templateField) {
            return _this.set('valueOptions', templateField != null ? templateField.get('patternOptions').selections : []);
          };
        })(this));
      }
    }).observes('fieldSelect'),
    actions: {
      removeFilter: function(filter) {
        return this.get('parentView').get('controller').send('removeFilter', filter);
      }
    }
  });

}).call(this);

//# sourceMappingURL=condition_filterline_component.js.map


(function() {
  KotiveWebapp.ConditionFilterlineOrComponent = Ember.Component.extend({
    didInsertElement: function() {
      return this.set('isFirstCondition', this.get('condition').get('order') === 0);
    },
    orderChanged: (function() {
      return this.set('isFirstCondition', this.get('condition').get('order') === 0);
    }).observes('condition.order')
  });

}).call(this);

//# sourceMappingURL=condition_filterline_or_component.js.map


(function() {
  KotiveWebapp.DrawHelptextComponent = Ember.Component.extend({
    hasHelpText: (function() {
      var ref;
      return ((ref = this.get('model.style')) != null ? ref.helptext : void 0) != null;
    }).property('model', 'model.style', 'model.style.helptext')
  });

}).call(this);

//# sourceMappingURL=draw_helptext_component.js.map


(function() {
  KotiveWebapp.DrawKotiveFieldComponent = Ember.Component.extend({
    fieldType: (function() {
      var model;
      model = this.get('model');
      if (model.get('style') != null) {
        return model.get('style').kind;
      } else {
        return 'text';
      }
    }).property('model.style.kind'),
    inputField: (function() {
      var ref;
      return (ref = this.get('fieldType')) === 'text' || ref === 'email' || ref === 'number' || ref === 'password' || ref === 'tel' || ref === 'url' || ref === 'date' || ref === 'time' || ref === 'datetime';
    }).property('fieldType'),
    checkField: (function() {
      return this.get('fieldType') === 'check';
    }).property('fieldType'),
    selectField: (function() {
      return this.get('fieldType') === 'select';
    }).property('fieldType'),
    radioField: (function() {
      return this.get('fieldType') === 'radio';
    }).property('fieldType'),
    buttonField: (function() {
      return this.get('fieldType') === 'submit';
    }).property('fieldType'),
    dividerField: (function() {
      return this.get('fieldType') === 'divider';
    }).property('fieldType'),
    paragraphField: (function() {
      return this.get('fieldType') === 'paragraph';
    }).property('fieldType'),
    textAreaField: (function() {
      return this.get('fieldType') === 'textarea';
    }).property('fieldType'),
    heading: (function() {
      return this.get('fieldType') === 'heading';
    }).property('fieldType'),
    sectionField: (function() {
      return this.get('fieldType') === 'section';
    }).property('fieldType'),
    uploadField: (function() {
      return this.get('fieldType') === 'upload';
    }).property('fieldType'),
    uploadshowField: (function() {
      return this.get('fieldType') === 'uploadshow';
    }).property('fieldType')
  });

}).call(this);

//# sourceMappingURL=draw_kotive_field_component.js.map


(function() {
  KotiveWebapp.DrawKotiveServiceFieldComponent = Ember.Component.extend({
    inDesignerMode: (function() {
      return this.get('mode') === 'designer';
    }).property('mode'),
    shotAtwhoComponent: (function() {
      var ref;
      return this.get('inDesignerMode') && ((ref = this.get('model.style.kind')) === 'textarea' || ref === 'text' || ref === 'email' || ref === 'number' || ref === 'password' || ref === 'tel' || ref === 'url');
    }).property('inDesignerMode', 'model.style.kind'),
    classes: (function() {
      if (this.get('model.style.kind') === 'textarea') {
        return 'form-control textarea';
      } else {
        return 'form-control';
      }
    }).property('model', 'model.style.kind'),
    rows: (function() {
      if (this.get('model.style.kind') === 'textarea') {
        return '3';
      } else {
        return '1';
      }
    }).property('model', 'model.style.kind')
  });

}).call(this);

//# sourceMappingURL=draw_kotive_service_field_component.js.map


(function() {
  KotiveWebapp.DropTooltipComponent = Ember.Component.extend({
    actions: {
      closeDropTooltip: function() {
        return this.get('parentView').get('controller').send('closeDropTooltip');
      },
      submit: function() {
        return this.get('parentView').get('controller').send('submit');
      }
    }
  });

}).call(this);

//# sourceMappingURL=drop_tooltip_component.js.map


(function() {
  KotiveWebapp.DropTooltipFooterComponent = Ember.Component.extend({
    actions: {
      submit: function() {
        return this.get('parentView').send('submit');
      }
    }
  });

}).call(this);

//# sourceMappingURL=drop_tooltip_footer_component.js.map


(function() {
  KotiveWebapp.DropTooltipFooterDeleteConfirmComponent = Ember.Component.extend({
    actions: {
      closeDropTooltip: function() {
        return this.get('parentView').send('closeDropTooltip');
      },
      deleteAction: function() {
        return this.sendAction();
      }
    }
  });

}).call(this);

//# sourceMappingURL=drop_tooltip_footer_delete_confirm.js.map


(function() {
  KotiveWebapp.DropTooltipHeaderComponent = Ember.Component.extend({
    actions: {
      closeDropTooltip: function() {
        return this.get('parentView').send('closeDropTooltip');
      }
    },
    showCloseButton: (function() {
      if (this.get('showClose') != null) {
        return this.get('showClose');
      } else {
        return true;
      }
    }).property()
  });

}).call(this);

//# sourceMappingURL=drop_tooltip_header_component.js.map


(function() {
  KotiveWebapp.DropTooltipYesnoComponent = Ember.Component.extend({
    actions: {
      clickedYes: function() {
        return this.sendAction();
      },
      clickedNo: function() {
        return this.sendAction();
      }
    }
  });

}).call(this);

//# sourceMappingURL=drop_tooltip_yesno_component.js.map


(function() {
  KotiveWebapp.XAvatarComponent = Ember.Component.extend({
    tagName: "img",
    classNames: "avatar img-rounded",
    attributeBindings: "width height src".w(),
    width: 35,
    height: 35,
    service: "gravatar",
    largestDimension: (function() {
      if (this.get('width') > this.get('height')) {
        return this.get('width');
      } else {
        return this.get('height');
      }
    }).property('width', 'height'),
    src: (function() {
      return this[this.get("service")](this.get("user"));
    }).property("service"),
    facebook: function(user) {
      return "http://graph.facebook.com/" + (Ember.String.htmlSafe(user)) + "/picture?type=large";
    },
    github: function(user) {
      return "https://identicons.github.com/" + (Ember.String.htmlSafe(user)) + ".png";
    },
    gravatar: function(user) {
      if (user != null) {
        return "https://secure.gravatar.com/avatar/" + (window.md5(user.toLowerCase())) + "?s=" + (this.get('largestDimension')) + "&d=mm&r=g";
      }
    },
    getHtml: function(email) {
      var url;
      url = (function() {
        switch (this.get('service')) {
          case 'gravatar':
            return this.gravatar(email);
          case 'facebook':
            return this.facebook(email);
          case 'github':
            return this.github(email);
          default:
            return function() {
              return '';
            };
        }
      }).call(this);
      return "<img src=\"" + url + "\" class=\"" + (this.get('classNames').join(' ')) + "\" width=\"" + (this.get('width')) + "\" height=\"" + (this.get('height')) + "\"/>";
    }
  });

}).call(this);

//# sourceMappingURL=gravatar_component.js.map


(function() {
  KotiveWebapp.CheckboxCheckComponent = Ember.Checkbox.extend({
    hookup: (function() {
      var action;
      action = this.get("action");
      if (action) {
        this.on("change", this, this.sendHookup);
      }
    }).on("init"),
    sendHookup: function(ev) {
      var action, controller;
      action = this.get("action");
      controller = this.get("controller");
      controller.send(action, this.$().prop("checked"));
    },
    cleanup: (function() {
      this.off("change", this, this.sendHookup);
    }).on("willDestroyElement")
  });

}).call(this);

//# sourceMappingURL=kotive_checkbox_observer_check.js.map


(function() {
  KotiveWebapp.KotiveChosenSelectComponent = Ember.Component.extend({
    didInsertElement: function() {
      return Ember.run.scheduleOnce('afterRender', this, (function(_this) {
        return function() {
          return _this.$('select').on('change', function(evt, params) {
            _this.set('userChangedOption', true);
            _this.set('selectedKey', _this.$('select').val());
            return Ember.run.next(function() {
              return _this.set('userChangedOption', false);
            });
          });
        };
      })(this));
    },
    selectedValueUpdated: (function() {
      if (!this.get('userChangedOption')) {
        return this.$('select').val(this.get('selectedKey'));
      }
    }).observes('selectedKey'),
    chosenOptions: (function() {
      return {
        width: '100%',
        no_results_text: 'Sorry, could not find a match',
        disable_search_threshold: 5,
        inherit_select_classes: true,
        change_action: this.optionDidChange
      };
    }).property()
  });

}).call(this);

//# sourceMappingURL=kotive_chosen_select_component.js.map


(function() {
  KotiveWebapp.KotiveConditionsComponent = Ember.Component.extend({
    init: function() {
      return this._super();
    },
    actions: {
      createActivationCondition: function() {
        return this.get('parentView').get('controller').send('createActivationCondition');
      },
      createCompletionCondition: function() {
        return this.get('parentView').get('controller').send('createCompletionCondition');
      },
      addFilter: function(condition) {
        return this.get('parentView').get('controller').send('addFilter', condition);
      },
      removeFilter: function(filter) {
        return this.get('parentView').get('controller').send('removeFilter', filter);
      }
    }
  });

}).call(this);

//# sourceMappingURL=kotive_conditions_component.js.map


(function() {
  KotiveWebapp.KotiveFieldCheckComponent = Ember.Component.extend(KotiveWebapp.KotiveFieldFunctionsComponentMixin, KotiveWebapp.PredefinedOptionsComponentMixin, KotiveWebapp.PatternEncodingsMixin, {
    init: function() {
      this._super();
      return this.setPredefinedDescr();
    },
    hasSelections: (function() {
      return (this.get('model.patternOptions.selections') != null) && this.get('model.patternOptions.selections').length !== 0;
    }).property('model.patternOptions.selections'),
    isEmpty: (function() {
      return (this.get('mode') === 'designer' && this.get('model.style.optionsType') !== 'predefined' && !this.get('hasSelections')) || (this.get('mode') !== 'designer' && !this.get('hasSelections'));
    }).property('hasSelections', 'model.style.optionsType', 'mode'),
    values: (function() {
      if (this.get('value') === '') {
        return [];
      } else {
        return this.get('value').split('^').map((function(_this) {
          return function(val) {
            return _this.decode(val);
          };
        })(this));
      }
    }).property('value'),
    valuesChanged: (function() {
      var valueStr;
      if (!this.get('showPredefinedInfo')) {
        valueStr = this.get('values').map((function(_this) {
          return function(val) {
            return _this.encode(val);
          };
        })(this)).join('^');
        if (this.get('model.style.optionsType') !== 'predefined') {
          this.get('model').setPattern({
            "default": this.get('values')
          }, this.get('model').refreshPatternString());
        }
        return this.set('value', valueStr);
      }
    }).observes('values.@each', 'model.style.optionsType')
  });

}).call(this);

//# sourceMappingURL=kotive_field_check_component.js.map


(function() {
  KotiveWebapp.KotiveFieldDividerComponent = Ember.Component.extend(KotiveWebapp.KotiveFieldFunctionsComponentMixin, {});

}).call(this);

//# sourceMappingURL=kotive_field_divider_component.js.map


(function() {
  KotiveWebapp.KotiveFieldInputComponent = Ember.Component.extend({
    init: function() {
      this.set('elementId', uuid.v4().replace(/\-/g, ''));
      this._super();
      return this.setFieldTypes();
    },
    fieldType: (function() {
      var model;
      model = this.get('model');
      if (model.get('style') != null) {
        return model.get('style').kind;
      } else {
        return 'text';
      }
    }).property('model.style.kind'),
    inDesignerMode: (function() {
      return this.get('mode') === 'designer';
    }).property('mode'),
    fieldTypeChanged: (function() {
      return this.setFieldTypes();
    }).observes('fieldType'),
    fields: ['text', 'date', 'email', 'number', 'password', 'tel', 'url', 'time'],
    setFieldTypes: function() {
      var fieldType;
      fieldType = this.get('fieldType');
      return _.each(this.get('fields'), (function(_this) {
        return function(field) {
          return _this.set(field + "Field", fieldType === field);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=kotive_field_input_component.js.map


(function() {
  KotiveWebapp.KotiveFieldParagraphComponent = Ember.Component.extend({
    inDesignerMode: (function() {
      return this.get('mode') === 'designer';
    }).property('mode')
  });

}).call(this);

//# sourceMappingURL=kotive_field_paragraph_component.js.map


(function() {
  KotiveWebapp.KotiveFieldRadioComponent = Ember.Component.extend(KotiveWebapp.KotiveFieldFunctionsComponentMixin, KotiveWebapp.PredefinedOptionsComponentMixin, {
    init: function() {
      this._super();
      if (this.get('model.style.optionsType') === 'predefined' && this.get('mode') === 'designer') {
        return this.setPredefinedDescr();
      }
    },
    hasSelections: (function() {
      return (this.get('model.patternOptions.selections') != null) && this.get('model.patternOptions.selections').length !== 0;
    }).property('model.patternOptions.selections'),
    isEmpty: (function() {
      return (this.get('mode') === 'designer' && this.get('model.style.optionsType') !== 'predefined' && !this.get('hasSelections')) || (this.get('mode') !== 'designer' && !this.get('hasSelections'));
    }).property('hasSelections', 'model.style.optionsType', 'mode')
  });

}).call(this);

//# sourceMappingURL=kotive_field_radio_component.js.map


(function() {
  KotiveWebapp.KotiveFieldSelectComponent = Ember.Component.extend(KotiveWebapp.PredefinedOptionsComponentMixin, {
    init: function() {
      this._super();
      if (this.get('prompt') == null) {
        this.set('prompt', 'Please select ...');
      }
      if (this.get('model.style.optionsType') === 'predefined' && this.get('mode') === 'designer') {
        return this.setPredefinedDescr();
      }
    },
    hasSelections: (function() {
      return (this.get('model.patternOptions.selections') != null) && this.get('model.patternOptions.selections').length !== 0;
    }).property('model.patternOptions.selections'),
    isEmpty: (function() {
      return (this.get('mode') === 'designer' && this.get('model.style.optionsType') !== 'predefined' && !this.get('hasSelections')) || (this.get('mode') !== 'designer' && !this.get('hasSelections'));
    }).property('hasSelections', 'model.style.optionsType', 'mode')
  });

}).call(this);

//# sourceMappingURL=kotive_field_select_component.js.map


(function() {
  KotiveWebapp.KotiveFieldTextareaComponent = Ember.Component.extend({
    inDesignerMode: (function() {
      return this.get('mode') === 'designer';
    }).property('mode')
  });

}).call(this);

//# sourceMappingURL=kotive_field_textarea_component.js.map


(function() {
  KotiveWebapp.KotiveFieldUploadComponent = Ember.Component.extend({
    inDesignerMode: (function() {
      return this.get('mode') === 'designer';
    }).property('mode')
  });

}).call(this);

//# sourceMappingURL=kotive_field_upload_component.js.map


(function() {
  KotiveWebapp.KotiveSelectComponent = Ember.Component.extend({
    init: function() {
      if (this.get('prompt') == null) {
        this.set('prompt', 'Please select ...');
      }
      return this._super();
    },
    didInsertElement: function() {
      return this.$('select').on('change', (function(_this) {
        return function() {
          return _this.set('value', _this.$('select').val());
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=kotive_select_component.js.map


(function() {
  KotiveWebapp.ModalContainerComponent = Ember.Component.extend({
    actions: {
      closeModal: function() {
        return this.get('parentView').get('controller').send('closeModal');
      }
    }
  });

}).call(this);

//# sourceMappingURL=modal_container_component.js.map


(function() {
  KotiveWebapp.ModalFooterComponent = Ember.Component.extend({
    actions: {
      closeModal: function() {
        return this.get('parentView').send('closeModal');
      }
    }
  });

}).call(this);

//# sourceMappingURL=modal_footer_component.js.map


(function() {
  KotiveWebapp.ModalFooterDeleteConfirmComponent = Ember.Component.extend({
    actions: {
      closeModal: function() {
        return this.get('parentView').send('closeModal');
      },
      deleteAction: function() {
        return this.sendAction();
      }
    }
  });

}).call(this);

//# sourceMappingURL=modal_footer_delete_confirm.js.map


(function() {
  KotiveWebapp.ModalHeaderComponent = Ember.Component.extend({
    actions: {
      closeModal: function() {
        return this.get('parentView').send('closeModal');
      }
    },
    showCloseButton: (function() {
      if (this.get('showClose') != null) {
        return this.get('showClose');
      } else {
        return true;
      }
    }).property('showCloseButton')
  });

}).call(this);

//# sourceMappingURL=modal_header_component.js.map


(function() {
  KotiveWebapp.ModalYesnoComponent = Ember.Component.extend({
    actions: {
      clickedYes: function() {
        return this.sendAction();
      },
      clickedNo: function() {
        return this.sendAction();
      }
    }
  });

}).call(this);

//# sourceMappingURL=modal_yesno_component.js.map


(function() {
  KotiveWebapp.Oauth2GenerateComponent = Ember.Component.extend({
    actions: {
      execute: function() {
        var params, url, win;
        this.ensureOldWindowsClosed();
        params = this.get('model.authParams');
        url = "/oauth2/" + params.target_service + "?scope=" + (encodeURIComponent(params.required_scope));
        win = window.open(url, '_blank');
        return this.set('authWin', win);
      }
    },
    didInsertElement: function() {
      return this.waitForAuthResponseTrigger();
    },
    willDestroyElement: function() {
      return this.ensureOldWindowsClosed();
    },
    authenticated: (function() {
      return (this.get('model.patternString') != null) && this.get('model.patternString').trim() !== '';
    }).property('model.patternString'),
    ensureOldWindowsClosed: function() {
      if (this.get('authWin') != null) {
        this.get('authWin').close();
        return this.set('authWin', null);
      }
    },
    waitForAuthResponse: function() {
      var doc, err, tokenData;
      if (this.get('authWin') != null) {
        try {
          doc = $(this.get('authWin').document);
          tokenData = doc.find('#tokenData').val();
          if (tokenData != null) {
            if (tokenData === 'ERROR/DENIED') {
              this.authError();
            } else {
              this.set('model.patternString', tokenData);
            }
            this.get('authWin').close();
            return this.set('authWin', null);
          }
        } catch (_error) {
          err = _error;
          if (err instanceof DOMException) {
            return console.log('Waiting for OAuth leg to complete....');
          } else {
            throw err;
          }
        } finally {
          this.waitForAuthResponseTrigger();
        }
      } else {
        return this.waitForAuthResponseTrigger();
      }
    },
    waitForAuthResponseTrigger: function() {
      return Ember.run.later((function(_this) {
        return function() {
          if (!(_this.get('isDestroyed') || _this.get('isDestroying'))) {
            return _this.waitForAuthResponse();
          }
        };
      })(this), 500);
    },
    authError: function() {
      return Messenger().post({
        id: 'oauth2-error',
        singleton: false,
        hideAfter: 20,
        showCloseButton: true,
        message: "Sorry but something went wrong while attempting to authenticate with " + (this.get('model.authParams.target_service')) + " - please try again anad make sure you click the allow option",
        type: 'error'
      });
    }
  });

}).call(this);

//# sourceMappingURL=oauth2_component.js.map


(function() {
  KotiveWebapp.SwitchBranchComponent = Ember.Component.extend({
    tagName: '',
    actions: {
      setActive: function(group) {
        return this.sendAction('action', group);
      }
    },
    isActive: (function() {
      return this.get('group.id').toString() === this.get('activeGroupId').toString();
    }).property('group', 'activeGroupId'),
    spacer: '&nbsp;&nbsp;&nbsp;&nbsp;',
    spacing: (function() {
      var pos;
      pos = this.get('position') + 1;
      return Array(pos).join(this.get('spacer'));
    }).property('position'),
    nextPosition: (function() {
      return this.get('position') + 1;
    }).property('position'),
    subGroups: (function() {
      if (this.get('groups') != null) {
        return this.get('groups').filterBy('id_parent', this.get('group.id')).sortBy('label');
      } else {
        return [];
      }
    }).property('groups', 'groups.@each')
  });

}).call(this);

//# sourceMappingURL=switch_branch_component.js.map


(function() {
  KotiveWebapp.ApplicationView = Ember.View.extend(KotiveWebapp.DropTooltipViewMixin, {
    afterRenderEvent: function() {
      this.doDropToolTipSetup();
      this.setupDesignerViewChanges();
      $(document).click((function(_this) {
        return function(e) {
          if (e.target.id === 'kotive-modal') {
            _this.get('controller.modalController').send('disconnectingModal');
            return _this.get('controller').trigger('hideModal');
          }
        };
      })(this));
      this.get('controller').on('showModal', this, (function(_this) {
        return function() {
          _this.get('controller.modalController').send('openingModal');
          return _this.$('.modal').modal('show');
        };
      })(this));
      return this.get('controller').on('hideModal', this, (function(_this) {
        return function() {
          return _this.$('.modal.in').modal('hide');
        };
      })(this));
    },
    willDestroyElement: function() {
      this.doDropTooltipTeardown();
      this.get('controller').off('showModal', this);
      this.get('controller').off('hideModal', this);
      this.get('controller').off('inDesignerPath', this);
      return this.get('controller').off('notInDesignerPath', this);
    },
    setupDesignerViewChanges: function() {
      var bodyEl;
      bodyEl = $('body');
      this.get('controller').on('inDesignerPath', this, function() {
        if (!bodyEl.hasClass('designer')) {
          return bodyEl.addClass('designer');
        }
      });
      this.get('controller').on('notInDesignerPath', this, function() {
        if (bodyEl.hasClass('designer')) {
          return bodyEl.removeClass('designer');
        }
      });
      return this.get('controller').runInDesignerPathLogic();
    }
  });

}).call(this);

//# sourceMappingURL=application_view.js.map


(function() {
  KotiveWebapp.ConditionView = Ember.View.extend({
    afterRender: function() {
      var activeTab;
      activeTab = null;
      return $('a[data-toggle="tab"]').on('show.bs.tab', function(e) {
        if ($(e.target)) {
          activeTab = $(e.target).attr('href');
          if (activeTab === '#conditions') {
            $(".add-field-btn").hide();
            $("#add-activation-condition").parent().prev().find('.or-label').hide();
            return $("#add-completion-condition").parent().prev().find('.or-label').hide();
          } else if (activeTab === '#properties') {
            return $(".add-field-btn").show();
          }
        }
      });
    },
    willDestroyElement: function() {
      this.get('controller').off('conditionChanges', this);
      return this.removeObserver('controller', this, 'model.templateFields.@each');
    }
  });

}).call(this);

//# sourceMappingURL=condition_view.js.map


(function() {
  KotiveWebapp.DatatableView = Ember.View.extend({
    tagName: 'table',
    afterRenderEvent: function() {
      return this.drawTable();
    },
    datasetChanged: (function() {
      return this.drawTable();
    }).observes('columns', 'dataRows'),
    drawTable: function() {
      var dataRows, dataTable, order, ref, tbl;
      if (this.get('columns') && (this.get('dataRows') != null)) {
        dataRows = this.get('dataRows');
        if (this.get('order') != null) {
          order = this.get('order');
        } else {
          if (this.get('columns').length > 3) {
            order = [[this.get('columns').length - 2, 'desc']];
          } else {
            order = [[0, 'asc']];
          }
        }
        if (this.get('dataTable') != null) {
          dataTable = this.get('dataTable');
          dataTable.fnClearTable();
          if (this.get('dataRows').length !== 0) {
            dataTable.fnAddData(dataRows);
          }
        } else {
          dataTable = this.$().dataTable({
            columns: this.get('columns'),
            scrollY: '75vh',
            scrollX: true,
            scrollCollapse: true,
            columnDefs: [
              {
                orderable: false,
                className: 'select-checkbox',
                targets: 0,
                width: '10px'
              }
            ],
            select: {
              style: 'multi',
              selector: 'td:first-child',
              info: false
            },
            paging: false,
            order: order,
            processing: true,
            language: {
              search: "Quickfilter:",
              emptyTable: this.get('noDataMessage') || 'No data available'
            },
            buttons: this.setButtons(this.get('buttons'))
          });
          if (this.get('dataRows').length !== 0) {
            dataTable.fnAddData(dataRows);
            tbl = this.$().DataTable();
            tbl.buttons().container().prependTo($('.dataTables_filter', tbl.table().container()));
          }
          this.set('dataTable', dataTable);
        }
      } else {
        if ((ref = this.get('dataTable')) != null) {
          ref.fnClearTable();
        }
      }
      return true;
    },
    setButtons: function(btns) {
      var buttons;
      buttons = [];
      if (btns != null) {
        btns = btns.split(',');
        btns.forEach((function(_this) {
          return function(btn) {
            if (btn === 'delete') {
              return buttons.pushObject({
                text: '<span class="glyphicon glyphicon-trash"></span>&nbsp;Delete',
                className: 'btn btn-default btn-sm delete-btn',
                action: function() {
                  return _this.get('controller').send('showDeleteDrop');
                }
              });
            } else if (btn === 'download') {
              return buttons.pushObject({
                extend: 'csv',
                text: '<span class="glyphicon glyphicon-download-alt"></span>&nbsp;Download',
                className: 'btn btn-success btn-sm',
                exportOptions: {
                  columns: ':not(:last-child)'
                }
              });
            }
          };
        })(this));
      }
      return buttons;
    }
  });

}).call(this);

//# sourceMappingURL=datatable_view.js.map


(function() {
  KotiveWebapp.DesignerWorkflowsView = Ember.View.extend(KotiveWebapp.DocumentQueryMixin, KotiveWebapp.ElementHeightSetViewMixin, {
    afterRenderEvent: function() {
      this.get('controller').on('setActivityEditorSize', this, (function(_this) {
        return function() {
          return _this.setActivityEditorSize();
        };
      })(this));
      this.setActivityEditorSizeEvents({
        element: '.panel-kotive-taskflows',
        heightOffset: 180
      });
      this.setupActivityAddedListener();
      this.setupShowDropListener();
      return this.checkForTaskflowTemplate();
    },
    willDestroyElement: function() {
      this.get('controller').off('setActivityEditorSize', this);
      this.get('controller').off('workflowAddedIndicate', this);
      return this.get('controller').off('showDrop', this);
    },
    checkForTaskflowTemplate: function() {
      var taskflowTemplate;
      taskflowTemplate = this.get('controller').get('taskflowTemplate');
      if (taskflowTemplate != null) {
        this.get('controller').set('taskflowTemplate', null);
        return this.get('controller').showTaskflowRecipes(taskflowTemplate);
      }
    },
    setupActivityAddedListener: function() {
      return this.get('controller').on('workflowAddedIndicate', this, function(templateActivity) {
        return Ember.run.scheduleOnce('afterRender', this, (function(_this) {
          return function() {
            var element;
            element = _this.$("#" + (templateActivity.get('id')));
            $('html, body').animate({
              scrollTop: element.offset().top - 100,
              easing: 'easeInOut'
            }, 300);
            element.addClass('scroll-highlight');
            return Ember.run.later(function() {
              return element.addClass('fade-out');
            }, 1000);
          };
        })(this));
      });
    },
    setupShowDropListener: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'workflows-add';
      return this.get('controller').on('showDrop', this, (function(_this) {
        return function() {
          var model, targetEl;
          targetEl = _this.get('viewEl').querySelector('.new-workflow');
          model = _this.get('controller').newTemplateActivity();
          return _this.get('controller').send(actionName, targetEl, viewName, model, {
            position: 'bottom right',
            positionMobile: 'bottom right'
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=designer_workflows_view.js.map


(function() {
  KotiveWebapp.ForgotView = Ember.View.extend({
    didInsertElement: function() {
      return this.$('.form-control.email-value').focus();
    },
    willDestroyElement: function() {
      return this.get('controller').off('readyToFocus', this);
    }
  });

}).call(this);

//# sourceMappingURL=forgot_view.js.map


(function() {
  KotiveWebapp.GeneratedTaskView = Ember.View.extend({
    afterRenderEvent: function() {},
    willDestroyElement: function() {}
  });

}).call(this);

//# sourceMappingURL=generated_task_view.js.map


(function() {
  KotiveWebapp.IndexView = Ember.View.extend({
    afterRenderEvent: function() {},
    willDestroyElement: function() {}
  });

}).call(this);

//# sourceMappingURL=index_view.js.map


(function() {
  KotiveWebapp.LoginView = Ember.View.extend({
    didInsertElement: function() {
      this.$('.form-control.email-value').focus();
      return $('#kotive-modal').modal('hide');
    },
    willDestroyElement: function() {
      return this.get('controller').off('readyToFocus', this);
    }
  });

}).call(this);

//# sourceMappingURL=login_view.js.map


(function() {
  KotiveWebapp.ReferralsView = Ember.View.extend({
    afterRenderEvent: function() {
      return this.get('controller').on('highlightReferralToken', this, (function(_this) {
        return function() {
          return _this.$('input.form-control.kotive-embedded-scripts').select().focus();
        };
      })(this));
    },
    willDestroyElement: function() {
      return this.get('controller').off('highlightReferralToken', this);
    }
  });

}).call(this);

//# sourceMappingURL=referrals_view.js.map


(function() {
  KotiveWebapp.RegistrationView = Ember.View.extend({
    didInsertElement: function() {
      this.$('.form-control.password-value').focus();
      this.get('controller').on('signupEmailInvalid', this, function() {
        $('.alert.alert-warning').addClass('hidden');
        return $('#js-signup-alert').removeClass('hidden');
      });
      this.get('controller').on('confirmationPasswordInvalid', this, function() {
        $('.alert.alert-warning').addClass('hidden');
        return $('#js-password-alert').removeClass('hidden');
      });
      this.get('controller').on('confirmationCompanyInvalid', this, function() {
        $('.alert.alert-warning').addClass('hidden');
        return $('#js-company-alert').removeClass('hidden');
      });
      return this.get('controller').on('apiError', this, function() {
        $('.alert.alert-warning').addClass('hidden');
        return $('#js-api-error').removeClass('hidden');
      });
    },
    willDestroyElement: function() {
      this.get('controller').off('readyToFocus', this);
      this.get('controller').off('signupEmailInvalid', this);
      this.get('controller').off('confirmationPasswordInvalid', this);
      this.get('controller').off('confirmationCompanyInvalid', this);
      return this.get('controller').off('apiError', this);
    }
  });

}).call(this);

//# sourceMappingURL=registration_view.js.map


(function() {
  KotiveWebapp.ReportView = Ember.View.extend(KotiveWebapp.ElementHeightSetViewMixin, KotiveWebapp.DocumentQueryMixin, {
    afterRenderEvent: function() {
      this.setupReportColumnChooserListener();
      return this.setupDeleteReportTaskflowsListener();
    },
    willDestroyElement: function() {
      this.get('controller').off('showReportColumnChooserDrop', this);
      return this.get('controller').off('deleteReportTaskflows', this);
    },
    setupReportColumnChooserListener: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'report-column-chooser';
      return this.get('controller').on('showReportColumnChooserDrop', this, (function(_this) {
        return function() {
          var model, targetEl;
          targetEl = _this.get('viewEl').querySelector('.report-column-chooser-btn');
          model = _this.get('controller').get('model');
          return _this.get('controller').send(actionName, targetEl, viewName, model, {
            position: 'bottom right',
            positionMobile: 'bottom right'
          });
        };
      })(this));
    },
    setupDeleteReportTaskflowsListener: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'report-taskflows-delete';
      return this.get('controller').on('deleteReportTaskflows', this, (function(_this) {
        return function() {
          var model, targetEl;
          targetEl = _this.get('viewEl').querySelector('.delete-btn');
          model = _this.get('controller').get('model');
          return _this.get('controller').send(actionName, targetEl, viewName, model, {
            position: 'bottom right',
            positionMobile: 'bottom right'
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=report_view.js.map


(function() {
  KotiveWebapp.ResetView = Ember.View.extend({
    didInsertElement: function() {
      return this.$('.form-control.email-value').focus();
    },
    willDestroyElement: function() {
      return this.get('controller').off('readyToFocus', this);
    }
  });

}).call(this);

//# sourceMappingURL=reset_view.js.map


(function() {
  KotiveWebapp.RoleAddView = Ember.View.extend({
    didInsertElement: function() {
      return this.get('controller').on('readyToFocus', this, (function(_this) {
        return function() {
          return _this.$('#role-label').focus();
        };
      })(this));
    },
    willDestroyElement: function() {
      return this.get('controller').off('readyToFocus', this);
    }
  });

}).call(this);

//# sourceMappingURL=role_add_view.js.map


(function() {
  KotiveWebapp.RoleEditorView = Ember.View.extend(KotiveWebapp.DocumentQueryMixin, {
    afterRenderEvent: function() {
      this.setupRoleAddListener();
      this.setupRoleAddedListener();
      this.setupRoleUpdatingListener();
      return this.setupRoleDeleteListener();
    },
    willDestroyElement: function() {
      this.get('controller').off('addNewRole', this);
      this.get('controller').off('roleAdded', this);
      this.get('controller').off('updatingRole', this);
      return this.get('controller').off('deleteRole', this);
    },
    setupRoleAddListener: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'role-add';
      return this.get('controller').on('addNewRole', this, (function(_this) {
        return function(model) {
          _this.get('controller').send('closeDropTooltip');
          return Ember.run.next(function() {
            var targetEl;
            targetEl = _this.get('viewEl').querySelector('.add-new-role-link');
            return _this.get('controller').send(actionName, targetEl, viewName, model, {
              position: 'top left',
              positionMobile: 'top left'
            });
          });
        };
      })(this));
    },
    setupRoleAddedListener: function() {
      return this.get('controller').on('roleAdded', this, (function(_this) {
        return function(roleId) {
          return Ember.run.scheduleOnce('afterRender', _this, function() {
            var element, parentDiv;
            element = _this.$("tr#" + roleId);
            parentDiv = _this.$('.modal-body');
            parentDiv.animate({
              scrollTop: element.offset().top - 100,
              easing: 'easeInOut'
            }, 300);
            element.addClass('scroll-highlight');
            return Ember.run.later(function() {
              return element.addClass('fade-out');
            }, 1000);
          });
        };
      })(this));
    },
    setupRoleUpdatingListener: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'role-update';
      return this.get('controller').on('updatingRole', this, (function(_this) {
        return function(role) {
          _this.get('controller').send('closeDropTooltip');
          return Ember.run.next(function() {
            var targetEl;
            targetEl = _this.$("tr#" + (role.get('id')) + " .role")[0];
            return _this.get('controller').send(actionName, targetEl, viewName, role, {
              position: 'top left',
              positionMobile: 'top left'
            });
          });
        };
      })(this));
    },
    setupRoleDeleteListener: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'role-delete';
      return this.get('controller').on('deleteRole', this, (function(_this) {
        return function(role) {
          _this.get('controller').send('closeDropTooltip');
          return Ember.run.next(function() {
            var targetEl;
            targetEl = _this.$("tr#" + (role.get('id')) + " .role-delete")[0];
            return _this.get('controller').send(actionName, targetEl, viewName, role, {
              position: 'middle right',
              positionMobile: 'middle right'
            });
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=role_editor_view.js.map


(function() {
  KotiveWebapp.RoleUpdateView = Ember.View.extend({
    didInsertElement: function() {
      return this.get('controller').on('readyToFocus', this, (function(_this) {
        return function() {
          return _this.$('input').select();
        };
      })(this));
    },
    willDestroyElement: function() {
      return this.get('controller').off('readyToFocus', this);
    }
  });

}).call(this);

//# sourceMappingURL=role_update_view.js.map


(function() {
  KotiveWebapp.SignupView = Ember.View.extend(KotiveWebapp.ElementHeightSetViewMixin, {
    didInsertElement: function() {
      this.$('.modal-dialog').addClass('modal-sm');
      this.setActivityEditorSizeEvents({
        element: '.modal.modal-body',
        heightOffset: 200
      });
      this.$('.form-control.email-value').focus();
      this.get('controller').on('signupEmailInvalid', this, function() {
        $('.alert.alert-warning').addClass('hidden');
        return $('#js-signup-alert').removeClass('hidden');
      });
      this.get('controller').on('confirmationPasswordInvalid', this, function() {
        $('.alert.alert-warning').addClass('hidden');
        return $('#js-password-alert').removeClass('hidden');
      });
      this.get('controller').on('confirmationCompanyInvalid', this, function() {
        $('.alert.alert-warning').addClass('hidden');
        return $('#js-company-alert').removeClass('hidden');
      });
      return this.get('controller').on('apiError', this, function() {
        $('.alert.alert-warning').addClass('hidden');
        return $('#js-api-error').removeClass('hidden');
      });
    },
    willDestroyElement: function() {
      return this.get('controller').off('readyToFocus', this);
    }
  });

}).call(this);

//# sourceMappingURL=signup_view.js.map


(function() {
  KotiveWebapp.TemplateActivityAddView = Ember.View.extend(KotiveWebapp.KotiveFlowIntegrationViewMixin, KotiveWebapp.ElementHeightSetViewMixin, {
    afterRenderEvent: function() {
      this.get('controller').on('activityTypeSelected', this, (function(_this) {
        return function(kind) {
          return _this.setTemplateActivityTypeSelected(kind);
        };
      })(this));
      this.setupMarkActivityAddedListener();
      this.setTemplateActivitySubTypeSelectedListener();
      return this.setActivityEditorSizeEvents({
        element: '.modal.modal-body',
        heightOffset: 200
      });
    },
    willDestroyElement: function() {
      this.get('controller').off('activityTypeSelected', this);
      this.get('controller').off('activitySubTypeSelected', this);
      this.get('controller').off('readyToFocus', this);
      return this.teardownFlowDesigner();
    },
    setTemplateActivityTypeSelected: function(kind) {
      var querySelector;
      querySelector = ".thumb." + kind;
      this.$('.template-activity-type-block').children('.selected').removeClass('selected');
      this.$('.template-activity-type-block').children(querySelector).addClass('selected');
      return Ember.run.later(function() {
        if (kind === 'form' || kind === 'subtree') {
          return this.$('.form-control.title-value').focus();
        } else {
          return this.$('.form-control.field-type-selection').focus();
        }
      }, 50);
    },
    setTemplateActivitySubTypeSelectedListener: function() {
      return this.get('controller').on('activitySubTypeSelected', this, (function(_this) {
        return function(subType) {
          _this.$('.template-activity-sub-types').children('li').each(function() {
            if ($(this).hasClass('selected')) {
              return $(this).removeClass('selected');
            }
          });
          return _this.$("#" + (subType.get('id'))).addClass('selected');
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=template_activity_add_view.js.map


(function() {
  KotiveWebapp.TemplateActivityFormView = Ember.View.extend(KotiveWebapp.DocumentQueryMixin, {
    templateFieldsChanged: (function() {
      var model, orderedTemplateFields;
      orderedTemplateFields = this.get('controller.orderedTemplateFields');
      model = this.get('controller.model');
      return Ember.run.later((function(_this) {
        return function() {
          if ((model != null) && model.get('kind') === 'form') {
            _this.addSortableLogic();
          }
          return _this.send('setActivityEditorSize');
        };
      })(this), 200);
    }).observes('controller.orderedTemplateFields', 'controller.model'),
    pathDidChange: (function() {
      var elements;
      elements = this.$('.kotive-template-activity-form-field');
      if (this.get('controller.controllers.application.currentPath') !== 'group.designer.workflow.template-activity.template-field' && (elements != null)) {
        return elements.each(function() {
          var element;
          element = $(this);
          if (element.hasClass('selected')) {
            return element.removeClass('selected');
          }
        });
      }
    }).observes('controller.controllers.application.currentPath'),
    fieldAdded: (function() {
      var currentField;
      currentField = this.get('controller.controllers.template-field-add.model');
      if ((currentField != null) && this.get('controller.controllers.application.currentPath') === 'group.designer.workflow.template-activity.index') {
        return this.get('controller.controllers.template-activity').trigger('templateFieldSelected', currentField);
      }
    }).observes('controller.model.templateFields.length'),
    afterRenderEvent: function() {
      this.setupActivityLoadedEvent();
      this.setupAddNewFieldEvent();
      this.setupFieldSelectedEvent();
      return this.setupTemplateFieldAddedListener();
    },
    willDestroyElement: function() {
      this.get('controller').off('addNewTemplateField', this);
      this.get('controller').off('activityLoaded', this);
      this.get('controller.controllers.template-activity').off('templateFieldSelected', this);
      this.get('controller.controllers.template-activity').off('newTemplateFieldCreated', this);
      this.get('controller.controllers.condition').off('reloadConditionFilters', this);
      this.get('controller').off('createActivationCondition', this);
      this.get('controller').off('createCompletionCondition', this);
      this.get('controller').off('addFilter', this);
      this.get('controller').off('removeFilter', this);
      this.removeObserver('controller.model', this, 'modelDidChange');
      this.removeObserver('controller.controllers.condition', this, 'model.templateFields.@each');
      return this.removeObserver('controller.controllers.condition', this, 'model.templateConditions.@each');
    },
    setupActivityLoadedEvent: function() {
      return this.get('controller').on('activityLoaded', this, function() {
        return this.$('#js-field-tab a[href="#properties"]').tab('show');
      });
    },
    setupAddNewFieldEvent: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'template-field-add';
      return this.get('controller').on('addNewTemplateField', this, function() {
        var model, targetEl;
        targetEl = this.get('viewEl').querySelector('.btn.add-field-btn');
        model = this.get('controller').newTemplateField();
        return this.get('controller').send(actionName, targetEl, viewName, model, {
          position: 'top right',
          positionMobile: 'top right'
        });
      });
    },
    addSortableLogic: function() {
      var sortables;
      sortables = this.$('.sortable');
      if ((sortables != null) && sortables.length !== 0) {
        return sortables.sortable({
          axis: 'y',
          update: (function(_this) {
            return function(event, ui) {
              return _this.$('.sortable').children('.kotive-template-activity-form-field').each(function(index, element) {
                var id;
                id = $(element).data('field-id');
                return _this.get('controller').trigger('templateFieldReordered', index, id);
              });
            };
          })(this)
        });
      }
    },
    setupFieldSelectedEvent: function() {
      var doSelectedFieldLogic;
      doSelectedFieldLogic = (function(_this) {
        return function(templateField) {
          var elements;
          elements = _this.$('.kotive-template-activity-form-field');
          if (elements.length === 0) {
            return Ember.run.next(function() {
              return doSelectedFieldLogic(templateField);
            });
          } else {
            return elements.each(function() {
              var element;
              element = $(this);
              if (element.data('field-id') === templateField.get('id')) {
                if (!element.hasClass('selected')) {
                  return element.addClass('selected');
                }
              } else {
                if (element.hasClass('selected')) {
                  return element.removeClass('selected');
                }
              }
            });
          }
        };
      })(this);
      return this.get('controller.controllers.template-activity').on('templateFieldSelected', this, doSelectedFieldLogic);
    },
    setupTemplateFieldAddedListener: function() {
      return this.get('controller.controllers.template-activity').on('newTemplateFieldCreated', this, (function(_this) {
        return function(templateField, doScroll) {
          return Ember.run.later(function() {
            var element, parentDiv;
            element = _this.$(".kotive-template-activity-form-field[data-field-id='" + (templateField.get('id')) + "']");
            parentDiv = _this.$('.panel-body');
            if (doScroll) {
              parentDiv.animate({
                scrollTop: parentDiv[0].scrollHeight,
                easing: 'easeInOut'
              }, 400);
            }
            element.addClass('scroll-highlight');
            return Ember.run.later(function() {
              element.addClass('fade-out');
              return Ember.run.later(function() {
                element.removeClass('scroll-highlight');
                return element.removeClass('fade-out');
              }, 1100);
            }, 1000);
          }, 300);
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=template_activity_form_view.js.map


(function() {
  KotiveWebapp.TemplateActivityView = Ember.View.extend(KotiveWebapp.ElementHeightSetViewMixin, KotiveWebapp.DocumentQueryMixin, {
    afterRenderEvent: function() {
      this.get('controller').on('setActivityEditorSize', this, (function(_this) {
        return function() {
          return _this.setActivityEditorSize();
        };
      })(this));
      this.setActivityEditorSizeEvents({
        element: '.panel-body.template-activity-editor-body',
        heightOffset: 180
      });
      this.setupDatepicker();
      this.setupLabelEditListener();
      return this.setupDeleteTaskListener();
    },
    willDestroyElement: function() {
      this.get('controller').off('setActivityEditorSize', this);
      this.get('controller').off('editingLabelActivated', this);
      return this.get('controller').off('deleteTask', this);
    },
    newActivityLoaded: (function() {
      return $('a[href="#properties"]').tab('show');
    }).observes('controller.model'),
    setupDatepicker: function() {
      return Ember.run.later(function() {
        return $(document).on("click input", "input[type=\"date\"], input[type=\"text\"].datepicker", function(e) {
          $(this).prop("type", "text").datepicker({
            format: "yyyy-mm-dd",
            autoclose: true,
            todayBtn: true,
            todayHighlight: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            changeMonth: true,
            changeYear: true,
            showWeek: true,
            firstDay: 1
          });
          return Ember.run.next((function(_this) {
            return function() {
              return $(_this).datepicker("show");
            };
          })(this));
        });
      }, 500);
    },
    setupLabelEditListener: function() {
      var controller;
      controller = this.get('controller');
      return controller.on('editingLabelActivated', this, (function(_this) {
        return function() {
          return Ember.run.next(function() {
            var el;
            el = _this.$('.task-label-edit');
            el.focus();
            return el.on('keyup', function(e) {
              if (e.keyCode === 27) {
                controller.send('editTaskLabelCancel');
              }
              if (e.keyCode === 13) {
                return controller.send('updateTaskLabel');
              }
            });
          });
        };
      })(this));
    },
    setupDeleteTaskListener: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'template-activity-delete';
      return this.get('controller').on('deleteTask', this, (function(_this) {
        return function() {
          var model, targetEl;
          targetEl = _this.get('viewEl').querySelector('.delete-task-btn');
          model = _this.get('controller').get('model');
          return _this.get('controller').send(actionName, targetEl, viewName, model, {
            position: 'bottom right',
            positionMobile: 'bottom right'
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=template_activity_view.js.map


(function() {
  KotiveWebapp.TemplateFieldAddView = Ember.View.extend(KotiveWebapp.ElementHeightSetViewMixin, {
    afterRenderEvent: function() {
      Ember.run.next((function(_this) {
        return function() {
          return _this.$('.form-control.label-value').focus();
        };
      })(this));
      this.$('.form-control.field-type-selection').on('change', (function(_this) {
        return function() {
          return _this.$('.form-control.label-value').focus();
        };
      })(this));
      return this.setActivityEditorSizeEvents({
        element: '.modal.modal-body',
        heightOffset: 200
      });
    },
    willDestroyElement: function() {
      return this.get('controller').off('readyToFocus', this);
    }
  });

}).call(this);

//# sourceMappingURL=template_field_add_view.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorMultipleOptionsView = Ember.View.extend({
    afterRenderEvent: function() {
      this.setupOptionsToggleListener();
      return Ember.run.later((function(_this) {
        return function() {
          return _this.setupSortableOptions();
        };
      })(this), 500);
    },
    didDestroyElement: function() {
      this.get('controller').off('showOptionsList', this);
      return this.get('controller').off('hideOptionsList', this);
    },
    setupOptionsToggleListener: function() {
      this.get('controller').on('showOptionsList', this, function() {
        return this.$('.field-options-container').velocity('slideDown', {
          duration: 400
        });
      });
      return this.get('controller').on('hideOptionsList', this, function() {
        return this.$('.field-options-container').velocity('slideUp', {
          duration: 400
        });
      });
    },
    setupSortableOptions: function() {
      return this.$('.sortable').sortable({
        axis: 'y',
        handle: '.draggable-handle',
        update: (function(_this) {
          return function(event, ui) {
            var elementsOrder;
            elementsOrder = [];
            _this.$('.sortable').children('.template-field-option').each(function(index, element) {
              return elementsOrder.pushObject(parseInt($(element).data('field-index')));
            });
            return _this.get('controller').elementsReordered(elementsOrder);
          };
        })(this)
      });
    }
  });

}).call(this);

//# sourceMappingURL=template_field_editor_multiple_options_view.js.map


(function() {
  KotiveWebapp.TemplateFieldEditorSingleOptionsView = Ember.View.extend({
    afterRenderEvent: function() {
      this.setupOptionsToggleListener();
      return Ember.run.later((function(_this) {
        return function() {
          return _this.setupSortableOptions();
        };
      })(this), 500);
    },
    didDestroyElement: function() {
      this.get('controller').off('showOptionsList', this);
      return this.get('controller').off('hideOptionsList', this);
    },
    setupOptionsToggleListener: function() {
      this.get('controller').on('showOptionsList', this, function() {
        return this.$('.field-options-container').velocity('slideDown', {
          duration: 400
        });
      });
      return this.get('controller').on('hideOptionsList', this, function() {
        return this.$('.field-options-container').velocity('slideUp', {
          duration: 400
        });
      });
    },
    setupSortableOptions: function() {
      return this.$('.sortable').sortable({
        axis: 'y',
        handle: '.draggable-handle',
        update: (function(_this) {
          return function(event, ui) {
            var elementsOrder;
            elementsOrder = [];
            _this.$('.sortable').children('.template-field-option').each(function(index, element) {
              return elementsOrder.pushObject(parseInt($(element).data('field-index')));
            });
            return _this.get('controller').elementsReordered(elementsOrder);
          };
        })(this)
      });
    }
  });

}).call(this);

//# sourceMappingURL=template_field_editor_single_options_view.js.map


(function() {
  KotiveWebapp.TemplateFieldView = Ember.View.extend(KotiveWebapp.ElementHeightSetViewMixin, KotiveWebapp.DocumentQueryMixin, {
    afterRenderEvent: function() {
      this.setupDeleteFieldListener();
      this.setActivityEditorSizeEvents({
        element: '.modal',
        heightOffset: 225
      });
      this.setActivityEditorSizeEvents({
        element: '.modal-body',
        heightOffset: 225
      });
      Ember.run.next((function(_this) {
        return function() {
          return _this.$('.form-control.label-value').focus();
        };
      })(this));
      return this.$('.form-control.field-type-selection').on('change', (function(_this) {
        return function() {
          return _this.$('.form-control.label-value').focus();
        };
      })(this));
    },
    willDestroyElement: function() {
      return this.get('controller').off('deleteTemplateField', this);
    },
    setupDeleteFieldListener: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'template-field-delete';
      return this.get('controller').on('deleteTemplateField', this, (function(_this) {
        return function() {
          var model, targetEl;
          targetEl = _this.get('viewEl').querySelector('.delete-template-field-btn');
          model = _this.get('controller').get('model');
          return _this.get('controller').send(actionName, targetEl, viewName, model, {
            position: 'top left',
            positionMobile: 'top left'
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=template_field_view.js.map


(function() {
  KotiveWebapp.WorkflowSettingsView = Ember.View.extend(KotiveWebapp.KotiveFlowIntegrationViewMixin, KotiveWebapp.ElementHeightSetViewMixin, {
    afterRender: function() {
      return this.get('controller').on('setViewListeners', this, (function(_this) {
        return function() {
          return _this.$('.kotive-embedded-scripts').on('mouseover', function() {
            return $(this).select();
          });
        };
      })(this));
    },
    afterRenderEvent: function() {
      return this.setupDeleteWorkflowListener();
    },
    willDestroyElement: function() {
      this.get('controller').off('setViewListeners', this);
      return this.get('controller').off('deleteWorkflow', this);
    },
    setupDeleteWorkflowListener: function() {
      var actionName, viewName;
      actionName = 'openDropTooltip';
      viewName = 'workflow-delete';
      return this.get('controller').on('deleteWorkflow', this, (function(_this) {
        return function() {
          var model, targetEl;
          targetEl = _this.get('viewEl').querySelector('.delete-workflow-btn');
          model = _this.get('controller').get('model');
          return _this.get('controller').send(actionName, targetEl, viewName, model, {
            position: 'bottom left',
            positionMobile: 'bottom left'
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=workflow_settings_view.js.map


(function() {
  KotiveWebapp.WorkflowView = Ember.View.extend(KotiveWebapp.KotiveFlowIntegrationViewMixin, KotiveWebapp.ElementHeightSetViewMixin, {
    afterRenderEvent: function() {
      this.setupKotiveFlowDesigner('#kotive-flow-container');
      this.setupLabelEditListener();
      return this.setActivityEditorSizeEvents({
        element: '.panel-kotive-flow',
        heightOffset: 125
      });
    },
    willDestroyElement: function() {
      return this.get('controller').off('editingLabelActivated', this);
    },
    setupLabelEditListener: function() {
      var controller;
      controller = this.get('controller');
      return controller.on('editingLabelActivated', this, (function(_this) {
        return function() {
          return Ember.run.next(function() {
            var el;
            el = _this.$('.workflow-label-edit');
            el.focus();
            return el.on('keyup', function(e) {
              if (e.keyCode === 27) {
                controller.send('editWorkflowLabelCancel');
              }
              if (e.keyCode === 13) {
                return controller.send('updateWorkflowLabel');
              }
            });
          });
        };
      })(this));
    }
  });

}).call(this);

//# sourceMappingURL=workflow_view.js.map


(function() {
  KotiveWebapp.WorkflowsAddView = Ember.View.extend({
    didInsertElement: function() {
      return this.get('controller').on('readyToFocus', this, (function(_this) {
        return function() {
          return _this.$('.form-control.title-value').focus();
        };
      })(this));
    },
    willDestroyElement: function() {
      return this.get('controller').off('readyToFocus', this);
    }
  });

}).call(this);

//# sourceMappingURL=workflows_add_view.js.map


(function() {
  KotiveWebapp.Router.map(function() {
    this.route('login');
    this.route('logout');
    this.route('offline');
    this.route('startup');
    this.route('no-access');
    this.route('something-went-wrong');
    this.resource('user', {
      path: '/user'
    }, function() {
      this.route('synchronise');
      return this.resource('invite-synchronise', {
        path: 'invite-synchronise/:invite_synchronise_identifier'
      });
    });
    this.resource('people-management');
    this.resource('signup', {
      path: '/person/decrecated/:token'
    });
    this.route('registration', {
      path: '/person/confirm/:token'
    });
    this.route('forgot', {
      path: '/person/forgot_password'
    });
    this.route('reset', {
      path: '/person/reset_password/:token'
    });
    this.resource('referrals');
    this.resource('designers');
    this.resource('switch');
    this.resource('group', {
      path: '/group/:group_id'
    }, function() {
      this.route('create');
      this.route('edit');
      this.resource('designer', function() {
        this.route('workflows');
        return this.resource('workflow', {
          path: 'workflow/:workflow_id'
        }, function() {
          return this.resource('template-activity', {
            path: 'activity/:template_activity_id'
          }, function() {
            return this.resource('template-field', {
              path: 'field/:template_field_id'
            });
          });
        });
      });
      this.resource('taskflow', {
        path: 'taskflow/:taskflow_id'
      }, function() {
        this.route('full');
        this.route('lite');
        return this.route('retry');
      });
      this.resource('report', {
        path: 'report/:report_id'
      }, function() {
        return this.resource('report-history', {
          path: '/history/:report_history_id'
        });
      });
      this.resource('people', function() {
        return this.route('create');
      });
      this.resource('person', {
        path: 'person/:person_id'
      }, function() {
        return this.route('edit');
      });
      return this.resource('groups-new');
    });
    this.resource('generate-taskflow', {
      path: 'generate-taskflow/:taskflow_template'
    });
    this.resource('details');
    return this.resource('permissions');
  });

}).call(this);

//# sourceMappingURL=router.js.map


        return true;
      });
    };
  })(this));

}).call(this);

//# sourceMappingURL=app.js.map
//@ sourceMappingURL=combined-scripts.js.map